export const traduction = [
  {
    id: 0, // Anglais
    CHOOSE_STEP: "Choose a step...",
    NO_ACTIVE_WORKFLOW: "No active workflow",
    WF_OTHER_WORKFLOWS_HEADER: "Other workflows",
    ATTACH_FILE: "Attach file",
    ATTACH_FILE_COMING_SOON: "File attachment coming soon",
    BACK_TO_FORM: "Retour",
    CHOOSE: "Choose a step",
    WF_ACTION_APPROVE: "Approve",
    WF_ACTION_CLOSE: "Close",
    WF_ACTION_REFUSE: "Refuse",
    WF_ACTION_REQUEST_CHANGES: "Request changes",
    WF_ACTION_RETURN: "Send back",
    WF_ACTION_TRANSMIT: "Forward",
    WF_ACTION_VALIDATE_STEP: "Validate step",
    WF_ASSIGNED_TO_YOU: "Assigned to you",
    WF_AWAITING_CLAIM: "Awaiting assignment",
    WF_BY: "by",
    WF_CLAIM: "Take ownership",
    WF_EVENTS: "events",
    WF_FIELDS_CHANGED: "fields changed",
    WF_FIELD_CHANGED: "field changed",
    WF_IN_PROGRESS: "In progress",
    WF_LINK_CHANGES: "link changes",
    WF_MORE_FIELDS: "more",
    WF_OTHER_WORKFLOWS: "other",
    WF_REJECT: "Reject",
    WF_REJECTED: "Rejected",
    WF_RESUME: "Resume",
    WF_SAVE_FIRST: "Save before taking workflow actions",
    WF_SHOW_LESS: "Show less",
    WF_SUBMIT: "Submit",
    WF_VALIDATE: "Validate",
    WORKFLOW_ACTIONS: "Actions",
    WORKFLOW_ACTION_ERROR: "Workflow action failed",
    WORKFLOW_ASSIGN: "Assign",
    WORKFLOW_ASSIGNEE: "assignee",
    WORKFLOW_ASSIGNEES: "assignees",
    WORKFLOW_ASSIGN_ERROR: "Unable to update assignees",
    WORKFLOW_ASSIGN_SUCCESS: "Assignees updated",
    WORKFLOW_CHOOSE_STEP: "Select a step",
    WORKFLOW_CLAIM_BUTTON: "Prendre en charge",
    WORKFLOW_CLAIM_SUCCESS: "Step claimed",
    WORKFLOW_COMMENT: "Comment",
    WORKFLOW_COMMENT_PLACEHOLDER: "Add a comment (optional)",
    WORKFLOW_CONDITION_FIELD: "Pass condition (passCondition)",
    WORKFLOW_CONDITION_HINT: "Free condition — same format as the lifecycle (JsonLogic / filter). Leave blank to require nothing.",
    WORKFLOW_CONDITION_INVALID_JSON: "Invalid JSON — not saved",
    WORKFLOW_CONDITION_MESSAGE_FIELD: "Message shown when the condition blocks",
    WORKFLOW_WARN_CONDITION_FIELD: "Warning condition (warnCondition)",
    WORKFLOW_WARN_CONDITION_HINT: "Non-blocking — same format as the pass condition. When it is not met, the submitter must confirm before submitting. Leave blank to show no warning.",
    WORKFLOW_WARN_CONDITION_MESSAGE_FIELD: "Message shown in the warning",
    WORKFLOW_WARNING_TITLE: "Warning before submitting",
    WORKFLOW_WARNING_CONFIRM: "Submit anyway",
    WORKFLOW_WARNING_ACKNOWLEDGED: "Submitted despite the warning",
    WORKFLOW_DEFAULT: "Auto",
    WORKFLOW_LOADING_CONTENT: "Please wait while the workflow loads.",
    WORKFLOW_LOADING_TITLE: "Loading…",
    WORKFLOW_NEXT_STEP: "Choose a next step",
    WORKFLOW_NO_HISTORY: "No history available",
    WORKFLOW_PICKER_CLEAR: "Clear",
    WORKFLOW_PICKER_EMPTY: "No results",
    WORKFLOW_PICKER_GROUPS: "Groups",
    WORKFLOW_PICKER_SEARCH: "Search…",
    WORKFLOW_PICKER_SELECTED: "Selected",
    WORKFLOW_PICKER_SHOW_ALL: "Show all",
    WORKFLOW_PICKER_SHOW_SELECTED: "Selected only",
    WORKFLOW_PICKER_USERS: "Users",
    WORKFLOW_REASSIGN: "Reassign",
    WORKFLOW_REASSIGN_SUCCESS: "Assignees updated",
    WORKFLOW_REASSIGN_TITLE: "Reassign",
    WORKFLOW_REJECT_BUTTON: "Reject",
    WORKFLOW_REJECT_LABEL_FIELD: "Reject button label",
    WORKFLOW_REJECT_SUCCESS: "Step rejected",
    WORKFLOW_STEP_BLOCKED_DEFAULT: "This step's data condition is not met yet.",
    WORKFLOW_STEPS: "Steps",
    WORKFLOW_SUBMIT_BUTTON: "Submit",
    WORKFLOW_SUBMIT_LABEL_FIELD: "Submit button label",
    WORKFLOW_SUBMIT_SUCCESS: "Step submitted",
    WORKFLOW_TAB_HISTORY: "Progress",
    WORKFLOW_TAB_PROGRESSION: "Progression",
    WORKFLOW_VALIDATE_BUTTON: "Validate",

    WF_EVENT_SUBMITTED: "Submitted",
    WF_EVENT_REJECTED: "Rejected",
    WF_EVENT_REASSIGNED: "Reassigned",
    WF_EVENT_CLAIMED: "Claimed",
    WF_COMPLETED: "Completed",
    WF_ALL_STEPS_DONE: "All steps have been completed.",

    MENU_REMOVE_FAVORITE: "Remove from favorites",
    MENU_ADD_FAVORITE: "Add to favorites",
    MENU_EDIT_FAVORITES: "Edit favorites",
    MENU_DONE_FAVORITES: "Done editing favorites",
    MENU_EXPAND: "Expand",
    MENU_COLLAPSE: "Collapse",
    MENU_WHATS_NEW: "What's new",
    MENU_AI_ASSISTANT: "AI Assistant",
    AI_STATUS_ACTIVE: "Active",
    AI_STATUS_ARCHIVED: "Archived",
    AI_STATUS_ALL: "All",
    AI_LOADING_MESSAGE_SEARCH: "Looking for the best sources…",
    AI_LOADING_MESSAGE_GATHER: "Gathering relevant data…",
    AI_LOADING_MESSAGE_RESPONSE: "Drafting a detailed response…",
    AI_PROPOSAL_STATUS_PENDING: "Pending",
    AI_PROPOSAL_STATUS_ACCEPTED: "Accepted",
    AI_PROPOSAL_STATUS_REJECTED: "Rejected",
    AI_PLAN_STEP_STATUS_STARTED: "In progress",
    AI_PLAN_STEP_STATUS_SUCCESS: "Success",
    AI_PLAN_STEP_STATUS_ERROR: "Error",
    AI_PROPOSAL_KIND_CREATE: "Creation",
    AI_PROPOSAL_KIND_UPDATE: "Update",
    AI_PROPOSAL_KIND_DELETE: "Deletion",
    AI_PROPOSAL_KIND_OTHER: "Other",
    AI_PROPOSAL_SCOPE_REFERENTIAL: "Referential",
    AI_PROPOSAL_SCOPE_SAMPLE: "Sample",
    AI_PROPOSAL_SCOPE_OTHER: "Other",
    AI_TOOL_NO_RESULT: "_No result returned._",
    AI_NEVER: "Never",
    AI_PLAN_STEP_LABEL: "Step",
    AI_PLAN_EXECUTION_LIVE: "Plan running…",
    AI_PLAN_PROGRESS_LIVE: "Live execution",
    AI_PLAN_PROGRESS_HISTORY: "Real-time progress",
    AI_PLAN_AGENT_CONTINUES: "The assistant continues the planned actions.",
    AI_PLAN_BADGE_LIVE: "Live",
    AI_PLAN_BADGE_HISTORY: "History",
    AI_PLAN_RUNNING_TITLE: "Plan running",
    AI_PLAN_COMPLETED_TITLE: "Plan completed",
    AI_LAST_UPDATE_LABEL: "Last update",
    AI_TARGET_UNKNOWN: "Target not specified",
    AI_ACTION_ERROR_GENERIC: "Action not possible. Please try again.",
    AI_RENAME_EMPTY_ERROR: "Title cannot be empty.",
    AI_RENAME_TOO_LONG_ERROR: "Title must contain at most 120 characters.",
    AI_DELETE_CONFIRM: "Delete this conversation permanently? This action is irreversible.",
    AI_PROPOSAL_INVALID: "Invalid or incomplete AI proposal.",
    AI_PROPOSAL_TARGET_UNKNOWN: "Unable to determine the referential targeted by this proposal.",
    AI_PROPOSAL_APPROVED:
      "Proposal approved. Remember to apply the changes in the referential.",
    AI_PROPOSAL_REJECTED: "Proposal rejected.",
    AI_REPORT_DOWNLOAD_ERROR: "Unable to download this report.",
    AI_REPORT_SHARE_IN_PROGRESS: "Link in progress…",
    AI_REPORT_SHARE_COPY: "Copy link",
    AI_REPORT_SHARE_COPIED: "Share link copied (valid about 1h).",
    AI_REPORT_SHARE_READY: "Share link ready.",
    AI_REPORT_SHARE_ERROR: "Unable to create a share link for this report.",
    AI_SAMPLE_AUTO_CREATED: "Sample created automatically.",
    AI_SAMPLE_AUTO_UPDATED: "Sample updated automatically.",
    SCIM_ENDPOINTS_TITLE: "Endpoints & documentation",
    SCIM_ENDPOINTS_DESC: "List all active SCIM URLs and copy them instantly.",
    SCIM_ENDPOINTS_COPY_BASE: "Copy base URL",
    SCIM_BASE_COPIED: "SCIM base URL copied",
    SCIM_ENDPOINTS_LOADING: "URLs available once loaded…",
    SCIM_DOC_LINK: "Open SCIM documentation",
    SCIM_ENDPOINT_COPIED: "SCIM endpoint copied",
    SCIM_SECTION_TITLE: "SCIM (Azure AD, Okta…)",
    SCIM_TOGGLE_LABEL: "Enable SCIM",
    SCIM_PORTAL_LABEL: "Portal identifier",
    SCIM_PORTAL_HINT: "Used in the URL /scim/{portal}/v2. Matches your businessId.",
    SCIM_GENERATED_LABEL: "Generated credentials",
    SCIM_GENERATED_EMPTY: "No active credential",
    SCIM_DURATION_LABEL: "Duration",
    SCIM_DURATION_30: "30 days",
    SCIM_DURATION_90: "90 days",
    SCIM_DURATION_180: "180 days",
    SCIM_GENERATE_IN_PROGRESS: "Generating…",
    SCIM_GENERATE_ACTION: "Generate credentials",
    SCIM_SECRET_BANNER: "Secret displayed once",
    SCIM_ALLOWED_IPS_LABEL: "SCIM allowed IPs",
    SCIM_IP_PLACEHOLDER: "1.2.3.4\n10.0.0.0/24",
    SCIM_FETCHING_IP: "Please wait…",
    SCIM_ADD_MY_IP: "Add my IP",
    SCIM_FIREWALL_TITLE: "Application firewall",
    SCIM_FIREWALL_DESC: "Block all PocketResult APIs with an IP whitelist.",
    SCIM_FIREWALL_TOGGLE: "Enable firewall",
    SCIM_FIREWALL_ALLOWED_IPS: "Application allowed IPs",
    SCIM_PREPARE_IP_HINT:
      "You can prefill IP lists before enabling SCIM or the firewall to avoid self-blocking. SCIM 2.0 standards (Azure AD, Okta…) are supported.",
    SCIM_SECRET_NONE: "No active secret",
    SCIM_SECRET_EXPIRES_AT: "Expires on {date} at {time}",
    SCIM_SAVE_IN_PROGRESS: "Saving…",
    AI_PROPOSAL_APPROVE_PROMPT: "Comment for approval (optional)",
    AI_PROPOSAL_REJECT_PROMPT: "Reason for rejection (optional)",
    AI_FULLSCREEN_EXIT: "Exit fullscreen",
    AI_FULLSCREEN_ENTER: "Fullscreen",
    AI_SUMMARY_UNAVAILABLE: "Summary unavailable",
    AI_CONVERSATION_ARCHIVED: "Archived",
    AI_CONVERSATION_ACTIVE: "Active",
    AI_PENDING_RESPONSE: "Response in progress",
    AI_WEB_SOURCE_RECENTLY_ALLOWED: "This domain was just allowed. Relaunch the search.",
    AI_SEND_IN_PROGRESS: "Sending…",
    AI_REQUEST_WEB_SOURCE: "Request unlock",
    AI_LOADING_MORE: "Loading…",
    AI_VIEW_PREVIOUS_MESSAGES: "See previous messages",
    AI_PROMPT_SUGGESTION: "Can you propose new actions based on our data?",
    AI_NO_RECENT_ACTION: "No recent actions. Send a message to start a new run.",
    AI_HIDE_DETAILS: "Hide details",
    AI_SHOW_DETAILS: "Technical details",
    AI_BUTTON_COPIED: "Copied",
    AI_BUTTON_COPY: "Copy",
    AI_WARNING_ARCHIVED: "Impossible to send a message, restore the conversation",
    AI_COMPOSER_PLACEHOLDER: "Write your message…",
    AI_NEW_CONVERSATION_TITLE: "New conversation",
    AI_REPORTS_TITLE: "Downloadable reports",
    AI_REPORTS_SUBTITLE: "Exports history",
    AI_BUTTON_DOWNLOAD: "Download",
    AI_LINK_LABEL: "Link:",
    AI_LINK_OPEN: "open",
    AI_LABEL_EXPIRES: "expires",
    AI_REPORT_UNAVAILABLE: "Report unavailable.",
    AI_REPORT_READY_BANNER: "Report ready",
    AI_WEB_SOURCE_REQUEST_MESSAGE: "Request from AI Assistant for",
    AI_WEB_SOURCE_REQUEST_RECORDED_REF: "Request recorded (%ref).",
    AI_WEB_SOURCE_REQUEST_RECORDED_HOST: "Request recorded for %host.",
    AI_MODAL_TITLE: "AI Assistant",
    AI_BUTTON_CLOSE: "Close",
    AI_PARTIAL_BADGE: "Partial",
    AI_CONVERSATIONS_LOADING: "Loading conversations…",
    AI_NO_CONVERSATION_HINT: "No conversation yet. Start one 👆",
    AI_SELECT_CONVERSATION_PROMPT: "Choose a conversation to view its details.",
    AI_HISTORY_LOADING: "Loading history…",
    AI_PROPOSALS_LOADING: "Loading proposals…",
    AI_LOAD_MORE: "Load more",
    AI_REPLAY_LAST_MESSAGE: "Replay the last message",
    AI_REPLAY_BUTTON: "Replay",
    AI_TURN_AUTHOR_USER: "You",
    AI_TURN_ERROR_FLAG: "Reported error",
    AI_WEB_SOURCE_BLOCKED_DESC: "This source is blocked. Request whitelisting to resume the search.",
    AI_WEB_SOURCE_AUTOREF_LABEL: "Automatic reference:",
    AI_RENAME_CONVERSATION: "Rename conversation",
    AI_RENAME: "Rename",
    AI_LAST_ACTIVITY: "Last activity",
    AI_CONVERSATION_IN_PROGRESS: "Conversation in progress",
    AI_BUTTON_RESTORE: "Restore",
    AI_BUTTON_ARCHIVE: "Archive",
    AI_BUTTON_PURGE: "Purge messages",
    AI_BUTTON_DELETE: "Delete",
    AI_PARTIAL_WARNING: "Partial conversation flagged by the backend.",
    AI_ASSISTANT_THINKING: "Assistant is processing…",
    AI_SEND_IN_PROGRESS: "Sending…",
    AI_SEND_BUTTON: "Send",
    AI_JOURNAL_TITLE: "AI Journal",
    AI_JOURNAL_SUBTITLE: "Actions, deliverables and decisions in real time",
    AI_JOURNAL_RELAUNCH: "Replay",
    AI_BUSINESS_SUMMARY_TITLE: "Business summary",
    AI_BUSINESS_SUMMARY_UPDATED: "Updated",
    AI_PLAN_TOGGLE_SHOW: "Show",
    AI_PLAN_TOGGLE_HIDE: "Hide",
    AI_DIAGNOSTICS_TITLE: "Technical details",
    AI_DIAGNOSTICS_EVENTS: "events",
    AI_DIAGNOSTICS_SHOW: "Show",
    AI_DIAGNOSTICS_HIDE: "Hide",
    AI_DIAGNOSTIC_LABEL: "Diagnostic",
    AI_TIMELINE_COLLAPSED_MESSAGE: 'History hidden. Click "%label%" to inspect the plan.',
    AI_PLAN_NARRATIVE_TITLE: "Plan proposal",
    AI_PLAN_NARRATIVE_GENERATED: "Generated",
    AI_REPORT_GENERATED: "Generated",
    AI_TIMEOUT_TITLE: "LLM timeout",
    AI_TIMEOUT_DESC: "Replay the last request with the same context.",
    AI_TIMEOUT_RETRY: "Retry",
    AI_ASSISTANT_LABEL: "Assistant",
    AI_TYPING_STATUS: "typing…",
    AI_PROPOSALS_TITLE: "AI decisions",
    AI_PROPOSALS_DESCRIPTION: "Manage the proposals generated by the assistant",
    AI_PROPOSALS_TAB_PENDING: "Pending",
    AI_PROPOSALS_TAB_ALL: "History",
    AI_PROPOSALS_EMPTY: "No proposal for this filter.",
    LABEL_SHOW_ALL_TASKS: "Show all tasks",
    // Generics words
    SELECTED_BUSINESS: "Select a business",
    LABEL_SELECTED_BUSINESS:
      "Please select a business to log in to, as multiple businesses are associated with your account.",
    CONTINUE: "Continue",
    CANCEL: "cancel",
    VALIDATE: "validate",
    SEND_TO_CUSTOMER: "Send to customer",
    RETURN_TO_CONSULTANT: "Return to consultant",
    ERASE: "erase",
    CHANGES_SAVES_SUCCESS: "Changes saved successfully",
    ERROR_CHANGES_SAVES: "Error: Changes were not saved",
    RECEIVE_AN_ALERT_AFTER: "Receive an alert after",
    RECEIVE_AN_ALERT_BEFORE: "Receive an alert before",
    BUSINESS_NO_CONFIG_ALERT_BEFORE: "Your business has not configured any due date.",
    BUSINESS_NO_CONFIG_ALERT_AFTER: "Your business has not configured any post-due date.",
    SETTING_GRACE_PERIOD: "Setting the grace period",
    ADD_A_DELAY: "Add a delay",
    ALERTS: "Alerts",
    ALERTS_SUCCESS_UPDATED: "Alerts have been successfully updated",
    ALERTS_ERROR_UPDATED: "Error: Alerts could not be updated",
    close: "close",
    share: "share",
    search: "search",
    IMPORT: "import",
    PREPARE: "prepare",
    VISUALIZE: "VISUALIZE",
    VISUALISATION: "Visualization",
    add: "add",
    addition: "addition",
    configure: "configure",
    CENTERED: "Centered",
    PAGE: "page",
    WELCOME: "Welcome",
    TUTORIAL: "Tutorial",
    HIDE: "Hide",
    USED: "Used",
    NOT_USED: "Not used",
    ADD_DESCRIPTION: "Add description",
    SAUVEGARDE: "Save",
    SAUVEGARDER: "Save",
    LAST_MISE_A_JOUR: "Last update",
    MISE_A_JOUR: "Update",
    NOM_SAUVEGARDE: "Backup name",
    DATE_SAUVEGARDE: "Backup date",
    ACTION_ELEMENT: "Action and item",
    SORT_BY_NAME: "Sort by name",
    ACTION: "Action",
    ELEMENT: "Element",
    CREATION: "Creation",
    MODIFICATION: "Change",
    USER: "User",
    MENU: "Menu",
    TO_SELECT: "to select",
    CLOTURER: "Enclose",
    // Login Part
    titleLogin: "Pocket Result DEMO",
    firstTextLogin: "Welcome back!",
    secondTextLogin: "Please login to continue.",
    stayConnectedLabel: "Remember me",
    FORGOT_PASSWORD: "Forgot your password",
    PASSWORD: "Password",
    SEND: "Send",
    SENT: "Sent",
    ENTER_YOUR_EMAIL_TO_RESET_IT:
      "Enter your email address, an email will be sent to you to reset your password :",
    NEW: "New",
    DISCOVER_MORE_ABOUT_POCKET_STUDIO: "Discover more about Pocket Studio",
    PRIVACY_POLICY: "Privacy Policy",
    passwordDontMatch: "Passwords don't appear to match",
    labelOnLogin: "Login",
    noAccount: "Don't have an account? Sign up now",
    wrongCredential: "Incorrect email or password.",
    placeholderEmailLogin: "Email",
    placeholderPasswordLogin: "Password",
    langue1: "English",
    langue2: "French",
    langue3: "Portuguese",
    // Header / NavBar Section
    MY_PROFILE: "My Profile",
    DISCONNECT: "Logout",
    HELPING_CENTER: "Helping Center",
    STATUS_SERVER: "Server Status",
    PAGE_MOSAIC: "Page Mosaic",
    DASHBOARD: "Dashboards",
    DATA: "Data",
    ADMINISTRATION: "Administration",

    SOURCES: "Sources",
    ALL_SOURCES: "All Sources",
    NEW_SOURCE: "New Source",
    EDIT_SOURCE: "Edit a Source",
    ANALYSIS: "Analyses",
    NEW_ANALYSIS: "New Analysis",
    NAVBAR_GED: "Document management",
    OBJECTIFS: "Objectives",
    MODULE_FORMULAIRE: "Module Formulaire",
    PLANNING_CONTROLS: "My controls",
    MY_ACTION_PLANS: "My action plan",
    MAPPING_RISK: "Risk Frameworks",
    FORMULAIRE: "Forms",
    GESTION_DOCUMENTAIRE: "Document Management",
    NOTIFICATION_CENTER: "Notification center",
    FICHE_AFFAIRE: "Case file",
    MSF_DASHBOARD: "Dashboard",
    LABEL_MENU_AFFAIRE: "Cases",
    MODEL_MANAGEMENT: "Model Management",
    GESTION_RELATION_INSTITUT: "Management of institutional relations",
    MAIL_MANAGEMENT: "Mail management",
    COMMUNICATION: "Communication",
    SUCCESS_TO_UPDATE_PROFILE: "Your profile has been successfully updated.",
    //PAGE PARAMETRES CARTOGRAPHIE
    GOVERNANCE: "Governance",
    GOVERNANCE_PARAMETERS: "Governance Settings",
    CHOICE_MAPPING: "Choice Mapping",
    BY_DEFAULT: "By default",
    CONTROL_COMPLIANCE_SCALE: "Control compliance scale",
    CREATE_NEW_SCALE: "Create a new scale",
    CONTROL_COMPLETION_TIME: "Control completion times",
    LOCK_CONTROL_DEADLINE: "Lock control once the deadline has passed",
    GRACE_PERIOD_DAYS: "Grant a grace period in days",
    GRACE_PERIOD_CONFIG: "Grace period configuration",
    ADD_PERIOD: "Add period",
    ROLES_CONCERNED: "Roles concerned",
    SELECT_MAPPING: "Select a mapping",
    MAPPING_TABLE_GLOBAL: "Global Mapping",
    MAPPING_TABLE_ACTIVITY: "Activity Mapping",
    MAPPING_TABLE_RISK: "Risk Mapping",
    CHOICE_TYPE_MAPPING: "Choice mapping type",
    COMPLIANCE_SCALE_NAME: "Compliance Scale Name",
    DEPRECATED: "Deprecated",
    ADD_A_FIELD: "Add a field",
    CURRENT_FIELDS: "Current fields",
    CUSTOM_FIELDS: "Custom fields",
    DEFAULT_FIELDS: "Default fields",
    FIELD_MANDATORY: "Mandatory field",
    DEFAULT_FIELD: "Default field",
    TWO_MINIMUM_FIELDS_REQUIRED: "Two minimum fields required",
    COLOR_FIELD: "Color Field",
    LOWER_BOUND_INCLUDED_FIELD: "Lower bound included field",
    MODEL_RISK: "Risk Model",
    MODEL_STANDART: "Standard model",
    VIEW_MODEL: "View my model",
    CREATE_MODEL: "Create a new model",
    MATRIX_RISK: "Risk Matrix",
    MATRIX_RISK_STANDART: "Standard Matrix",
    VIEW_MATRIX: "View my matrix",
    EDIT_MATRIX: "Edit ma matrice",
    CREATE_MATRIX: "Create a new matrix",
    ADD_MATRIX: "Add matrix",
    SAVE_MATRIX: "Save matrix",
    MODIFY_MATRIX: "Edit matrix",
    NAME_MATRIX_RISK: "Risk Matrix Name",
    CALCUL_IMPACT: "General impact calculation",
    ADD_IMPACT: "Add impact",
    DEFINTION_ECHELLE_IMPACT: "Definition of the impact scale",
    CALCUL_FREQUENCY: "General frequency calculation",
    ADD_FREQUENCY: "Add frequency",
    DEFINTION_ECHELLE_FREQUENCY: "Definition of the frequency scale",
    CALCUL_RISKBRUT: "Calculation of gross risk",
    DEFINTION_SCALE_RISKBRUT: "Definition of the raw risk scale",
    IMPACT_GENERAL: "General impact",
    FREQUENCY_GENERAL: "General frequency",
    DEFINTION_SCALE_CONFORMITY: "Definition of the raw conformity scale",
    VIEW_SCALE_CONFORMITY: "View my Scale",
    EDIT_SCALE_CONFORMITY: "Edit my Scale",
    SUCCESS_TO_CREATE_CONFORMITY_SCALE: "Creation of the compliance scale successfully",
    GENERAL_BUSINESS_MAPPING: "General Business Mapping",
    DEFAULT_MAPPING: "Default mapping",
    SETUP_BUSINESS: "Business setup",
    SETUP_MAPPING: "Mapping setup",
    //PAGE HEADER
    TITLE: "title",
    TITLE_SYNTHESE: "Synthesis",
    CONSIGNE: "Instructions",
    DESCRIPTION: "description",
    SHARE: "share",
    VISUALIZE: "visualise",
    CONFIGURE: "set up",
    CREATE: "create",
    SAVE: "SAVE",
    SAVE_LOWERCASE: "Save",
    ENREGISTRER: "Save",
    SAVE_DRAFT: "Save draft",
    EVALUATE: "Evaluate",
    PUBLISHED: "Published",
    NO_PUBLISHED: "No Published",
    FIX_A_BLOC: "Fix a bloc",
    YOUR_PAGE_HAS_NO_TITLE: "Your page does not have a title, please fill in one.",
    ENREGISTRER_MODIFICATION: "Save changes",
    //Share
    GROUPS_AND_USERS: "Groups and users",
    // Forget password Part
    firstTextForgetPassword: "Enter your email address and we will send you a link.",
    secondTextForgetPassword: "to reset your password",
    AN_EMAIL_JUST_LEFT_TO_RESET_PASSWORD: "An email has just left to reset your password",
    EMAIL_NOT_SENT: "Email could not be sent, please try again",
    wrongEmail: "Email not found. Please try again",
    sendLink: "Send the link",
    // Reset password Part
    textResetPassword: "Your new password must include at least :",
    UNVALID_PASSWORD: "Your password does not meet the security criteria",
    buttonChangePassword: "Change my password",
    needUpperCase: " uppercase",
    needLowerCase: " lowercase",
    needNumber: " number",
    needCharacters: " characters",
    needCharactersSpecial: " special characters",
    definePassword: "Set a new password",
    placeholderNewPassword: "New password",
    confirmSuccess: "Your new password has been successfully created.",
    YOUR_OLD_PASSWORD: "Your old password",
    WRONG_OLD_PASSWORD: "Ahem, this isn't your password.",
    confirmPassword: "Confirm new password",
    placeholderConfirmPassword: "Confirm new password",
    criteriaRequier: "Your password does not meet the security criteria.",
    passwordNotTheSame: "Passwords are not the same.",
    confirmSuccess: "Your password has been created, try to connect.",
    confirmationPassword: "Confirm new password",
    invalidTokenResetPassword: "For security reasons, the link you followed has expired.",
    invdalidTokenResendEmail: "Click here",
    // Registration Part
    titleRegistration: "Welcome !",
    firstTextLeftRegistration: "Fill in your personal data",
    secondTextLeftRegistration: "and start your experience with us !",
    firstTextRegistration: "Hey! Registration will only take",
    secondTextRegistration: "2 minutes, pinkie promise",
    placeholderFirstname: "First Name",
    placeholderLastname: "Last Name",
    sensitivityPassword1: "Strong",
    sensitivityPassword2: "Medium",
    sensitivityPassword3: "Weak",
    libellePassword: "Password",
    libellePrivacyPolicy1: "I agree to ",
    libellePrivacyPolicy2: "the privacy policy",
    buttonRegistration: "Registration",
    libellePrivacyRobotPolicy: "I am not a robot",
    ou: "or",
    goToLogin1: "Already registered ?",
    goToLogin2: "To log in",
    goToLogin: "Already registered? Sign in",
    errorRegistration:
      "We are sorry, we are encountering some problems when creating your account.",
    successRegistration: "Your account has been successfully created!",
    // Registration Business Part
    titleRegistrationBusiness: "Welcome",
    firstTextRegistrationBusiness: "To start using Pocket Result DEMO",
    secondTextRegistrationBusiness: "please fill in these fields.",
    labelRegistrationBusiness1: "Company name",
    labelRegistrationBusiness2: "Phone number",
    labelRegistrationBusiness3: "Domaine name",
    //FORM
    GLOBAL_COMMENT: "Global comment",
    MANDATORY: "Mandatory",
    CHOOSE_ANSWER: "Choose answer",
    ENTER_AN_ANSWER: "Enter an answer",
    ENTER_A_RECOMMENDATION: "Enter a recommendation",
    NOT_SPECIFIED: "Not specified",
    NOT_SPECIFIED_RECO: "No recommendation provided",
    NONE_RECOMMENDATIONS: "None recommendation",
    // Console Admin
    BUSINESS_DESACTIVATED: "Your business is currently desactivated, please contact support.",
    USER_DESACTIVATED: "Your account is currently desactivated, please contact support.",
    ENTITY: "Entity",
    ASSOCIATED_ENTITY: "Associated entity",
    SUB_ENTITY: "Sub-entity",
    ENTITY_GESTION: "Gestion of entities",
    NUMBER_OF_GROUP: "Number of groups",
    NUMBER_OF_ROLES: "Number of roles",
    NUMBER_OF_USERS: "Number of users",
    CREATION_DATE: "Creation date",
    USE_GOVERNANCE: "Use Governance",
    USE_FORM: "Use Form",
    ADD_ENTITY: "Add an entity",
    ENTITY_NAME: "Entity name",
    FIRST_USER_EMAIL: "First email of user",
    ADD_BUSINESS: "Add a business",
    ENTITY_INFORMATIONS: "Entity informations",
    BACK_TO_LIST: "Back to list",
    DISABLE_USER: "Disable User",
    ENABLE_USER: "Enable User",
    DISABLE_ROLE: "Disable Role",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ROLE: "Are you sure you want to delete this role ?",
    NO_BUSINESS_FOUND: "No business found",
    ADDITIONAL_FEATURES: "Additional Features",
    ACTIVATE_RIGHTS_ENTITY: "Activate rights of entity",
    ACTIVATE_GOVERNANCE_RIGHT: "Activate governance rights",
    ACTIVATE_INCIDENT_RIGHT: "Activate incident rights",
    ACTIVATE_FORM_ACCESS: "Activate form access",
    ACTIVATE_DOCUMENT_MANAGEMENT_ACCESS: "Activate access to document management",
    ACTIVATE_AUDIT_MODULE: "Activate access to audit module",
    ACTIVATE_MSF_MODULE: "Activate access to MSF module",
    ACTIVATE_REFERENTIALS_MODULE: "Activate access to referentials module",
    ACTIVATE_ANOMALIES: "Activate anomalies",
    ACTIVATE_INCIDENTS: "Activate incidents",
    ACTIVATE_RECOMMENDATIONS: "Activate recommendations",
    ACTIVATE_REFERENTIALS: "Activate referentials",
    ACTIVATE_CONFIG_GRC: "Activate config grc",
    ACTIVATE_KPIS_DASH: "Activate Kpis Dash",
    ACTIVATE_GED: "Activate document management (GED)",
    TYPE_OF_GOVERNANCE: "Type of governance",
    UNDEFINED_NAME: "Undefined name",
    ANOMALY: "Issue",
    ANOMALIES: "Issues",
    ADD_ANOMALY: "Add issue",
    INCIDENT: "Incident",
    ADD_INCIDENT: "Add incident",
    ACTIONS_CORRECTIVES: "Corrective actions",
    ACTIONS_PLANS: "Actions plans",
    ACTION_PLAN: "Action plan",
    PERFORMERS: "Performers",
    PERFORMER: "Performers",
    DATE_OF_IMPLEMENTATION: "Date of implementation",
    DEADLINE: "Deadline",
    TASKS: "Tasks",
    ASSIGNED_YOU_TASKS_NON_CONFORMITY: "assigned you to a task regarding the non-compliance",
    ADD_AN_ACTION_PLAN: "Add an action plan",
    SELECT_A_PERIOD_TO_DISPLAY: "Select a period to display",
    // My Profile part
    FIRST_NAME: "First Name",
    LAST_NAME: "Last Name",
    EMAIL: "Email",
    EMAIL_ADRESS: "Email Address",
    INCORRECT_EMAIL_ADDRESS: "Incorrect Email Address",
    POSITION: "Position",
    FUNCTION: "Job",
    DEPARTMENT: "Department",
    LANGUAGE: "Language",
    HOME_PAGE: "Home Page",
    CHANGE_MY_PASSWORD: "Change my password",
    EDITION: "Edition",
    PROFILE_PICTURE: "Profile Picture",
    MAX_SIZE_PROFILE_PICTURE: "The maximum allowed file size is 200 KB.",
    CONFIRM_CHANGE_PASSWORD: "Update the password",
    DELETE_PROFILE_PICTURE: "Delete",
    ENTITY_WORK: "Work Entity",
    USER_PROFILS: "User profiles",
    ENTITIES_MEMBERSHIP: "Membership Entities",
    BY_DEFAULT: "By default",
    // Accès & Entreprise Part
    CUSTOMIZATION: "Customization",
    LOCALISATION_INPUT_LABEL: "Display coordinates when loading the map",
    LATTITUDE: "Latitude",
    LONGITUDE: "Longitude",
    DESIGN: "Design",
    ROLES: "Roles",
    USERS: "Users",
    CONTROLS_TAB: "Controls",
    ACTIVTY_TAB: "Activity",
    RISK_TAB: "Risks",
    RISK_RESIDUAL_TAB: "Residual Risks",
    HISTORY: "History",
    CARTOGRAPHY_HISTORY: "Cartography history",
    ADMIN_BUSINESS: "Admin Business",
    COMPANY_NAME: "Company Name",
    PHONE_NUMBER: "Phone number",
    CONTACT_EMAIL: "Email",
    WEBSITE: "Website",
    PLATEFORM_COLORS: "Platform colours",
    SIDEBAR_COLOR: "Sidebar color",
    PRIMARY_COLOR: "Primary color",
    ALTERNATIVE_COLOR: "Alternative color",
    ILLUSTRATION_COLOR: "Main illustration color",
    BUSINESS_UNIT: "Business Unit",
    EDITION: "Edit",
    UPLOAD_LOGO: "Upload Logo",
    COLORS: "Colors",
    INTERFACE_COLOR: "Interface colors",
    OVERVIEW: "Overview",
    CREATED_ON: "Created on",
    ACCESS: "Access",
    ADD_NEW_USER: "Add new user",
    NEW_USER: "new user",
    MODIFY_USER: "Modify user",
    buttonAcces2: "Edit access",
    UNVALID_EMAIL: "Please enter a valid email",
    ALREADY_USED_EMAIL: "This email is already used on the platform",
    ENTER_VALID_FIRSTNAME: "Please enter a first name",
    ENTER_VALID_LASTNAME: "Please enter a name",
    ENTER_VALID_FUNCTION: "Please enter a function",
    SELECT_VALID_ACCESS: "Please select an access",
    SELECT_VALID_GROUP: "Please select an group",
    GROUP: "Group",
    CLIENT: "Client",
    CLIENTS: "Clients",
    newActivity: "new activity",
    addActivity: "Add an activity",
    editActivity: "Edit a activity",
    labelActivity1: "Name reference",
    labelActivity2: "Activity reference",
    NEW_ROLE: "new role",
    addARole: "Add a role",
    EDIT_A_ROLE: "Edit a role",
    labelRoleTitle1: "Edit access",
    labelRoleTitle2: "Add a new role",
    labelRoleTitle3: "Delete access",
    NB_USERS: "Number of users",
    ROLE_NAME: "Role name",
    labelRole2: "Role Access",
    labelRole3: "Create from a role level",
    labelRole4: "Warning! The role level will change the price of access.",
    errorEnterNameAccess: "Please enter a role name",
    errorAccessAldreadyExist: "The role name already exists, please change it and try again.",
    roleCategory1: "Users",
    roleCategory2: "Company",
    roleCategory3: "Dashboard",
    roleCategory4: "Data",
    roleCategory5: "Roles",
    roleCategory6: "Administrator",
    roleCategory7: "Form",
    roleCategory8: "Governance",
    roleCategory9: "Groups",
    COLOR_CHARTS_PALETTES: "Color palettes for graphics",
    SEARCH: "Search",
    EDIT: "Edit",
    ADD_A_PALETTE: "Add a palette",
    PALETTE_NAME: "Name of the palette",
    DEFAULT_PALETTE: "Default palette",
    PALETTE: "Palette",
    TEN_COLORS_RECOMMENDED: "10 colors recommended",
    GALERY_PALETTE: "Galery palette",
    ADD_A_COLOR: "Add a color",
    ACTIONS: "Actions",
    PALETTE_MUST_HAVE_A_NAME: "The palette must have one name",
    PALETTE_MUST_HAVE_AT_LEAST_ONE_COLOR: "The palette must have at least one color",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_LAST_PALETTE:
      "Are you sure you want to remove the last palette in the company? If your company does not have a palette anymore, it will use the public palettes of the application",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_PALETTE:
      "Are you sure you want to remove this color palette?",
    LOADING: "Loading...",
    REFERENTIALS_STATS_LOADING: "Loading statistics...",
    STATS_EMPTY_STATE: "No data available",
    STATS_SERIES_USAGE: "Usage",
    STATS_SERIES_CONNECTIONS: "Connections",
    USER_STATS_NO_USER_ID: "Unable to retrieve the user ID.",
    USER_STATS_NO_DATA: "No data available for this user.",
    USER_STATS_FORBIDDEN: "You do not have permission to view this user's statistics.",
    USER_STATS_TITLE: "User statistics",
    USER_STATS_GENERAL: "General information",
    USER_STATS_LAST_LOGIN: "Last login",
    USER_STATS_NEVER: "Never",
    USER_STATS_LOGIN_COUNT: "Login count",
    USER_STATS_TOP_CUBES: "Most used cubes",
    USER_STATS_TOP_REFERENTIALS: "Most used referentials",
    USER_STATS_NO_ACTIVITY: "No activity recorded.",
    GLOBAL_STATS_LOADING: "Loading global statistics...",
    GLOBAL_STATS_NO_DATA: "No statistics available",
    GLOBAL_STATS_TITLE: "Global statistics",
    GLOBAL_STATS_USERS: "Users",
    GLOBAL_STATS_TOTAL_USERS: "Total users",
    GLOBAL_STATS_ACTIVE_7_DAYS: "Active (7 days)",
    GLOBAL_STATS_ACTIVE_30_DAYS: "Active (30 days)",
    GLOBAL_STATS_TOP_CUBES: "Most used cubes",
    GLOBAL_STATS_TOP_REFERENTIALS: "Most used referentials",
    GLOBAL_STATS_DAILY_LOGINS: "Daily logins",
    COLOR_ONE: "Color 1",
    COLOR_TWO: "Color 2",
    USE_GRADIENT: "Use a color gradient",
    HEADER_SIZE: "Header size",
    HEADER: "Header",
    INTERFACE: "Interface",
    ERROR_MESSAGE_SIZE_HEADER: "Be careful the value must be between 70 and 200 pixels !",
    NAVBAR_COLOR: "NavBar color",
    NAVBAR_SIZE: "Navbar size",
    HIDE_TITLE: "Hide title",
    HIDE_DESCRIPTION: "Hide description",
    USE_MINIMIZED_BUTTON_VIEW: "Use minimized button view",
    NAVBAR: "Navbar",
    TOP_TO_BOTTOM: "Top to bottom",
    BOTTOM_TO_TOP: "Bottom to top",
    LEFT_TO_RIGHT: "Right to left",
    RIGHT_TO_LEFT: "Left to right",
    BOTTOM_LEFT_TO_TOP_RIGHT: "Bottom left corner to top right corner",
    TOP_LEFT_TO_BOTTOM_RIGHT: "Top left corner to bottom right corner",
    BOTTOM_RIGHT_TO_TOP_LEFT: "Bottom right corner to top left corner",
    TOP_RIGHT_TO_BOTTOM_LEFT: "Top right corner to bottom left corner",
    HEADER_TEXT_COLOR: "Header text color",
    NAVBAR_TEXT_COLOR: "Navbar text color",
    //RIGHTS
    CREATE_ACCOUNT: "Create account",
    EDIT_ACCOUNT: "Edit account",
    DELETE_ACCOUNT: "Delete account",
    DELETE_THE_USER: "Delete the user",
    EDIT_COMPANY_INFO: "Edit company info",
    CREATE_BUSINESS_UNIT: "Create Business Units",
    EDIT_BUSINESS_UNIT: "Edit Business Units",
    DELETE_BUSINESS_UNIT: "Delete Business Units",
    CREATE_DASHBOARD: "Create dashboards",
    EDIT_DASHBOARD: "Edit dashboards",
    DELETE_DASHBOARD: "Delete dashboards",
    SHARE_DASHBOARD: "Share dashboards",
    IMPORT_DATA: "Import data",
    EDIT_DATA: "Edit data",
    NO_RESPONSE: "No response",
    DELETE_DATA: "Delete data",
    NO_ACCESS_DATASOURCE: "No access to data sources",
    CREATE_ROLE: "Create roles",
    EDIT_ROLE: "Edit roles",
    DELETE_ROLE: "Delete roles",
    DELETE_THE_ROLE: "Delete the role",
    CREATE_GROUP: "Create groups",
    EDIT_GROUP: "Edit groups",
    DELETE_GROUP: "Delete groups",
    VIEW_GROUP: "View groups",
    CREATE_ADMINISTRATOR: "Create administrator",
    EDIT_ADMINISTRATOR: "Edit administrator",
    DELETE_ADMINISTRATOR: "Delete administrator",
    VIEW_CREATED_ACCOUNTS: "Viewing created accounts",
    VIEW_FORM: "Viewing form",
    VIEW_TREE: "Relations view",
    CREATE_FORM: "Create form",
    EDIT_FORM: "Edit form",
    DELETE_FORM: "Delete form",
    DUPLICATE_FORM: "Duplicate form",
    REPONSE_FORM: "respond form",
    PARAMETERS_FORM: "Parameters form",
    NO_ACCESS: "No access",
    ACCESS_CONTROL: "Access Governance",
    ACCESS_CARTOGRAPHIE: "Mapping Access",
    ACCESS_PLANNING: "Access Planning Control",
    ADD_CARTO: "Create Mapping",
    DELETE_CARTO: "Deleted Mapping",
    PARAMS_CARTO: "Settings Mapping",
    ADD_ACTIVITY: "Create Activity",
    EDIT_ACTIVITY: "Edit Activity",
    ADD_RISK: "Create Risk",
    EDIT_RISK: "Edit Risk",
    ADD_TASK: "Add a task",
    DELETE_RISK: "Delete Risk",
    ADD_CONTROL: "Create Control",
    EDIT_CONTROL: "Edit Control",
    DUPLICATE_CONTROL: "Duplicate Control",
    DELETE_CONTROL: "Delete Control",
    WAIT_FOR_VALIDATION: "Wait for validation",
    FRAMEWORK: "Framework",
    FRAMEWORK_FRANCE: "Framework france",
    SELECT_FRAMEWORK: "Select framework",
    SELECT_CONTROLS: "Select controls",
    RELEVANT_CONTROLS: "Relevant controls",
    DETAILS: "Details",
    EVENT_LOG: "Event log",
    IMPACT_ANALYSIS: "Impact analysis",
    COMMENTS: "Comments",
    ACCESS_DOC_ACTUALITY: "Access news / regulatory monitoring",
    ADD_DOC_ACTUALITY: "Add news",
    EDIT_DOC_ACTUALITY: "Edit news",
    DELETE_DOC_ACTUALITY: "Delete news",
    ACCESS_DOC_GOVERNANCE: "Governance access",
    ADD_DOC_GOVERNANCE: "Add governance year",
    EDIT_DOC_GOVERNANCE: "Edit governance year",
    DELETE_DOC_GOVERNANCE: "Delete governance year",
    ACCESS_DOC_SOLLICITE: "Access documented requested",
    ACCESS_DOC_HISTORY: "Access history",
    ACCESS_DOC_RECOMMENDATIONS: "Access recommendations documents",
    ACCESS_DOCUMENT_MANAGEMENT: "Access document management",
    ACCESS_VALIDATION_MANAGER: "Manager validation access",
    //
    labelEditUser: "Editing a user",
    labelCreateUser: "Adding a new user",
    addAUser: "Add a user",
    btnCreateUser: "Create new user",
    //GOVERNANCE
    SUCCESS_TO_CHANGE_BUSINESS_GOVERNANCE_RIGHT:
      "The change in business governance right has been successfully completed",
    FAIL_TO_CHANGE_BUSINESS_GOVERNANCE_RIGHT:
      "An error has been encountered during the changes of business governance rights",
    SUCCESS_TO_DELETE_GOVERNANCE_CONTENT: "The governance content has been deleted successfully",
    FAIL_TO_UPDATE_REQUEST_GOVERNANCE: "Failed to update governance",
    SUCCESS_TO_UPDATE_REQUEST_GOVERNANCE: "Successful governance update",
    SUCCESS_TO_CREATE_REQUEST_GOVERNANCE: "Successful creation of governance",
    FAIL_TO_CREATE_REQUEST_GOVERNANCE: "Failed to create governance",
    FAIL_TO_UPDATE_REQUEST_ACTUALITY: "Failed to update actuality",
    SUCCESS_TO_UPDATE_REQUEST_ACTUALITY: "Successful actuality update",
    SUCCESS_TO_CREATE_REQUEST_ACTUALITY: "Successful creation of actuality",
    SUCCESS_TO_DELETE_ACTUALITY: "Actuality successfully deleted",
    FAIL_TO_DELETE_ACTUALITY: "Failed to delete actuality",
    FAIL_TO_CREATE_REQUEST_ACTUALITY: "Failed to create actuality",
    SUCCESS_TO_PATCH_RISK: "Successful risk update",
    FAIL_TO_PATCH_RISK: "Failed to update risk",
    SUCCESS_TO_UPDATE_ACTIVITY: "Successful activity update",
    FAIL_TO_UPDATE_ACTIVITY: "Failed to update activity",
    SUCCESS_TO_VALIDATE_TASK: "Task validated successfully",
    FAIL_TO_VALIDATE_TASK: "Failed to validate task",
    SUCCESS_TO_SAVE_RESPONSE: "Successfully saved your response",
    FAIL_TO_SAVE_RESPONSE: "Failed to save your response",
    SUCCESS_TO_UPDATE_CUSTOM_SKELETON: "Successfully saved your model",
    FAIL_TO_UPDATE_CUSTOM_SKELETON: "Failed to save your model",
    TESTTING: "Testing",
    DISPOSITIF: "Device",
    //WIDGETS
    WIDGET_SETTINGS: "Widget settings",
    STYLE: "Style",
    TABS: "Tabs",
    AND: "AND",
    OR: "OR",
    CATEGORY: "Category",
    VERSION: "Version",
    DEPENDS_ON: "Depends on",
    GROUP_BY: "Group by",
    SELECT_Y: "Select Y axis value",
    SELECT_X: "Select X axis value",
    CALCULUS: "Calculus",
    ADD_A_VALUE: "Add a value",
    ADD_A_FORMULA: "Add a formula",
    EDIT_A_FORMULA: "Edit formula",
    CUSTOM_CALCULUS: "Custom calculus",
    HIDE_QUESTION: "Hide question",
    HIDE_FORMULA: "Hide formula",
    FIELD: "Field",
    DAY_MONTH_YEAR: "Day-Month-Year",
    DAY_MONTH: "Day-Month",
    MONTH_YEAR: "Month-Year",
    MONTH_IN_LETTER_YEAR: "Month in letter-Year",
    DAY: "Day",
    MONTH: "Month",
    TRIMESTER: "Quarter",
    SEMESTER: "Half year",
    YEAR: "Year",
    CHANGE_WIDGET_TYPE: "Change widget type",
    AUTHORIZE_COMPARISON: "Authorize Comparison",
    AUTHORIZE_FILTERING: "Authorize Filtering",
    SORT: "SORT",
    DEFAULT: "Default",
    TRUNCATE: "Truncation",
    WRAP: "Return to line",
    NO_SORTING: "No sorting",
    ASCENDING: "Ascending",
    DESCENDING: "Descending",
    DISPLAYED_RESULTS: "Displayed Results",
    RESULTS_NUMBER: "Results number",
    BEST_RESULTS: "Best Results",
    WORST_RESULTS: "Worst Results",
    FIRST_SELECT_FIELDS_TO_DISPLAY: "First select fields to display",
    FIRST_SELECT_NUMERIC_FIELDS_TO_DISPLAY: "First select numeric fields to display",
    OF: "of",
    FOR: "for",
    DISPLAYED_FIELDS: "Displayed fields",
    OTHER_FIELDS: "Other fields",
    OTHER_DOCUMENTS: "Other documents",
    WIDGET_NOT_CONFIGURED: "Widget not configured",
    WIDGET_FILTER_HIERARCHY_EMPTY: "No item",
    WIDGET_FILTER_HIERARCHY_CONFIGURE: "Configure the relation",
    WIDGET_SOURCE_LABEL: "Data source",
    WIDGET_SOURCE_CUBE: "Page data (cube)",
    WIDGET_SOURCE_VIEW_COLUMNS: "Columns produced by this view",
    WIDGET_SOURCE_MISSING_FIELDS: "Configured fields missing from this view, to be re-selected",
    DATA_VIEWS: "Data views",
    VIEW_NEW: "New view",
    VIEW_LIST_EMPTY: "No view on this page",
    VIEW_PUBLISHED: "Published",
    VIEW_NAME: "Name",
    VIEW_DESCRIPTION: "Description",
    VIEW_TAB_DEFINITION: "Definition",
    VIEW_TAB_HISTORY: "History",
    VIEW_VALIDATE: "Validate",
    VIEW_VALID: "Valid definition",
    VIEW_SAVED: "View saved",
    VIEW_RESTORED: "Version restored",
    VIEW_NAME_REQUIRED: "The view name is required",
    VIEW_NO_OUTPUT_COLUMN: "No output column",
    VIEW_AVAILABLE_COLUMNS: "Available columns",
    VIEW_HISTORY_COUNT: "Saved versions",
    VIEW_HISTORY_RESTORE: "Restore",
    VIEW_HISTORY_RESTORED_FROM: "restored from v",
    VIEW_HISTORY_EMPTY: "No version saved yet",
    VIEW_HISTORY_LOAD_MORE: "Load older versions",
    LINE: "line",
    RELATION_TO_TRAVERSE: "Relation to traverse",
    PARENT_SIDE: "Parent side",
    LABEL_FIELD: "Displayed field (label)",
    DEFAULT_REFERENCE: "Reference (default)",
    SELECT_A_FIELD_FIRST: "Select a field first",
    SELECT_ALL: "Select all",
    WARNING_RESET_DATA_WIDGET:
      "Please note that this graph is not adapted to the current data configuration. The change will reset the configuration data. Would you like to continue ?",
    //CONDITION
    CONDITIONS: "Conditions",
    ADD_AN_OR_CONDITION: 'Add "OR" condition',
    ADD_AN_AND_CONDITION: 'Add "AND" condition',
    EQUAL_SYMBOL: "is ",
    DIFFERENT_SYMBOL: "is not ",
    INFERIOR_SYMBOL: "is less than ",
    SUPERIOR_SYMBOL: "is greater than ",
    INFERIOR_OR_EQUAL_SYMBOL: "is less than or equal to ",
    SUPERIOR_OR_EQUAL_SYMBOL: "is greater than or equal to ",
    DISPLAY: "Display",
    LOCALISER_PAR: "locate by",
    ADVANCED_MODE: "Advanced mode",
    UNIQUE_SELECTION_LIST: "Unique Selection List",
    MULTIPLE_SELECTION_LIST: "Multiple Selection List",
    CHARTS: "Charts",
    FILTERS: "Filters",
    TEXTS: "Texts",
    HISTOGRAM_TYPE: "Histogram type",
    HISTOGRAM_ORIENTATION: "Histogram orientation",
    PIE_TYPE: "Pie type",
    LINE_TYPE: "Line type",
    STYLE_CURVE: "Curve style",
    STYLE_BULLETS: "Bullets style",
    APPLY_STYLE_ALL_CURVES: "Apply style to all curves",
    FIELD_LABEL: "Field label",
    //WIDGET SETTINGS
    MOVE_TO_MAIN_LAYOUT: "Move to main layout",
    MOVE_TO_FIXED_LAYOUT: "Move to fixed Layout",
    DISPLAY_PERIOD: "Display period",
    SEARCH_BY_COLUMN: "Search by column",
    LABEL: "Label",
    CENTRAL_TEXT: "Central text",
    EXTERNAL_LABEL: "External label",
    HIDE_EXTERNAL_LABEL: "Hide external labels",
    TITLE_STYLE: "Title Style",
    TITLE_ALIGNMENT: "Title Alignment",
    VALUE: "Value",
    VALUES: "Values",
    BACKGROUND: "Background",
    BORDER: "Border",
    ACTIVE_BORDER: "Enable borders",
    SINGLE_COLOR: "Unique label color",
    SINGLE_COLOR_VALUE: "Label color",
    USE_MY_COLOR_PALLET: "Use my color pallet",
    THICKNESS: "thickness",
    ALIGNMENT: "Alignment",
    ICON_ALIGNMENT: "Icon alignment",
    ICON_OPACITY: "Icon opacity",
    TEXT: "Text",
    LABEL_ALIGNMENT: "Label alignment",
    TEXT_ALIGNMENT: "Text alignment",
    TEXT_STYLE: "Text style",
    BULLET_COLOR: "Bullets color",
    ANGLES: "Angles",
    PROGRESS_BAR_HEIGHT: "Bar thickness",
    PROGRESS_BAR_NUMBER: "Number of progress bar",
    PROGRESS_BAR_FIRST_LABEL: "Label 1",
    PROGRESS_BAR_SECOND_LABEL: "Label 2",
    ROUNDING_UPPER_LEFT_CORNER_COLUMN: "Rounding of the upper left corner of columns",
    ROUNDING_UPPER_RIGHT_CORNER_COLUMN: "Rounding of the upper right corner of columns",
    ROUNDING_LOWER_LEFT_CORNER_COLUMN: "Rounding of the lower left corner of columns",
    ROUNDING_LOWER_RIGHT_CORNER_COLUMN: "Rounding of the lower right corner of columns",
    ROUNDING_SERIES: "Rounding of series",
    COLUMN_WIDTH: "Column width",
    INNER_RADIUS: "Inner radius",
    PIE_GAUGE_MODE: "Complete to 100% (gauge mode)",
    SHOW_MENU: "Show menu",
    USE_MARKER: "Activate google markers",
    SHOW_FULLSCREEN: "Enlarge widget",
    HIDE_LABEL_INFERIOR_TO_A_VALUE: "Hide label inferior to a value",
    VALUE_UNDER_WHICH_TO_HIDE_LABELS: "Value under which to hide labels",
    SHOW_EXPORT_MENU: "Show exports menu",
    SHOW_LEGEND: "Show legend",
    SWAP_MAP: "To be able to change maps",
    REGION: "Region",
    DEPARTEMENT: "Department",
    REDIRECT_BUTTON_NO_PAGE: "No page has been configured for redirect",
    REDIRECT_BUTTON_NO_URL: "No URL has been entered for the redirection",
    LEGEND_POSITION: "Legend position",
    ZOOM_ANIMATION: "Zoom animation",
    ZOOM_BUTTONS: "Zoom buttons",
    ZOOM_SCALE: "Zoom scale",
    ZOOM_DURATION: "Zoom duration",
    MAP_TOOLTIP_COLOR: "Tooltip color",
    TOOLTIP_ACTIVATION: "Tooltip activation",
    TOOLTIP: "Tooltip",
    MAP_IS_DRAGGABLE: "Moving the cartography",
    MAP_IS_ZOOMABLE: "Be able to zoom",
    LEGEND_LABEL: "Legend label",
    MAP_VUE: "Display type",
    MAP_CHOICE: "Choice of cartography",
    MAP_FRANCE_DEP: "French departments",
    MAP_FRANCE_REG: "French region",
    MAP_FRANCE_REG_NEW: "New French",
    MAP_WORLD: "World",
    TYPE_MAP_COLOR: "Colors",
    TYPE_MAP_BULLET: "Bullets",
    TYPE_MAP_BULLET_COLOR: "Bullets + colors",
    TYPE_MAP_BULLET_COLOR_NUMBER: "Bullets + colors + number",
    TOP: "Top",
    REDIRECT_BUTTON_INPUT_URL: "URL",
    REDIRECT_BUTTON_SELECT_URL: "PAGE",
    REDIRECT_BUTTON_SELECT_REFERENTIEL: "REFERENTIEL",
    REDIRECT_BUTTON_SELECT_ICON: "select an icon",
    REDIRECT_BUTTON_SHAPE: "Button color & shape",
    ADD_AN_ICON: "Add an Icon",
    ICON_STYLE: "Icon Style",
    NO_ICONS_TO_SHOW: "No Icons to show",
    SEARCH_AN_ICON: "Search an icon ...",
    THAT_IS_TO_SAY: "That is to say:",
    BOTTOM: "Bottom",
    RIGHT: "Right",
    LEFT: "Left",
    YES: "Yes",
    NO: "No",
    OK: "OK",
    NO_CONCERNED: "No concerned",
    PLACEHOLDER: "Placeholder",
    FILTER_TYPE: "Filter Type",
    DEFAULT_VALUES: "Default values",
    SELECTION_TYPE: "Selection type",
    ONLY_ONE_DATE: "Only one date",
    PERIOD: "Period",
    CUSTOM_STYLE: "Custom style",
    DEFAULT_STYLE: "Default style",
    TITLE_AXE_X: "Title Axe X",
    TITLE_AXE_Y: "Title Axe Y",
    BULLET_SIZE: "Bullet size",
    CURVE_THICKNESS: "Curve thickness",
    LOGARITHMIC_VIEW: "Logarithmic view",
    CURVE_STYLE: "Curve Style",
    SOLID: "Solid",
    DASHED: "Dashed",
    DOTTED: "Dotted",
    TYPE_OF_PLOT: "Type of plot",
    CURVE_LINE: "Curved lines",
    STRAIGHT_LINE: "Straight lines",
    OPACITY: "Opacity",
    TRANSPARENCY: "Transparency (%)",
    UPLOAD_A_NEW_PHOTO: "Upload a new picture",
    UPLOAD_TEXT_BTN: "Click or Drag & Drop to upload file",
    BLUR: "Blur",
    HIDE_CENTERED_VALUE: "Hide centered value",
    HIDE_AXIS_VALUES: "Hide axis values",
    HIDE_CENTERED_TEXT: "Hide centered text",
    SHOW_CENTERED_VALUE: "Show centered text",
    STYLE_CENTERED_TEXT: "Style of the centered text",
    NO_FILE: "No File",
    STYLE_LABELS: "Label style",
    STYLE_VALUES: "Values style",
    STYLE_CENTERED_VALUE: "Style of the centered value",
    STYLE_CENTERED_PERCENT: "Style of the centered percentage",
    CUSTOM_CENTER_TEXT: "Custom central text",
    DO_NOT_DISPLAY_WIDGET_TITLE: "Do not display widget title",
    OPACITY_UNDER_THE_CURVE: "Area opacity under the curve",
    HIDE_GRID_HORIZONTALY: "Hide grid horizontaly",
    HIDE_GRID_VERTICALY: "Hide grid verticaly",
    START_ANGLE: "Start Angle",
    END_ANGLE: "End Angle",
    SHOW_GRID: "Show grid",
    HIDE_LABELS: "Hide labels",
    SHOW_STACK_TOTAL: "Display the column total",
    STACK_TOTAL_COLOR: "Total color",
    STACK_TOTAL_FONT_SIZE: "Total size",
    COLOR_BY_VALUE: "Color by value",
    COLOR_BY_VALUE_HINT: "The value exactly as shown in the legend",
    GANTT_CHART: "Gantt",
    WEEK: "Week",
    PROGRESS: "Progress",
    GANTT_COLUMNS: "Gantt columns",
    GANTT_SIDEBAR_WIDTH: "Label column width (%)",
    GANTT_DURATION_UNIT: "Duration unit",
    GANTT_EXCLUDE_WEEKENDS: "Exclude weekends from durations",
    GANTT_NO_COLUMN_YET: "Add columns to the widget first, then assign their roles.",
    GANTT_PICK_COLUMNS:
      "Choose the label column and the start date column in the widget configuration.",
    GANTT_SKIPPED_ROWS: "rows ignored: no label or no usable start date",
    GANTT_NO_END_ROLE: "No end date column selected: every row is shown as a milestone.",
    GANTT_SAME_COLUMN:
      "The same column is set as start and end date: every bar has zero length.",
    GANTT_ALL_ZERO_LENGTH:
      "Every row has the same start and end date: all bars have zero length.",
    GANTT_REVERSED_ROWS:
      "rows have an end date before the start date — start/end roles may be swapped.",
    GANTT_SKIPPED_ROWS_HINT:
      "A date column used as the first grouping is turned into a display label and can no longer be read as a date.",
    HIDE_VALUES: "Hide values",
    DISPLAY_IN_MULTIPLE_PROGRESS_BAR: "Vertical display",
    BAR: "bar",
    TYPE_LABEL_TEXT: "Type of text display",
    TYPE_LABEL_VALUE: "Type of value display",
    TYPE_EXTERNAL_LABEL_TEXT: "Type of label display",
    CUSTOM_TEXT: "Custom text",
    TEXT_AND_VALUE: "Text and value",
    VALUE_AND_TEXT: "Value and text",
    PERCENT_AND_VALUE: "Percent and value",
    VALUE_AND_PERCENT: "Value and percent",
    VALUE_PERCENT_AND_CUSTOM: "Value, Percent & Custom Text",
    PERCENT: "Percent",
    MINIMUM_DISTANCE_BETWEEN_GRID_LINES: "Minimum distance between grid lines",
    SHOW_ONLY_MIN_AND_MAX: "Show only minimum and maximum",
    SHOW_LABEL: "Show label",
    LABEL_POSITION: "Label position",
    DEFAULT_COLOR: "Default color",
    SLIDER_COLOR: "Slider color",
    SHOW_TOTALS: "Show totals",
    ADD_A_PAGINATION: "Add a pagination",
    PAGINATION_COLOR: "Pagination color",
    NB_LINES_PER_PAGE: "Number of lines per page",
    HEADER_COLOR: "Header color",
    FOOTER_COLOR: "Footer color",
    HEADER_FONT_SIZE: "Header font size",
    HEADER_TEXT_COLOR: "Header text color",
    FOOTER_TEXT_COLOR: "Footer text color",
    DISPLAY_HEAD_CELL_SEPARATOR: "Display header cell separator",
    DISPLAY_LINE_SEPARATOR: "Display line separator",
    DISPLAY_COLUMN_SEPARATOR: "Display column separator",
    TEXT_ALIGNMENT_IN_THE_HEADER: "Text alignment in the header",
    TEXT_ALIGNMENT_IN_THE_FOOTER: "Text alignment in the footer",
    TEXT_ALIGNMENT_IN_COLUMNS: "Text alignment in columns",
    DISPLAY_VALUE_TO_ZERO: "Display value to zero",
    FREEZE_FIRST_COLUMN: "Freeze first column",
    RESIZABLE_COLUMNS: "Resizable columns",
    ENABLE_TOOLTIP_CELL: "Enable tooltip cell",
    CHOOSE_YOUR_COLOR_THEME: "Choose your color theme",
    PALETTE1: "Palette 1",
    PALETTE2: "Palette 2",
    PALETTE3: "Palette 3",
    PALETTE4: "Palette 4",
    PALETTE5: "Palette 5",
    PALETTE6: "Palette 6",
    DECIMAL_NUMBER: "Decimal number",
    THOUSAND_SEPARATOR: "Thousand separator",
    DECIMAL_SEPARATOR: "Decimal separator",
    DOT_OPTION: "Dot",
    COMMA_OPTION: "Comma",
    SHOW_CLOCK_HAND: "Show clock hand",
    LABELS_ROTATION_ON_X_AXE: "Labels rotation on X axe",
    COLOR_EVEN_LINE: "Color even line",
    COLOR_ODD_LINE: "Color odd line",
    DISPLAY_NUMBER_OF_LINE: "Display number of lines",
    NUMBER_OF_LINE: "Number of lines :",
    CUSTOM_SCALE: "Custom Scale",
    AXIS_END: "End axis",
    AXIS_START: "Start axis",
    START_AXIS_TO_ZERO: "Start axis at 0",
    DELIMITED_AXIS_Y_VALUE: "Delimited value y axis",
    SET_AS_MODEL: "Set as model",
    MIN: "Min",
    MAX: "Max",
    HIDE_AXE_X_LABEL: "Hide x axis labels",
    HIDE_AXE_Y_LABEL: "Hide y axis labels",
    WIDGET_SHAPE: "Widget background & shape",
    COLOR_AND_TEXT: "Color and text",
    EXPORT_AND_FULLSCREEN: "Export and fullscreen",
    GRID: "Grid",
    ADVANCED_STYLE: "Advanced Style",
    FEATURES: "Features",
    AXIS: "Axis",
    LEGEND: "Legend",
    LEGEND_LABEL_DISPLAY_TYPE: "Legend label display type",
    ENABLE_TREE_ZOOM: "Activate the tree view zoom",
    ENABLE_NAVIGATION_BAR: "Activate the navigation bar",
    MAX_LEVELS_AT_ONCE: "Number of levels at once",
    INITIAL_VIEW_TEXT: "Text of the initial view",
    TYPE_CENTRAL_TEXT: "Type of central text",
    CENTRAL_LABEL_STYLE: "Central label style",
    CENTRAL_VALUE_STYLE: "Central value style",
    NAME_AND_VALUE: "Name & Value",
    GAUGE_ROUNDING: "Gauge rounding",
    TYPE_MAX_VALUE: "Type of maximum value",
    SUM_OF_ALL: "Sum of all values",
    MAX_VALUE: "Maximum value",
    ANGLE_PRESETS: "Angle presets",
    LINEAR_GAUGE: "Linear Gauge",
    CIRCULAR_GAUGE_75: "Circular Gauge 75%",
    CIRCULAR_GAUGE_100: "Circular Gauge 100%",
    SIDE_MENU_COLOR: "Side menu color",
    SIDE_MENU_COLOR_TEXT: "Side menu text color",
    SIDE_MENU: "Side menu",
    APPLY_THIS_STYLE_TO_ALL_WIDGETS: "Apply this style to all widgets",
    APPLY_STYLE_ON_WIDGET_IS_SUCCESS: "The style has been applied to all of your widgets",
    //MULTITAB WIDGET
    FIRST_SELECT_A_TAB: "First, select a tab",
    TAB_NAME: "Tab name",
    SELECT_YOUR_TAB_NAME: "Select your tab name",
    ICON: "Icon",
    ACTIVE_TABS_EFFECT: "Active tabs effect",
    UNDERLINE: "Underline",
    TABS_ALIGNMENT: "Tabs alignment",
    CENTER: "Center",
    ADD_A_TAB: "Add a tab",
    WIDGET: "Widget",
    SELECT_A_RANGE: "Select a range",
    MINIMAL_COLOR: "Minimal color",
    MAXIMUM_COLOR: "Maximal color",
    MAX_FONT_SIZE: "Maximal font size",
    TOO_MANY_FIELD_CONFIG_RESET:
      "Too many fields selected for this type of widget. Configuration hase been reset",
    ICON_POSITIVE_SELECTED: "Positive icon",
    ICON_POSITIVE_STYLE: "Style of the selected positive icon",
    ICON_NEUTRAL_SELECTED: "Neutral icon",
    ICON_NEUTRAL_STYLE: "Style of the selected neutral icon",
    ICON_NEGATIVE_SELECTED: "Negative icon",
    ICON_NEGATIVE_STYLE: "Style of the selected negative icon",
    VALUE_POSITIVE_STYLE: "Style of the positive value",
    VALUE_NEUTRAL_STYLE: "Style of the neutral value",
    VALUE_NEGATIVE_STYLE: "Style of the negative value",
    COMPARISON_STYLE: "Comparison text style",
    CUSTOM_LABEL_STYLE: "Custom text style",
    PERCENT_OR_DELTA: "Percentage or difference",
    DELTA: "Delta",
    BOLDER: "Bolder",
    BOLD: "Bold",
    NORMAL: "Normal",
    LIGHTER: "Lighter",
    //CHARTS
    pieChart: "Pie",
    semiPieChart: "Semi Pie Chart",
    doublePieChart: "Double Pie Chart",
    doubleSemiPieChart: "Double Semi Pie Chart",
    stackedBar: "Stacked Bar",
    stackedBar100: "Stacked Bar 100",
    horizontalBarChart: "Horizontal Bar Chart",
    horizontal: "Horizontal",
    vertical: "Vertical",
    lineChart: "Curve",
    SINGLE_CURVE: "Single curve",
    stackedArea: "Stacked Area",
    cumulativeLineChart: "Cumulative Curve",
    dropdownList: "Dropdown list",
    counter: "Counter",
    histogram: "Bar Chart",
    pyramide: "Pyramide",
    table: "Table",
    ag_table: "Table",
    gaugeChart: "Gauge Chart",
    multiGauge: "Multi Gauge Chart",
    treeMap: "Tree Map",
    CALENDAR: "Calendar",
    ENTER_DATE: "Enter a date",
    RADAR_CHART: "Radar Chart",
    CARTOGRAPHIE: "Map",
    CARTE: "Map",
    MAPPING_FILTER: "Map Filter",
    BASIC_TEXT: "Text",
    WIDGET_REDIRECT_BUTTON_NAME: "Redirect button",
    WIDGET_IMAGE_NAME: "Image",
    DOUBLE_PROGRESS_BAR: "Progress Bar",
    multiTabWidget: "Multi Tab Widget",
    googleMap: "Google map",
    rangeFilter: "Range Filter",
    multiGauge: "Multi Gauge",
    evolutionWidget: "Evolution",
    heatMap: "HeatMap",
    heatMapRisk: "HeatMap",
    cloudWords: "Word Cloud",
    actualityList: "Actuality List",
    HIERARCHICAL_FILTER: "Hierarchical filter",
    // FULLSCREEN
    EXIT_FULLSCREEN_MODE: "Exit Fullscreen Mode",
    // CALENDAR
    FROM: "from",
    TO: "to",
    TO: "to",
    TO_V3: "to",
    TO_ADD: "To add",
    ALREADY_PRESENT: "Already present",
    REMAININGS: "Remainings",
    PLEASE_ADD_ONE_PIECE_AT_LEST: "Please add at least one piece of data before validating.",
    NUMBER_EXCEEDS_LIMIT: "The number of samples exceeds the allowed limit.",
    TO_V2: "to",
    SELECTION_OF_AN_ANALYSIS_PERIOD: "Selection of an analysis period",
    SELECT_A_COMPARISON_PERIOD: "Select a comparison period",
    YOU_DID_NOT_SELECT_ANALYSIS_PERIOD: "You did not select analysis period",
    // Mosaique des dashboards
    labelMosaique1: "My Dashboards",
    labelMosaique2: "Shared Dashboard",
    buttonMosaique: "New Dashboard",
    SET_TO_HOME_PAGE: "Set to Home Page",
    MODIFY_THUMBNAIL: "MODIFY THUMBNAIL",
    AUTOMATIC_SCREENSHOT: "Automatic screenshot",
    IMAGE: "Image",
    THUMBNAIL_TYPE: "Thumbnail type",
    ADD_IMAGE: "ADD IMAGE",
    // Dashboard Part
    buttonDashboard1: "Edit this dashboard",
    buttonDashboard2: "New Dashboard",
    buttonDashboard3: "Confirm changes",
    buttonDashboard4: "New Widget / Module",
    buttonDashboard5: "Add a filter",
    emptyWidget: "Select the data to be displayed",
    labelWidgetSetting1: "Add a title",
    labelWidgetSetting2: "Comparison period",
    labelWidgetSetting3: "Widget Size",
    labelWidgetSetting4: "Recently used files",
    labelWidgetSetting5: "Select data",
    labelWidgetSetting6: "Filters",
    labelWidgetSetting7: "Filter example",
    labelWidgetSetting8: "Formulas",
    widgetSize1: "Little",
    widgetSize2: "Average",
    widgetSize3: "High",
    buttonWidgetSetting1: "Select file",
    buttonWidgetSetting2: "Add a filter",
    buttonWidgetSetting3: "Add a calculation",
    labelFormule1: "Sheets in your files",
    labelFormule2: "Formula",
    CONFIRM_DATA: "Confirm Data",
    titleNewWidget: "Widget List",
    MOVE_UP: "Move up",
    MOVE_DOWN: "Move down",
    // No Data
    OUPS_AN_ERROR_OCCURED: "Oups, an error occurred",
    YOUR_APP_DOES_NOT_CONTAIN_ANY_DATA: "Your application does not yet contain any data.",
    NO_PAGE_YET: "You have not yet published any pages.",
    NO_SOURCE_YET: "You have not yet imported a source.",
    NO_SOURCE_IN_DIRECTORY: "You have no sources in this directory.",
    CREATE_FIRST_PAGE: "Create my first page",
    IMPORT_FIRST_SOURCE: "Import first source",
    GET_STARTED_QUESTION: "How about you get started?",
    NO_DATA_REPONSE: "No Response to this check",

    FIRST_OPERATION: "first operation",
    SECOND_OPERATION: "second opération",
    THIRD_OPERATION: "third opération",
    FOURTH_OPERATION: "Fourth opération",
    FIFTH_OPERATION: "Fifth opération",
    I_ADD_A_NEW_OPERATION: "I add a new operation",
    ADD_A_CONDITION: "add a condition",
    OPERATION: "Operation",
    OPERATIONS: "Operations",
    SEARCH_AN_OPERATION: "Search an operation",
    I_STOP_HERE: "I stop here",
    BROWSE_OPERATIONS: "Browse Operations",
    VALIDATE_ADDITION: "Validate the addition",
    ON_DATAS: "on datas",
    FIELD_NAME: "field name",
    OUTPUT_FIELD: "Output field",
    OUTPUT_VALUE: "Output value",
    REOPEN_ANSWER: "Reopen the answer",
    identity: "identity",
    mean: "average",
    max: "maximum",
    min: "minimum",
    sum: "sum",
    sub: "substraction",
    std: "standard deviation ",
    prod: "multiplication",
    count: "count",
    div: "division",
    COUNT_DISTINCT: "Count - Distinct",
    overallPercentage: "group percentage",
    cumPercentage: "data percentage",
    LIST: "List",
    SOURCE: "Source",
    ACTIVE: "Active",
    THIS_FUNCTIONALITY_IS_NOT_AVAILABLE_YET: "This functionality is not available yet",
    DISPLAY_LABEL: "Display label",
    DISPLAY_LABEL_AND_COLOR: "Display label and color",
    DISPLAY_VALUE_AND_COLOR: "Display value and color",
    DISPLAY_MODE: "Display mode",
    WIDGET_FILTER_HIERARCHY_PLACEHOLDER: "Filter by hierarchy",
    SELECTED: "selected",
    DISPLAY_MODE_SELECTOR: "Selector (dropdown)",
    DISPLAY_MODE_TREE: "Expanded tree",
    HIERARCHY_CLICK_MODE: "Click on an entity",
    WIDGET_DESCRIPTION: "Description (tooltip)",
    HIERARCHY_CLICK_MODE_BRANCH: "Checks the entity and its children",
    HIERARCHY_CLICK_MODE_CYCLE: "Three steps: entity alone, with its children, none",
    DISPLAY_MODE_PERSONALIZATION: "Display mode personalization",
    NO_CONFIG_YET: "No configuration yet",
    // Datas part
    MANAGE_SOURCES: "Manage sources",
    MANAGE_RELATIONS: "Manage relations",
    TRANSFORM_DATAS: "Transform datas",
    PREPARE_DATAS: "Prepare my datas",
    FORMULAS: "Formulas",
    EXPLORE_DATACATALOGUE: "Explore datacatalogue",
    DATACATALOGUE: "Datacatalogue",
    MANAGE_YOUR_DATA_TEXT_CONTENT:
      "Manage your data sources, make new connections and enrich your application.",
    TRANSFORM_TEXT_CONTENT: "Get the best out of your data by combining your different fields.",
    PREPARE_TEXT_CONTENT:
      "Get the best out of your data by combining or distinguishing your different fields",
    ANALYSE: "Analyse",
    ANALYSE_YOUR_DATA_TEXT_CONTENT: "Analyze your data, detect anomalies and correlations ...",
    STRUCTURE: "Structure",
    STRUCTURE_YOUR_DATA_TEXT_CONTENT: "Select fields from your ressources to create data table",
    MANAGE_TABLE: "Manage tables",
    VISUALIZE_TEXT_CONTENT:
      "Consult the available fields and prepare your data for integration into your pages.",
    USE_ALGORITHMS_ML_TEXT_CONTENT: "Use algorithms to learn more about your data.",
    USE_RELATION_TEXT_CONTENT: "Create relationships between your tables",
    ENTER_A_NAME_FOR_YOUR_ANALYSIS: "Enter a name for your analysis",
    //SOURCES
    YOU_ASSOCIATION_MUST_BE_CONTAIN_A_TITLE: "Your association must be contain a title",
    YOU_MUST_BE_SELECTIONNATE_ONE_DIFFERENT_FIELD: "You must be selectionnate one different field",
    LINK_IDENTIC_FIELD_FROM_EACH_SOURCE: "Link identic field from each source",
    NAME_OF_MY_ASSOCIATION: "Name of my association",
    SELECT_SOURCES: "Select sources",
    COLUMN_CHOICES: "Columns choices",
    ADD_COLUMN: "Add columns",
    RELOAD: "Reload",
    SOURCE_ASSOCIATION: "Link my sources",
    SELECT_SOURCE_TO_ASSOCIATE: "Select sources to associate",
    MAKE_SURE_THAT_THERE_IS_AN_IDENTICAL_FIELD_IN_EACH_OF_THE_CHOSEN_SOURCES:
      "Make sure that there is an identical field in each of the chosen sources",
    YOUR_DATASOURCE_IS_CREATED_BUT_YOUR_DATA_ARE_STILL_LOADING:
      "Your datasource is created, the loading of your data is in progress. You will be notified when your data is available",
    DATA_FROM_THE_DATASOURCE_IS_BEING_INTEGRATED:
      "Your data from the datasource is being integrated",
    INTEGRATION_OF_YOUR_DATA_IS_FINISHED_YOU_CAN_NOW_ACCESS_YOUR_DATA:
      "Your data integration is complete. You can now have access to your datasource",
    seeDatacatalogue: "SEE MY DATACATALOGUE",
    ADD_A_SOURCE: "ADD A SOURCE",
    ADD_NEW_ROW: "ADD A NEW ROW",
    ARE_YOU_SURE_TO_DELETE_THIS_ROW: "Are you sure you want to delete this row ?",
    WARNING_COLUMN_NAME_ALREADY_EXIST: "Warning this column name already exists",
    WARNING_COLUMN_NAME_EMPTY: "Warning the column name cannot be empty",
    WARNING_MESSAGE_EMPTY: "Warning the message is empty",
    CONFIRM: "Confirm",
    I_UNDERSTAND: "I understand",
    TYPE: "Type",
    ALL_MASCULINE: "All",
    ALL_FEMININE: "All",
    ADD_DATA: "ADD DATA",
    ADD_NEW_COLUMN: "Add new Column",
    NEW_COLUMN: "New Column",
    COLUMN: "Column",
    COLUMNS: "Columns",
    CURRENT_COLUMNS: "Current columns",
    WHICH_COLUMN_DO_YOU_WANT_TO_DELETE: "Which column do you want to delete ?",
    DELETE_COLUMN: "Delete Column",
    DEFAULT_VALUE: "Default Value",
    TRUE: "True",
    FALSE: "False",
    DISABLED: "Disabled",
    ACTIVATED: "Activated",
    FIELDS: "Fields",
    LINES: "Lines",
    UPDATED_THE: "Date updated",
    UPDATED_ON: "Updated on",
    searchSourceType: "Find a source type",
    UPLOAD_YOUR_FILE: "Upload your file",
    FIELD_DEFINITIONS: "Field definitions",
    WHAT_IS_THE_DELIMITER_OF_YOUR_FILE: "What is the delimiter of your file",
    COMMA: "Comma",
    SEMICOLON: "Semicolon",
    OTHER_DELIMITER: "Other delimiter",
    NO_DATA_AVAILABLE: "No data available",
    NO_DATA_AVAILABLE_CHOOSE_A_FILE: "No data available, choose a CSV file",
    CHOOSE_A_FILE_CSV: "Choose a file CSV",
    CSV_HAS_BEEN_LOADED: "CSV has been loaded",
    INPUT_PLACEHOLDER_NAME_SOURCE: "Enter here the name to give to this source",
    NAME_FIELD: "FIELD NAME",
    TYPE_FIELD: "TYPE",
    ADD_YOUR_FILE: "Add your file",
    ADD_FILE: "Add a file",
    REPLACE_FILE: "Replace the file",
    REPLACE_DATASOURCE: "Replace datasource",
    REPLACE_SOURCE_CONTENT_OR_ADD_LINE: "Replace the content of your source or add lines",
    ADD_LINES: "Add lines",
    FILE_NAME: "Filename",
    SIZE: "Size",
    DATA_UPDATE: "Data update",
    MOVE_TO: "Move to",
    RENAME: "Rename",
    REMOVE_FROM_FOLDER: "Remove from Folder",
    CANT_MOVE_PAGE_ONLY_ONE_FOLDER_AVAILABLE: "Can't move page. Only one folder available",
    BACK: "Back",
    NB_COLUMNS: "Number of Columns",
    NB_LINES: "Number of Lines",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ACTUALITY:
      "Are you sure, you want to delete this actuality ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_GOVERNANCE:
      "Are you sure, you want to delete this governance ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_SOURCE: "Are you sure, you want to delete this source ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_RISK: "Are you sure, you want to delete this risk ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_RISK_RESIDUAL:
      "Are you sure, you want to delete this risk residual?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CONTROL:
      "Are you sure, you want to delete this contrôle ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CHECKPOINT:
      "Are you sure, you want to delete this checkpoint ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEMPLATE:
      "Are you sure, you want to delete this template ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_SOURCE_IS_USED:
      "Attention the fields of this source are used in your widgets, if you delete this source the concerned widgets will have to be reconfigured. Are you sure you want to delete this source?",
    AT_LEAST_ONE_COLUMN_HAVE_TO_BE_SELECTED: "At least one column have to be selected",
    YOU_NEED_TO_ADD_A_FILE: "You need to add a file",
    YOU_NEED_TO_ENTER_A_SOURCE_NAME: "You need to enter a source name",
    NEW_SOURCE_NAME: "New source name",
    NO_SOURCES_FOUND: "No sources found",
    FIND_A_SOURCE: "FIND A SOURCE",
    WARNING_FIELDS_TYPE: "The selected fields must be of the same type",
    WARNING_DIRECTORY_MANDATORY:
      "Please note that the name of the directory must contain at least three characters to validate the creation !",
    WARNING_BEFORE_DELETE_DIRECTORY:
      "This directory contains sources, do you really want to delete it?",
    DOWNLOAD: "Download",
    DOWNLOADING_FILE: "Downloading",
    ERROR_DOWNLOADING_FILE: "An error occurred while downloading the file",
    FILE_NOT_FOUND: "File not found",
    REPERTORIES: "Repertories",
    JODITEDITOR: "Text editor",
    //TABLES
    TABLES: "Tables",
    TABLE: "Table",
    ADD_A_TABLE: "Add a table",
    LINKED_RESSOURCES: "Linked ressources",
    REQUEST: "Requests",
    //RELATION
    RELATIONS: "Relations",
    MY_RELATIONS_ONE_TO_ONE: "Relations 1 - 1",
    MY_RELATIONS_MULTIPLE: "Relations multiples",
    SOURCE_NAME: "Source name",
    RELATION_NAME: "Nom de la relation",
    LEFT_SOURCE: "Left source",
    RIGHT_SOURCE: "Right source",
    FIELD_FROM_LEFT_SOURCE: "Field from left source",
    FIELD_FROM_RIGHT_SOURCE: "Field from right source",
    NEW_RELATION: "New relation",
    ALL_RELATIONS: "All relations",
    SORT_DIAGRAM: "Sort automatically the diagram",
    //ADD_SOURCE
    SHEET_SELECTION: "Sheet selection",
    SELECT_FILE_TYPE: "Select file type",
    //SOURCES
    SUCCESS_TO_CREATE_SOURCE_FOLDER: "The source folder has been successfuly created",
    SUCCESS_TO_GET_SOURCE_FOLDERS: "The source folders are been succesfully recovered",
    FAIL_TO_CREATE_SOURCE_FOLDER: "Fail to create source folder",
    SUCCESS_TO_DELETE_SOURCE_FOLDER: "The source folder has been successfuly deleted",
    //DATACATALOGUE
    ALIAS: "ALIAS",
    FIELD_TITLE: "FIELD TITLE",
    FIELD_TYPE: "FIELD TYPE",
    LAST_UPDATE: "LAST UPDATE",
    nbRowsLengthText: "results",
    selectRowCountText: "selected rows",
    groupByText: "Group by",
    customButtonTitle: "add a field",
    USE_THESE_FIELDS: "Use these fields",
    USE_THIS_FIELD: "Use this field",
    BOOLEAN: "Boolean",
    INTEGER: "Integer",
    NUMBER: "Number",
    DATE: "Date",
    IMPLEMENTATION_DATE: "Implementation date",
    STRING: "String",
    ARRAY: "List",
    ZIP_CODE_FR: "Zip Code FR",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_FIELD: "Are you sure, you want to delete this field ?",
    FIELDS_FROM_DIFFERENT_SOURCES_HAVE_BEEN_SELECTED:
      "Fields from different sources have been selected",
    FIELD_NOT_FOUND: "Field not found",
    NEW_FIELD_NAME: "New field name",
    ALL_DATACATALOGUE: "All datacatalogue",
    TABLES: "Tables",
    MAJ_DATACATALOGUE: "Updated ago",
    DAY_DATACALOGUE: "days",
    //ANALYSIS & ML
    ANALYSIS_NAME: "Analysis name",
    COLUMNS_IDENTIFY_SAMPLES: "Columns identifying the samples",
    COLUMNS_CAN_BE_ASSOCIATED_NEW_DATA: "Columns that can be associated with new data",
    ANALYSIS_TYPE: "Analysis type",
    START_ANALYSIS: "Start analysis",
    CREATED_THE: "Date created",
    AUTHOR: "Author",
    STATUS: "Status",
    ACTIONS: "Actions",
    CREATE_AN_ANALYSIS: "Create an analysis",
    SHOW_ANALYSE: "Show analysis",
    DELETE_ANALYSIS: "Delete analysis",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ANALYSIS:
      "Are you sure you want to delete this analysis ?",
    TEXT_SUMMARY: "Text summary",
    TOPIC_MODELING: "Topic modeling",
    SENTIMENT_ANALYSIS: "Sentiment analysis",
    EMOTIONAL_LABELING: "Emotionnal labeling",
    TEXT_SUMMARY_DESCRIPTION: "Text summary description",
    TOPIC_MODELING_DESCRIPTION: "Topic modeling description",
    SENTIMENT_ANALYSIS_DESCRIPTION: "Sentiment analysis description",
    EMOTIONAL_LABELING_DESCRIPTION: "Emotionnal labeling description",
    CHANGE_ANALYSE_TYPE: "Change analyse type",
    QUICKLY_GET_A_SUMMARY_OF_YOUR_CORPUS: "Quickly get a summary of your corpus",
    DETERMINE_THE_MAIN_SUBJECTS_PRESENT_IN_YOUR_CORPUS:
      "Determine the main subjects present in your corpus",
    PREDICT_AN_OPINION_FROM_COMMENTS: "Predict an opinion from comments",
    DETECT_THE_EMOTIONS_PRESENT_IN_YOUR_DATA: "Detect the emotions present in your data",
    PARAMETERS: "Parameters",
    RESULT: "Result",
    RESULTS: "Results",
    NAME: "Name",
    DATA_FIELD_CHOICE: "Data field choice",
    SUCCESS: "Success",
    FAILURE: "Failure",
    IN_PROGRESS: "In progress",
    DONE: "Done",
    TODO: "To do",
    DONE_FEMALE: "Done",
    ABANDONED_FEMALE: "Abandoned",
    ANALYSIS_FAILED: "Analysis failed",
    ANALYSIS_IN_PROGRESS: "Analysis in progress",
    REFRESH_PAGE_IN_SECONDS: "Refresh the page in a few seconds",
    INITIAL_TEXT: "Initial text",
    SUMMARY_FOR: "Summary for",
    DATA_SELECTION: "Data selection",
    ENTER_A_NUMBER: "Enter a number",
    WORDS_NUMBER: "Words number",
    TOPICS_NUMBER: "Topics number",
    ALLOWED_VALUES: "allowed values",
    OR: "OR",
    //error form backend
    ERROR: "Error",
    DATA_COLUMNS_DONT_MATCH_THE_CURRENT_REFERENTIAL:
      "Some columns in the imported file do not match the referential",
    ACCEPT_ONLY_CSV: "Accept only CSV",
    CREATE_ACCOUNT_ERROR: "Error creating profile",
    GET_BUSINESS_INFORMATIONS_ERROR: "Error get business informations",
    FETCHED_USERS_ERROR: "Error create business",
    CREATE_BUSINESS_USER_ERROR: "You can't create a user",
    DELETE_BUSINESS_USER_ERROR: "You can't delete a user",
    UPDATE_BUSINESS_USER_ERROR: "You can't update a user",
    ERROR_GET_USER: "Problem to get user.",
    ERROR_CANNOT_DELETE_USER: "Problem to delete user",
    ERROR_CANNOT_UPDATE_USER: "Problem to update user",
    CREATE_BUSINESS_ROLE_ERROR: "You can't create a role",
    UPDATE_BUSINESS_ROLE_ERROR: "You can't update a role",
    CANNOT_DELETE_ROLE: "Vous ne pouvez pas supprimer ce rôle, des utilisateurs y sont liés",
    DELETE_BUSINESS_ROLE_ERROR: "You can't delete a role",
    CANT_FIND_PAGE_THUMBNAIL: "Can't find page Thumbnail",
    CANT_FIND_BUSINESS_LOGO: "Can't find business logo",
    CANT_FIND_IMAGE: "Can't find image",
    YOUR_LOGIN_DETAILS_ARE_WRONG: "Your login details are wrong",
    YOUR_EMAIL_IS_UNKNOWN: "Your email is unknown",
    BAD_OLD_PASSWORD: "Bad old password.",
    WIDGET_ID_TO_DELETE_IS_EMPTY: "Widget to delete is empty",
    FAIL_TO_GET_CSV_STREAM: "Fail to get csv file information",
    FAIL_TO_GET_EXCEL_STREAM: "Fail to get excel file information",
    FAIL_TO_ADD_CSV_FILE: "Fail to get csv file information",
    SUCCESS_DELETE_COLUMN: "Your column has been deleted successfully",
    TOKEN_EXPIRED: "The access token is expired, please reconnect",
    WRONG_TOKEN: "Wrong token",
    BAD_TOKEN: "A problem happened with your token",
    CREATE_BUSINESS_SUCCESS: "Success create business",
    CREATE_BUSINESS_ERROR: "Error create business",
    FAIL_TO_ADD_DATA: "An error occurred while adding the data",
    DATA_HAS_BEEN_ADD: "The data has been added successfully",
    //Back - Profil
    SUCCES_CREATE_PROFILE: "The user's account has been successfully created",
    ERROR_CREATE_PROFILE: "We encountered an error while adding the user",
    SUCCES_DELETE_PROFILE: "Your deletion has been taken into account",
    ERROR_DELETE_PROFILE: "We were unable to delete the user",
    SUCCES_UPDATE_PROFILE: "The user's account has been successfully modified",
    ERROR_UPDATE_PROFILE: "We encountered an error while modifying the user",
    SUCCESS_TO_CREATE_BUSINESS: "Your business has been successfully created",
    SUCCESS_TO_GET_ALL_BUSINESS: "All of your business are been retrieving successfully",
    FAIL_TO_CREATE_BUSINESS: "The creation of business has been failed",
    FAIL_TO_GET_BUSINESS: "The recovery of business has been failed",
    FAIL_TO_UPDATE_BUSINESS: "We encountered an error while modifying your business",
    SUCCESS_TO_UPDATE_BUSINESS: "The business has been successfully modified",
    FAIL_TO_CREATE_ROLE: "We encountered an error while adding the new role",
    SUCCESS_TO_CREATE_ROLE: "Your role has been added",
    FAIL_TO_UPDATE_ROLE: "We encountered an error while changing the role",
    SUCCESS_TO_UPDATE_ROLE: "The role has been changed",
    FAIL_TO_DELETE_ROLE: "We were unable to remove the role",
    SUCCESS_TO_DELETE_ROLE: "Your deletion has been taken into account",
    FAIL_TO_DELETE_BUSINESS_ROLE: "Fail to delete business role",
    FAIL_TO_GET_BUSINESS_INFORMATIONS: "Fail to get business information",
    FAIL_TO_GET_USERS: "Fail to get users",
    FAIL_TO_GET_USERS_NAMES: "Fail to get users names",
    FAIL_TO_GET_USER: "Fail to get user",
    FAIL_TO_UPDATE_USER: "Fail to update user",
    SUCCESS_TO_UPDATE_USER: "Success to update user",
    SUCCESS_TO_GET_USERS_NAMES: "Success to get users names",
    FAIL_TO_DELETE_PAGE: "We were unable to delete your page",
    SUCCESS_TO_DELETE_PAGE: "Your deletion has been taken into account",
    FAIL_TO_GET_PAGE_PERMISSION: "Fail to get page permission",
    SUCCESS_TO_GET_PAGE_PERMISSION: "Success to get page permission",
    FAIL_TO_GET_PAGE_PERMISSION_BY_USER: "Fail to get page permission by user",
    SUCCESS_TO_GET_PAGE_PERMISSION_BY_USER: "Success to get page permission by user",
    FAIL_TO_GET_PAGE_PERMISSION_BY_PAGE_ID: "Fail to get page permission by page id",
    SUCCESS_TO_GET_PAGE_PERMISSION_BY_PAGE_ID: "Success to get page permission by page id",
    FAIL_TO_GET_A_PAGE_PERMISSION: "Fail to get a page permission",
    SUCCESS_TO_GET_A_PAGE_PERMISSION: "Success to get a page permission",
    FAIL_TO_PATCH_PAGE_PERMISSION: "Fail to update page permission",
    SUCCESS_TO_PATCH_PAGE_PERMISSION: "Success to update page permission",
    FAIL_TO_CHECK_PAGE_PERMISSION: "Fail to check page permission",
    SUCCESS_TO_CHECK_PAGE_PERMISSION: "Success to check page permission",
    FAIL_TO_GET_PAGES: "Fail to get pages",
    SUCCESS_TO_GET_PAGES: "Success to get pages",
    SUCCESS_TO_GET_PAGES_BY_USER: "Success to get pages by user",
    FAIL_TO_GET_PAGE_BY_PAGE_ID: "Fail to get pages by pageID",
    SUCCESS_TO_GET_PAGE_BY_PAGE_ID: "Success to get pages by pageID",
    FAIL_TO_PATCH_A_PAGE: "We were unable to save your changes",
    SUCCESS_TO_PATCH_A_PAGE: "Your changes have been taken into account",
    SUCCESS_TO_UPDATE_ANOMALY: "The issue has been successfully modified",
    FAIL_TO_UPDATE_ANOMALY: "Fail to update issue",
    SUCCESS_ADD_PAGE_FOLDER: "Page folder has been add successfully",
    FAIL_TO_ADD_PAGE_FOLDER: "We encountered an error while adding the page folder",
    SUCCESS_GET_PAGE_FOLDER: "The recovery of page folder is a success",
    ERROR_GET_PAGE_FOLDER: "Fail to recovered page folder",
    SUCCESS_UPDATE_PAGE_FOLDER: "The page folder has been updated successfully",
    FAIL_UPDATE_PAGE_FOLDER: "Fail to update page folder",
    SUCCESS_DELETE_PAGE_FOLDER: "The page folder has been deleted successfully",
    FAIL_DELETE_PAGE_FOLDER: "Fail to delete page folder",
    FAIL_TO_CLEAR_FULL_PAGE: "Fail to delete full page",
    FAIL_TO_DELETE_PAGE_PERMISSION: "Fail to delete page permission",
    FAIL_TO_DELETE_WIDGETS: "Fail to delete widgets",
    FAIL_TO_GET_WIDGETS_BY_PAGE_ID: "Fail to get widgets by page id",
    SUCCESS_TO_GET_WIDGETS_BY_PAGE_ID: "Success to get widgets by page id",
    FAIL_TO_CREATE_MULTIPLE_WIDGET: "Fail to create multiple widget",
    SUCCESS_TO_CREATE_MULTIPLE_WIDGET: "Success to create multiple widget",
    SUCCESS_TO_DELETE_WIDGETS: "Success to delete widgets",
    FAIL_TO_GET_A_WIDGET: "Fail to get widget",
    SUCCESS_TO_GET_A_WIDGET: "Success to get widget",
    SUCCESS_TO_DELETE_RELATION: "The relationship has been successfully deleted",
    SUCCESS_TO_GET_RELATIONS: "The relations are been succesfully recovered",
    FAIL_TO_DELETE_RELATION: "Fail to delete relation",
    SUCCESS_TO_PATCH_RELATION: "Success to patch relation",
    FAIL_TO_PATCH_RELATION: "Fail to patch relations",
    SUCCESS_TO_POST_ANOMALY: "The issue has been successfully created",
    SUCCESS_TO_CREATE_GROUP: "The group was successfully created",
    FAIL_TO_CREATE_GROUP: "Failed to create group",
    SUCCESS_TO_CREATE_TASK: "The task was successfully created",
    FAIL_TO_CREATE_TASK: "Failed to create task",
    SUCCESS_TO_UPDATE_TASK: "Task successfully updated",
    FAIL_TO_UPDATE_TASK: "Error updating task",
    SUCCESS_TO_POST_INCIDENT: "L'incident a été crée avec succès",
    SUCCESS_TO_UPDATE_INCIDENT: "Incident successfully updated",
    FAIL_TO_UPDATE_INCIDENT: "Error updating incident",
    FAIL_TO_POST_INCIDENT: "Échec de la création du l'incident",
    FAIL_TO_GET_GROUP: "Failed to recovered group",
    SUCCESS_TO_GET_GROUPS: "Groups are recovered with success",
    SUCCESS_TO_UPDATE_GROUP: "Group updated successfully",
    SUCCESS_TO_GET_USER_GROUP: "The recovered of user group has been successfull",
    FAIL_TO_GET_USER_GROUP: "Failed to recovered user group",
    FAIL_TO_UPDATE_GROUP: "We encountered an error updating the group",
    SUCCESS_TO_GET_GROUPS_BY_BUSINESS_ID:
      "The recovery of groups by business id has been successfull",
    FAIL_TO_GET_GROUPS_BY_BUSINESS_ID: "We encountered an error to get groups by business id",
    SUCCESS_TO_ASK_FOR_ACTION_PLAN_VALIDATION:
      "Action plan validation request completed successfully",
    FAIL_TO_ASK_FOR_ACTION_PLAN_VALIDATION:
      "We encountered an error requesting action plan validation",
    SUCCESS_TO_VALIDATE_ACTION_PLAN: "Action plan validation was successful",
    FAIL_TO_VALIDATE_ACTION_PLAN: "We encountered an error validating the action plan",
    //Back - Widget
    FAIL_TO_UPDATE_WIDGET: "We were unable to update your widget",
    SUCCESS_TO_UPDATE_WIDGET: "Your widget has been successfully updated",
    FAIL_TO_CREATE_DATACATALOGUE: "Fail to create datacatalogue",
    SUCCESS_TO_CREATE_DATACATALOGUE: "Success to create datacatalogue",
    FAIL_TO_REQUEST_DATA: "We encountered an error while requesting your data",
    SUCCESS_TO_REQUEST_DATA: "Success to request data",
    FAIL_TO_GET_ALL_DATACATALOGUE_META_INFO: "Fail to get all datacatalogue meta informations",
    SUCCESS_TO_GET_ALL_DATACATALOGUE_META_INFO:
      "Success to get all datacatalogue meta informations",
    FAIL_TO_GET_DATACATALOGUE_META_INFO: "Fail to get datacatalogue meta informations",
    SUCCESS_TO_GET_DATACATALOGUE_META_INFO: "Success to get datacatalogue meta informations",
    FAIL_TO_GET_DATACATALOGUE_COLUMN_FIELDS: "Fail to get datacatalogue column/fields",
    SUCCESS_TO_GET_DATACATALOGUE_COLUMN_FIELDS: "Success to get datacatalogue column/fields",
    FAIL_TO_PATCH_DATACATALOGUE_EMPLOYEES_RIGHTS: "Fail to update datacatalogue employees rights",
    SUCCESS_TO_PATCH_DATACATALOGUE_EMPLOYEES_RIGHTS:
      "Success to update datacatalogue employees rights",
    FAIL_TO_PATCH_DATACATALOGUE_TEAMS_RIGHTS: "Fail to update datacatalogue teams rights",
    SUCCESS_TO_PATCH_DATACATALOGUE_TEAMS_RIGHTS: "Success to update datacatalogue teams rights",
    SUCCESS_TO_GET_CSV_STREAM: "Success to get CSV file informations",
    SUCCESS_TO_GET_EXCEL_STREAM: "Success to get Excel file informations",
    FAIL_TO_GET_DATASOURCES: "Fail to get datasources",
    SUCCESS_TO_GET_DATASOURCES: "Success to get datasources",
    SUCCESS_TO_GET_FILE_OVERVIEW: "Success to get file overview",
    FAIL_TO_GET_FILE_OVERVIEW: "We encountered an error while loading your source",
    //Back - Datasource
    SUCCESS_TO_POST_NEW_RELATION: "The new relation has been created successfully",
    FAIL_TO_POST_NEW_RELATION: "The new relationship could not be created",
    SUCCESS_TO_POST_DATASOURCES: "Your file has been added",
    FAIL_TO_POST_DATASOURCES: "We encountered an error while adding your source",
    SUCCESS_TO_DELETE_DATASOURCE: "Your deletion has been taken into account",
    FAIL_TO_DELETE_DATASOURCE: "We were unable to remove your source",
    SUCCESS_TO_PATCH_DATASOURCE: "Your update has been taken into account",
    FAIL_TO_PATCH_DATASOURCE: "We were unable to update your source",
    FAIL_TO_ADD_FIELD_DATASOURCE: "We encountered an error while adding a new field in your source",
    SUCCESS_TO_ADD_FIELD_DATASOURCE: "Your field has been successfully added",
    //Back - FIELDS
    SUCCESS_TO_PATCH_FIELD: "Your field has been successfully modified",
    FAIL_TO_PATCH_FIELD: "We encountered an error while modifying your field",
    //Back - SHARE
    SUCCESS_ADD_PAGE_PERMISSION: "Your file has been successfully shared",
    FAIL_TO_ADD_PAGE_PERMISSION: "We encountered an error while sharing your page",
    //Back - PIPELINE
    SUCCESS_TO_DELETE_PIPELINE: "Your analysis has been successfully deleted",
    FAIL_TO_DELETE_PIPELINE: "We encountered an error while deleting your analysis",
    FAIL_TO_CREATE_PIPELINE: "Your analysis has been successfully created",
    SUCCESS_TO_CREATE_PIPELINE: "We encountered an error while creating your analysis",

    SUCCESS_TO_ADD_CSV_FILE: "Success to add CSV file",
    FAIL_TO_ADD_EXCEL_FILE: "Fail to add Excel file",
    SUCCESS_TO_ADD_EXCEL_FILE: "Success to add Excel file",
    UPLOAD_IMAGES_SUCCESS: "Success to upload image",
    NO_PAGE_ID_PROVIDED: "No page Id provided",
    SUCCESS_TO_UPLOAD_IMAGE: "Success to upload image",
    SUCCESS_TO_UPDATE_PASSWORD: "Fail to update password",
    SUCCESS_CREATE_PASSWORD: "Your password has been created successfully",
    SUCCESS_UPDATE_PASSWORD: "Your password has been changed successfully",
    FAIL_UPDATE_PASSWORD: "Your password is incorrect",
    SUCCESS_TO_CREATE_WIDGET: "Success to create widget",
    FAIL_TO_CREATE_WIDGET: "Fail to create widget",
    //Back - Pages
    SUCCESS_TO_CREATE_YOUR_PAGE: "Your page has been created successfully",
    SUCCESS_TO_CREATE_PIPELINE_PAGE: "Your planer has been created successfully",
    DELETE_PAGE_WHILE_FAILED_TO_CREATE_PAGE_PERMISSION: "Fail to create page permission",
    MULTIPLE_ERROR_DURING_PAGE_CREATION: "Fail to create page",
    FAIL_TO_CREATE_PAGE: "We encountered an error while creating your page",
    SUCCESS_TO_DUPLICATE_PAGE: "Your page has been successfully duplicated",
    FAIL_TO_DUPLICATE_PAGE: "We encountered an error while duplicating your page",
    //CONFIRMATION MESSAGE
    YOU_DONT_HAVE_RIGHTS_TO_ACCESS_THIS_PAGE:
      "It seems that you don't have rights to access this page",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_PAGE: "Are you sure you want to delete this page ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_FOLDER: "Are you sure you want to delete this folder ?",
    THIS_FUNCTIONNALITY_IS_NOT_AVAILABLE_YET: "This functionnality is not available yet",
    ARE_YOU_SURE_YOU_WANT_TO_DUPLICATE_WIDGET: "Are you sure you want to duplicate this widget ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_WIDGET: "Are you sure you want to delete this widget ?",
    WOULD_YOU_LIKE_TO_CHANGE_PAGE_AND_LOSE_MODIFICATION:
      "Are you sure you want to change page ? Non-saved modifications will be lost",
    IMPOSSIBLE_TO_SAVE_PAGE_WITH_EMPTY_TITLE: "Impossible to save page with empty title",
    // ColorPalettes
    SUCCESS_TO_UPDATE_BUSINESS_DEFAULT_PALETTE: "Default business palette updated",
    SUCCESS_TO_CREATE_PALETTE: "Your color palette has been added successfully",
    SUCCESS_TO_GET_PALETTE: "Your color palette has been retrieving successfully",
    FAIL_TO_CREATE_PALETTE: "An error occurred while creating the color palette",
    FAIL_TO_GET_PALETTE: "An error occurred while retrieving your color palette",
    FAIL_TO_UPDATE_BUSINESS_DEFAULT_PALETTE:
      "An error occured while updating your business default color palette",
    MISSING_FIELDS_TO_CREATE_PALETTE: "Some fields needed to create the color palette are missing",
    SUCCESS_TO_UPDATE_PALETTE: "Your color palette has been updated successfully",
    FAIL_TO_UPDATE_PALETTE: "An error occurred while modifying the color palette",
    SUCCESS_TO_DELETE_PALETTE: "Your color palette has been successfully deleted",
    FAIL_TO_DELETE_PALETTE: "An error occured while deleting the color palette",
    SUCCESS_TO_GET_BUSINESS_PALETTE: "Your business color palette has been retrieving succesfully",
    FAIL_TO_GET_BUSINESS_PALETTE: "An error occurred while retrieving the business color palettes",
    SUCCESS_TO_GET_PUBLIC_PALETTE: "Your public color palette has been retrieving successfully",
    FAIL_TO_GET_PUBLIC_PALETTE: "An error occurred while retrieving the public color palettes",
    ARCHIVE: "Archive",
    DELETE: "Delete",
    ACTIVE: "Active",
    DUPLICATE: "Duplicate",
    DUPLICATE_ANOTHER_PAGE: "Duplicate to another page",
    DUPLICATE_WIDGET_TO: "Move widget to...",
    COPY: "Copy",
    MODYFY_THUMBNAIL: "Modify thumbnail",
    NEW_PAGE: "New Page",
    NEW_FOLDER: "New Folder",
    PAGES: "Pages",
    FOLDERS: "Folders",
    FOLDER: "Folder",
    SPECIFIC_PAGES: "Specific Pages",
    MOVE_PAGE_TO: "Move page to ...",
    PAGE_LIST: "Page List",
    PAGE_SCREENSHOTS_ARE_TEMPORARILY_UNAVAILABLE: "Page screenshots are temporarily unavailable",
    CSV_NAME_ALREADY_USED: "The name of the CSV source is already used",
    EXCEL_NAME_ALREADY_USED: "The name of the EXCEL source is already used",
    NO_PAGE_OUTSIDE_FOLDERS: "No pages found out of folders",
    SUCCESS_COLOR_COPY_TO_CLIPBOARD: "The color has been copied successfully",
    // Page configuration
    TILTE_PAGE_CONFIGURATION: "SETTING UP THE PAGE",
    LABEL_BACKGROUND_PAGE_CONFIG: "BACKGROUND",
    OPTION_CHOICE_BACKGROUND_PAGE_1: "Solid color",
    OPTION_CHOICE_BACKGROUND_PAGE_2: "Background image",
    OPTION_CHOICE_BACKGROUND_PAGE_3: "Same as page",
    LABEL_BACKGROUND_PAGE_CONFIG_COLOR: "COLOR",
    LABEL_BACKGROUND_PAGE_CONFIG_OPACITY: "OPACITY",
    LABEL_BACKGROUND_PAGE_CONFIG_OPACITY_COLOR: "BACKGROUND COLOR",
    LABEL_BACKGROUND_PAGE_CONFIG_BLUR: "BLUR",
    APPLY_TRANSPARENCY: "APPLY_TRANSPARENCY",
    SHADOWING: "SHADOWING",
    PAGE_STYLE: "PAGE STYLE",
    FIXED_BLOC_STYLE: "FIXED BLOC STYLE",

    // Page permissions
    AN_USER_HAS_AN_INVALID_PAGE_ACCESS_STATUS: "An user has an invalid page access status.",
    UNAUTHORIZED_STATUS: "Unauthorized Status",
    THERE_IS_ONLY_ONE_OWNER: "There is only one owner !!",
    VIEWER: "Viewer",
    EDITOR: "Editor",
    OWNER: "Owner",
    // **************************** Gouvernance ********************************
    // Message Request
    RESPONSE_CONTROL_EXISTING: "A response has already been submitted for this check",
    // Controls
    AGENCE: "Agency",
    TIMER_CONTROL: "Estimated execution time in man-days",
    TIMER_CONTROL_LABEL: "Estimated execution time",
    TIMER_CONTROL_VALUE: "m/d",
    OBLIGATOIRE: "Required",
    EXECUTION_TIME_CONTROL_LABEL: "Execution time",
    EXECUTION_TIME_ACTIVATION: "Activer le temps d'exécution",
    AVERAGE_NOTE: "Average grade",
    LEVEL: "level",
    LINE_OF_DEFENSE: "Line of Defense",
    ACTIVITY: "Activity",
    RISKNAME: "Risk Name",
    RISK: "Risk",
    RISK_LEVEL: "Risk level",
    RISKS: "Risks",
    FREQUENCE_CONTROL: "Control frequency",
    THEMATIC: "Thematic",
    TYPE_CONTROL: "Type",
    CHECKLIST: "CHECKLIST",
    REFERENCE: "Reference",
    INCIDENT_DESCRIPTION: "Incident description",
    RECOMMENDATION_DESCRIPTION: "Description",
    ACTIVITY_CONCERNED_BY_INCIDENT: "Activity concerned by the incident",
    PROCESS: "Control title",
    OBJECTIF_CONTROL: "Control objective",
    OBJECTIF_MISSION: "Mission objective",
    MITIGANT_TYPE: "Mitigant type",
    REMARK: "Remark",
    ADD_COMMENTS: "Add comments",
    NO_COMMENTS: "No comments",
    NO_CHANGE: "No change",
    COMMENTS_ECHANTILLON: "Sample description",
    CONTROLLER: "Controller",
    CONTROLLERS: "Controllers",
    PERIODICITY: "Periodicity",
    SAMPLE: "Sampling",
    EXHAUSTIVE: "Exhaustive",
    MODE_OPERATOIRE: "Operating Mode",
    AFFECTATION: "Assigned to",
    CHECKPOINTS: "CHECKPOINTS",
    DATE_FIRST_OCCURRENCE: "Date of the first occurence",
    DAILY: "Daily",
    WEEKLY: "Weekly",
    MONTHLY: "Monthly",
    ANNUAL: "Annual",
    QUARTERLY: "Quarterly",
    SEMI_ANNUAL: "Semi annual",
    ANY: "Any",
    RISK_PRIMARY: "Primary Risk",
    RISK_SECONDARY: "Secondary Risk",
    RISK_ASSIGNED: "Assigned risk",
    CRITICAL: "Critical",
    CRITICALITY: "Criticality",
    CONTROL_IDS: "Control ids",
    VERYLOW: "Very weak",
    HIGH: "High",
    HIGH_V2: "High",
    MEDIUM: "Medium",
    HIGH_FEMALE: "High",
    VERY_HIGH: "Very high",
    VERY_HIGH_FEMALE: "Very high",
    MODERATE: "Moderate",
    MODERATE_FEMALE: "Moderate",
    LOW: "Low",
    COLOR: "COLOR",
    COLOR_LOWER_CASE: "Color",
    PREVIEW: "Preview",
    COLLABORATOR: "COLLABORATOR",
    JOB: "JOB",
    SELECTED_COLLABORATORS: "SELECTED COLLABORATORS",
    TO_VALIDATE: "TO VALIDATE",
    THIS_CONTROL_IS: "This control is",
    NO_REP_CONTROLE: "You cannot respond to this control",
    MY_SOURCES: "My sources",
    SORT_MY_SOURCES: "Sort my sources",
    ALPHABETICAL_ORDER_ASC: "Alphabetical order ascending",
    ALPHABETICAL_ORDER_DESC: "Alphabetical order descending",
    DATE_ASC: "Date ascending",
    DATE_DESC: "Date descending",
    SIZE_ASC: "Size ascending",
    SIZE_DESC: "Size descending",
    NO_REP_CONTROLE: "You cannot respond to this control",
    filterStatus: "Status",
    filterProcess: "Control title",
    filterControls: "Controls",
    filterlabelRealiser: "To achieve",
    filterlabelNonConforme: "Not Compliant",
    filterlabelConforme: "Compliant",
    filterlabelConsultant: "In progress Consultant",
    filterlabelManager: "In Progress Manager",
    filterlabelRealises: "Realized",
    WARNING_REQUIRED_FIELD: "Warning, all required fields are not answered.",
    NAME_SECTION_CANT_BE_VOID: "Name section can't be void.",
    SECTION_WITH_ALLREADY_EXISTING_NAME: "section with allready existing name.",
    NAME_OF_NEW_SECTION: "Name of new section",
    ADD_SECTION: "Add section",
    NAME_OF_SECTION_IS_EDITABLE: "The section name is editable.",
    DUPLICATE: "Duplicate",
    DELETE: "Delete",
    START: "Start",
    END: "End",
    ADD_RANGE: "Add range",
    GAUGE_SCALE: "Gauge scale",
    PERSONALIZED_RANGE: "Personalized range",
    CONFIGURATION_RANGES: "Ranges configuration",
    NEW_VALUE_MAPPER: "New value mapper",
    VALUE_MAPPER: "Value mapper",
    LABEL_VALUE_ORIGINAL: "Value original",
    LABEL_VALUE_RENAMED: "Value renamed",
    // RISK
    riskLabelAddRisk: "Add a risk",
    riskLabelEditRisk: "Edit a risk",
    riskLabelDetailRisk: "Risk detail",
    riskLabelNameRisk: "Risk name",
    riskLabelActiviteRisk: "Activity",
    riskLabelDescriptionRisk: "Description",
    riskLabelRegulatoryReference: "Regulatory reference",
    riskLabelImpact: "Impact",
    riskLabelFrequence: "Frequency",
    riskLabelRiskBrut: "Inherent Risk",
    riskLabelRiskBrutComment: "Inherent risk comment",
    riskLabelType: "Type",
    riskLabelReferenceRisk: "Risk reference",
    riskLabelRiskResiduel: "Residual risk",
    riskLabelImpactResidual: "Residual impact",
    riskLabelFrequenceResidual: "Residual frequency",
    riskLabelRiskResidualComments: "Residual risk comment",
    riskLabelResponsableRisk: "Risk manager",
    riskLabelTypeRisk: "Risk type",
    riskLabelLevelRisk: "Risk level",
    riskLabelAffectation: "Assignment",
    // RISK RESIDUAL
    riskLabelAddRiskResidual: "Add residual risk",
    riskLabelEditRiskResidual: "Edit residual risk",
    riskLabelNameRiskResidual: "Residual risk name",
    riskLabelRiskResidual: "Residual risk",
    riskLabelRiskResidualAssocie: "Associated risk",
    riskLabelCommentRiskResidual: "Remark",
    // Mapping RISK
    activityLabelMapping: "Activity",
    refLabelMapping: "Risk reference",
    riskLabelMapping: "Risk",
    impactLabelMapping: "Impact",
    frequencyLabelMapping: "Frequency",
    riskBrutLabelMapping: "Inherent Risk",
    controlLabelMapping: "Controls",
    mitigantLabelMapping: "Mitigants",
    riskResidualLabelMapping: "Residual risk",
    commentLabelMapping: "Remark",
    notSpecifiedLabelMapping: "Not specified",
    notControlLabelMapping: "No Control",
    notMitigantLabelMapping: "No Mitigant",
    responsableRiskLabelMapping: "Risk manager",
    controlAttachedRiskLabelMapping: "Risk related controls",
    entitledMitigantLabelMapping: "Title of mitigants",
    typeRiskLabelMapping: "Type of risk",
    ADD_DIRECTORY_FOLDER: "Add a repertory",
    CREATION_DIRECTORY_FOLDER: "Directory creation",
    DIRECTORY_NAME: "Directory name",
    DIRECTORY_DESCRIPTION: "Directory description",
    INDEX_DIRECTORY: "Directory",
    SHOW_DIRECTORIES_ONLY: "Show directories only",
    MESSAGE_SOURCE_USED: "Fields from this source are used in your pages.",
    MESSAGE_SOURCE_NOT_USED: "Fields from this source are not used in any of your pages.",
    CANT_DUPLICATE_MULTITAB_WIDGET:
      "Please note that you cannot duplicate this type of widget on another page.",
    CANT_DUPLICATE_TEMPORARY_WIDGET:
      "Impossible to duplicate widget : You should save your page first",
    FAIL_TO_DUPLICATE_WIDGET_TO_ANOTHER_PAGE: "Failed to duplicate widget to another page",
    SUCCESS_TO_DUPLICATE_WIDGET_TO_ANOTHER_PAGE: "Widget duplication in another successful page",
    VIEW_PLANNING: "Schedule view",
    HIDE_PAST_CHECKS: "Hide past checks",
    FROM_DATE: "From",
    TO_DATE: "To",
    SELECTED_DATES: "Selected dates",
    ADD_MAPPING: "Add framework",
    IMPLEMENT_REFERENCIAL: "Implement a repository",
    REFERENT_MAPPING: "Referent mapping",
    REFERENT_RISK: "Referent risk",
    REFERENT_PERSON: "Referent person",
    AFFECTED_PERSON: "Assigned person",
    MAPPING: "Framework",
    ANSWERS: "Answers",
    CREATE_A_ACTIVITY: "CREATE AN ACTIVITY",
    CREATE_A_RISK: "CREATE A RISK",
    CREATE_A_CONTROL: "CREATE A CONTROL",
    CREATE_A_RESIDUAL_RISK: "CREATE RESIDUAL RISK",
    TABLE_LABEL_CONTROLS: "# CONTROLS",
    TABLE_LABEL_MITIGANTS: "# MITIGANTS",
    RISK_CONTROL_SYSTEM: "Risk Framework",
    FIGER_LA_CARTOGRAPHIE: "Freeze Mapping",
    RETOUR_HISTORIQUE_CARTOGRAPHIE: "Back to history",
    TITLE_OF_MITIGANTS: "Mitigants",
    RISK_RELATED_CONTROLS: "Controls",
    RELATED_FILES: "Related files",
    RETAIL: "Retail",
    ACTIVITY_REFERENCE: "Activity reference",
    ACTIVITY_NAME: "Activity name",
    MAPPING_RISK_SINGULAR: "Risk Frameworks",
    AUCUN_RESULTAT: "No results were found",
    A_CETTE_DATE: "to this date",
    ASSIGN_TO_ACTIVITY: "Assign to an activity",
    ASSIGN_TO_SUB_ACTIVITY: "Assign to a sub-activity",
    SUB_ACTIVITY: "Sub activity",
    CONTROL_TITLE: "Control title",
    ADD_A_CONTROL: "Add a control",
    PUBLISH: "Validated",
    DRAFT: "Draft",
    CONTROL: "Control",
    CONTROLS: "Controls",
    MITIGANT: "Mitigant",
    SAMPLE_SINGULAR: "Sampling",
    SAMPLES: "Samples",
    NO_SAMPLES_AVAILABLE: "No samples available",
    NO_SAMPLES_AVAILABLE_YET: "No samples available yet",
    SHOW_SOURCES_USED_ONLY: "Show only used sources",
    SELECT: "Select",
    SELECTED_DATES: "Selected dates",
    DATE_EFFECT_CONTROL: "Control effective date",
    DATE_DEADLINE_CONTROL: "Due date for carrying out the control",
    DATE_INVALID_EFFECT_DEADLINE:
      "Please note that the effective date cannot be greater than the due date of the check!",
    FIRST_DAY_WORKING: "1st working day",
    FIVE_DAY_WORKING: "5th working day",
    TEN_DAY_WORKING: "10th working day",
    FIFTEEN_DAY_WORKING: "15th working day",
    TWENTY_DAY_WORKING: "20th working day",
    HORS_THEMATIC: "No Thematic",
    LABEL_IN_ENGLISH: "Label in english",
    LABEL_IN_FRENCH: "Label in french",
    // ****************** Document Management ******************
    ACTUALITY_TAB: "News / regulatory watch",
    GOVERNANCE_TAB: "Governance",
    DOCUMENT_TAB: "Requested documents",
    HISTORY_TAB: "Historical",
    CREATED_DATE: "Created",
    UPDATE_DATE: "Update",
    VISIBILY_ONLINE: "Visible online",
    BUSINESS_UNIT: "Business Unit",
    SECTOR_ACTIVITY: "Activity area",
    ADD_ACTUALITY: "Add news",
    CONCERNED_CLIENT: "Customer concerned",
    CONCERNED_CONSULTANT: "Consultant concerned",
    ADD_YEAR: "Add a year",
    ARCHIVED: "Archived",
    TO_ARCHIVE: " To archive",
    FILTER_BY: "Filter by",
    DOCUMENTS: "Documents",
    DOCUMENT: "Document",
    CONCERNED_CONTROLE: "Control concerned",
    CONTROLEUR: "Controller",
    DATES: "Dates",
    UPDATE_DATE_BY: "Created by",
    NAME_DOCUMENT: "Name document",
    TITLE_DOCUMENT: "Title document",
    CONTROL_TABLE: "Table of controls",
    GOVERNANCE_TEXT1: "Governance mission to outsource permanent and periodic internal control",
    GOVERNANCE_TEXT2: "Compliance and Internal Control Committee",
    GOVERNANCE_TEXT3: "Organization of permanent internal control missions",
    NO_REQUESTED_DOCUMENT: "There is no requested document",
    WAITING: "Waiting",
    ADDED: "Added",
    REJECTED: "Rejected",
    A_REJECTED: "Rejected",
    REJECTED_FEMININ: "Rejected",
    VALIDATION_IN_PROGRESS: "Validation in progress",
    REJECT: "Reject",
    VALIDATED: "Validated",
    THIS_COLUMNS_WILL_BE_IGNORED: "This columns will be ignored",
    true: "True",
    false: "False",
    RESULTAT_CONFORMITE: "Compliance result",
    // ****************** Incident Management ******************
    INCIDENT_MANAGEMENT: "Incident management",
    CORRECTIVE_ACTIONS_MANAGEMENT: "Corrective actions management",
    VIEW_ALL_INCIDENTS: "View all incidents",
    ACCESS_INCIDENT: "Access to incidents",
    CREATE_INCIDENT: "Create incidents",
    EDIT_INCIDENT: "Edit Incident",
    EDIT_REFERENCE_INCIDENT: "Edit the reference of an incident",
    DELETE_INCIDENT: "Delete incident",
    VALIDATE_INCIDENT: "Validate an incident",
    INCIDENT_VALIDATION: "Incident validation",
    ACTION_PLAN_VALIDATION: "Action plan validation",
    ACTION_PLAN_VALIDATE: "Validate action plan",
    ACTION_PLAN_REJECT: "Reject action plan",
    ACTION_PLAN_CONFIRM: "Action plan confirm",
    ACTION_PLAN_ACCESS: "Access to the action plan",
    VISION_TASKS: "Task vision",
    TASK_VISION: "Task vision",
    VALIDATION: "Validation",
    IMPORTED_RESPONSES_WILL_BE: "Imported responses will be saved as",
    CONSULTANTS: "Consultants",
    CREATE_CONTROLS_PLAN: "CREATE A CONTROL PLAN",
    LINK_CONTROLS: "Link controls",
    LINK_RISQUES: "Link risks",
    LINK_ACTIVITY: "Link activity",
    CONTEXT: "Context",
    CONSTAT: "Report",
    TOPICS: "TOPICS",
    TOPIC: "Topic",
    LEVELS: "LEVELS",
    CUSTOMERS: "CUSTOMERS",
    THEME: "Theme",
    STANDARD: "Standard",
    BLANC: "White",
    VERT: "Green",
    GREY: "Grey",
    RETRO: "Retro",
    AUBERGINE: "Eggplant",
    BLACK: "Black",
    NIGHT: "Night",
    CUSTOMER: "Customer",
    CUSTOMER_LOGO: "Customer logo",
    CONTROL_PLAN_PARAMETERS: "Parameterization of the control plan",
    AUDIT_PLAN_PARAMETERS: "Configuration of the audit plan",
    CREATE_CONTROL: "CREATE A CONTROL",
    NUMBER_CONTROL_POINTS: "Number of control points",
    NUMBER_AFFECTATION_CONSULTANT: "Number of consultant assignments",
    MY_CONTROLS_LIST: "My checklist",
    ASSIGN: "Assign",
    CONSULTANT: "Consultant",
    AFFECTATION_STATUS: "Affectation status",
    SETTINGS: "Settings",
    SETTING: "Setting",
    REQUESTED_DOCUMENTS: "Requested documents",
    REQUESTED_DOCUMENTS_CLIENT: "Documentation requested Customer",
    REQUESTED_DOCUMENTS_CONSULTANT: "Documentation requested Consultant",
    CONFIRM_DELETE_PLAN_CONTROL:
      "Are you sure you want to permanently delete this control plane and all associated controls ?",
    CONFIRM_ARCHIVE_PLAN_CONTROL:
      "Are you sure you want to archive this control plan and all associated controls ?",
    CONFIRM_ARCHIVE_MODEL_PLAN_CONTROL:
      "Please note this control plan is a model, do you really want to archive it and all the associated controls?",
    CONFIRM_DELETE_MODEL_PLAN_CONTROL:
      "Please note, this control plan is a model, do you really want to permanently delete it and all associated controls?",
    CONFIRM_DUPLICATE_PLAN_CONTROL: "Are you sure to duplicate this control plan ?",
    CONFIRM_DUPLICATE_MODEL_PLAN_CONTROL: "Are you sure to duplicate this control plan model ?",
    CONFIRM_DELETE_CONTROL: "Are you sure you want to permanently delete this control ?",
    CONFIRM_ARCHIVE_CONTROL: "Are you sure you want to archive this control ?",
    CONTROLLED_PERIOD: "Controlled period",
    DATE_OF_COMPLETION: "Period of completion",
    EVOLUTION: "Evolution",
    DATE_OF_COMPLETION_CONTROL: "Date of completion control",
    CONTROLLER_TRIGRAM: "Controller trigram",
    REVIEWER_TRIGRAM: "Reviewer trigram",
    CONTROL_DESCRIPTION: "Description of the control",
    RISK_DESCRIPTION: "Description of the risk",
    TOOLS_DOCUMENTS_USED: "Tools and documents used",
    SEE_DOCUMENTS_REQUESTED: "See Documents requested or list of documents obtained",
    RISK_APPROACH: "Risk approach",
    REGULATORY_REFERENCE: "Regulatory reference",
    CONTROL_PROTOCOL: "Control protocol",
    CONTROL_ATTACHED_DOCUMENTS: "Documents attached to the control",
    ACTUALITY_ATTACHED_DOCUMENTS: "Documents attached to the actuality",
    TASK_ATTACHED_DOCUMENTS: "Documents attached to the task",
    INSERT_FILE: "Insert file",
    CREATE_CONTROL_POINT: "Create a checkpoint",
    CHECKPOINT: "Checkpoint",
    REFERENCE_CHECKPOINT: "Reference",
    NAME_CHECKPOINT: "Checkpoint title",
    CONTROL_SUMMARY_SHEET: "Control summary sheet",
    SYNTHESIS: "Synthesis",
    SUMMARY_OF_CONTROL: "Summary of control",
    SUMMARY_CONTROL_AND_RECOMMENDATIONS: "Summary of the control and recommendations",
    TABLE_OF_RECOMMENDATIONS: "Table of recommendations",
    TABLE_OF_PREVIOUS_RECOMMENDATIONS: "Table of previous recommendations",
    CONTACTS: "Contacts",
    DEPARTMENTS_CONCERNED: "Departments concerned",
    CONFIRM_DELETE_CONTROL: "Are you sure to delete this control ?",
    CONFIRM_DUPLICATE_CONTROL: "Are you sure to duplicate this control ?",
    ALERT_PARAMETERS_UNVALID: "Please note that some required parameters are empty.",
    ALERT_CHECKPOINT_UNDEFINED: "At least one control point must be created.",
    ALERT_AFFECTATION_UNDEFINED: "At least one assignment must be assigned.",
    ALERT_RESULTAT_UNDEFINED: "Please note that the RESULT is mandatory in your checkpoints.",
    DELETE_ACTIVITY: "Delete Activity",
    CONFIRM_DELETE_ACTIVITY: "Are you sure to delete this activity ?",
    CONTROL_PLAN: "Plan of control",
    RATING: "Rating",
    COMPLIANCE_DEGREES: "Compliance Degree",
    CONTROL_PLANS: "Control planes",
    CONTROL_NEED_AFFECTATION_AND_CONTROL_POINT:
      "Attention to publish a control at least one control point and one assignment must be defined.",
    SOME_FIELDS_MANDATORY_ARE_EMPTY: "Please note that some required fields are empty.",
    SOME_FIELDS_MANDATORY_ARE_EMPTY_V2:
      "Please note that some required fields are empty. Also note that at least one checkpoint and one assignment are required to publish the control.",
    MY_CONTROL_PLANS: "My control plans",
    DOWNLOAD_ATTACHMENTS: "Download attachments",
    ATTACHMENTS: "Attachments",
    MANDATORY_ATTACHMENTS: "Mandatory attachments",
    UPDATED_FINEGAN_EXPERTISES: "Updated FINEGAN EXPERTISES",
    VALIDATION_FINEGAN_EXPERTISES: "Validation FINEGAN EXPERTISES",
    TOOLS_AND_DOCUMENTS: "Tools and documents",
    DOCUMENT_TAB_PLURAL: "Requested documents",
    ADD_THE: "Added on ",
    REGULATORY_REFERENCE_PLURAL: "Regulatory references",
    PENDING: "Pending",
    UNAFFECTED: "Unaffected",
    AFFECTED: "Affected",
    WAITING_FOR_DOCUMENTS: "Waiting for documents",
    AWAITING_VALIDATION_MANAGER: "Awaiting validation manager",
    AWAITING_VALIDATION_CUSTOMER: "Awaiting validation customer",
    RESPONSABLE: "Responsible",
    DATE_CIBLE: "Target date for implementation",
    CONTROL_REPORT_OF: "Control report of",
    DATA_PREVIEW: "Data preview",
    // ****************** ACTION PLAN ******************
    REFERENCE_TAB_AP: "Reference",
    ANOMALY_TAB_AP: "Issue",
    LIBELLE_TAB_AP: "Labels",
    TASKS_TAB_AP: "Tasks",
    CREATOR_TAB_AP: "Creator",
    PERIOD_TAB_AP: "Period",
    STATUS_TAB_AP: "Status",
    CONTROL_TAB_AP: "Controls",
    DESCRIPTION_TAB_AP: "Description",
    CONFORMITE_TAB_AP: "Compliance",
    DATE_TAB_AP: "Date",
    HISTORY_TAB_AP: "History",
    ANO_TAB_AP: "Anomalies",
    HISTORY_LABEL_AP: "Control history",
    // ****************** RECOMMANDATIONS ******************
    PARTIELLEMENT_CONFORME_AVEC_FAIBLE_IMPACT: "PARTIALLY COMPLIANT WITH LOW IMPACT",
    PARTIELLEMENT_CONFORME_AVEC_FORT_IMPACT: "PARTIALLY COMPLIANT WITH HIGH IMPACT",
    FICHE_SUIVI_DES_RECOMMANDATIONS: "RECOMMENDATIONS FOLLOW-UP SHEET",
    STATUT_DES_RECOMMANDATIONS: "STATUS OF RECOMMENDATIONS",
    DATE_CLOTURE_RECOMMANDATION_2: "OF THE RECOMMENDATION",
    NOMBRE_DE_RECOMMANDATION: "NUMBER OF RECOMMENDATIONS",
    DATE_CLOTURE_RECOMMANDATION_1: "CLOSING DATE",
    EN_ATTENTE_DE_VALIDATION_2: "OF CONFIRMATION",
    AJOUT_COMMENTAIRE: "ADD COMMENTARY",
    EN_ATTENTE_DE_VALIDATION_1: "PENDING",
    POINTS_DE_CONTROLE: "CHECKPOINTS",
    RECOMMANDATION: "Recommendation",
    REFERENCE_RECO: "REFERENCE",
    DATE_SUIVI_2: "FOLLOW-UP",
    DATE_ECHEANCE: "DEADLINE",
    CONFORMITE: "COMPLIANCE",
    EN_COURS: "IN PROGRESS",
    ABANDONED: "ABANDONED",
    COMMENTAIRE: "COMMENT",
    CONFORME: "COMPLIANT",
    DATE_SUIVI_1: "DATE",
    PRIORITE: "PRIORITY",
    CONTROLE: "CONTROL",
    PERIODE: "PERIOD",
    STATUT: "STATUS",
    NIVEAU: "LEVEL",
    CLOSE: "CLOSE",
    ENTER_TEXT: "Enter text...",
    ASSOCIATED_ACTIVITY: "Associated activity",
    ASSOCIATED_RISK: "Associated risk",
    ASSOCIATED_RISKS: "Associated risks",
    DATE_OF_CONTROL: "Date of control",
    TYPE_OF_CONTROL: "Type of control",
    OCCURENCE: "Occurence",
    EDIT_OCCURRENCE: "Edit occurrence",
    ARCHIVE_OCCURRENCE: "Archive occurrence",
    OVERVIEW_OF_CONTROL: "Overview of the control",
    CONTROL_PARAMETERS: "Control parameters",
    CONFIRMATION_DELETE_MAPPING_RISKS: "Do you really want to delete this map?",
    ASSOCIATED_MAPPING_RISKS: "Associated mapping risks",
    COMPLIANCE: "Compliance",
    USE_WORKING_DAYS: "Use working days",
    DAILY: "Daily",
    NO_DOCUMENT: "No document",
    LIST_CHANGED_CONTROLS: "List of changed controls",
    VALIDATION_OF_CONTROLS: "Validation of controls",
    ENTITLED: "Entitled",
    REGULATORY_REFERENCE_DOCUMENTS: "Regulatofy reference documents",
    COMMIT_CHANGES: "Commit changes",
    SUCCESS_TO_DELETE_FILE: "The document has been successfully deleted",
    SUCCESS_TO_UPLOAD_FILE: "The document has been added successfully",
    SUCCESS_TO_UPDATE_CONTROL_PLAN: "The control plan has been modified successfully",
    WARNING_RISK_EMPTY: "Attention the risk cannot be empty.",
    GLOBAL_VISUALIZATION: "Global visualization",
    NOT_STARTED: "Not started",
    CONFORM: "Compliant",
    NOT_CONFORM: "Not compliant",
    ENDED: "Ended",
    LOW_CONFORM: "Partially compliant with low impact",
    STRONG_CONFORM: "Partially compliant with strong impact",
    OPERATIONAL: "Operational",
    LEGAL: "Legal",
    FRAUD: "Fraud",
    OPERATIONAL_CONFORMITE: "Operationnal/Compliance",
    IT: "IT",
    FINANCIAL: "Financial",
    SECURITY: "Security",
    LITIGE_COMMERCIAUX: "Commercial disputes",
    RISQUE_CREDIT: "Credit risk",
    LITIGE_AUTORITES: "Dispute with authorities",
    ERREURS_EVALUATION_RISQUE: "Errors in risk assessment",
    ERREUR_EXECUTION: "Execution error",
    FRAUDE_ET_AUTRES: "Fraud and other criminal activities",
    DEFAILLANCE_SYSTEME: "Information systems failure",
    RISQUE_LIQUIDITE: "Liquidity risk",
    PERTE_RESSOURCES_EXPLOITATION: "Loss of operating ressources",
    CONFIRM_ADD_THESE_DOCUMENTS: "Confirm the addition of these documents",
    ASSOCIATED_CONTROL: "Associated control",
    ASSOCIATED_CONTROLS: "Associated controls",
    ADDED_FILENAME: "Added file name",
    ADDED_DATE: "Date added",
    FORM_IS_EMPTY: "The form is empty",
    NO_DOCUMENTS_TO_DISPLAY: "No documents to display",
    VALIDATION_SPACE: "Validation space",
    VALIDATION_OF_REQUESTED_DOCUMENTS: "Validation of requested documents",
    CONFIRMATION_REJECT_DOCUMENT: "Do you really want to reject this document?",
    CONFIRMATION_VALIDATE_DOCUMENT: "Do you really want to validate this document?",
    NAME_OF_ADDED_FILE: "Name of added file",
    NAME_OF_REQUESTED_DOCUMENT: "Name of requested document",
    MODIFIED_THE: "Modified...",
    DOCUMENTS_TO_VALIDATE: "Documents to validate",
    REVIEWS: "Reviews",
    EDIT_RECOMMENDATION: "Edit recommendation",
    PRIORITY: "Priority",
    MANAGER: "Manager",
    MANAGER_V2: "Manager",
    DUE_DATE: "Due date",
    FOLLOW_UP_DATE: "Follow up date",
    RECOMMENDATIONS: "Recommendations",
    RECOMMENDATION: "Recommendation",
    MY_RECOMMENDATIONS: "My recommendations",
    ERROR_FOLLOW_UP_DATE: "Please note that the opening date cannot be less than the current date.",
    ERROR_DUE_DATE: "Please note that the expiry date cannot be less than the opening date.",
    ERROR_RECOMMENDATION_IS_EMPTY:
      "You must fill in all the fields before validating this recommendation.",
    ERROR_OPINION_IS_EMPTY: "Attention the comment must contain at least 5 characters !",
    SUCCESS_TO_UPDATE_RECOMMENDATION: "The recommendation has been successfully updated.",
    SUCCESS_TO_CREATE_RECOMMENDATION: "The recommendation has been successfully created.",
    WARNING_TO_DELETE_MAPPING_RISK:
      "An activity, risk or control is linked to the framework, so it cannot be deleted",
    VALIDATE_WITHOUT_MODIFICATIONS: "Validate without modifications",
    VALIDATE_WITH_MODIFICATIONS: "Validate with modifications",
    SEE_CHANGES: "See changes",
    FAIL_CONSULTANT_UPDATE_CONTROL: "Error updating control",
    CONTROLS_IN_WAITING: "Controls in waiting",
    CONTROL_STATUS: "Control status",
    NOT_AFFECTED: "Not affected",
    AFFECTED_TO_CONSULTANT: "Affected to consultant",
    WAITING_FOR_CONTROL_MODIFICATIONS_VALIDATION: "Awaiting validation of changes",
    WAITING_FOR_CLIENTS_DOCUMENTS: "Waiting for clients documents",
    WAITING_FOR_DOCUMENTS_VALIDATION: "Waiting for documents validation",
    READY_TO_BE_ANSWERED: "Ready to be answered",
    FINISHED: "Finished",
    SUCCESS_CONSULTANT_UPDATE_CONTROL: "The control status has been successfully updated",
    ACTIVITIES_AND_RISKS: "Activities and risks",
    VIEW_CHANGES: "View changes",
    PENDING_CONTROL_CHANGES: "Pending control changes",
    VALIDATE_CONTROL: "Do you really want to validate control ?",
    DO_YOU_START_CONTROL: "Do you want to start control ?",
    START_CONTROL: "Start control",
    CONFIRM_CONTROL_WITHOUT_CHANGES: "Do you really want to confirm this check without changes ?",
    CONFIRM_CONTROL_REQUEST_CHANGES:
      "Are you sure you want to request these changes for this control?",
    REJECT_CONTROL_REQUEST_CHANGES_V1: "Reject and return to consultant.",
    REJECT_CONTROL_REQUEST_CHANGES_V2: "Reject and release the control.",
    SUCCESS_TO_REJECT_MODIFICATION: "The control was successfully rejected",
    MODIFICATIONS: "Modifications",
    FAIL_TO_UPDATE_CONTROL: "Control update failed",
    SUCCESS_TO_PATCH_CONTROL: "Control update successfull",
    RECOMMENDATION_OPENING_DATE: "Recommendation opening date",
    NUMBER_OF_RECOMMENDATIONS: "Number of recommendations",
    PERMANENT: "Permanent",
    PERIODIC: "Periodic",
    SECTORS: "Sectors",
    WEEK_SHORT: "WEEK",
    SUCCESS_TO_ADD_RISK: "New risk successfully added",
    SUCCESS_TO_DELETE_RISK: "Risk successfully removed",
    SUCCESS_TO_ADD_RISK_RESIDUAL: "New residual risk successfully added",
    SUCCESS_TO_UPDATE_RISK_RESIDUAL: "Residual risk updated successfully",
    SUCCESS_TO_DELETE_RISK_RESIDUAL: "Residual risk successfully removed",
    SUCCESS_TO_ARCHIVE_RISK_RESIDUAL: "Residual risk successfully removed",
    SELECT_A_DATE: "Select a date",
    SEND_A_MESSAGE: "Send a message",
    THREAD: "Thread",
    TASKS_VALIDATION: "Validation of tasks",
    FORM: "Form",
    FILES: "Files",
    FILE_INSERT: "File insert",
    CONCERNED_DEPARTMENTS: "Concerned department(s)",
    MY_DOCUMENT: "My document",
    DOCUMENTS_ASSOCIATED_WITH_CHECKPOINTS: "Documents associated with checkpoints",
    DRAG_YOUR_FILE: "Drag your file",
    OR_CLICK_HERE: "or click here",
    ADMINISTRATION_AND_MANAGEMENT_OF_THE_COMPANY: "Administration and management of the company",
    CUSTOMER_RELATIONSHIPS: "Customer relationships",
    FUNDS_MANAGEMENT_AND_OPERATIONS: "Funds management and operations",
    COMPLIANCE_ETHICS_RISKS_AND_CYBERSECURITY: "Compliance, ethics, risks and cybersecurity",
    CONTROL_ALREADY_ANSWERED: "The control has already been completed",
    CONTROL_ISNT_READY_ANSWERED: "The control is not yet ready to respond",
    CONTROL_WRONG_RIGHTS: "You do not have the rights to respond to the control.",
    EFFACER: "Erase",
    ERROR_MESSAGE_CREATE_FIRST_CLIENT: "You must first create your client before adding a logo",
    THERE_ARE_NO_FILES_TO_ADD: "There are no files to add.",
    ERROR_USER_TYPE_POST_DOCS_ASSOCIATE_RESPONSE:
      "Your type of user does not allow the addition of this type of document.",
    ERROR_CONTROL_RESPONSE_POST_DOCS_ASSOCIATE_RESPONSE:
      "The control must first have received a response before you can add this type of document.",
    ERROR_CONTROL_RESPONSE_POST_DOCS_ASSOCIATE_RESPONSE_V2:
      "You must have saved or sent a reply before adding these documents.",
    CONTROL_WAITING_VALID_MANAGER: "The control is awaiting Manager validation.",
    CONTROL_WAITING_VALID_CLIENT: "The control is awaiting Customer validation.",
    CONTROL_IS_OVER: "The control is over.",
    ERROR_CONTROL_CANT_VALIDATE: "Error, the control could not be validated",
    ERROR_CONTROL_CANT_REJECT: "Error, the control could not be rejected",
    START_CONTROLLED_PERIOD: "Start of the controlled period",
    END_CONTROLLED_PERIOD: "End of the controlled period",
    SUCCESS_TO_DELETE_GROUP: "The client has been successfully deleted",
    SUCCESS_TO_DELETE_ENTITY: "The entity has been successfully deleted",
    SUCCESS_TO_ARCHIVE_ENTITY: "The entity has been successfully archived",
    SUCCESS_TO_UNARCHIVE_ENTITY: "The entity has been successfully un-archived",
    SUCCESS_TO_DELETE_ENTITIES: "Entities have been successfully deleted",
    SUCCESS_TO_ARCHIVE_ENTITIES: "Entities have been successfully archived",
    SUCCESS_TO_UNARCHIVE_ENTITIES: "Entities have been successfully un-archived",
    WARNING_CANT_DELETE_GROUP_CLIENT:
      "Please remove all attached users before deleting this client group.",
    ADDED_A_MESSAGE_TO_THE_CONTROL: "added a message to the control",
    ADD_DOCUMENTS_TO_RECOMMENDATION: "added documents to the recommendation",
    BELONGING_TO_THE_CONTROL: "belonging to the control",
    MESSAGE_CONTENT: "Message content",
    LIST_CONTROL_RESPONSES: "Control responses",
    CONTROL_RESPONSE: "Control response",
    CREATOR_NAME: "Creator name",
    CONTROL_TYPE: "Type of control",
    START_DATE: "Start date",
    NEXT_FOLLOWUP_DATE: "Next followup date",
    END_DATE: "End date",
    PLACEHOLDER_SAMPLING:
      "Description of the selected sample: Type / Number / Size / Year(s) under review / Other",
    CONTROL_PROGRESS: "Control progress",
    ON_DATE: "On",
    CONTROL_OPENED_BY: "Control opened by",
    AUDIT_TRAIL: "Audit trail",
    AUDIT_TRAILS: "Audit trails",
    SUCCESS_TO_ADD_OPINION_TO_RECOMMENDATION: "Your comment has been added",
    ASSIGNED_TO: "Assigned to",
    VALIDATION_MANAGER_ON: "Validated by the Manager on",
    VALIDATION_CLIENT_ON: "Validated by the Client on",
    SUCCESS_TO_ADD_RESPONSE: "Successfully saved your response",
    SUCCESS_TO_PATCH_RESPONSE: "Successfully saved your response",
    FAIL_TO_DELETE_FILE: "File deletion failed",
    NO_CONTROLS_SELECTED: "No controls selected",
    CONTROLS_SELECTED: "Controls selected",
    EXPORT_CONTROLS: "Export controls",
    EXPORT_DATA: "Export the data",
    EXPORT_AFFECTED_CONTROLS: "Export affected controls",
    EXPORT_CUSTOM_SHEET_DEFAULT: "Custom sheet",
    EXPORT_TABLE_HEADERS_UNDEFINED: "Error: table headers are undefined.",
    EXPORT_TABLE_NO_DATA: "No data available for this table.",
    EXPORT_TABLE_GENERATION_ERROR: "Error while generating the table: %error%",
    EXPORT_PDF_TABLE_UNSUPPORTED: "PDF rendering for this table is not supported yet.",
    JSONFORMS_EMPTY_NO_DATA_TITLE: "No data available",
    JSONFORMS_EMPTY_FILTERED_TITLE: "No results with these filters",
    JSONFORMS_EMPTY_SEARCH_TITLE: "No results for this search",
    JSONFORMS_EMPTY_NO_ACCESS_TITLE: "Access restricted",
    JSONFORMS_EMPTY_SUB_CREATE_ONLY: "Create a new item.",
    JSONFORMS_EMPTY_SUB_LINK_ONLY: "Link an existing %s.",
    JSONFORMS_EMPTY_SUB_LINK_OR_CREATE: "Link an existing %s or create a new one.",
    JSONFORMS_EMPTY_SUB_NO_ACTION: "No data available.",
    JSONFORMS_EMPTY_SUB_FILTER: "Adjust or reset your filters.",
    JSONFORMS_EMPTY_SUB_SEARCH: "Modify or clear the search.",
    JSONFORMS_EMPTY_SUB_NO_ACCESS: "You don't have permission to view this content.",
    JSONFORMS_EMPTY_BTN_EDIT_FILTERS: "Adjust filters",
    JSONFORMS_EMPTY_BTN_RESET_FILTERS: "Reset",
    JSONFORMS_EMPTY_BTN_CLEAR_SEARCH: "Clear search",
    JSONFORMS_EMPTY_BTN_ADD: "Link",
    JSONFORMS_EMPTY_BTN_CREATE: "Create",
    JSONFORMS_EMPTY_BTN_CREATE_MODAL: "Create in modal",
    JSONFORMS_EMPTY_BTN_CREATE_REDIRECT: "Create via redirect",
    JSONFORMS_EMPTY_BTN_MORE_OPTIONS: "More options",
    JSONFORMS_FIELD_REQUIRED: "Required field",
    JSONFORMS_FIELD_LOCKED_BY_RULE: "Field locked by a rule on this record",
    JSONFORMS_SECTION_HIGHLIGHTED: "Section involved at the current step",
    JSONFORMS_SECTION_FOLD_EXPAND: "Show section",
    JSONFORMS_SECTION_FOLD_COLLAPSE: "Fold section",
    JSONFORMS_SECTION_FOLDED_HINT: "Folded: not flagged for this record. Expand it to check.",
    RELATION_VIEW_CREATE: "Create",
    RELATION_VIEW_CREATE_CONSTRAINED: "Creation is constrained on this block",
    RELATION_VIEW_PICK_PARENT: "Choose the element to attach to",
    RELATION_VIEW_PICK_PARENT_EMPTY: "This record has no linked element yet — create one first.",
    JSONFORMS_LINK_UNLINK: "Unlink",
    JSONFORMS_LINK_CREATE: "Create",
    JSONFORMS_LINK_ACTIONS: "Actions",
    JSONFORMS_LINK_ADD: "Link an existing %s",
    JSONFORMS_LINK_ADD_TAB: "Link",
    JSONFORMS_LINK_CREATE_ITEM: "Create a new %s",
    JSONFORMS_LINK_VIEW_TABLE: "Table view",
    JSONFORMS_LINK_VIEW_GANTT: "Gantt view",
    JSONFORMS_LINK_COLLAPSE: "Collapse table",
    JSONFORMS_LINK_EXPAND: "Expand table",
    JSONFORMS_LINK_COMPLETE: "Enable local edit",
    JSONFORMS_LINK_IMPORT_TAB: "Import",
    JSONFORMS_LINK_SELECTED_COUNT: "{count} selected",
    JSONFORMS_LINK_SELECTION_CAP_EXCEEDED: "Too many items selected ({count}), refine the selection (maximum {max})",
    JSONFORMS_IMPORT_BACK: "Back",
    JSONFORMS_IMPORT_TEMPLATE_ERROR: "Template could not be retrieved, please try again shortly.",
    JSONFORMS_GOOGLE_SHOW_TEXT: "Show as text",
    JSONFORMS_GOOGLE_SHOW_MAP: "Show on map",
    JSONFORMS_GOOGLE_TOGGLE_LABEL: "Toggle view",
    JSONFORMS_GOOGLE_OPEN_MAP: "Open in OpenStreetMap",
    JSONFORMS_JODIT_PLACEHOLDER: "Write here…",
    JSONFORMS_ERROR_REQUIRED: "This field is required.",
    JSONFORMS_ERROR_MIN_CHAR: "This field must contain at least one character.",
    JSONFORMS_ERROR_MIN_ITEMS: "This field must contain at least one value.",
    JSONFORMS_ERROR_NUMBER: "Allowed characters (0,...,9,.,-,,)",
    JSONFORMS_ERROR_STRING: "This field must be a text.",
    JSONFORMS_ERROR_DEFAULT: "Invalid value.",
    JSONFORMS_ERROR_MIN_LENGTH: "This field must contain at least {limit} characters.",
    JSONFORMS_ERROR_MAX_LENGTH: "This field must not exceed {limit} characters.",
    JSONFORMS_ERROR_MIN_ITEMS_COUNT: "This field must contain at least {limit} values.",
    JSONFORMS_ERROR_MAX_ITEMS: "This field must not contain more than {limit} values.",
    JSONFORMS_ERROR_UNIQUE_ITEMS: "Values must be unique.",
    JSONFORMS_ERROR_MINIMUM: "This value must be greater than or equal to {limit}.",
    JSONFORMS_ERROR_EXCLUSIVE_MINIMUM: "This value must be greater than {limit}.",
    JSONFORMS_ERROR_MAXIMUM: "This value must be less than or equal to {limit}.",
    JSONFORMS_ERROR_EXCLUSIVE_MAXIMUM: "This value must be less than {limit}.",
    JSONFORMS_ERROR_MULTIPLE_OF: "This value must be a multiple of {limit}.",
    JSONFORMS_ERROR_FORMAT: "This value has an invalid format.",
    JSONFORMS_ERROR_ENUM: "This value is not one of the allowed values.",
    JSONFORMS_ERROR_CONST: "This value is not the expected one.",
    JSONFORMS_ERROR_NOT: "This value is not allowed.",
    JSONFORMS_ERROR_IF: "This field does not satisfy the applicable conditional rule.",
    JSONFORMS_ERROR_DATE_AFTER: "{end} must be after {start}.",
    CHOOSING_OBJECTS_SEPARATOR: "Choosing a separator for multiple objects",
    ANSWER_OF: "Answer of",
    SURVEY: "Survey",
    SURVEY_CONFIGURATION: "Survey configuration",
    ADD_SURVEY: "Add a survey",
    ENABLE_COLUMNS_TOTAL: "Enable columns total",
    ORGANIZE_YOUR_TASKS: "Organize your tasks",
    ASSOCIATE_TASKS: "Associate tasks",
    HAS_BEEN_COMPLETED_AND_READY_VALIDATION: "has been completed and is ready for validation.",
    PRESENTATION_OF_CONTROL: "Overview of the control",
    FAIL_TO_DELETE_ACTIVITY: "Failed to delete activity",
    RECOMMENDATIONS_PRIORITY: "Recommendations priority",
    CONTROL_PLAN_LEVEL: "Control plan level",
    IN_DEVELOPMENT_PROGRESS: "In development progress",
    CONTROL_LOCKED_DEADLINE_PAST:
      "Control is locked because the deadline for response is won over.",
    CREATE_AUDIT_PLAN: "Create an audit plan",
    CREATE_AUDIT_MISSION: "Create an audit mission",
    CREATE_AUDIT_POINT: "Create an audit point",
    SUBMIT: "Submit",
    SUBMITTED: "Submitted",
    SUBMIT_AUDIT_PLAN: "Submit Audit Plan",
    REVIEW: "Review",
    SUMMARY_SHEET_AUDIT_PLAN: "Summary sheet of the audit plan",
    MY_AUDIT_PLANS: "My audit plans",
    AUDIT_REPORT: "Audit report",
    MY_CURRENT_AUDIT_REPORT: "My current audit report",
    ADD_A_RECOMMENDATION: "Add a recommendation",
    NAME_AUDIT_PLAN: "Audit plan name",
    CONFIRM_DELETE_AUDIT_PLAN: "Are you sure you want to delete this audit plan ?",
    CONFIRM_DELETE_AUDIT_RECOMMENDATION: "Are you sure you want to delete this recommendation ?",
    AUDIT_RECOMMENDATION: "Audit recommendation",
    AUDIT_RECOMMENDATIONS: "Audit recommendations",
    AUDIT_PLAN: "Audit plan",
    AUDIT_MISSION: "Audit mission",
    CANT_DELETE_AUDIT_PLAN_IT_CONTAINS_RECOS:
      "You cannot delete this audit plan because it still contains recommendations.",
    FAIL_TO_DELETE_AUDIT_PLAN: "Error deleting audit plan",
    WAITING_AUDIT_PLAN_VALIDATION: "Awaiting submission of audit plan",
    SUCCESS_TO_MODIFY_AUDIT_PLAN: "The audit plan has been modified successfully",
    AUDIT_PLANS: "Audit plans",
    ACCESS_AUDIT_PLANS: "Audit plans access",
    VIEW_AUDITS_PLANS: "View audit plans",
    EDIT_AUDIT_PLAN: "Edit an audit plan",
    DELETE_AUDIT_PLAN: "Delete an audit plan",
    DUPLICATE_AUDIT_PLAN: "Duplicate an audit plan",
    USE_AUDIT_PLANS_SCOPE: "Use the scope of audit plans",
    ACTIVATE_THEMATIC_CONTROLS: "Activate the theme of controls",
    CREATE_NEW_THEMATIC: "Create a new theme",
    RECOMMENDATION_STATUS: "Recommendation status",
    ENABLE_REDIRECT_ANOMALY_CONTROL_NOT_COMPLIANT:
      "Be redirected to the creation of anomaly in case of non-compliance of the control",
    ERROR_MESSAGE_DELETE_ACTIVITY_SUB_ACTIVITIES:
      "This activity cannot be deleted because secondary activities are still linked to it, please delete the secondary activities first.",
    ENABLE_PARENT_CONTROL: "Enable parent controls",
    ENABLE_RECO_CONTROL: "Enable recommendations in controls",
    NEW_PLANNER: "New planner",
    BETA_VERSION: "beta version",
    PERIMETER: "Perimeter",
    CONCERNED_TEAMS: "Concerned teams",
    ADD_AUDIT_TRAIL: "Add this audit trail",
    MY_AUDIT_TRAIL: "My audit trail",
    MODEL_NAME: "Model name",
    FREE_TEXT: "Free text",
    TEXT_AREA: "Text area",
    SELECTOR: "Selector",
    SELECTOR_MULTIPLES: "Multi selector",
    CHECKBOX: "Checkbox",
    SUCCESS_TO_CREATE_CUSTOM_SKELETON: "The new model has been created successfully",
    SUCCESS_TO_DELETE_CUSTOM_SKELETON: "The model has been deleted successfully",
    USE_CUSTOM_SKELETONS_ANOMALIES: "Use custom anomalies models",
    USE_CUSTOM_SKELETONS_INCIDENTS: "Use custom incidents models",
    USE_CUSTOM_SKELETONS_RECOMMENDATIONS: "Use custom recommendations models",
    USE_CUSTOM_SKELETONS_ACTIVITIES: "Use custom activities models",
    USE_NEW_RIKS_CREATION_PAGE: "Use the new risk creation page",
    USE_CUSTOM_SKELETONS_RISKS: "Use custom risks models",
    CONFIRMATION_DELETE_MODEL: "Are you sure you want to delete this model ?",
    ERROR_SKELETON_NEED_NAME_AND_FIELD:
      "Please note that the model needs a name and at least one field that is not a default field!",
    DECLARANT_NAME: "Declarant's name",
    CONTROLEUR_NAME: "Responsible for Monitoring Recommendation",
    OPTIONS_LIST: "Options list",
    OPTIONS: "Options",
    CURRENT_OPTIONS: "Current options",
    LIST_INVALID_LIST_NAME: "Please enter a list name.",
    LIST_INVALID_LIST_OPTIONS: "Please enter at least one option.",
    LIST_LIST_NAME: "Name of the list",
    LIST_LIST_OPTIONS: "Options",
    LIST_NEW_LIST: "Ajouter une liste de choix",
    LIST_TITLE_LIST_SETTINGS: "List setting",
    LIST_CONFIRM_DELETE_LIST: "Are you sure you want to delete this list?",
    LIST_DELETE_LIST: "Delete",
    LIST_CANCEL_LIST: "Cancel",
    LIST_VALIDATE_LIST: "Validate",
    ADD_OPTION: "Add an option",
    CREATE_A_NEW_LIST: "Create a new list",
    STRING_LIST: "String list",
    CONTACT_RCCI: "Contact - Identity of the RCCI / RCSI",
    ADD_NEW_VALUE: "Add new value",
    SAVE_LIST: "Save list",
    EDIT_LIST: "Edit list",
    SUCCESS_TO_CREATE_CUSTOM_LIST: "The list was created successfully",
    SUCCESS_TO_PATCH_CUSTOM_LIST: "The list was edited successfully",
    RESPONSIBLES: "Responsibles",
    THREAD_IS_OPEN_TO_ALL_USERS: "The thread is currently open to all users.",
    WARNING_MESSAGE_EDIT_MODEL_CONTROL_PLAN:
      "Please note you are going to modify a control plan template, do you want to continue?",
    TABLE_VIEW: "Table view",
    CARDS_VIEW: "Cards view",
    ONE_RECO_IS_LATE: "At least one recommendation is late",
    RECO_ARE_STILL_TO_BE_COMPLETED: "Recommendations are still to be completed",
    NEW_RECO_READY_TO_BE_COMPLETED: "A new recommendation is ready to be completed",
    NEW_MESSAGES: "New posts !",
    NO_CLIENT_ASSIGNED_TO_CONTROL_PLAN: "No clients are assigned to this control plane",
    ACCESS_MESSAGES: "Access messages",
    GLOBAL_COMPLIANCE: "Global compliance",
    MY_LIST_OF_MISSIONS: "My list of missions",
    MISSION: "Mission",
    MISSIONS: "Missions",
    MY_MISSIONS: "My missions",
    CREATE_A_MISSION: "Create a mission",
    PENDING_MISSIONS: "Pending missions",
    AUDIT_POINT: "Audit point",
    MISSION_STATUS: "Mission status",
    CREATE_AN_AUDIT_POINT: "Create an audit point",
    AUDIT_PLAN_LEVEL: "Audit plan level",
    AUDIT_POINT_TITLE: "Audit point title",
    TITLE_OF_THE_MISSION: "Title of the mission",

    WITH_HISTORY: "With history",
    WITHOUT_HISTORY: "Without history",

    // ****************** ACTIVITIES 99 ADVISORY******************
    CROWFUNDING_SERVICE_PROVIDER: "Crowdfunding service provider",
    FINANCIAL_INVESTMENT_ADVISOR: "Financial investment advisor",
    DIGITAL_ASSET_SERVICE_PROVIDERS: "Digital asset service providers",
    MUTUAL_SECURITIZATION_FUND: "Mutual securitization fund",
    INVESTMENT_FIRM: "Investment firm",
    BANKING_ESTABLISHMENT: "Banking establishment",
    FOREST_MANAGEMENT: "Forest management",
    PRIVATE_EQUITIY: "Private equity",
    INFRASTRUCTURE: "Infrastructure",
    PRIVATE_DEBT: "Private debt",
    PROPERTY_MANAGEMENT: "Property mangement",
    SOPHISTICATED_MANAGEMENT: "Sophisticated management",
    TRADITIONAL_MANAGEMENT: "Traditional management",
    ACTION_PLAN_RELATED_ANOMALY: "The action plan related to the anomaly",
    ACTION_PLAN_RELATED_INCIDENT: "The action plan related to the incident",
    AUDIT_TRAIL_NAME: "Audit trail name",
    NEW_FIELD: "New field",
    DOCUMENTS_RECOMMENDATIONS: "Recommendations documents",
    RISK_PERIMETER: "Risk scrope",
    RISK_VALUATION: "Risk assessment",
    // ****************** BUSINESS INFORMATIONS CLIENTS ******************
    BI_CLIENTS: "Customers",
    BI_TELECHARGER: "Download",
    BI_AJOUT_CLIENT: "Add a client",
    BI_EDIT_CLIENT: "Edit a client",
    // ****************** BUSINESS INFORMATIONS GROUPS ******************
    TAB_GROUPS: "Groups",
    CREATED: "Create",
    GROUP_NAME: "Name of the group",
    ADD_GROUP: "Add a group",
    EDIT_GROUP: "Edit a group",
    MANAGER_GROUP: "Group Manager",
    CONNECTES_USERS: "Connected users",
    // ****************** NOTIFICATIONS ****************
    SUBSCRIBE: "Subscribe",
    NOTIFICATIONS: "Notifications",
    NOUVELLES_NOTIFICATIONS: "New notifications",
    AUCUNE_NOUVELLE_NOTIFICATION: "No new notification",
    HISTORIQUE_NOTIFICATIONS: "Notification history",
    AUCUN_HISTORIQUE: "No history available",
    NO_NOTIFICATION_AVAILABLE: "You haven’t received any notifications yet",
    NOTIFICATION_SUBSCRIPTION_INFO_1: "You can subscribe to notifications by clicking the ",
    NOTIFICATION_SUBSCRIPTION_INFO_2: " button on a repository’s page.",
    A_REPONDU_AU_CONTROLE: "responded to control",
    LE_CONTROLE_EST: "The control is",
    A_CREER_ANOMALIE: "created the issue",
    UPDATED_STATUS_NON_CONFORMITY_TO: "updated the status of the non-compliance",
    A_CREER_CONTROL: "created the control",
    A_CREER_INCIDENT: "created the incident",
    A_CREER_AUDIT_RECO: "created the audit recommendation",
    A_SUPPRIME_LA_PAGE: "deleted the page",
    A_MODIFIE_LA_PAGE: "modified the page",
    ASSIGNATION_PLAN_CONTROLE: "assigned you to the control plane",
    ASSIGNATION_CONTROLE: "assigned the following control to you",
    REJECTED_CONTROL: "rejected the control",
    VALIDATED_CONTROL: "validated the control",
    VALIDATED_ACTION_PLAN: "validated action plan",
    ACTIVATE_EMAIL_NOTIFICATIONS: "Enable email notifications",
    REGROUP_NOTIFICATIONS_SUMMARY: "Group your notifications into a summary",
    MAIL_SYNTHESIS_FREQUENCY: "Frequency",
    CATEGORIE_CONTROLE_1: "Assignment to a control",
    CATEGORIE_CONTROLE_2: "Processing of the control by the operational",
    CATEGORIE_CONTROLE_3: "Degrees of compliance of the control if non-compliant control",
    CATEGORIE_CONTROLE_4: "Degrees of compliance if control compliant",
    CATEGORIE_CONTROLE_5: "Reminder at D-2 deadline of the control",
    CATEGORIE_CONTROLE_6: "Reminder at D deadline of the control",
    CATEGORIE_CONTROLE_7: "D+2 relaunch of the control",
    CATEGORIE_CONTROLE_8: "Validation / Rejection of control",
    CATEGORIE_ANOMALIE_1: "Creation of an issue / incident",
    CATEGORIE_ANOMALIE_2: "Creation of an action plan related to an issue",
    CATEGORIE_ANOMALIE_3: "Assignment of an action plan",
    CATEGORIE_ANOMALIE_4: "Reminder at D-2 deadline of the action plan",
    CATEGORIE_ANOMALIE_5: "Reminder at D deadline of the action plan",
    CATEGORIE_ANOMALIE_6: "D+2 reminder of the action plan",
    CATEGORIE_ANOMALIE_7: "Processing of the action plan by the operational staff",
    CATEGORIE_ANOMALIE_8: "Validation or rejection of a completed action plan",
    CATEGORIE_RECOMMENDATION_1: "Create a recommendation",
    CATEGORIE_RECOMMENDATION_2: "Closing of the recommendation",
    CATEGORIE_RECOMMENDATION_3: "Creation of the recommendation action plan",
    CATEGORIE_RECOMMENDATION_4: "Recommendation Action Plan Assignment",
    CATEGORIE_RECOMMENDATION_5: "Processing of the action plan by the operational staff",
    CATEGORIE_RECOMMENDATION_6: "Comments from the control sheets",
    CATEGORIE_RECOMMENDATION_7: "Comments recommendation",
    CATEGORIE_DASHBOARD_1: "Sharing a dashboard",
    CATEGORIE_DASHBOARD_2: "Editing a dashboard",
    CATEGORIE_DASHBOARD_3: "Deleting a dashboard",
    MSF_CONTRAT_ETUDE_SIGNATAIRE: "assigned you as a signatory to the study contract",
    MSF_CONTRAT_ETUDE_VALIDATION: "has validated the study contract",
    MSF_CONTRAT_TRAVAUX_SIGNATAIRE: "assigned you as a signatory to the works contract",
    MSF_CONTRAT_TRAVAUX_VALIDATION: "has validated the works contract",
    MSF_DOES_NOT: "does not",
    MSF_BESOIN_MSF_COMPLET: "need a complete MSF need",
    MSF_OUVERTURE_PL: "PL requested on",
    MSF_FACTURATION: "CE sent to billing on",
    MSF_PPI_COPIE_INFRAPOLE: "PL and astre request transmitted to the PPI on",
    // ****************** ANOMALIES - INCIDENTS ****************
    ANOMALIE_REFERENCE: "Reference",
    ANOMALIE_CONTROLE: "Controls",
    ANOMALIE_PLAN_ACTION: "Action plan",
    ANOMALIE_STATUS: "Status",
    INCIDENT_NOM: "Name",
    INCIDENT_PROPRIETAIRE: "Owner ID",
    INCIDENT_CRITICITE: "Criticality",
    INCIDENTS: "Incidents",
    CREATOR: "Creator",
    WAITING_FOR_ADMIN_VALIDATION: "Waiting for admin validation",
    AWAITING_ADMIN_TASKS_VALIDATION: "Awaiting validation by the administrator",
    AWAITING_AUDITOR_TASKS_VALIDATION: "Awaiting validation of the tasks by the auditor",
    WAITING_VALIDATION: "Waiting validation",
    WAITING_FINAL_VALIDATION: "Waiting final validation",
    VALIDATE_BY_ADMIN: "Validated by admin",
    TASKS_TO_BE_CARRIED: "Tasks to be carried out",
    CLOSED: "Closed",
    SUCCESS_TO_DELETE_ANOMALY: "The issue has been successfully removed",
    CONFIRMATION_DELETE_ANOMALIE: "Do you really want to delete this anomaly ?",
    CONFIRMATION_DELETE_INCIDENT: "Do you really want to delete this incident ?",
    CONFIRMATION_DELETE_AUDIT_RECO: "Do you really want to delete this audit recommendation ?",
    CONFIRMATION_DELETE_RECO: "Do you really want to delete this recommendation ?",
    IL_A_REFERENCE: "it has as a reference",
    ELLE_A_REFERENCE: "it has as a reference",
    PERFORMERS_ANO: "Assigned to",
    TASK_LIST: "Task lists",
    NO_NEED_TASK: "Criticality does not require establishing tasks",
    SAVE_EDIT: "Save changes",
    SUCESS_TO_CREATE_NON_CONFORMITY: "The no compliance has been successfully created.",
    SUCCESS_TO_UPDATE_NON_CONFORMITY: "The no compliance has been successfully updated.",
    SUCCESS_TO_UPDATE_STATUT_NON_CONFORMITY:
      "The status of the non-compliance has been successfully changed.",
    SUCCESS_TO_DELETE_NON_CONFORMITY: "The no compliance has been successfully removed.",
    SUCCESS_TO_DELETE_INCIDENT: "The incident has been successfully deleted.",
    SUCCESS_TO_DELETE_ANOMALY: "The anomaly has been successfully removed.",
    FAIL_TO_DELETE_INCIDENT: "Failed to delete incident.",
    FAIL_TO_DELETE_ANOMALY: "Failed to delete anomaly.",
    FAIL_TO_CREATE_NON_CONFORMITY: "We encountered an error while creating your no compliance.",
    FAIL_TO_UPDATE_NON_CONFORMITY: "We encountered an error while updating your no compliance.",
    FAIL_TO_DELETE_NON_CONFORMITY: "We encountered an error while deleting your no compliance.",
    APPEARS_IN_VISUALIZATION_BOARD: "Appears in the visualization board",
    WARNING_TO_EXIST_REF_NON_CONFORMITY: "The reference entered is already in use.",
    // ****************** CONFIG PARTAGE SOURCE ****************
    SHARE_MY_SOURCE: "Share my source",
    ADD_NEW_RIGHT: "Add new right",
    CONFIG_SOURCE_RIGHT: "Source rights configuration",
    CONFIG_LINE_SOURCE_RIGHT: "Configuration of source line rights",
    MY_CURRENT_SOURCE_RIGHT: "My current source rights",
    RIGHT_AFFECTED: "Affected rights",
    GROUPS_CONCERNED: "Groups concerned",
    OPERATOR: "Operator",
    VALUE_FIELD: "Field value",
    READ_LABEL: "Read",
    EDIT_LABEL: "Edit",
    SHARE_LABEL: "Share",
    DELETE_LABEL: "Delete",
    ADD_FIELD_LABEL: "Add Field",
    MESSAGE_ALERT_PERMISSION:
      "The group does not have sufficient source rights to configure row rights",
    // ****************** CENTRE NOTIFICATION ****************
    QUAND_ET_COMMENT: "Choose when and how to receive notifications",
    SELECT_NOTIFICATION:
      "Select which push notifications and email notifications you want to receive",
    // ****************** Traduction Orange ****************
    PROCESSUS: "Process",
    SUB_PROCESSUS: "Sub process",
    CREATE_A_PROCESSUS: "CREATE A PROCESS",
    ADD_PROCESSUS: "Create Process",
    EDIT_PROCESSUS: "Edit Process",
    newProcessus: "new process",
    addProcessus: "add a process",
    editProcessus: "edit a process",
    labelProcessus1: "Process name",
    labelProcessus2: "Process reference",
    ASSIGN_TO_PROCESSUS: "Assign to a process",
    ASSIGN_TO_SUB_PROCESSUS: "Assign to a sub-process",
    DELETE_PROCESSUS: "Delete Process",
    CONFIRM_DELETE_PROCESSUS: "Do you really want to delete this process?",
    // ****************** Traduction SNCF MSF ****************
    PHONE: "Phone",
    BUSINESS: "Business",
    DESCRIPTIF: "Description",
    STUDY_CONTRACT: "Study contract",
    WORKS_CONTRACT: "Works contract",
    MSF_MANAGER: "Responsable",
    MSF_AFFAIRE_CONCERNED: "Case concerned",
    MSF_MODEL: "Model",
    MSF_NAME_CONTRAT: "Contract name",
    MSF_ADD_ATTACHMENT: "Add attachment",
    WORK_PLANNING: "WORK PLANNING",
    CAPABILITIES: "CAPACITIES",
    STEP_TRACKING: "STEP TRACKING",
    SEND_PLANNING: "SEND PLANNING",
    VALIDATE_PLANNING: "VALIDATE PLANNING",
    UNVALIDATE_PLANNING: "UNVALIDATE PLANNING",
    ACCOMPANIMENTS: "Accompaniments",
    CATENARY_BREAKS: "Catenary breaks",
    ITC: "ITC",
    ADVERTISERS: "Advertisers",
    LTV: "LTV",
    IC_VISIT: "IC visit",
    SETTING_TARGET: "Setting targets",
    FOLLOWED_BY_DRILLING: "Drilling support",
    TARGET_DROP: "Dropping targets",
    MSF_LINES: "Lines",
    MSF_WAY: "Way",
    MSF_WORKING_RANGE_AVAILABLE: "Working range available",
    MSF_WORKING_RANGE_TIME: "Work schedule available",
    MSF_AVAILABLE_DATE: "Available date",
    MSF_REMARKS: "Remarks",
    MSF_ADD_LINES: "ADD LINES",
    MSF_ADD_LINES_TRAVAUX: "ADD A LINE WORKS",
    MSF_NATURE_OPERATION: "Nature of the operation",
    MSF_SIGNATORY_STUDY: "Study contract signatory",
    MSF_SIGNATORY_WORKS: "Work contract signatory",
    MSF_ADD_A_DATE: "ADD A DATE",
    MSF_NIGHT_OF: "Night of",
    MSF_RELANCE_SIGNATORY: "REMIND SIGNATURE",
    MSF_RELANCE_SIGNATORY_SUCCESS: "The reminder has been sent",
    MSF_MAIL_SENT: "Mail sent",
    MSF_TIME_RANGE: "Time range",
    MSF_DAY_TO_DAY: "Day to day (ex: MoTu)",
    DESTINATAIRE: "Recipient",
    INTERLOCUTEUR: "Interlocutor",
    MAIL_SUBJECT: "Mail subject",
    EMAIL_SENT: "Email sent",
    SUCCESS_TO_PATCH_DATA_AFFAIRE: "The case data has been successfully updated",
    SUCCESS_TO_GET_DOCUSIGN_ACCESS_TOKEN: "Connection to DocuSign successful",
    // *********** Structuring Source ******************
    CREATED_TABLE: "Creating new table",
    IMPORT_TABLE: "Import table",
    LOAD_TABLE: "Load table",
    ADD_TABLE: "Add table",
    JOINTURE: "Join",
    ADD_COLONNE: "Add a column",
    NOM_COLONNE: "Name a column",
    DELETE_COLONNE: "Delete a column",
    GROUPER_PAR: "Group by",
    FORMULE: "Formula",
    FILTRE: "Filter",
    CLEAR_FILTER: "Clear Filter",
    NOM_CHAMP: "Name a field",
    CONDITION: "Condition",
    DISPO_TABLE: "Available table",
    MANIPULE_TABLE: "Manipulated table",
    EXPORT: "Export",
    LOAD: "Load",
    // **************** Administration *************************
    INFORMATIONS: "Informations",
    CREATE_NEW_PROFILE: "Create a new profile",
    NEW_PROFILE: "New profile",
    PROFILE: "Profile",
    PROFILE_NAME: "Profile name",
    PROFILE_NAME_IS_EMPTY: "Profile Name is invalid",
    NO_MODULE_SELECTED: "No module selected",
    PROFILES: "Profiles",
    ORGANIGRAMME: "Organizational chart",
    SA: "AS",
    UPDATE_AVAILABLE: "Update to see the latest changes",
    CREATE_NEW_ENTITY: "Create a new entity",
    ADD_OR_DELETE_USER_FROM_ENTITY: "Add / Delete user from entity",
    REMOVE_ALL_MEMBERS_OF_ENTITY: "Remove all members from entity",
    WOULD_YOU_LIKE_TO_DELETE_THIS_ENTITY: "Would you like to delete this entity ?",
    SUB_ENTITIES_WILL_ALSO_BE_DELETED: "Sub-entities will also be deleted",
    WOULD_YOU_LIKE_TO_ARCHIVE_THIS_ENTITY: "Would you like to archive this entity ?",
    SUB_ENTITIES_WILL_ALSO_BE_ARCHIVED: "Sub-entities will also be archived",
    WOULD_YOU_LIKE_TO_UNARCHIVE_THIS_ENTITY: "Would you like to unarchive this entity ?",
    SUB_ENTITIES_WILL_ALSO_BE_UNARCHIVED: "Sub-entities will also be unarchived",
    WOULD_YOU_LIKE_TO_REMOVE_ALL_MEMBERS_OF_THIS_ENTITY:
      "Would you like to remove all members of this entity ?",
    NEW_ENTITY: "New entity",
    ATTACHED_TO_SUPERIOR_ENTITY: "Attached to a superior entity",
    CONCERNED_MODULE: "Concerned Module",
    CLEARANCE_LEVEL: "Clearance level",
    INSTITUTIONAL_RELATION: "Institutional relations",
    MAIL_MANAGEMENT: "Mail management",
    PLATEFORM: "Platform",
    CAN_ACCESS_MAIL_MANAGEMENT: "Access to mail management",
    CAN_ACCESS_INSTITUTIONAL_RELATION: "Access to institutional relations",
    // ****************** Objectif Perigourdine *********************
    GESTION_OBJECTIFS: "Objectives management",
    OBJECTIF: "Objectives",
    PAR_GROUPE: "By groups",
    PAR_POLE_COMMERCIAL: "By sales center",
    OBJECTIF_CA: "Turnover objective",
    OBJECTIF_MARGE: "Margin objective",
    CHIFFRE_AFFAIRE_N1: "Turnover N-1",
    CA_N1: "Turnover N-1",
    CA_CALCULE: "Calculated turnover",
    CA: "Turnover",
    TAUX_CROISSANCE_ATTENDU: "Expected growth rate",
    MARGE_N1: "Margin N-1",
    MARGE_CALCULEE: "Calculated margin",
    MARGE: "Margin",
    SOUS_FAMILLE: "Subfamily",
    FAMILLE: "Family",
    COMMERCIAL: "Commercial",
    VARIATION_N1: "Variation N-1",
    REALISE: "Realized",
    DASHBOARD_VISUALISATION: "Dashboard Visualisation",
    EDIT_OBJECTIFS: "Edit Objectives",
    // *********** Chats ******************
    CHAT_ACCESS_TO_CHAT:
      "You will be able to access the chat once you have created the time sheet.",
    CHAT_ERROR_LOAD_DATA: "There was a problem retrieving your messages.",
    CHAT_REQUIRE_CONTENT: "The message cannot be empty.",
    CHAT_RETRY: "Try again",
    CHAT_MENTION_PLACEHOLDER: "Write a message, @ to mention someone",
    CHAT_MENTION_NO_RESULT: "No user with access to this item",
    CHAT_MENTION_LOADING: "Searching…",
    CHAT_MENTION_UNKNOWN_USER: "Unknown user",
    CHAT_MENTION_LIMIT_REACHED: "You can mention up to 20 people per message",
    // *************** GRC REFERENTIALS *************
    WAITING_SAVE: "Waiting save",
    LABEL_RIGHT: "Right",
    LABEL_ADD: "Add",
    LABEL_DOWNLOAD_EXEMPLE: "Download example",
    LABEL_DOWNLOAD_NOT_IMPORTED_DATA: "Download not imported data",
    LABEL_IMPORT: "Import",
    LABEL_CREATE: "Create",
    REFERENTIAL: "Referential",
    REFERENTIALS: "Referentials",
    REFERENTIALS_SELECT_REFERENTIAL: "Please select a repository.",
    REFERENTIALS_SHOW_WORKFLOW: "View workflows",
    REFERENTIALS_ACTION_ADD: "Add",
    REFERENTIALS_NOT_FOUND: "Error: Referential not Found.",
    REFERENTIALS_OPEN_MODAL: "Open in modal",
    REFERENTIALS_LOAD_MORE: "Load more",
    REFERENTIALS_LOADING_MORE: "Loading...",
    REFERENTIALS_NO_DATASOURCE: "No data source",
    REFERENTIALS_EMPTY_STATE: "No items",
    REFERENTIALS_OPEN_SAMPLE: "Open record",
    REFERENTIALS_SAMPLE_DETAILS: "Item details",
    REFERENTIALS_MENU_SECTION_ACTIONS: "Actions",
    REFERENTIALS_MENU_SECTION_ADMIN: "Admin",
    REFERENTIALS_MENU_SECTION_WORKFLOW: "Workflow",
    REFERENTIALS_MENU_SECTION_CAMPAIGNS: "Campaigns",
    REFERENTIALS_MENU_IMPORT: "Import",
    REFERENTIALS_MENU_DUPLICATE: "Duplicate",
    REFERENTIALS_MENU_REPAIR_RIGHTS: "Repair samples",
    REFERENTIALS_REPAIR_SUCCESS: "Repair completed.",
    REFERENTIALS_REPAIR_STREAM_ERROR: "Repair stream error: %error%",
    REFERENTIALS_KPI_UPDATE_SUCCESS: "KPIs updated successfully.",
    REFERENTIALS_KPI_UPDATE_ERROR: "Unable to update KPIs.",
    REFERENTIALS_UNIQUE_INFO_PREFIX: "Existing information:",
    HISTORY_REDIRECTION_TITLE: "Show the version corresponding to this update",
    HISTORY_TITLE: "Latest changes",
    HISTORY_TEXT: "has modified",
    FORM_SUCCESS_MESSAGE: "Update successful.",
    FORM_NO_CHANGES_MESSAGE: "No changes to save.",
    FORM_ERROR_MESSAGE: "Error: Update failed.",
    FORM_NEW_VERSION_RECEIVED: "New version received.",
    ARIA_LABEL_ADD_SAMPLE: "Add a sample",
    ARIA_LABEL_CREATE_SAMPLE: "Create a sample",
    ARIA_LABEL_CLOSE_MODAL: "Close modal",
    ARIA_LABEL_CLOSE: "Close",
    ALERT_REDIRECT_CREATE_SAMPLE:
      "Please save the current edit before you can create a new recording. Actions button > Save.",
    BOOLEAN_INPUT_FALSE: "No",
    BOOLEAN_INPUT_TRUE: "Yes",
    INPUT_UPLOAD_FILE_COUNT_ONE: "{count} file added",
    INPUT_UPLOAD_FILE_COUNT_OTHER: "{count} files added",
    INPUT_UPLOAD_FILE_LABEL_ONE: "File added",
    INPUT_UPLOAD_FILE_LABEL_OTHER: "Files added",
    INPUT_UPLOAD_FILE_TEXT_1: "file",
    INPUT_UPLOAD_FILE_TEXT_2: "added",
    FILE_TRANSFER_IN_PROGRESS: "File transfer in progress",
    EXPORT_IN_PROGRESS: "Export in progress",
    REQUIRED_FIELDS_ARE_EMPTY:
      "Make sure to correct all fields in red and follow the instructions indicated in red",
    EXPORT_TYPE: "Export type",
    AG_GRID_MENU_1: "Open in new tab",
    DOWNLOAD_DOCUMENT_1: "Data recovery",
    DOWNLOAD_DOCUMENT_2: "Preparing data",
    DOWNLOAD_DOCUMENT_3: "Downloading data",
    DOWNLOAD_DOCUMENT_MENU_1: "Export this page to CSV",
    DOWNLOAD_DOCUMENT_MENU_2: "Export to CSV",
    DOWNLOAD_DOCUMENT_MENU_3: "Export this page to XLSX",
    DOWNLOAD_DOCUMENT_MENU_4: "Export to XLSX",
    TOOLTIP_LOCK_JSON_FORMS: "Auto field",
    TOOLTIP_LOCK_SELECT_ROLE_DOC: "Please create your file for this functionality",
    TOOLTIP_REQUIRED_FIELD: "Required field",
    ALERT_DELETE_REFERENTIAL_SUB_CONTENT: "This item is linked to other items.",
    ALERT_REQUIRED_FIELDS: "The following fields must be correctly filled in:",
    // *************** GRC Evaluation *************
    INSTANTIATION: "Instantiation",
    ASSIGNED: "Assigned",
    INSERT: "Insert",
    ADD_FOLDER: "Add Folder",
    OCCURENCES: "Occurences",
    A_QUESTION: "A question",
    A_TEXT: "Un texte",
    ADD_A_QUESTION: "Add a question",
    EDIT_A_QUESTION: "Edit question",
    QUESTION: "Question",
    SCOPE_OF_QUESTION: "Scope of question",
    RESPONSE_TYPE: "Response type",
    MANDATORY_RESPONSE: "Mandatory response",
    CONDITIONAL_QUESTION: "Conditional question",
    CONDITIONAL_QUESTION_REFERENCE: "Choose the reference question",
    CONDITIONAL_QUESTION_VALUE: "Conditional value",
    CONDITIONAL_QUESTION_OPERATOR: "Operator",
    ADD_TEXT: "Add text",
    EDIT_TEXT: "Edit text",
    WORDING: "Wording",
    EDITER: "Edit",
    PARAMETER: "Parameter",
    FOLLOW_UPS: "Follow-ups",
    RESULTAT: "Result",
    ADDED_SAMPLE: "Added a new link",
    REMOVED_SAMPLE: "Removed a link",
    SAVE_AND_ACTIVE: "Save and active",
    SAVE_AND_RUN: "Save and run",
    SEND_FOR_REVIEW: "Send for review",
    EXTRACT: "extract",
    VARIABLE: "Variable",
    KPIS: "KPIS",
    CALCULATE_KPI: "Calculate a KPI",
    EDIT_KPI: "Edit KPI",
    NO_OCCURENCE_ACTIVE: "No active occurrence",
    FORM_BLOCKER_UNSAVED_QUIT_TITLE: "Changes not saved.",
    FORM_BLOCKER_UNSAVED_QUIT_CONTENT: "Do you want to save before exiting ?",
    FROM_BLOCKER_SAVE_QUIT: "No, Save and Exit",
    FROM_BLOCKER_NOSAVE_QUIT: "Yes, Exit Without Saving",
    NO_ACTIVE_WORFLOW: "No Active Workflow",
    START_RUN: "Validate",
    FROM_TITLE_START_RUN: "Start the evaluation",
    FROM_CONTENT_START_RUN:
      "Once the evaluation has started, you will no longer be able to modify the content of the questionnaire. Are you sure you want to continue?",
    FROM_CONTENT_START_RUN_2:
      "You are about to start the evaluation. Are you sure you want to continue?",
    QUESTIONNAIRE_NOT_CREATED_INFO: "You have not yet created a questionnaire for this control.",
    LIST_OF_FOLDERS: "List of folders",
    PREVIOUS: "Previous",
    NEXT: "Next",
    ACCES_REFERENTIAL: "Access the referential",
    IMPORT_EXCEL: "Import excel",
    DELETE_SAMPLES: "Are you sure you want to delete the selected data?",
    ADD_SAMPLES: "Add samples",
    ADD_SAMPLE: "Add sample",
    NUMBER_OF_SAMPLES_TO_ADD: "Number of samples to add",
    ADD_SAMPLES_MANUALLY: "Add samples manually",
    ADD_SAMPLES_CSV: "Add samples via a CSV file",
    ADD_VARIABLE: "Add variable",
    OCCURRENCE_NOTES_ADD_BTN: "Add",
    OCCURRENCE_NOTES_ADD_BTN_TITLE: "Add an attachment",
    OCCURRENCE_NOTES_ATTACHMENTS_LABEL: "Supporting documents",
    OCCURRENCE_NOTES_BTN_LABEL: "Supporting documents",
    OCCURRENCE_NOTES_CANCEL: "Cancel",
    OCCURRENCE_NOTES_CLOSE: "Close",
    OCCURRENCE_NOTES_DELETE_TITLE: "Delete",
    OCCURRENCE_NOTES_ERR_DELETE: "Error deleting the supporting document",
    OCCURRENCE_NOTES_ERR_MAX_FILES: "Maximum number of attachments reached (5)",
    OCCURRENCE_NOTES_ERR_MIME: "File type not allowed",
    OCCURRENCE_NOTES_ERR_OPEN: "Unable to open the file",
    OCCURRENCE_NOTES_ERR_SAVE: "Error saving the observation",
    OCCURRENCE_NOTES_ERR_SIZE: "File too large (max 10 MB)",
    OCCURRENCE_NOTES_ERR_UPLOAD: "Upload error",
    OCCURRENCE_NOTES_NO_ATTACHMENTS: "No attachments",
    OCCURRENCE_NOTES_OBSERVATION_LABEL: "Observation",
    OCCURRENCE_NOTES_OBSERVATION_PLACEHOLDER: "Add an observation…",
    OCCURRENCE_NOTES_SUCCESS_ADD: "Supporting document added",
    OCCURRENCE_NOTES_SUCCESS_DELETE: "Supporting document deleted",
    OCCURRENCE_NOTES_TITLE: "Supporting documents",
    OCCURRENCE_NOTES_VALIDATE: "Validate",
    MESSAGE_INFOS_SAMPLE: "The addition was ignored because this repository is already in use",
    MESSAGE_INFOS_EXISTING_LINK: "Already existing link",
    ONE_ITEM_ONLY: "Unique",
    RESPONSE_RATE: "Response rate",
    RESPONSE_EXIT_ALERT_CONTENT: "This response contains unsaved changes. What do you want to do with them?",
    RESPONSE_EXIT_ALERT_LEAVE: "Leave without saving",
    RESPONSE_EXIT_ALERT_REQUIRED_MISSING: "Some required fields are empty: fill them in to be able to validate.",
    RESPONSE_EXIT_ALERT_TITLE: "Unsaved changes",
    ANSWERED: "Answered",
    BY: "by",
    NOT_ANSWERED: "Not answered",
    WEIGHT: "Weight",
    PERSONALIZED_FORMULA: "Personalized formula",
    PTS_CONTROL_TABLE_COL_1: "Start date",
    PTS_CONTROL_TABLE_COL_2: "End date",
    PTS_CONTROL_TABLE_COL_3: "Responsible",
    PTS_CONTROL_TABLE_COL_4: "Assigned",
    PTS_CONTROL_TABLE_COL_5: "Start date of implementation",
    PTS_CONTROL_TABLE_COL_6: "End date of implementation",
    CLOSED_F: "Closed",
    TO_ANSWER: "To answer",
    ANSWERED_F: "Answered",
    NOT_READY_F: "Not ready",
    MODAL_AFFECT_OCCURRENCE_1: "Response period",
    MODAL_AFFECT_OCCURRENCE_2: "Start date",
    MODAL_AFFECT_OCCURRENCE_3: "End date",
    LOADER_GRC: "Loading...",
    EXECUTION: "Execution",
    EXECUTION_DU_CONTROLE: "Execution of the control",
    EXECUTE_CONTROL: "Execute the check",
    EDIT_KPIS: "Edit KPIS",
    SAVE_ANSWER: "Save and validate",
    SAVE_DRAFT_V2: "Save as draft",
    SYNCING_AFTER_SAVE: "Save confirmed — syncing with server…",
    NEW_DATA_AVAILABLE_RELOAD: "New data available — please reload before saving.",
    DRAFT_CONFLICTS_TITLE: "Conflicts detected",
    DRAFT_IN_CREATION: "Creation in progress: unsaved changes.",
    CREATION_READY: "Creation in progress: you can start typing.",
    DRAFT_UNSAVED_TITLE: "You have unsaved changes.",
    DRAFT_EXISTS_READONLY: "Unsaved changes available. You can save them.",
    WRITE_DRAFT_EXISTS: "An edit draft exists (not applied in this mode).",
    SYNCING: "Syncing…",
    RELOAD: "Reload",
    RESOLVE_CONFLICTS: "Resolve",
    RELOAD_BEFORE_SAVE: "Reload before saving",
    VIEW_CHANGES_TITLE: "Preview your changes",
    DELTA_OLD_VALUE: "Previous value",
    DELTA_NEW_VALUE: "New value",
    HISTORY_VERSION_OF: "Version of {date}",
    CELL_LIST_MORE_ARIA: "{count} more, view all",
    CELL_LIST_LINKS_COUNT_ONE: "1 link",
    CELL_LIST_LINKS_COUNT_OTHER: "{count} links",
    CELL_LIST_UNTITLED: "{count} untitled",
    RESOLVE_CONFLICTS_TITLE: "Conflict resolution",
    RESOLVE_AND_CONTINUE: "Resolve and continue",
    DISCARD_DRAFT: "Discard",
    DISCARD_DRAFT_CONFIRM: "Discard the draft?",
    DRAFT_DISCARDED: "Draft discarded.",
    NO_CHANGES_TO_SAVE: "No changes to save.",
    SAMPLE_UPDATED_SUCCESSFULLY: "Saved.",
    HEADER_SWITCH_CLASSIC: "Switch back to classic",
    HEADER_SWITCH_MODERN: "Try the modern style",
    AUTH_GUARD_MODAL_H2: "Your session will expire soon",
    AUTH_GUARD_MODAL_CONTENT:
      "For your security, your session will expire in 5 minutes. Be sure to save your current work or renew your session to stay logged in.",
    AUTH_GUARD_MODAL_BUTTON: "Renew Session",
    CHOOSE_A_STEP: "Choose a step",
    ROLES_SPEC_DOC: "Document specific roles",
    CONFIG_ROLES_SPEC_DOC: "Configuring roles per repository",
    GRACE_PERIOD: "Grace period",
    REALISATION_DURATION: "Realization duration",
    // *************** GRC Tasks *************
    TASK: "Task",
    MY_TASKS: "My tasks",
    GROUP_TASKS: "Tasks group",
    NATURE: "Nature",
    COMPLETION: "Completion",
    LATE: "Late",
    IS_LATE: "Is late",
    DAYS_LATE: "Days late",
    LATE_STATUS: "Late status",
    ASSIGNOR: "Assignor",
    ASSIGNED: "Assigned",
    TASKS_STATUS: "Tasks status",
    TASKS_NATURE: "Tasks nature",
    OBJECT_TYPE: "Object type",
    OBJECT_NAME: "Object Name",
    GROUP_LEVEL: "Group level",
    LABEL_YEAR: "Year",
    LABEL_MONTH: "Month",
    LABEL_WEEK: "Week",
    LABEL_DAY: "Day",
    SHOW_LIST: "Show list",
    LABEL_TABLE: "Table",
    LABEL_GANTT: "Gantt",
    LABEL_SHOW_LEGEND: "Show Legend",
    LABEL_LIBELLE: "Label",
    LABEL_START_DATE: "Start date",
    LABEL_END_DATE: "End date",
    LABEL_PROGRESS: "Progress",
    LABEL_DURATION: "Duration",
    UNIT: "Unit",
    DOWNLOAD_QUESTIONNAIRE: "Download the questionnaire",
    DOWNLOAD_QUESTIONNAIRE_UNIQ_SHEET: "Download the questionnaire (response in a single tab)",
    DOWNLOAD_QUESTIONNAIRE_MULTIPLES_SHEETS: "Download the questionnaire (answers per item)",
    RETURN_QUESTIONNAIRE: "Return the questionnaire",
    SEND_ANSWERS: "Send answers",
    EXPORT_RESPONSES: "Export responses",
    ENLARGE: "Enlarge",
    REDUCE: "Reduce",
    // *************** Communications Page ***************
    CONVERSATIONS: "Conversations",
    NAVIGATION_ERROR_1: "An error occurred while retrieving conversations.",
    MODAL_SETTING_CONVERSATION_1: "Chat Settings",
    MODAL_SETTING_CONVERSATION_SELECT_1: "Participants",
    MODAL_SETTING_CONVERSATION_INPUT_1: "Conversation name",
    MODAL_SETTING_CONVERSATION_INPUT_2: "Pinned conversation",
    MODAL_SETTING_CONVERSATION_BUTTON_1: "Delete conversation",
    MODAL_SETTING_CONVERSATION_DELETE_1: "Are you sure you want to delete this conversation?",
    ICON_CONVERSATION_TEXT_1: "Start a new chat to see your conversations appear here.",
    ICON_CONVERSATION_TEXT_2: "Create a chat",
    ICON_CONVERSATION_TEXT_3: "You have no conversation found yet.",
    ICON_CONVERSATION_TEXT_4: "You have no conversation associated with yet:",
    // *************** Modal Configuration Duplication ***************
    MODAL_DUPLICATION_CONFIGURATION_MAIN_TITLE: "Duplication settings",
    MODAL_DUPLICATION_CONFIGURATION_FIELD_1: "Select all",
    MODAL_DUPLICATION_CONFIGURATION_LABEL_1: "Duplicate while keeping links :",
    // *************** Export Modal ***************
    MODAL_EXPORT_CONFIGURATION_LABEL_1: "Export while keeping data :",
    MODAL_EXPORT_CONFIGURATION_LABEL_2: "Related items :",
    // *************** Import Data Modal ***************
    MODAL_IMPORT_DATA_LABEL_1: "Download the template to enter your data",
    MODAL_IMPORT_DATA_ERROR_LABEL_1: "Error while importing - Some data could not be integrated",
    MODAL_IMPORT_DATA_ERROR_SUB_LABEL_1: "Click here to view the error details",
    MODAL_IMPORT_DATA_ERROR_MODAL_HEADER: "Detail of errors",
    MODAL_IMPORT_DATA_LABEL_2: "Upload the file here once completed",
    MODAL_IMPORT_DATA_ERROR_LABEL_2: "Upload the file here once modified",
    MODAL_IMPORT_DATA_LABEL_3: "Click Add to import your data into the application",
    MODAL_IMPORT_DATA__ERROR_LABEL_3: "Click Add to import your data into the application",
    MODAL_IMPORT_DATA_LABEL_4: "Données en cours d'intégration...",
    MODAL_IMPORT_DATA_ERROR_LABEL_4: "Données en cours d'intégration...",
    INPUT_FILES_DND_LABEL_1: "Drag and drop your file",
    INPUT_FILES_DND_LABEL_2: "Processing...",
    NUMBER_OF_DAYS: "Number of days",
    CUSTOMIZE_REALIZATION_PERIOD: "Customize the completion period",
    RESTRICTION_REALIZATION_PERIOD: "Restriction of the period of realization",
    NO_CONTROL_IS_LINKED_YET: "No control is linked yet",
    CONTROLS_WILL_BE_CARRIED_OUF_FROM: "The controls will be carried out fromu",
    CHOOSE_FREQUENCY_EACH_CONTROL: "Please choose a frequency of occurrence for each control",
    EXECUTION_OF_CONTROLS: "Execution of controls",
    FOR_THIS_CHECK_CHOOSE_DOMAIN: "For such a check, choose a sample domain",
    FOR_THIS_CHECK_CHOOSE_COUNT_ECHANTILLONS: "For such a control, choose a sample size,",
    RAPPORTER: "Rapporteur",
    TASK_LABEL: "Task label",
    CURRENT_TASKS: "Current tasks",
    NEW_DOCUMENTS: "New documents",
    SELECT_FIELDS: "Select fields",
    SELECT_FIELDS_DESCRIPTION:
      "You can use here fields already created from other evaluations. This will not affect the original evaluations.",
    CONDITIONAL: "Conditional",
    NO_FIELDS_AVAILABLE: "No fields available",
    REQUIRED: "Required",
    CONTROL_INSTANCE: "Control instance",
    DATES_OF_OCCURENCE: "Dates of occurence",
    RESULT_OF_CONTROL: "Results of the control",
    NONE_KPIS_CONFIGURED: "No tracking flags configured",
    MAIN_KPI: "Main KPI",
    NO_RESULT_YET: "No result yet.",
    MAIN_KPI_NOT_COMPUTED: "Main KPI not calculated for this campaign.",
    CURRENT_PERIOD: "current",
    PERIODS_LABEL: "period(s)",
    CAMPAIGN_MISSING_NAME: "Campaign name missing",
    CAMPAIGN_MISSING_START_DATE: "Start date missing",
    CAMPAIGN_MISSING_END_DATE: "End date missing",
    CAMPAIGN_MISSING_CONTROLS: "No controls to launch",
    MISSING_INFORMATIONS: "Missing informations",
    COMPLETED: "Completed",
    CANCELLED_FEMALE: "Cancelled",
    SUCCESS_OCCURENCE_UPDATE: "Occurence updated successfully",
    ERROR_OCCURENCE_UPDATE: "Error updating the occurence",
    SUCCESS_SAMPLES_ADDED: "Samples added successfully",
    ERROR_SAMPLES_ADDED: "Error adding samples",
    EXECUTE_CONTROLS: "Execute controls",
    CAMPAIGN_ALREADY_EXISTS:
      "A control campaign already exists. You can modify the start date of the controls execution.",
    OCCURENCE_CLOSED_PAST:
      "Unable to respond to this occurrence as the completion date has passed.",
    OCCURENCE_CLOSED_FUTURE:
      "Unable to respond to this occurrence as the completion date has not yet been reached.",
    OCCURENCE_LOCKED: "The occurrence is locked because a response has already been recorded",
    NEXT_STEP: "Next step",
    PREVIOUS_STEP: "Previous step",
    CONFIGURATION: "Configuration",
    CAMPAIGNS_RESULTS: "Campaigns results",
    CAMPAIGNS_NAME: "Campaign name",
    CAMPAIGN_SUPERVISORS: "Campaign Supervisors",
    CAMPAIGNS_SELECT_FOR_ALL: "Select for all :",
    CAMPAIGNS: "Campaigns",
    CAMPAIGN_CREATE: "Create a campaign",
    CARD_NO_DESCRIPTION: "No description",
    NO_CAMPAIGN_CREATED: "You have not created a campaign yet.",
    NO_RESULT_CAMPAIGN: "This campaign does not yet contain any responses.",
    FROM_TITLE_CLOSING_CAMPAIGN: "Close the campaign",
    FROM_CONTENT_CLOSING_CAMPAIGN: "You are about to close the campaign",
    FROM_SUB_CONTENT_CLOSING_CAMPAIGN: "Are you sure you want to continue?",
    FROM_TITLE_ARCHIVING_CAMPAIGN: "Archive the campaign",
    FROM_CONTENT_ARCHIVING_CAMPAIGN: "You are about to archive the campaign",
    ARCHIVE_OCCURRENCE: "Archive occurrence",
    ARCHIVE_DOSSIER_SAMPLE: "Archive the sample",
    FROM_CONTENT_ARCHIVING_OCCURRENCE: "You are about to archive this occurrence.",
    FROM_SUB_CONTENT_ARCHIVING_OCCURRENCE: "Are you sure you want to continue ?",
    FROM_SUB_CONTENT_ARCHIVING_CAMPAIGN: "Are you sure you want to continue ?",
    FROM_CONTENT_ARCHIVING_DOSSIER: "You are about to archive the sample",
    FROM_SUB_CONTENT_ARCHIVING_DOSSIER: "Are you sure you want to continue ?",
    ERROR_DATE_CAMPAIGN: "The end date cannot be earlier than the start date.",
    LABEL_RESPONSE: "Response",
    LABEL_RESPONSES: "Responses",
    NO_CAMPAIGN: "No campaign",
    CLOSING_CAMPAIGN: "Closed",
    VIEW_CAMPAIGN: "View",
    ENCLOSE_CAMPAIGN: "Close",
    NONE_CAMPAIGN: "No campaign found with your search.",
    ERROR_LOAD: "Loading error",
    AFFECTED_ORGA: "Assignment of entities",
    TAB_OVERVIEW: "Overview",
    TAB_TABLE_LIST: "List",
    TAB_TABLE_ARBRE: "Tree structure",
    SAVING_THE_CONFIGURATION: "Saving the configuration",
    REFRESH_DATA: "Refresh data",
    DATA_UP_TO_DATE: "Data up to date",
    DATA_STALE: "Data outdated",
    DATA_LAST_MODIFIED: "Data last modified",
    REFERENTIAL_LAST_UPDATED: "Referentials config last updated",
    DASHBOARD_LAST_REFRESHED: "Dashboard last refreshed",
    DATA_STALE_HINT: "Data has changed since the last computation — consider refreshing.",
    NEVER: "never",
    ERROR_RETRY: "An unexpected error has occurred. Please try again.",
    ADD_CUSTOM_FIELD: "Add a custom field",
    // JsonForms GedLink
    GED_LINK_VIEW_DOCUMENT: "View document",
    GED_LINK_EDIT_DOCUMENT: "Edit document",
    GED_LINK_DELETE_DOCUMENT: "Delete document",
    GED_LINK_LOADING: "Loading documents...",
    GED_LINK_OPEN_DOCUMENT: "Browse documents",
    GED_SEE_MORE: "See more",
    websocketLost: {
      title: "Server connection lost",
      reconnecting: "Attempting to restore connection automatically…",
      disconnected: "Connection lost. Reconnecting…",
      disconnectedNetwork: "Connection lost. Please check your network or contact IT.",
      disconnectedServer:
        "Connection lost. The server appears down—please check server status or contact IT.",
      attempts: "Number of attempts",
      reloadWarning: "Do not reload the page to avoid data loss.",
      checkServers: "Before anything, check server status:",
      viewStatus: "View real-time status",
      reloadButton: "Reload page (last resort)",
      reloadConfirmTitle: "Warning",
      reloadConfirmMessage: "Reloading the page will lose unsaved data. Confirm?",
    },
    FERMER: "Close",
    TAPEZ_POUR_RECHERCHER: "Tap to search…",
    CREE_PAR: "Created by",
    MODIFIE_PAR: "Modified by",
    LE: "the",
    TAPEZ_AU_MOINS_3_CARACTERES: "Type at least 3 characters…",
    CHARGEMENT_DU_REFERENTIEL: "Loading referential...",
    FIRSTNAME: "First name",
    LASTNAME: "Last name",
    UNSAVED_CHANGES_TITLE: "Unsaved changes",
    UNSAVED_CHANGES_MESSAGE_WRITE:
      "You have unsaved changes. Do you want to save them before opening the workflow?",
    UNSAVED_CHANGES_MESSAGE_READ:
      "You have unsaved local changes. Do you want to save them before opening the workflow?",
    SAVE_AND_CONTINUE: "Save and continue",
    CONTINUE_WITHOUT_SAVE: "Continue without saving",
    SAVING: "Saving...",
    EMAIL_RESET_PASSWORD_BY_ADMIN_SUCCESS: "The email has been sent successfully",
    EMAIL_RESET_PASSWORD_BY_ADMIN_ERROR: "An error occurred while sending the email",
    // ***************************************** Modal Profil V2
    EN_COURS_DE_SAUVEGARDE: "Saving...",
    AVATAR_CHANGER: "CHANGE",
    AVATAR_SUPPRIMER: "DELETE",
    AVATAR_RULES: "The maximum file size allowed is 400Ko",
    AVATAR_ERROR: "The file is too large",
    MODIFIER_MON_MOT_DE_PASSE: "Modify my password",
    PALCEHOLDER_INPUT_NOM: "Name",
    PALCEHOLDER_INPUT_PRENOM: "First name",
    PALCEHOLDER_INPUT_EMAIL: "Email",
    PALCEHOLDER_INPUT_LANGUE: "Language",
    PALCEHOLDER_INPUT_PAGE_D_ACCUEIL: "Home page",
    ANCIEN_MOT_DE_PASSE: "Old password",
    NOUVEAU_MOT_DE_PASSE: "New password",
    CONFIRMER_LE_NOUVEAU_MOT_DE_PASSE: "Confirm new password",
    VALIDER_MON_MOT_DE_PASSE: "VALIDATE PASSWORD",
    VALIDATION_EN_COURS: "VALIDATION IN PROGRESS...",
    MOT_DE_PASSE_MODIFIE: "Password modified successfully",
    MOT_DE_PASSE_MODIFIE_ERROR: "An error occurred during password modification",
    UTILISATEUR_MODIFIE: "User modified successfully",
    UTILISATEUR_MODIFIE_ERROR: "An error occurred during user modification",
    // ***************************************** Administration V2
    AMDMINISTRATION_TITLE: "Administration",
    LOGO_CHANGER: "CHANGE",
    LOGO_SUPPRIMER: "DELETE",
    LOGO_RULES: "The maximum file size allowed is 500Ko",
    LOGO_ERROR: "The file is too large",
    SAUVEGARDE_EN_COURS: "Saving...",
    UPDATE_BUSINESS_SUCCESS: "The business information has been updated successfully",
    UPDATE_BUSINESS_ERROR: "An error occurred during business modification",
    PALETTE_DE_COULEURS: "Palettes of colors",
    TOOLTIP_ANNULER_SUPPRESSION: "Restore deleted palettes",
    SUPPRIMER_TOUTES_PALETES: "Delete all palettes",
    AJOUTER_PALETTE: "Add a palette",
    AUCUNE_PALETTE: "No color palette available",
    COPIE_COULEUR: "Color copied:",
    COPIE_COULEUR_WARNING: "Error copying color",
    MODIFIER_LA_PALETTE: "Modify the palette",
    AJOUTER_UNE_PALETTE: "Add a palette",
    ENREGISTRER_LA_PALETTE: "Save the palette",
    SUPPRIMER_LA_PALETTE: "Delete the palette",
    NOM_DE_LA_PALETTE: "Name of the palette",
    PALETTE_PAR_DEFAUT: "Default palette",
    PALETTE_DE_COULEURS: "Palette of colors",
    AJOUTER_UNE_COULEUR: "Add a color",
    PROFIL_UPDATE_SUCESS: "Your profile has been modified successfully",
    PROFIL_UPDATE_ERROR: "An error occurred while updating your profile",
    // ***************************************** Duplication Modal page référentiel
    DUPLICATION_EN_COURS: "Duplication in progress...",
    DUPLICATION_DES: "Duplication of",
    ECHANTILLONS_EN_COURS: "samples in progress...",
    ESTIMATION: "estimate",
    DUPLIQUER: "Duplicate",
    TOOLTIP_PROPS_CHECKBOX_DUPLICATION:
      "This element cannot be duplicated because it depends on a unique link",
    AUCUN_CHAMP_DISPONIBLE: "No fields available",
    DUPLICATION_SUCCESS_MESSAGE: "Duplication completed successfully",
    DUPLICATION_ERROR_MESSAGE: "An error occurred during duplication",
    APPLIQUER_A_TOUT: "Apply to all duplicated elements",
    // ***************************************** Code erreurs V2
    FILE_EXTENSION_NOT_ACCEPTED: "File extension not accepted",
    FILE_SIZE_TOO_LARGE: "File size too large",
    WIDGET_DATA_NETWORK_ERROR: "Some dashboard data could not be loaded. Try again or refresh the page.",
    UPLOAD_FAILED: "An error occurred during upload",
    UNKNOWN_ERROR: "An unknown error occurred",
    UNIQUE_CONSTRAINT_VIOLATION_PART_1: "The value",
    UNIQUE_CONSTRAINT_VIOLATION_PART_2: "already exists. Please enter another.",
    REFERENTIAL_LOCK_BANNER_TITLE: "This record is locked",
    REFERENTIAL_LOCK_BANNER_DESCRIPTION: "The field \"{field}\" is \"{value}\". All fields are read-only. Use a workflow transition to unlock this record.",
    REFERENTIAL_LOCK_RULES_TITLE: "Locking rules",
    REFERENTIAL_LOCK_RULES_SAVED: "Locking rules saved.",
    REFERENTIAL_LOCK_RULES_ERROR: "Failed to save the locking rules.",
    REFERENTIAL_LOCK_ADD_RULE: "Add a rule",
    REFERENTIAL_LOCK_WATCH_FIELD: "Watched field",
    REFERENTIAL_LOCK_TRIGGER_VALUES: "Trigger values",
    REFERENTIAL_LOCK_EXCEPT_FIELDS: "Excluded fields",
    "ERROR.SAMPLE_LOCKED": "This record is locked: the field \"{field}\" is \"{value}\". Use a workflow transition to unlock it.",
    "ERROR.SAMPLES_DUPLICATION_SCOPE_INVALID": "Choose which records to duplicate: select rows or apply a filter (one of the two).",
    "ERROR.SAMPLES_DUPLICATION_FORBIDDEN": "You are not allowed to create records in this referential.",
    "ERROR.SAMPLES_DUPLICATION_IN_PROGRESS": "A duplication is already running on this referential. Wait for it to finish before starting another.",
    "ERROR.SAMPLES_DUPLICATION_EMPTY": "Nothing to duplicate: no record matches the selection.",
    "ERROR.SAMPLES_DUPLICATION_TOO_MANY": "Too many records to duplicate at once: narrow the selection or the filter.",
    "SAMPLES_DUPLICATION_DOCK_TITLE": "Duplication: {{referential}}",
    "SAMPLES_DUPLICATION_ALREADY_RUNNING": "A duplication is already running on this referential — follow it in the progress bar. You can start another one when it ends.",
    "SAMPLES_DUPLICATION_SKIPPED": "{{count}} selected record(s) could not be read or no longer exist: they were not duplicated.",
    "DUPLICATE_CONFIRM_ALL": "{{count}} records will be duplicated. Continue?",
    "SAMPLES_DUPLICATION_SELECT_ALL_UNAVAILABLE": "Selecting every row is not available here — tick the rows to duplicate.",
    "SAMPLES_DUPLICATION_SUMMARY_ALL": "{{done}} record(s) duplicated",
    "SAMPLES_DUPLICATION_SUMMARY_PARTIAL": "{{done}} record(s) duplicated, {{failed}} failed",
    "SAMPLES_DUPLICATION_SUMMARY_NONE": "No record could be duplicated",
    "ERROR.TRANSLATE_ALL_IN_PROGRESS": "A translation of all labels is already running. Follow it in the progress bar; you can start another one when it ends.",
    "ERROR.TRANSLATE_ALL_LOCALES_INVALID": "No recognised target language: tick at least one language.",
    "ERROR.LABEL_I18N_GLOSSARY_TERM_INVALID": "The glossary term is invalid: check its length and the languages used.",
    "ERROR.LABEL_I18N_GLOSSARY_TERM_DUPLICATE": "This term already exists in the glossary.",
    "ERROR.LABEL_I18N_GLOSSARY_CONFLICT": "This term was modified by someone else. Reload the glossary and try again.",
    "ERROR.LABEL_I18N_GLOSSARY_FULL": "The glossary is full: delete a term before adding another.",
    "ERROR.LABEL_I18N_SUGGEST_UNAVAILABLE": "The translation suggestion service is unavailable. Labels can still be entered manually.",
    "ERROR.LABEL_I18N_SUGGEST_SOURCE_INVALID": "Nothing to translate: the label is empty or longer than 2,000 characters.",
    "ERROR.LABEL_I18N_SUGGEST_SOURCE_LOCALE_INVALID": "Unknown source language: use one of the tool's six languages.",
    "TRANSLATE_ALL_DOCK_TITLE": "Translate all labels",
    "TRANSLATE_ALL_RUNNING": "Translating…",
    "TRANSLATE_ALL_ELEMENT": "{{translated}} translated, {{failed}} failed",
    "TRANSLATE_ALL_REMAINING": "{{remaining}} label(s) not processed (time limit reached, translation service unavailable, or label changed during the run) — run it again to complete",
    "TRANSLATE_ALL_FAILED": "Technical error — our team has been notified",
    "TRANSLATE_ALL_INTERRUPTED": "Translation interrupted — label categories already translated are saved; run it again to complete",
    "TRANSLATE_ALL_NOTHING": "Nothing to translate: every label already has its translations",
    "TRANSLATE_ALL_SUMMARY_ALL": "{{done}} label category(ies) translated",
    "TRANSLATE_ALL_SUMMARY_PARTIAL": "{{done}} label category(ies) fully translated, {{failed}} incomplete — run it again to complete",
    "TRANSLATE_ALL_SUMMARY_NONE": "No label could be translated — please try again later",
    "OPERATION_TYPE_TRANSLATE_ALL": "Translate all labels",
    "OPERATION_TYPE_SERIES_SYNC": "Series synchronisation",
    "OPERATION_TYPE_SAMPLES_DUPLICATION": "Records duplication",
    "OPERATION_RUN_PENDING": "Queued — waiting for a free slot",
    "OPERATION_TYPE_CAMPAIGN_LAUNCH": "Campaign launch",
    "OPERATION_TYPE_SERIES_GENERATION": "Series generation",
    "ADMIN_TRANSLATIONS_SAVE_SKIPPED": "{{count}} row(s) not saved: the label changed or no longer exists on the server. Your edit is kept — reload the grid and redo it.",
    "ADMIN_TRANSLATIONS_SAVED_REFRESH_FAILED": "Saved — refresh failed, reload the grid.",
    "ADMIN_TRANSLATIONS_GLOSSARY_TAB": "Glossary",
    "ADMIN_TRANSLATIONS_GLOSSARY_TITLE": "Client glossary",
    "ADMIN_TRANSLATIONS_GLOSSARY_HELP": "Terms listed here are applied by AI suggestions and by \"Translate everything\". Translations already entered never change.",
    "ADMIN_TRANSLATIONS_GLOSSARY_TERM": "Term",
    "ADMIN_TRANSLATIONS_GLOSSARY_MEANING": "Meaning (helps the AI with acronyms)",
    "ADMIN_TRANSLATIONS_GLOSSARY_FORBIDDEN": "Forbidden translations",
    "ADMIN_TRANSLATIONS_GLOSSARY_ADD": "Add a term",
    "ADMIN_TRANSLATIONS_GLOSSARY_EDIT": "Edit",
    "ADMIN_TRANSLATIONS_GLOSSARY_DELETE": "Delete",
    "ADMIN_TRANSLATIONS_GLOSSARY_CONFIRM_DELETE": "Delete the term \"{{term}}\"? Existing translations are not affected.",
    "ADMIN_TRANSLATIONS_GLOSSARY_EMPTY": "No term yet. Add the vocabulary the AI must respect.",
    "ADMIN_TRANSLATIONS_GLOSSARY_SAVED": "Term saved.",
    "ADMIN_TRANSLATIONS_GLOSSARY_CONFLICT_RELOADED": "This term was changed by someone else. The latest version has been reloaded; please redo your edit.",
    "ADMIN_TRANSLATIONS_GLOSSARY_FORBIDDEN_LIMIT": "At most {{max}} forbidden translations per language, {{length}} characters each.",
    "ERROR.WORKFLOW_WARNING_NOT_ACKNOWLEDGED": "This step raises a warning. Confirm to submit anyway.",
    REFERENTIAL_LOCK_MESSAGE: "Custom message",
    REFERENTIAL_LOCK_MESSAGE_PLACEHOLDER: "Message shown to the user (optional)...",
    REFERENTIAL_LOCK_NO_RULES: "No locking rules configured.",
    SELECT_FIELD: "Select a field...",
    SELECT_VALUES: "Select values...",
    TYPE_VALUE_ENTER: "Type a value and press Enter...",
    SELECT_EXCLUDED_FIELDS: "Excluded fields (optional)...",
    REFERENTIAL_NOT_FOUND: "Referential not found",
    REFERENTIAL_NO_TEMPLATE: "Referential has no synthesis template.",
    TEMPLATE_SYNTHESIS_NOT_FOUND: "Synthesis template not found.",
    USER_NOT_FOUND: "User not found.",
    EMAIL_NOT_ENABLED: "Please enable the email sending option in the notification settings.",
    ALREADY_SENT: "The summary has already been sent this month.",
    ERROR_SUMMARY_SYNTHESIS: "Error sending the summary.",
    // Upload audit history (AdminConsole > Supervision > Upload History)
    ADMIN_PAGE_UPLOAD_HISTORY: "Upload History",
    UPLOAD_HISTORY_TITLE: "Upload audit trail",
    UPLOAD_HISTORY_DESC:
      "Log of every file upload attempt: accepted, accepted without antivirus scan, or rejected.",
    UPLOAD_HISTORY_EMPTY: "No upload recorded.",
    UPLOAD_HISTORY_SHOWING: "Showing",
    UPLOAD_HISTORY_COL_DATE: "Date",
    UPLOAD_HISTORY_COL_USER: "User",
    UPLOAD_HISTORY_COL_FILE: "File",
    UPLOAD_HISTORY_COL_SIZE: "Size",
    UPLOAD_HISTORY_COL_REPOSITORY: "Repository",
    UPLOAD_HISTORY_COL_PATH: "Upload path",
    UPLOAD_HISTORY_COL_STATUS: "Status",
    UPLOAD_HISTORY_COL_REASON: "Rejection reason",
    UPLOAD_HISTORY_FILTER_USER: "Filter by email…",
    UPLOAD_HISTORY_FILTER_REPOSITORY: "Filter by repository…",
    UPLOAD_HISTORY_FILTER_FROM: "From",
    UPLOAD_HISTORY_FILTER_TO: "To",
    UPLOAD_HISTORY_FILTER_ALL_STATUSES: "All statuses",
    UPLOAD_HISTORY_FILTER_ALL_REASONS: "All reasons",
    UPLOAD_HISTORY_FILTER_ALL_PATHS: "All paths",
    UPLOAD_HISTORY_FILTER_APPLY: "Filter",
    UPLOAD_STATUS_ACCEPTED: "Accepted",
    UPLOAD_STATUS_ACCEPTED_UNSCANNED: "Accepted (not scanned)",
    UPLOAD_STATUS_ACCEPTED_UNSCANNED_TOOLTIP:
      "Accepted without antivirus scanning: the antivirus was disabled or unreachable. The platform does not block uploads when its scanner is down.",
    UPLOAD_STATUS_REJECTED: "Rejected",
    UPLOAD_PATH_SINGLE: "Single",
    UPLOAD_PATH_MULTIPART: "Multipart",
    UPLOAD_REJECTION_INVALID_FILENAME: "Invalid filename",
    UPLOAD_REJECTION_DOUBLE_EXTENSION: "Dangerous double extension",
    UPLOAD_REJECTION_BLOCKED_EXTENSION: "Blocked file extension",
    UPLOAD_REJECTION_SVG_BLOCKED: "SVG file not allowed",
    UPLOAD_REJECTION_INVALID_MSG_STRUCTURE: "Invalid Outlook message structure",
    UPLOAD_REJECTION_CFB_NOT_ALLOWED: "Unsupported compound file container",
    UPLOAD_REJECTION_MIME_NOT_ALLOWED: "File type not allowed",
    UPLOAD_REJECTION_UNDETECTABLE_TYPE: "Undetectable file type",
    UPLOAD_REJECTION_MALWARE: "Malware detected",
  },
  // ******************************************************************************** Français
  {
    id: 1, // Français
    CHOOSE_STEP: "Choisissez une étape...",
    NO_ACTIVE_WORKFLOW: "Aucun flux de travail actif",
    WF_OTHER_WORKFLOWS_HEADER: "Autres flux de travail",
    ATTACH_FILE: "Joindre un fichier",
    ATTACH_FILE_COMING_SOON: "La possibilité de joindre un fichier arrive bientôt",
    BACK_TO_FORM: "Retour",
    CHOOSE: "Choisir une étape",
    WF_ACTION_APPROVE: "Approuver",
    WF_ACTION_CLOSE: "Clôturer",
    WF_ACTION_REFUSE: "Refuser",
    WF_ACTION_REQUEST_CHANGES: "Demander des modifications",
    WF_ACTION_RETURN: "Renvoyer",
    WF_ACTION_TRANSMIT: "Transmettre",
    WF_ACTION_VALIDATE_STEP: "Valider l'étape",
    WF_ASSIGNED_TO_YOU: "Assigné à vous",
    WF_AWAITING_CLAIM: "En attente d'affectation",
    WF_BY: "par",
    WF_CLAIM: "Prendre en charge",
    WF_EVENTS: "événements",
    WF_FIELDS_CHANGED: "champs modifiés",
    WF_FIELD_CHANGED: "champ modifié",
    WF_IN_PROGRESS: "En cours",
    WF_LINK_CHANGES: "modifications de liens",
    WF_MORE_FIELDS: "plus",
    WF_OTHER_WORKFLOWS: "autres",
    WF_REJECT: "Rejeter",
    WF_REJECTED: "Rejeté",
    WF_RESUME: "Reprendre",
    WF_SAVE_FIRST: "Enregistrez avant d'effectuer des actions sur le workflow",
    WF_SHOW_LESS: "Afficher moins",
    WF_SUBMIT: "Soumettre",
    WF_VALIDATE: "Valider",
    WORKFLOW_ACTIONS: "Actions",
    WORKFLOW_ACTION_ERROR: "Impossible d’exécuter l’action workflow",
    WORKFLOW_ASSIGN: "Attribuer",
    WORKFLOW_ASSIGNEE: "responsable",
    WORKFLOW_ASSIGNEES: "responsables",
    WORKFLOW_ASSIGN_ERROR: "Impossible de mettre à jour les affectations",
    WORKFLOW_ASSIGN_SUCCESS: "Affectations mises à jour",
    WORKFLOW_CHOOSE_STEP: "Choisir une étape",
    WORKFLOW_CLAIM_BUTTON: "Prendre en charge",
    WORKFLOW_CLAIM_SUCCESS: "Étape prise en charge",
    WORKFLOW_COMMENT: "Commentaire",
    WORKFLOW_COMMENT_PLACEHOLDER: "Ajouter un commentaire (optionnel)",
    WORKFLOW_CONDITION_FIELD: "Condition de passage (passCondition)",
    WORKFLOW_CONDITION_HINT: "Condition libre — même format que le lifecycle (JsonLogic / filtre). Laisser vide pour ne rien exiger.",
    WORKFLOW_CONDITION_INVALID_JSON: "JSON invalide — non enregistré",
    WORKFLOW_CONDITION_MESSAGE_FIELD: "Message si la condition bloque",
    WORKFLOW_WARN_CONDITION_FIELD: "Condition d'avertissement (warnCondition)",
    WORKFLOW_WARN_CONDITION_HINT: "Non bloquante — même format que la condition de passage. Quand elle n'est pas remplie, la personne qui soumet doit confirmer avant de soumettre. Laisser vide pour n'afficher aucun avertissement.",
    WORKFLOW_WARN_CONDITION_MESSAGE_FIELD: "Message affiché dans l'avertissement",
    WORKFLOW_WARNING_TITLE: "Avertissement avant soumission",
    WORKFLOW_WARNING_CONFIRM: "Soumettre malgré tout",
    WORKFLOW_WARNING_ACKNOWLEDGED: "Soumis malgré l'avertissement",
    WORKFLOW_DEFAULT: "Auto",
    WORKFLOW_LOADING_CONTENT: "Patientez pendant le chargement du workflow.",
    WORKFLOW_LOADING_TITLE: "Chargement…",
    WORKFLOW_NEXT_STEP: "Choisir l’étape suivante",
    WORKFLOW_NO_HISTORY: "Aucun historique disponible",
    WORKFLOW_PICKER_CLEAR: "Effacer",
    WORKFLOW_PICKER_EMPTY: "Aucun résultat",
    WORKFLOW_PICKER_GROUPS: "Groupes",
    WORKFLOW_PICKER_SEARCH: "Rechercher…",
    WORKFLOW_PICKER_SELECTED: "Sélectionné",
    WORKFLOW_PICKER_SHOW_ALL: "Tout afficher",
    WORKFLOW_PICKER_SHOW_SELECTED: "Afficher uniquement les sélectionnés",
    WORKFLOW_PICKER_USERS: "Utilisateurs",
    WORKFLOW_REASSIGN: "Réassigner",
    WORKFLOW_REASSIGN_SUCCESS: "Responsables mis à jour",
    WORKFLOW_REASSIGN_TITLE: "Réaffecter",
    WORKFLOW_REJECT_BUTTON: "Rejeter",
    WORKFLOW_REJECT_LABEL_FIELD: "Libellé du bouton Rejeter",
    WORKFLOW_REJECT_SUCCESS: "Étape rejetée",
    WORKFLOW_STEP_BLOCKED_DEFAULT: "La condition de passage de cette étape n'est pas remplie.",
    WORKFLOW_STEPS: "Étapes",
    WORKFLOW_SUBMIT_BUTTON: "Soumettre",
    WORKFLOW_SUBMIT_LABEL_FIELD: "Libellé du bouton Valider",
    WORKFLOW_SUBMIT_SUCCESS: "Étape soumise",
    WORKFLOW_TAB_HISTORY: "Avancement",
    WORKFLOW_TAB_PROGRESSION: "Progression",
    WORKFLOW_VALIDATE_BUTTON: "Valider",

    WF_EVENT_SUBMITTED: "Soumis",
    WF_EVENT_REJECTED: "Rejeté",
    WF_EVENT_REASSIGNED: "Réassigné",
    WF_EVENT_CLAIMED: "Pris en charge",
    WF_COMPLETED: "Terminé",
    WF_ALL_STEPS_DONE: "Toutes les étapes ont été complétées.",
    SCIM_ENDPOINTS_TITLE: "Endpoints & Documentation",
    SCIM_ENDPOINTS_DESC: "Retrouvez toutes les URLs SCIM actives et copiez-les en un clic.",
    SCIM_ENDPOINTS_COPY_BASE: "Copier l’URL de base",
    SCIM_BASE_COPIED: "URL SCIM copiée",
    SCIM_ENDPOINTS_LOADING: "URLs disponibles après chargement…",
    SCIM_DOC_LINK: "Consulter la documentation SCIM",
    SCIM_ENDPOINT_COPIED: "URL SCIM copiée",
    SCIM_SECTION_TITLE: "SCIM (Azure AD, Okta…)",
    SCIM_TOGGLE_LABEL: "Activer SCIM",
    SCIM_PORTAL_LABEL: "Identifiant portail",
    SCIM_PORTAL_HINT: "Utilisé dans l’URL /scim/{portal}/v2. Aligné sur votre businessId.",
    SCIM_GENERATED_LABEL: "Identifiants SCIM générés",
    SCIM_GENERATED_EMPTY: "Aucun identifiant actif",
    SCIM_DURATION_LABEL: "Durée",
    SCIM_DURATION_30: "30 jours",
    SCIM_DURATION_90: "90 jours",
    SCIM_DURATION_180: "180 jours",
    SCIM_GENERATE_IN_PROGRESS: "Génération...",
    SCIM_GENERATE_ACTION: "Générer un couple",
    SCIM_SECRET_BANNER: "Secret affiché une seule fois",
    SCIM_ALLOWED_IPS_LABEL: "IP autorisées SCIM",
    SCIM_IP_PLACEHOLDER: "1.2.3.4\n10.0.0.0/24",
    SCIM_FETCHING_IP: "Patientez...",
    SCIM_ADD_MY_IP: "Ajouter mon IP",
    SCIM_FIREWALL_TITLE: "Pare-feu applicatif",
    SCIM_FIREWALL_DESC: "Bloquez toutes les API PocketResult à l’aide d’une whitelist d’IP.",
    SCIM_FIREWALL_TOGGLE: "Activer le pare-feu",
    SCIM_FIREWALL_ALLOWED_IPS: "IP autorisées (application)",
    SCIM_PREPARE_IP_HINT:
      "Vous pouvez préparer les listes d’IP avant d’activer SCIM ou le pare-feu pour éviter de vous bloquer. Les normes SCIM 2.0 (Azure AD, Okta…) sont supportées.",
    SCIM_SECRET_NONE: "Aucun secret actif",
    SCIM_SECRET_EXPIRES_AT: "Expire le {date} à {time}",
    SCIM_SAVE_IN_PROGRESS: "Enregistrement...",
    MENU_REMOVE_FAVORITE: "Retirer des favoris",
    MENU_ADD_FAVORITE: "Ajouter aux favoris",
    MENU_EDIT_FAVORITES: "Modifier les favoris",
    MENU_DONE_FAVORITES: "Terminer l’édition des favoris",
    MENU_EXPAND: "Déplier",
    MENU_COLLAPSE: "Replier",
    MENU_WHATS_NEW: "Nouveautés",
    MENU_AI_ASSISTANT: "Assistant IA",
    AI_STATUS_ACTIVE: "Actives",
    AI_STATUS_ARCHIVED: "Archivées",
    AI_STATUS_ALL: "Toutes",
    AI_LOADING_MESSAGE_SEARCH: "Je cherche les meilleures sources…",
    AI_LOADING_MESSAGE_GATHER: "Je rassemble les données pertinentes…",
    AI_LOADING_MESSAGE_RESPONSE: "Je formule une réponse détaillée…",
    AI_PROPOSAL_STATUS_PENDING: "En attente",
    AI_PROPOSAL_STATUS_ACCEPTED: "Acceptée",
    AI_PROPOSAL_STATUS_REJECTED: "Rejetée",
    AI_PLAN_STEP_STATUS_STARTED: "En cours",
    AI_PLAN_STEP_STATUS_SUCCESS: "Succès",
    AI_PLAN_STEP_STATUS_ERROR: "Erreur",
    AI_PROPOSAL_KIND_CREATE: "Création",
    AI_PROPOSAL_KIND_UPDATE: "Mise à jour",
    AI_PROPOSAL_KIND_DELETE: "Suppression",
    AI_PROPOSAL_KIND_OTHER: "Autre",
    AI_PROPOSAL_SCOPE_REFERENTIAL: "Référentiel",
    AI_PROPOSAL_SCOPE_SAMPLE: "Échantillon",
    AI_PROPOSAL_SCOPE_OTHER: "Autre",
    AI_TOOL_NO_RESULT: "_Aucun résultat renvoyé._",
    AI_NEVER: "Jamais",
    AI_PLAN_STEP_LABEL: "Étape",
    AI_PLAN_EXECUTION_LIVE: "Plan en cours d’exécution…",
    AI_PLAN_PROGRESS_LIVE: "Exécution en cours",
    AI_PLAN_PROGRESS_HISTORY: "Progression en temps réel",
    AI_PLAN_AGENT_CONTINUES: "L’assistant poursuit les actions prévues.",
    AI_PLAN_BADGE_LIVE: "Live",
    AI_PLAN_BADGE_HISTORY: "Historique",
    AI_PLAN_RUNNING_TITLE: "Plan en cours",
    AI_PLAN_COMPLETED_TITLE: "Plan terminé",
    AI_LAST_UPDATE_LABEL: "Dernière mise à jour",
    AI_TARGET_UNKNOWN: "Cible non précisée",
    AI_ACTION_ERROR_GENERIC: "Action impossible. Réessayez.",
    AI_RENAME_EMPTY_ERROR: "Le titre ne peut pas être vide.",
    AI_RENAME_TOO_LONG_ERROR: "Le titre doit contenir au maximum 120 caractères.",
    AI_DELETE_CONFIRM: "Supprimer définitivement cette conversation ? Cette action est irréversible.",
    AI_PROPOSAL_INVALID: "Proposition IA invalide ou incomplète.",
    AI_PROPOSAL_TARGET_UNKNOWN: "Impossible de déterminer le référentiel ciblé par cette proposition.",
    AI_PROPOSAL_APPROVED: "Proposition approuvée. Pensez à appliquer les changements dans le référentiel.",
    AI_PROPOSAL_REJECTED: "Proposition refusée.",
    AI_REPORT_DOWNLOAD_ERROR: "Impossible de télécharger ce rapport.",
    AI_REPORT_SHARE_IN_PROGRESS: "Lien en cours…",
    AI_REPORT_SHARE_COPY: "Copier le lien",
    AI_REPORT_SHARE_COPIED: "Lien de partage copié (valide environ 1h).",
    AI_REPORT_SHARE_READY: "Lien de partage prêt.",
    AI_REPORT_SHARE_ERROR: "Impossible de créer un lien de partage pour ce rapport.",
    AI_SAMPLE_AUTO_CREATED: "Échantillon créé automatiquement.",
    AI_SAMPLE_AUTO_UPDATED: "Échantillon mis à jour automatiquement.",
    AI_PROPOSAL_APPROVE_PROMPT: "Commentaire pour l’approbation (optionnel)",
    AI_PROPOSAL_REJECT_PROMPT: "Motif du refus (optionnel)",
    AI_FULLSCREEN_EXIT: "Fenêtre réduite",
    AI_FULLSCREEN_ENTER: "Plein écran",
    AI_SUMMARY_UNAVAILABLE: "Résumé indisponible",
    AI_CONVERSATION_ARCHIVED: "Archivée",
    AI_CONVERSATION_ACTIVE: "Active",
    AI_PENDING_RESPONSE: "Réponse en cours",
    AI_WEB_SOURCE_RECENTLY_ALLOWED: "Ce domaine vient d’être autorisé. Relancez la recherche.",
    AI_SEND_IN_PROGRESS: "Envoi…",
    AI_REQUEST_WEB_SOURCE: "Demander le déblocage",
    AI_LOADING_MORE: "Chargement…",
    AI_VIEW_PREVIOUS_MESSAGES: "Voir les messages précédents",
    AI_PROMPT_SUGGESTION: "Peux-tu proposer de nouvelles actions basées sur nos données ?",
    AI_NO_RECENT_ACTION: "Aucune action récente. Envoyez un message pour démarrer une nouvelle exécution.",
    AI_HIDE_DETAILS: "Masquer les détails",
    AI_SHOW_DETAILS: "Détails techniques",
    AI_BUTTON_COPIED: "Copié",
    AI_BUTTON_COPY: "Copier",
    AI_WARNING_ARCHIVED: "Impossible d’envoyer un message, restaurez la conversation",
    AI_COMPOSER_PLACEHOLDER: "Écrivez votre message…",
    AI_NEW_CONVERSATION_TITLE: "Nouvelle conversation",
    AI_REPORTS_TITLE: "Rapports téléchargeables",
    AI_REPORTS_SUBTITLE: "Historique des exports",
    AI_BUTTON_DOWNLOAD: "Télécharger",
    AI_LINK_LABEL: "Lien :",
    AI_LINK_OPEN: "ouvrir",
    AI_LABEL_EXPIRES: "expire",
    AI_REPORT_UNAVAILABLE: "Rapport indisponible.",
    AI_REPORT_READY_BANNER: "Rapport téléchargé prêt",
    AI_WEB_SOURCE_REQUEST_MESSAGE: "Demande depuis Assistant IA pour",
    AI_WEB_SOURCE_REQUEST_RECORDED_REF: "Demande enregistrée (%ref).",
    AI_WEB_SOURCE_REQUEST_RECORDED_HOST: "Demande enregistrée pour %host.",
    AI_MODAL_TITLE: "Assistant IA",
    AI_BUTTON_CLOSE: "Fermer",
    AI_PARTIAL_BADGE: "Partielle",
    AI_CONVERSATIONS_LOADING: "Chargement des conversations…",
    AI_NO_CONVERSATION_HINT: "Aucune conversation. Lancez-en une nouvelle 👆",
    AI_SELECT_CONVERSATION_PROMPT: "Choisissez une conversation pour afficher les détails.",
    AI_HISTORY_LOADING: "Chargement de l’historique…",
    AI_PROPOSALS_LOADING: "Chargement des propositions…",
    AI_LOAD_MORE: "Charger plus",
    AI_REPLAY_LAST_MESSAGE: "Rejouer le dernier message",
    AI_REPLAY_BUTTON: "Rejouer",
    AI_TURN_AUTHOR_USER: "Vous",
    AI_TURN_ERROR_FLAG: "Erreur signalée",
    AI_WEB_SOURCE_BLOCKED_DESC:
      "Cette source est bloquée. Demandez son ajout à la whitelist pour relancer la recherche.",
    AI_WEB_SOURCE_AUTOREF_LABEL: "Référence automatique :",
    AI_RENAME_CONVERSATION: "Renommer la conversation",
    AI_RENAME: "Renommer",
    AI_LAST_ACTIVITY: "Dernière activité",
    AI_CONVERSATION_IN_PROGRESS: "Conversation en cours",
    AI_BUTTON_RESTORE: "Restaurer",
    AI_BUTTON_ARCHIVE: "Archiver",
    AI_BUTTON_PURGE: "Purger les messages",
    AI_BUTTON_DELETE: "Supprimer",
    AI_PARTIAL_WARNING: "Conversation partielle signalée par le backend.",
    AI_ASSISTANT_THINKING: "Assistant en cours de traitement…",
    AI_SEND_IN_PROGRESS: "Envoi…",
    AI_SEND_BUTTON: "Envoyer",
    AI_JOURNAL_TITLE: "Journal IA",
    AI_JOURNAL_SUBTITLE: "Actions, livrables et décisions en temps réel",
    AI_JOURNAL_RELAUNCH: "Relancer",
    AI_BUSINESS_SUMMARY_TITLE: "Synthèse métier",
    AI_BUSINESS_SUMMARY_UPDATED: "Mise à jour",
    AI_PLAN_TOGGLE_SHOW: "Afficher",
    AI_PLAN_TOGGLE_HIDE: "Masquer",
    AI_DIAGNOSTICS_TITLE: "Détails techniques",
    AI_DIAGNOSTICS_EVENTS: "événements",
    AI_DIAGNOSTICS_SHOW: "Afficher",
    AI_DIAGNOSTICS_HIDE: "Masquer",
    AI_DIAGNOSTIC_LABEL: "Diagnostic",
    AI_TIMELINE_COLLAPSED_MESSAGE: 'Historique masqué. Cliquez sur "%label%" pour consulter le plan.',
    AI_PLAN_NARRATIVE_TITLE: "Plan proposé",
    AI_PLAN_NARRATIVE_GENERATED: "Généré",
    AI_REPORT_GENERATED: "Généré",
    AI_TIMEOUT_TITLE: "L’IA a expiré",
    AI_TIMEOUT_DESC: "Relancer la dernière demande avec le même contexte.",
    AI_TIMEOUT_RETRY: "Réessayer",
    AI_ASSISTANT_LABEL: "Assistant",
    AI_TYPING_STATUS: "en cours…",
    AI_PROPOSALS_TITLE: "Décisions IA",
    AI_PROPOSALS_DESCRIPTION: "Gérez les propositions générées par l’assistant",
    AI_PROPOSALS_TAB_PENDING: "À décider",
    AI_PROPOSALS_TAB_ALL: "Historique",
    AI_PROPOSALS_EMPTY: "Aucune proposition pour ce filtre.",
    //Generics words
    SELECTED_BUSINESS: "Sélectionner une entreprise",
    LABEL_SELECTED_BUSINESS:
      "Veuillez sélectionner un business pour vous connecter, car plusieurs sont associés à votre compte.",
    CONTINUE: "Continuer",
    CANCEL: "annuler",
    VALIDATE: "valider",
    SEND_TO_CUSTOMER: "Envoyer au client",
    RETURN_TO_CONSULTANT: "Renvoyer au consultant",
    ERASE: "effacer",
    ALERTS: "Alertes",
    SETTING_GRACE_PERIOD: "Configurer le délai de grâce",
    ADD_A_DELAY: "Ajouter un délai",
    ALERTS_SUCCESS_UPDATED: "Les alertes ont été mises à jour avec succès",
    ALERTS_ERROR_UPDATED: "Erreur : les alertes n'ont pas pu être mises à jour",
    RECEIVE_AN_ALERT_AFTER: "Recevoir une alerte après",
    CHANGES_SAVES_SUCCESS: "Modifications enregistrées avec succès",
    ERROR_CHANGES_SAVES: "Erreur: les modifications n'ont pas été enregistrées",
    RECEIVE_AN_ALERT_BEFORE: "Recevoir une alerte avant",
    BUSINESS_NO_CONFIG_ALERT_BEFORE: "Votre business n'a configuré aucun délai d'avant échéance",
    BUSINESS_NO_CONFIG_ALERT_AFTER: "Votre business n'a configuré aucun délai d'après échéance",
    close: "fermer",
    share: "partager",
    search: "RECHERCHE",
    IMPORT: "importer",
    PREPARE: "préparer",
    VISUALIZE: "visualiser",
    VISUALISATION: "Visualisation",
    add: "ajouter",
    addition: "ajout",
    configure: "configurer",
    CENTERED: "Centré",
    PAGE: "page",
    WELCOME: "Bienvenue",
    TUTORIAL: "Tutoriel",
    HIDE: "Masquer",
    USED: "Utilisée",
    NOT_USED: "Non utilisée",
    ADD_DESCRIPTION: "Ajouter une description",
    SAUVEGARDE: "Sauvegarde",
    SAUVEGARDER: "Sauvegarder",
    LAST_MISE_A_JOUR: "Dernière mise à jour",
    MISE_A_JOUR: "Mise à jour",
    NOM_SAUVEGARDE: "Nom de la sauvegarde",
    DATE_SAUVEGARDE: "Date de la sauvegarde",
    ACTION_ELEMENT: "Action et élément",
    ACTION: "Action",
    ELEMENT: "Élément",
    CREATION: "Création",
    MODIFICATION: "Modification",
    USER: "Utilisateur",
    MENU: "Menu",
    TO_SELECT: "à sélectionner",
    CLOTURER: "Clôturer",
    // Login Part
    titleLogin: "Pocket Result DEMO",
    firstTextLogin: "Bon retour parmi nous !",
    secondTextLogin: "Merci de vous connecter pour continuer.",
    stayConnectedLabel: "Se souvenir de moi",
    FORGOT_PASSWORD: "Mot de passe oublié",
    PASSWORD: "Mot de passe",
    SEND: "Envoyer",
    SENT: "Envoyé",
    ENTER_YOUR_EMAIL_TO_RESET_IT:
      "Saisissez votre adresse e-mail, un e-mail vous sera transmis afin de procéder à la réinitialisation de votre mot de passe :",
    NEW: "Nouveau",
    DISCOVER_MORE_ABOUT_POCKET_STUDIO: "Découvrez en plus sur Pocket Studio",
    PRIVACY_POLICY: "politique de confidentialité",
    passwordDontMatch: "Vos mots de passe semblent ne pas correspondre",
    labelOnLogin: "Se connecter",
    noAccount: "Pas encore de compte ? S'inscrire",
    wrongCredential: "Email ou mot de passe incorrect.",
    placeholderEmailLogin: "Email",
    placeholderPasswordLogin: "Mot de passe",
    langue1: "Anglais",
    langue2: "Français",
    langue3: "Portugais",
    // Header / NavBar Section
    MY_PROFILE: "Mon profil",
    DISCONNECT: "Déconnexion",
    HELPING_CENTER: "Centre d'aide",
    STATUS_SERVER: "État des serveurs",
    PAGE_MOSAIC: "Mosaïque des pages",
    DASHBOARD: "Dashboards",
    DATA: "Données",
    ADMINISTRATION: "Administration",
    SOURCES: "Sources",
    NEW_SOURCE: "Nouvelle Source",
    ALL_SOURCES: "Toutes les Sources",
    EDIT_SOURCE: "Editer une Source",
    ANALYSIS: "Analyses",
    NEW_ANALYSIS: "Nouvelle Analyse",
    NAVBAR_GED: "Gestion des documents",
    OBJECTIFS: "Objectifs",
    MODULE_FORMULAIRE: "Module Formulaire",
    PLANNING_CONTROLS: "Mes contrôles",
    MY_ACTION_PLANS: "Mes plans d'action",
    MAPPING_RISK: "Cartographie des risques",
    CONTROL_PLAN: "Plan de contrôle",
    FORMULAIRE: "Formulaires",
    GESTION_DOCUMENTAIRE: "Gestion Documentaire",
    NOTIFICATION_CENTER: "Centre de notification",
    FICHE_AFFAIRE: "Fiche affaire",
    MSF_DASHBOARD: "Tableau de bord",
    LABEL_MENU_AFFAIRE: "Affaires",
    MODEL_MANAGEMENT: "Gestion des modèles",
    GESTION_RELATION_INSTITUT: "Gestion des relations institutionnelles",
    MAIL_MANAGEMENT: "Gestion du courrier",
    COMMUNICATION: "Communication",
    SUCCESS_TO_UPDATE_PROFILE: "Votre profil a été mis à jour avec succès.",
    //PAGE PARAMETRES CARTOGRAPHIE
    GOVERNANCE: "Gouvernance",
    GOVERNANCE_PARAMETERS: "Paramètrages Gouvernance",
    CHOICE_MAPPING: "Choix de la Cartographie",
    BY_DEFAULT: "Par défaut",
    CONTROL_COMPLIANCE_SCALE: "Echelle de conformité des contrôles",
    CREATE_NEW_SCALE: "Créer une nouvelle échelle",
    CONTROL_COMPLETION_TIME: "Délais de complétion d'un contrôle",
    LOCK_CONTROL_DEADLINE: "Verrouiller le contrôle une fois la deadline passée",
    GRACE_PERIOD_DAYS: "Accorder un délai de grâce en jours",
    GRACE_PERIOD_CONFIG: "Configuration du délai de grâce",
    ADD_PERIOD: "Ajouter un délai",
    ROLES_CONCERNED: "Rôles concernés",
    SELECT_MAPPING: "Sélectionner une cartographie",
    MAPPING_TABLE_GLOBAL: "Cartographie Global",
    MAPPING_TABLE_ACTIVITY: "Cartographie par activités",
    MAPPING_TABLE_RISK: "Cartographie par risques",
    CHOICE_TYPE_MAPPING: "Choix type cartographie",
    COMPLIANCE_SCALE_NAME: "Nom de l'échelle de conformité",
    DEPRECATED: "Obsolète",
    ADD_A_FIELD: "Ajouter un champ",
    CURRENT_FIELDS: "Champs actuels",
    CUSTOM_FIELDS: "Champs personnalisés",
    DEFAULT_FIELDS: "Champs par défaut",
    FIELD_MANDATORY: "Champ obligatoire",
    DEFAULT_FIELD: "Champ par défaut",
    TWO_MINIMUM_FIELDS_REQUIRED: "Deux champs minimum requis",
    COLOR_FIELD: "Couleur Champ",
    LOWER_BOUND_INCLUDED_FIELD: "Borne inférieure incluse champ",
    MODEL_RISK: "Modèle des risques",
    MODEL_STANDART: "Modèle standard",
    VIEW_MODEL: "Visualiser mon modèle",
    CREATE_MODEL: "Créer un nouveau modèle",
    MATRIX_RISK: "Matrice des risques",
    MATRIX_RISK_STANDART: "Matrice standart",
    VIEW_MATRIX: "Visualiser ma matrice",
    EDIT_MATRIX: "Editer ma matrice",
    CREATE_MATRIX: "Créer une nouvelle matrice",
    ADD_MATRIX: "Créer matrice",
    SAVE_MATRIX: "Sauvegarder matrice",
    MODIFY_MATRIX: "Modifier matrice",
    NAME_MATRIX_RISK: "Nom de la matrice des risques",
    CALCUL_IMPACT: "Calcul impact général",
    ADD_IMPACT: "Ajouter un impact",
    DEFINTION_ECHELLE_IMPACT: "Définition de l'échelle de l'impact",
    CALCUL_FREQUENCY: "Calcul fréquence général",
    ADD_FREQUENCY: "Ajouter une fréquence",
    DEFINTION_ECHELLE_FREQUENCY: "Définition de l'échelle de la fréquence",
    CALCUL_RISKBRUT: "Calcul du risque brut",
    DEFINTION_SCALE_RISKBRUT: "Définition de l'échelle du risque brut",
    IMPACT_GENERAL: "Impact général",
    FREQUENCY_GENERAL: "Fréquence général",
    DEFINTION_SCALE_CONFORMITY: "Définition de l'échelle de conformité",
    VIEW_SCALE_CONFORMITY: "Visualiser mon échelle",
    EDIT_SCALE_CONFORMITY: "Editer mon échelle",
    SUCCESS_TO_CREATE_CONFORMITY_SCALE: "Création de l'échelle de conformité avec succès",
    GENERAL_BUSINESS_MAPPING: "Cartographie Général du Business",
    DEFAULT_MAPPING: "Cartographie par défaut",
    SETUP_BUSINESS: "Configuration Business",
    SETUP_MAPPING: "Configuration Cartographie",
    //PAGE HEADER
    TITLE: "Titre",
    TITLE_SYNTHESE: "Synthèse",
    DESCRIPTION: "Description",
    CONSIGNE: "Consignes",
    SHARE: "Partager",
    VISUALIZE: "Visualiser",
    CONFIGURE: "Configurer",
    CREATE: "Créer",
    SAVE: "SAUVEGARDER",
    SAVE_LOWERCASE: "Sauvegarder",
    ENREGISTRER: "Enregistrer",
    SAVE_DRAFT: "Sauvegarder brouillon",
    EVALUATE: "Evaluer",
    PUBLISHED: "Publié",
    NO_PUBLISHED: "Non publié",
    FIX_A_BLOC: "Fixer un bloc",
    YOUR_PAGE_HAS_NO_TITLE: "Votre page n'a pas de titre, merci d'en renseigner un.",
    ENREGISTRER_MODIFICATION: "Sauvegarder les modifications",
    //Share
    GROUPS_AND_USERS: "Groupes et utilisateurs",
    // Forget password Part
    firstTextForgetPassword: "Entrez votre email et nous vous enverrons un lien",
    secondTextForgetPassword: "pour réinitialiser votre mot de passe",
    AN_EMAIL_JUST_LEFT_TO_RESET_PASSWORD:
      "Un email vient de partir pour réinitialiser votre mot de passe",
    EMAIL_NOT_SENT: "L'email n'a pas pu être envoyé, veuillez ressayer.",
    wrongEmail: "Email non trouvé. essayer à nouveau.",
    sendLink: "Envoyer le lien",
    // Reset password Part
    textResetPassword: "Votre nouveau mot de passe doit comprendre au moins :",
    UNVALID_PASSWORD: "Votre mot de passe ne répond pas aux critères de sécurité",
    buttonChangePassword: "Changer mon mot de passe",
    buttonChangePassword: "Valider mon mot de passe",
    needUpperCase: " majuscule",
    needLowerCase: " minuscule",
    needNumber: " chiffre",
    needCharacters: " caractères",
    needCharactersSpecial: " caractères spécial",
    definePassword: "Définissez un nouveau mot de passe",
    placeholderNewPassword: "Nouveau mot de passe",
    confirmationPassword: "Confirmation de votre nouveau mot de passe",
    confirmSuccess: "Votre mot de passe a bien été créé, essayez de vous connecter.",
    passwordNotTheSame: "Les mots de passe ne sont pas identiques.",
    criteriaRequier: "Votre mot de passe ne répond pas aux critères de sécurité.",
    YOUR_OLD_PASSWORD: "Ancien mot de passe",
    WRONG_OLD_PASSWORD: "Hum, ceci n'est pas votre mot de passe.",
    confirmPassword: "Confirmation de votre nouveau mot de passe",
    placeholderConfirmPassword: "Confirmation de votre nouveau mot de passe",
    confirmSuccess: "Votre nouveau mot de passe a été créé avec succès.",
    invalidTokenResetPassword:
      "Pour des raisons de sécurité, le lien que vous avez suivi a expiré.",
    invdalidTokenResendEmail: "Cliquer ici",
    // Registration Part
    titleRegistration: "Bienvenue !",
    firstTextLeftRegistration: "Renseigne tes données personnelles",
    secondTextLeftRegistration: "et commence ton expérience avec nous !",
    firstTextRegistration: "Salut ! L'inscription ne prendra",
    secondTextRegistration: "pas plus de 2 minutes, promis !",
    placeholderFirstname: "Prénom",
    placeholderLastname: "Nom",
    sensitivityPassword1: "Fort",
    sensitivityPassword2: "Moyen",
    sensitivityPassword3: "Faible",
    libellePassword: "Mot de passe",
    libellePrivacyPolicy1: "J'accepte la ",
    libellePrivacyPolicy2: "politique de confidentialité",
    buttonRegistration: "S'inscrire",
    libellePrivacyRobotPolicy: "Je ne suis pas un robot",
    ou: "ou",
    goToLogin1: "Déjà inscrit ?",
    goToLogin2: "Se connecter",
    goToLogin: "Déjà inscrit ? Se connecter",
    errorRegistration:
      "Nous sommes désolés, nous rencontrons des problèmes pour la création de votre compte.",
    successRegistration: "Votre compte a été créer avec succès !",
    // Registration Business Part
    titleRegistrationBusiness: "Bienvenue",
    firstTextRegistrationBusiness: "Pour commencer l'expérience",
    secondTextRegistrationBusiness: "Pocket result, veuillez renseigner ces champs.",
    labelRegistrationBusiness1: "Nom de l'entreprise",
    labelRegistrationBusiness2: "Téléphone de l'entreprise",
    labelRegistrationBusiness3: "Nom du domaine",
    //FORM
    GLOBAL_COMMENT: "Commentaire Global",
    MANDATORY: "Obligatoire",
    CHOOSE_ANSWER: "Choisir la réponse",
    ENTER_AN_ANSWER: "Saisir une réponse",
    ENTER_A_RECOMMENDATION: "Saisir une recommandation",
    NOT_SPECIFIED: "Non renseigné",
    NOT_SPECIFIED_RECO: "Aucune recommandation renseignée",
    NONE_RECOMMENDATIONS: "Aucune recommandation",
    // Console Admin
    BUSINESS_DESACTIVATED:
      "Votre business est actuellement désactivé, merci de contacter le support.",
    USER_DESACTIVATED: "Votre compte est actuellement désactivé, merci de contacter le support.",
    ENTITY: "Entité",
    ASSOCIATED_ENTITY: "Entité associée",
    SUB_ENTITY: "Sous-entité",
    ENTITY_GESTION: "Gestion des entités",
    NUMBER_OF_GROUP: "Nombre de groupe",
    NUMBER_OF_ROLES: "Nombre de rôles",
    NUMBER_OF_USERS: "Nombre d'utilisateurs",
    CREATION_DATE: "Date de création",
    USE_GOVERNANCE: "Accès Gouvernance",
    USE_FORM: "Accès Formulaire",
    ADD_ENTITY: "Ajouter une entité",
    ENTITY_NAME: "Nom de l'entité",
    FIRST_USER_EMAIL: "Premier email de l'utilisateur",
    ADD_BUSINESS: "Ajouter un business",
    ENTITY_INFORMATIONS: "Informations entité",
    BACK_TO_LIST: "Retour à la liste",
    DISABLE_USER: "Désactiver l'utilisateur",
    ENABLE_USER: "Activer l'utilisateur",
    DISABLE_ROLE: "Désactiver le role",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ROLE: "Êtes-vous sur de vouloir supprimer ce role ?",
    NO_BUSINESS_FOUND: "Aucun business trouvé",
    ADDITIONAL_FEATURES: "Fonctionnalités Additionnelles",
    ACTIVATE_RIGHTS_ENTITY: "Activer les droits de l'entité",
    ACTIVATE_GOVERNANCE_RIGHT: "Activer les droits de gouvernance",
    ACTIVATE_INCIDENT_RIGHT: "Activer les droits de la gestion des incidents",
    ACTIVATE_FORM_ACCESS: "Activer les accès au formulaire",
    ACTIVATE_DOCUMENT_MANAGEMENT_ACCESS: "Activer les accès à la gestion documentaire",
    ACTIVATE_AUDIT_MODULE: "Activer les accès au module audit",
    ACTIVATE_MSF_MODULE: "Activer les accès au module MSF",
    ACTIVATE_REFERENTIALS_MODULE: "Activer les accès au module référentiels",
    ACTIVATE_ANOMALIES: "Activer les anomalies",
    ACTIVATE_INCIDENTS: "Activer les incidents",
    ACTIVATE_RECOMMENDATIONS: "Activer les recommandations",
    ACTIVATE_REFERENTIALS: "Activer les référentiels",
    ACTIVATE_CONFIG_GRC: "Activer la configuration GRC",
    ACTIVATE_KPIS_DASH: "Activer Kpis sur Dashboard",
    ACTIVATE_GED: "Activer Gestion Documentaire (GED)",
    TYPE_OF_GOVERNANCE: "Type de gouvernance",
    UNDEFINED_NAME: "Le nom n'est pas défini",
    ANOMALY: "Anomalie",
    ANOMALIES: "Anomalies",
    ADD_ANOMALY: "Ajouter une anomalie",
    INCIDENT: "Incident",
    ADD_INCIDENT: "Ajouter un incident",
    ACTIONS_CORRECTIVES: "Actions correctives",
    ACTIONS_PLANS: "Plans d'action",
    ACTION_PLAN: "Plan d'action",
    PERFORMERS: "Performers",
    PERFORMER: "Performer",
    DATE_OF_IMPLEMENTATION: "Date de mise en œuvre",
    DEADLINE: "Date limite",
    TASKS: "Tâches",
    ASSIGNED_YOU_TASKS_NON_CONFORMITY: "vous a assigné à une tâche concernant la non-conformité",
    ADD_AN_ACTION_PLAN: "Ajouter un plan d'action",
    SELECT_A_PERIOD_TO_DISPLAY: "Sélectionnez une période à afficher",
    // My Profile part
    FIRST_NAME: "Prénom",
    LAST_NAME: "Nom",
    EMAIL: "Email",
    EMAIL_ADRESS: "Adresse Email",
    INCORRECT_EMAIL_ADDRESS: "Adresse email incorrecte",
    POSITION: "Profession",
    FUNCTION: "Fonction",
    DEPARTMENT: "Service",
    LANGUAGE: "Langue",
    HOME_PAGE: "Page d'accueil",
    CHANGE_MY_PASSWORD: "Modifier mon mot de passe",
    EDITION: "Édition",
    PROFILE_PICTURE: "Photo de profil",
    MAX_SIZE_PROFILE_PICTURE: "La taille de fichier maximale autorisée est de 200 Kio.",
    CONFIRM_CHANGE_PASSWORD: "Mettre à jour le mot de passe",
    DELETE_PROFILE_PICTURE: "Supprimer",
    ENTITY_WORK: "Entité de travail",
    USER_PROFILS: "Profils utilisateur",
    ENTITIES_MEMBERSHIP: "Entités d'appartenance",
    BY_DEFAULT: "Par défaut",
    // Accès & Entreprise Part
    CUSTOMIZATION: "Informations",
    LOCALISATION_INPUT_LABEL: "Coordonnées d'affichage au chargement de la carte",
    LATTITUDE: "Latitude",
    LONGITUDE: "Longitude",
    DESIGN: "Design",
    ROLES: "Rôles",
    USERS: "Utilisateurs",
    CONTROLS_TAB: "Contrôles",
    ACTIVTY_TAB: "Activités",
    RISK_TAB: "Risques",
    RISK_RESIDUAL_TAB: "Risques Residuels",
    HISTORY: "Historique",
    CARTOGRAPHY_HISTORY: "Historique cartographie",
    ADMIN_BUSINESS: "Admin Business",
    COMPANY_NAME: "Nom de l'entreprise",
    PHONE_NUMBER: "Téléphone de contact",
    CONTACT_EMAIL: "Email de contact",
    WEBSITE: "Site web",
    PLATEFORM_COLORS: "Couleurs de la plateforme",
    SIDEBAR_COLOR: "Couleur Menu Latéral",
    PRIMARY_COLOR: "Couleur action primaire",
    ALTERNATIVE_COLOR: "Couleur action alternative",
    ILLUSTRATION_COLOR: "Couleur principale illustration",
    BUSINESS_UNIT: "Business Unit",
    EDITION: "Edition",
    UPLOAD_LOGO: "Télecharger le logo",
    COLORS: "Couleurs",
    INTERFACE_COLOR: "Couleurs de l'interface",
    OVERVIEW: "Aperçu",
    CREATED_ON: "Créé le",
    ACCESS: "Accès",
    ADD_NEW_USER: "Ajouter un nouvel utilisateur",
    NEW_USER: "Nouvel utilisateur",
    MODIFY_USER: "Modifier l'utilisateur",
    buttonAcces2: "Editer les accès",
    UNVALID_EMAIL: "Veuillez entrer un email valide",
    ALREADY_USED_EMAIL: "Cet email est déjà utilisé sur la plateforme",
    ENTER_VALID_FIRSTNAME: "Veuillez entrer un prénom",
    ENTER_VALID_LASTNAME: "Veuillez entrer un nom",
    ENTER_VALID_FUNCTION: "Veuillez entrer une fonction",
    SELECT_VALID_ACCESS: "Veuillez sélectionner un accès",
    SELECT_VALID_GROUP: "Veuillez sélectionner un groupe",
    GROUP: "Groupe",
    CLIENT: "Client",
    CLIENTS: "Clients",
    newActivity: "nouvelle activité",
    addActivity: "ajouter une activité",
    editActivity: "éditer une activité",
    labelActivity1: "Nom de l'activité",
    labelActivity2: "Référence de l'activité",
    NEW_ROLE: "nouveau rôle",
    addARole: "ajouter un rôle",
    EDIT_A_ROLE: "éditer un rôle",
    labelRoleTitle1: "Editer les accès",
    labelRoleTitle2: "Créer un nouvel accès",
    labelRoleTitle3: "Supprimer un accès",
    NB_USERS: "Nombre d'utilisateur",
    ROLE_NAME: "Nom du rôle",
    labelRole2: "Accès du rôle",
    labelRole3: "Créer à partir du rôle",
    labelRole4: "Attention ! Le niveau de rôle modifiera le prix de l'accès",
    errorEnterNameAccess: "Veuillez entrer un nom de rôle",
    errorAccessAldreadyExist: "Le nom du rôle existe déjà, veuillez le modifier et ressayer.",
    roleCategory1: "Utilisateurs",
    roleCategory2: "Société",
    roleCategory3: "Dashboard",
    roleCategory4: "Données",
    roleCategory5: "Rôles",
    roleCategory6: "Administrateur",
    roleCategory7: "Formulaire",
    roleCategory8: "Gouvernance",
    roleCategory9: "Groupes",
    COLOR_CHARTS_PALETTES: "Palettes de couleurs des graphiques",
    SEARCH: "Recherche",
    SAVE_EDIT: "Sauvegarder les modifications",
    EDIT: "Modifier",
    ADD_A_PALETTE: "Ajouter une palette",
    PALETTE_NAME: "Nom de la palette",
    DEFAULT_PALETTE: "Palette par défaut",
    PALETTE: "Palette",
    TEN_COLORS_RECOMMENDED: "10 couleurs recommandées",
    GALERY_PALETTE: "Galerie de palette",
    ADD_A_COLOR: "Ajouter une couleur",
    ACTIONS: "Actions",
    PALETTE_MUST_HAVE_A_NAME: "La palette doit avoir un nom",
    PALETTE_MUST_HAVE_AT_LEAST_ONE_COLOR: "La palette doit comporter au moins une couleur",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_LAST_PALETTE:
      "Êtes-vous sur de vouloir supprimer la dernière palette de l'entreprise ? Si votre entreprise ne possède plus de palette, elle utilisera les palettes publiques de l'application",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_PALETTE:
      "Êtes-vous sur de vouloir supprimer cette palette de couleur ?",
    LOADING: "Chargement...",
    REFERENTIALS_STATS_LOADING: "Chargement des statistiques...",
    STATS_EMPTY_STATE: "Aucune donnée disponible",
    STATS_SERIES_USAGE: "Usage",
    STATS_SERIES_CONNECTIONS: "Connexions",
    USER_STATS_NO_USER_ID: "Impossible de récupérer l'ID utilisateur.",
    USER_STATS_NO_DATA: "Aucune donnée disponible pour cet utilisateur.",
    USER_STATS_FORBIDDEN: "Vous n'avez pas les droits pour consulter les statistiques de cet utilisateur.",
    USER_STATS_TITLE: "Statistiques utilisateur",
    USER_STATS_GENERAL: "Informations générales",
    USER_STATS_LAST_LOGIN: "Dernière connexion",
    USER_STATS_NEVER: "Jamais",
    USER_STATS_LOGIN_COUNT: "Nombre de connexions",
    USER_STATS_TOP_CUBES: "Cubes les plus utilisés",
    USER_STATS_TOP_REFERENTIALS: "Référentiels les plus utilisés",
    USER_STATS_NO_ACTIVITY: "Aucune activité enregistrée.",
    GLOBAL_STATS_LOADING: "Chargement des statistiques globales...",
    GLOBAL_STATS_NO_DATA: "Aucune statistique disponible",
    GLOBAL_STATS_TITLE: "Statistiques globales",
    GLOBAL_STATS_USERS: "Utilisateurs",
    GLOBAL_STATS_TOTAL_USERS: "Total utilisateurs",
    GLOBAL_STATS_ACTIVE_7_DAYS: "Actifs (7 jours)",
    GLOBAL_STATS_ACTIVE_30_DAYS: "Actifs (30 jours)",
    GLOBAL_STATS_TOP_CUBES: "Cubes les plus utilisés",
    GLOBAL_STATS_TOP_REFERENTIALS: "Référentiels les plus utilisés",
    GLOBAL_STATS_DAILY_LOGINS: "Connexions par jour",
    COLOR_ONE: "Couleur 1",
    COLOR_TWO: "Couleur 2",
    USE_GRADIENT: "UTILISER UN GRADIENT DE COULEURS",
    HEADER_SIZE: "TAILLE DU HEADER",
    HEADER: "En-tête",
    INTERFACE: "Interface",
    ERROR_MESSAGE_SIZE_HEADER: "Attention la valeur doit être comprise entre 70 et 200 pixels !",
    NAVBAR_COLOR: "Couleur de la barre de navigation",
    NAVBAR_SIZE: "TAILLE DE LA NAVBAR",
    HIDE_TITLE: "MASQUER LE TITRE",
    HIDE_DESCRIPTION: "MASQUER LA DESCRIPTION",
    USE_MINIMIZED_BUTTON_VIEW: "UTILISER L'AFFICHAGE DES BOUTONS RÉDUITS",
    NAVBAR: "Barre de navigation",
    TOP_TO_BOTTOM: "Haut en bas",
    BOTTOM_TO_TOP: "Bas en haut",
    LEFT_TO_RIGHT: "Droite à gauche",
    RIGHT_TO_LEFT: "Gauche à droite",
    BOTTOM_LEFT_TO_TOP_RIGHT: "Coin bas gauche à coin haut droit",
    TOP_LEFT_TO_BOTTOM_RIGHT: "Coin haut gauche à coin bas droit",
    BOTTOM_RIGHT_TO_TOP_LEFT: "Coin bas droit à coin haut gauche",
    TOP_RIGHT_TO_BOTTOM_LEFT: "Coin haut droit à coin bas gauche",
    HEADER_TEXT_COLOR: "Couleur du texte de l'en-tête",
    NAVBAR_TEXT_COLOR: "Couleur du texte de la barre de navigation",
    //RIGHTS
    CREATE_ACCOUNT: "Créer des comptes",
    EDIT_ACCOUNT: "Editer des comptes",
    DELETE_ACCOUNT: "Supprimer des comptes",
    DELETE_THE_USER: "Supprimer l'utilisateur",
    EDIT_COMPANY_INFO: "Editer les infos société",
    CREATE_BUSINESS_UNIT: "Créer un Business Unit",
    EDIT_BUSINESS_UNIT: "Editer un Business Unit",
    DELETE_BUSINESS_UNIT: "Supprimer un Business Unit",
    CREATE_DASHBOARD: "Créer un dashboard",
    EDIT_DASHBOARD: "Editer un dashboard",
    DELETE_DASHBOARD: "Supprimer un dashboard",
    SHARE_DASHBOARD: "Partager un dashboard",
    IMPORT_DATA: "Importer des données",
    EDIT_DATA: "Editer des données",
    NO_RESPONSE: "Aucune réponse",
    DELETE_DATA: "Supprimer des données",
    NO_ACCESS_DATASOURCE: "Pas d'accès aux sources de données",
    CREATE_ROLE: "Créer des rôles",
    EDIT_ROLE: "Editer des rôles",
    DELETE_ROLE: "Supprimer des rôles",
    DELETE_THE_ROLE: "Supprimer le rôle",
    CREATE_GROUP: "Créer des groupes",
    EDIT_GROUP: "Editer des groupes",
    DELETE_GROUP: "Supprimer des groupes",
    VIEW_GROUP: "Visualiser les groupes",
    CREATE_ADMINISTRATOR: "Créer des administrateurs",
    EDIT_ADMINISTRATOR: "Editer des administrateurs",
    DELETE_ADMINISTRATOR: "Supprimer des administrateurs",
    VIEW_CREATED_ACCOUNTS: "Visualisation des comptes créés",
    VIEW_FORM: "Visualisation des formulaires",
    VIEW_TREE: "Vue relations",
    CREATE_FORM: "Créer des formulaires",
    EDIT_FORM: "Editer des formulaires",
    DELETE_FORM: "Supprimer des formulaires",
    DUPLICATE_FORM: "Dupliquer à des formulaires",
    REPONSE_FORM: "Répondre à des formulaires",
    PARAMETERS_FORM: "Paramètrage des formulaires",
    NO_ACCESS: "Aucun droit d'accès",
    ACCESS_CONTROL: "Accès Gouvernance",
    ACCESS_CARTOGRAPHIE: "Accès Cartographie",
    ACCESS_PLANNING: "Accès Planning Contrôle",
    ADD_CARTO: "Créer Cartographie",
    DELETE_CARTO: "Supprimer Cartographie",
    PARAMS_CARTO: "Paramètres de la Cartographie",
    ADD_ACTIVITY: "Créer Activité",
    EDIT_ACTIVITY: "Editer Activité",
    ADD_RISK: "Créer Risque",
    EDIT_RISK: "Editer Risque",
    ADD_TASK: "Ajouter une tâche",
    DELETE_RISK: "Supprimer Risque",
    ADD_CONTROL: "Créer Contrôle",
    EDIT_CONTROL: "Editer Contrôle",
    DUPLICATE_CONTROL: "Dupliquer Contrôle",
    DELETE_CONTROL: "Supprimer Contrôle",
    WAIT_FOR_VALIDATION: "En attente de validation",
    FRAMEWORK: "Framework",
    FRAMEWORK_FRANCE: "Framework france",
    SELECT_FRAMEWORK: "Selectionner un framework",
    SELECT_CONTROLS: "Selectionner des contrôles",
    RELEVANT_CONTROLS: "Contrôles associés",
    DETAILS: "Details",
    EVENT_LOG: "Event log",
    IMPACT_ANALYSIS: "Impact analysis",
    REMARK: "Remarque",
    ACCESS_DOC_ACTUALITY: "Accès actualité / veille réglementaire",
    ADD_DOC_ACTUALITY: "Ajouter une actualité",
    EDIT_DOC_ACTUALITY: "Editer une actualité",
    DELETE_DOC_ACTUALITY: "Supprimer une actualité",
    ACCESS_DOC_GOVERNANCE: "Accès gouvernance",
    ADD_DOC_GOVERNANCE: "Ajouter une année de gouvernance",
    EDIT_DOC_GOVERNANCE: "Editer une année de gouvernance",
    DELETE_DOC_GOVERNANCE: "Supprimer une année de gouvernance",
    ACCESS_DOC_SOLLICITE: "Accès document sollicité",
    ACCESS_DOC_HISTORY: "Accès historique",
    ACCESS_DOC_RECOMMENDATIONS: "Accès documents recommandations",
    ACCESS_DOCUMENT_MANAGEMENT: "Accès gestion documentaire",
    ACCESS_VALIDATION_MANAGER: "Accès validation manager",
    ///
    labelEditUser: "Modification d'un utilisateur",
    labelCreateUser: "Ajout d'un nouvel utilisateur",
    addAUser: "Ajouter un utilisateur",
    btnCreateUser: "Créer le nouvel utilisateur",
    //GOVERNANCE
    SUCCESS_TO_CHANGE_BUSINESS_GOVERNANCE_RIGHT:
      "Le changement du droit de gouvernance d'entreprise à été réalisé avec succès",
    FAIL_TO_CHANGE_BUSINESS_GOVERNANCE_RIGHT:
      "Une erreur a été rencontrée lors des changements de droits de gouvernance d'entreprise",
    SUCCESS_TO_DELETE_GOVERNANCE_CONTENT: "Le contenu de la gouvernance a été supprimé avec succès",
    FAIL_TO_UPDATE_REQUEST_GOVERNANCE: "Échec lors de la mise à jour de la gouvernance",
    SUCCESS_TO_UPDATE_REQUEST_GOVERNANCE: "Mise à jour réussie de la gouvernance",
    SUCCESS_TO_CREATE_REQUEST_GOVERNANCE: "Création réussie de la gouvernance",
    FAIL_TO_CREATE_REQUEST_GOVERNANCE: "Échec lors de la création de la gouvernance",
    FAIL_TO_UPDATE_REQUEST_ACTUALITY: "Échec lors de la mise à jour de l'actualité",
    SUCCESS_TO_UPDATE_REQUEST_ACTUALITY: "Mise à jour réussie de l'actualité",
    SUCCESS_TO_CREATE_REQUEST_ACTUALITY: "Création réussie de l'actualité",
    SUCCESS_TO_DELETE_ACTUALITY: "Actualité supprimé avec succès",
    FAIL_TO_DELETE_ACTUALITY: "Échec lors de la suppression de l'actualité",
    FAIL_TO_CREATE_REQUEST_ACTUALITY: "Échec lors de la création de l'actualité",
    SUCCESS_TO_PATCH_RISK: "Mise à jour réussie du risque",
    FAIL_TO_PATCH_RISK: "Échec lors de la mise à jour du risque",
    SUCCESS_TO_UPDATE_ACTIVITY: "Mise à jour réussie de l'activité",
    FAIL_TO_UPDATE_ACTIVITY: "Échec lors de la mise à jour de l'activité",
    SUCCESS_TO_VALIDATE_TASK: "Validation de la tâche avec succès",
    FAIL_TO_VALIDATE_TASK: "Échec lors de la validation de la tâche",
    SUCCESS_TO_SAVE_RESPONSE: "Sauvegarde de votre réponse avec succès",
    FAIL_TO_SAVE_RESPONSE: "Échec lors de la sauvegarde de votre réponse",
    SUCCESS_TO_UPDATE_CUSTOM_SKELETON: "Sauvegarde de votre modèle avec succès",
    FAIL_TO_UPDATE_CUSTOM_SKELETON: "Échec lors de la sauvegarde de votre modèle",
    TESTTING: "Testing",
    DISPOSITIF: "Dispositif",
    //WIDGETS
    WIDGET_SETTINGS: "Paramétrage du widget",
    STYLE: "Style",
    TABS: "Onglets",
    AND: "ET",
    OR: "OU",
    CATEGORY: "Catégorie",
    VERSION: "Version",
    DEPENDS_ON: "Par rapport à",
    GROUP_BY: "Grouper par",
    SELECT_Y: "Sélectionner valeur de l'axe Y",
    SELECT_X: "Sélectionner valeur de l'axe X",
    CALCULUS: "Calcul",
    ADD_A_VALUE: "Ajouter une valeur",
    ADD_A_FORMULA: "Ajouter une formule",
    EDIT_A_FORMULA: "Modifier la formule",
    CUSTOM_CALCULUS: "Calcul personnalisé",
    HIDE_QUESTION: "Masquer la question",
    HIDE_FORMULA: "Masquer la formule",
    FIELD: "Champ",
    DAY_MONTH_YEAR: "Jour-Mois-Année",
    DAY_MONTH: "Jour-Mois",
    MONTH_YEAR: "Mois-Année",
    MONTH_IN_LETTER_YEAR: "Mois en lettre-Année",
    DAY: "Jour",
    MONTH: "Mois",
    TRIMESTER: "Trimestre",
    SEMESTER: "Semestre",
    YEAR: "Année",
    CHANGE_WIDGET_TYPE: "Changer le type de widget",
    AUTHORIZE_COMPARISON: "Autoriser la comparaison",
    AUTHORIZE_FILTERING: "Autoriser le filtrage",
    SORT: "TRIER",
    DEFAULT: "Défaut",
    TRUNCATE: "Troncage",
    WRAP: "Retour à la ligne",
    NO_SORTING: "Aucun tri",
    ASCENDING: "Croissant",
    DESCENDING: "Décroissant",
    DISPLAYED_RESULTS: "Résultats affichés",
    RESULTS_NUMBER: "Nombre de résultats",
    BEST_RESULTS: "Les meilleurs résultats",
    WORST_RESULTS: "Les moins bons résultats",
    FIRST_SELECT_FIELDS_TO_DISPLAY: "Sélectionner d'abord des champs à afficher",
    FIRST_SELECT_NUMERIC_FIELDS_TO_DISPLAY: "Sélectionner d'abord des champs numeriques à afficher",
    OF: "de",
    FOR: "pour",
    DISPLAYED_FIELDS: "Champs affichés",
    OTHER_FIELDS: "Autres champs",
    OTHER_DOCUMENTS: "Autres documents",
    WIDGET_NOT_CONFIGURED: "Widget non configuré",
    WIDGET_FILTER_HIERARCHY_EMPTY: "Aucun élément",
    WIDGET_FILTER_HIERARCHY_CONFIGURE: "Configurer la relation",
    WIDGET_SOURCE_LABEL: "Source de données",
    WIDGET_SOURCE_CUBE: "Données de la page (cube)",
    WIDGET_SOURCE_VIEW_COLUMNS: "Colonnes produites par cette vue",
    WIDGET_SOURCE_MISSING_FIELDS: "Champs configurés absents de cette vue, à re-sélectionner",
    DATA_VIEWS: "Vues de données",
    VIEW_NEW: "Nouvelle vue",
    VIEW_LIST_EMPTY: "Aucune vue sur cette page",
    VIEW_PUBLISHED: "Publiée",
    VIEW_NAME: "Nom",
    VIEW_DESCRIPTION: "Description",
    VIEW_TAB_DEFINITION: "Définition",
    VIEW_TAB_HISTORY: "Historique",
    VIEW_VALIDATE: "Valider",
    VIEW_VALID: "Définition valide",
    VIEW_SAVED: "Vue enregistrée",
    VIEW_RESTORED: "Version restaurée",
    VIEW_NAME_REQUIRED: "Le nom de la vue est obligatoire",
    VIEW_NO_OUTPUT_COLUMN: "Aucune colonne en sortie",
    VIEW_AVAILABLE_COLUMNS: "Colonnes disponibles",
    VIEW_HISTORY_COUNT: "Versions enregistrées",
    VIEW_HISTORY_RESTORE: "Restaurer",
    VIEW_HISTORY_RESTORED_FROM: "restauration de la v",
    VIEW_HISTORY_EMPTY: "Aucune version enregistrée",
    VIEW_HISTORY_LOAD_MORE: "Charger les versions plus anciennes",
    LINE: "ligne",
    RELATION_TO_TRAVERSE: "Relation à parcourir",
    PARENT_SIDE: "Côté parent",
    LABEL_FIELD: "Champ affiché (label)",
    DEFAULT_REFERENCE: "Référence (défaut)",
    SELECT_A_FIELD_FIRST: "Sélectionner d'abord un champ",
    SELECT_ALL: "Tout sélectionner",
    WARNING_RESET_DATA_WIDGET:
      "Attention, ce graphique n’est pas adapté à la configuration des données actuelles. Le changement réinitialisera la configuration des données. Souhaitez vous continuer ?",
    //CONDITION
    CONDITIONS: "Conditions",
    ADD_AN_OR_CONDITION: 'Ajouter une condition "OU"',
    ADD_AN_AND_CONDITION: 'Ajouter une condition "ET"',
    EQUAL_SYMBOL: "égal à ",
    DIFFERENT_SYMBOL: "différent de ",
    INFERIOR_SYMBOL: "inférieur à ",
    SUPERIOR_SYMBOL: "supérieur à ",
    INFERIOR_OR_EQUAL_SYMBOL: "inférieur ou égal à ",
    SUPERIOR_OR_EQUAL_SYMBOL: "supérieur ou égal à ",
    DISPLAY: "Afficher",
    LOCALISER_PAR: "Localiser par",
    ADVANCED_MODE: "Mode avancé",
    UNIQUE_SELECTION_LIST: "Liste sélection unique",
    MULTIPLE_SELECTION_LIST: "Liste sélection multiple",
    CHARTS: "Graphiques",
    FILTERS: "Filtres",
    TEXTS: "Textes",
    HISTOGRAM_TYPE: "Type d'histogramme",
    HISTOGRAM_ORIENTATION: "Orientation de l'histogramme",
    PIE_TYPE: "Type de camembert",
    LINE_TYPE: "Type de courbe",
    STYLE_CURVE: "Style de la courbe",
    STYLE_BULLETS: "Style des points de courbe",
    APPLY_STYLE_ALL_CURVES: "Appliquer le style à toutes les courbes",
    FIELD_LABEL: "Label du champ",
    //WIDGET SETTINGS
    MOVE_TO_MAIN_LAYOUT: "Déplacer vers la grille principale",
    MOVE_TO_FIXED_LAYOUT: "Déplacer vers la grille fixe",
    DISPLAY_PERIOD: "Période d'affichage",
    SEARCH_BY_COLUMN: "Recherche par colonne",
    LABEL: "Label",
    CENTRAL_TEXT: "Texte central",
    EXTERNAL_LABEL: "Label externe",
    HIDE_EXTERNAL_LABEL: "Masquer les labels externes",
    VALUE: "Valeur",
    VALUES: "Valeurs",
    TITLE_STYLE: "Style du titre",
    TITLE_ALIGNMENT: "Alignement du titre",
    BACKGROUND: "Arrière plan",
    BORDER: "Bordure",
    ACTIVE_BORDER: "Activer les bordures",
    SINGLE_COLOR: "Couleur des labels unique",
    SINGLE_COLOR_VALUE: "Couleur des labels",
    USE_MY_COLOR_PALLET: "Utiliser ma palette de couleurs",
    THICKNESS: "Épaisseur",
    ALIGNMENT: "Alignement",
    ICON_ALIGNMENT: "Alignement de l'icône",
    ICON_OPACITY: "Opacité de l'icône",
    TEXT: "Texte",
    LABEL_ALIGNMENT: "Alignement du label",
    TEXT_ALIGNMENT: "Alignement du texte",
    TEXT_STYLE: "Style du texte",
    BULLET_COLOR: "Couleur des bulles",
    ANGLES: "Angles",
    PROGRESS_BAR_HEIGHT: "Épaisseur de la barre",
    PROGRESS_BAR_NUMBER: "Nombre de barre",
    PROGRESS_BAR_FIRST_LABEL: "Label 1",
    PROGRESS_BAR_SECOND_LABEL: "Label 2",
    ROUNDING_UPPER_LEFT_CORNER_COLUMN: "Arrondi de la colonne du coin supérieur gauche",
    ROUNDING_UPPER_RIGHT_CORNER_COLUMN: "Arrondi de la colonne du coin supérieur droite",
    ROUNDING_LOWER_LEFT_CORNER_COLUMN: "Arrondi de la colonne du coin inférieur gauche",
    ROUNDING_LOWER_RIGHT_CORNER_COLUMN: "Arrondi de la colonne du coin inférieur droite",
    ROUNDING_SERIES: "Arrondi des séries",
    COLUMN_WIDTH: "Largeur de la colone",
    INNER_RADIUS: "Rayon intérieur",
    PIE_GAUGE_MODE: "Compléter à 100 % (mode jauge)",
    SHOW_MENU: "Montrer le menu",
    USE_MARKER: "Activer les markers google",
    SHOW_FULLSCREEN: "Agrandissement du widget",
    HIDE_LABEL_INFERIOR_TO_A_VALUE: "Masquer les labels des valeurs inférieures à une valeur",
    VALUE_UNDER_WHICH_TO_HIDE_LABELS: "Valeur en dessous de laquelle cacher les labels",
    SHOW_LEGEND: "Montrer la légende",
    SHOW_EXPORT_MENU: "Afficher le menu d'exports",
    SWAP_MAP: "Pouvoir changer de cartographie",
    REGION: "Région",
    DEPARTEMENT: "Département",
    REDIRECT_BUTTON_NO_PAGE: "Aucune page n'a été configurée pour la redirection",
    REDIRECT_BUTTON_NO_URL: "Aucune URL n'a été renseigné pour la redirection",
    LEGEND_POSITION: "Position de la légende",
    ZOOM_ANIMATION: "Animation du zoom",
    ZOOM_BUTTONS: "Boutons zoom",
    ZOOM_SCALE: "Plus ou moins gros zoom",
    ZOOM_DURATION: "Durée du zoom",
    MAP_TOOLTIP_COLOR: "Couleur du tooltip",
    TOOLTIP_ACTIVATION: "Activation du tooltip",
    TOOLTIP: "Étiquette de survol",
    MAP_IS_DRAGGABLE: "Déplacement de la cartographie",
    MAP_IS_ZOOMABLE: "Pouvoir zoomer",
    LEGEND_LABEL: "Label de la légende",
    MAP_VUE: "Type d'affichage",
    MAP_CHOICE: "Choix de la cartographie",
    MAP_FRANCE_DEP: "France départements",
    MAP_FRANCE_REG: "France région",
    MAP_FRANCE_REG_NEW: "Nouvelle France",
    MAP_WORLD: "Monde",
    TYPE_MAP_COLOR: "Couleurs",
    TYPE_MAP_BULLET: "Bulles",
    TYPE_MAP_BULLET_COLOR: "Bulles + couleurs",
    TYPE_MAP_BULLET_COLOR_NUMBER: "Bulles + couleurs + nombre",
    REDIRECT_BUTTON_INPUT_URL: "URL",
    REDIRECT_BUTTON_SELECT_URL: "PAGE",
    REDIRECT_BUTTON_SELECT_REFERENTIEL: "REFERENTIEL",
    REDIRECT_BUTTON_SELECT_ICON: "sélectionner un icône",
    REDIRECT_BUTTON_SHAPE: "Couleur & forme du Bouton",
    ADD_AN_ICON: "Ajouter une icône",
    ICON_STYLE: "Style de l'icône",
    NO_ICONS_TO_SHOW: "Aucun icône à afficher",
    SEARCH_AN_ICON: "Chercher une icône ...",
    THAT_IS_TO_SAY: "Soit :",
    TOP: "Haut",
    BOTTOM: "Bas",
    RIGHT: "Droite",
    LEFT: "Gauche",
    YES: "Oui",
    NO: "Non",
    OK: "OK",
    NO_CONCERNED: "Non concerné",
    PLACEHOLDER: "Placeholder",
    FILTER_TYPE: "Type de filtre",
    DEFAULT_VALUES: "Valeurs par defaut",
    SELECTION_TYPE: "Type de sélection",
    ONLY_ONE_DATE: "Une seule date",
    PERIOD: "Période",
    CUSTOM_STYLE: "Style personnalisé",
    DEFAULT_STYLE: "Style par défaut",
    TITLE_AXE_X: "Titre de l'Axe X",
    TITLE_AXE_Y: "Titre de l'Axe Y",
    BULLET_SIZE: "Taille des points",
    CURVE_THICKNESS: "Épaisseur de la courbe",
    LOGARITHMIC_VIEW: "Vue logarithmique",
    CURVE_STYLE: "Style de la courbe",
    SOLID: "Continu",
    DASHED: "Tirets",
    DOTTED: "Points",
    TYPE_OF_PLOT: "Type de tracé",
    CURVE_LINE: "Lignes courbes",
    STRAIGHT_LINE: "Lignes droites",
    OPACITY: "Opacité",
    TRANSPARENCY: "Transparence (%)",
    UPLOAD_A_NEW_PHOTO: "Ajouter une nouvelle image",
    UPLOAD_TEXT_BTN: "Cliquer ou Glisser-Déposer un fichier pour l'uploader",
    BLUR: "Flou",
    HIDE_CENTERED_VALUE: "Masquer la valeur central",
    HIDE_AXIS_VALUES: "Masquer les valeurs de l'axe",
    HIDE_CENTERED_TEXT: "Masquer le texte central",
    SHOW_CENTERED_VALUE: "Afficher le texte central",
    STYLE_CENTERED_TEXT: "Style du texte central",
    STYLE_LABELS: "Style des labels",
    STYLE_VALUES: "Style des valeurs",
    STYLE_CENTERED_VALUE: "Style de la valeur central",
    STYLE_CENTERED_PERCENT: "Style du pourcentage central",
    CUSTOM_CENTER_TEXT: "Texte central personnalisé",
    DO_NOT_DISPLAY_WIDGET_TITLE: "Ne pas afficher le titre du widget",
    OPACITY_UNDER_THE_CURVE: "Opacité de l'aire sous la courbe",
    HIDE_GRID_HORIZONTALY: "Masquer la grille horizontallement",
    HIDE_GRID_VERTICALY: "Masquer la grille verticallement",
    START_ANGLE: "Angle de début",
    END_ANGLE: "Angle de fin",
    SHOW_GRID: "Montrer la grille",
    HIDE_LABELS: "Masquer les labels",
    SHOW_STACK_TOTAL: "Afficher le total de la colonne",
    STACK_TOTAL_COLOR: "Couleur du total",
    STACK_TOTAL_FONT_SIZE: "Taille du total",
    COLOR_BY_VALUE: "Couleur par valeur",
    COLOR_BY_VALUE_HINT: "La valeur telle qu'elle s'affiche dans la légende",
    GANTT_CHART: "Gantt",
    WEEK: "Semaine",
    PROGRESS: "Avancement",
    GANTT_COLUMNS: "Colonnes du Gantt",
    GANTT_SIDEBAR_WIDTH: "Largeur de la colonne de libellés (%)",
    GANTT_DURATION_UNIT: "Unité de durée",
    GANTT_EXCLUDE_WEEKENDS: "Exclure les week-ends des durées",
    GANTT_NO_COLUMN_YET: "Ajoutez d'abord des colonnes au widget, puis attribuez-leur un rôle.",
    GANTT_PICK_COLUMNS:
      "Choisissez la colonne de libellé et la colonne de date de début dans la configuration du widget.",
    GANTT_SKIPPED_ROWS: "lignes ignorées : pas de libellé ou pas de date de début exploitable",
    GANTT_NO_END_ROLE:
      "Aucune colonne de date de fin choisie : chaque ligne s'affiche en jalon.",
    GANTT_SAME_COLUMN:
      "La même colonne est choisie comme date de début et de fin : toutes les barres ont une longueur nulle.",
    GANTT_ALL_ZERO_LENGTH:
      "Toutes les lignes ont la même date de début et de fin : toutes les barres ont une longueur nulle.",
    GANTT_REVERSED_ROWS:
      "lignes ont une date de fin antérieure à la date de début — les rôles début/fin sont peut-être inversés.",
    GANTT_SKIPPED_ROWS_HINT:
      "Une colonne de date utilisée comme premier regroupement est transformée en libellé d'affichage et ne peut plus être lue comme une date.",
    HIDE_VALUES: "Masquer les valeurs",
    DISPLAY_IN_MULTIPLE_PROGRESS_BAR: "Affichage verticale",
    BAR: "barre",
    TYPE_LABEL_TEXT: "Type d'affichage du texte",
    TYPE_LABEL_VALUE: "Type d'affichage de la valeur",
    TYPE_EXTERNAL_LABEL_TEXT: "Type d'affichage des labels",
    CUSTOM_TEXT: "Texte personnalisé",
    VALUE_AND_TEXT: "Valeur et texte",
    TEXT_AND_VALUE: "Texte et valeur",
    PERCENT_AND_VALUE: "Pourcentage et valeur",
    VALUE_AND_PERCENT: "Valeur et Pourcentage",
    VALUE_PERCENT_AND_CUSTOM: "Valeur, Pourcentage et Texte Personnalisé",
    PERCENT: "Pourcentage",
    MINIMUM_DISTANCE_BETWEEN_GRID_LINES: "Distance minimum entre les lignes de la grille",
    SHOW_ONLY_MIN_AND_MAX: "Montrer uniquement le minimum et le mximum",
    SHOW_LABEL: "Montrer les labels",
    LABEL_POSITION: "Position des labels",
    DEFAULT_COLOR: "Couleur par défaut",
    SLIDER_COLOR: "Couleur de la plage de valeur",
    SHOW_TOTALS: "Afficher les totaux",
    ADD_A_PAGINATION: "Ajouter une pagination",
    PAGINATION_COLOR: "Couleur de la pagination",
    NB_LINES_PER_PAGE: "Nombre de lignes par page",
    HEADER_COLOR: "Couleur de l'en-tête",
    FOOTER_COLOR: "Couleur du bas de page",
    HEADER_TEXT_COLOR: "Couleur du texte de l'en-tête",
    FOOTER_TEXT_COLOR: "Couleur du texte du bas de page",
    HEADER_FONT_SIZE: "Taille du texte de l'en-tête",
    DISPLAY_HEAD_CELL_SEPARATOR: "Afficher le séparateur de cellule du header",
    DISPLAY_LINE_SEPARATOR: "Afficher le séparateur de ligne",
    DISPLAY_COLUMN_SEPARATOR: "Afficher le séparateur de colonnes",
    TEXT_ALIGNMENT_IN_THE_HEADER: "Alignement du texte dans l'en-tête",
    TEXT_ALIGNMENT_IN_THE_FOOTER: "Alignement du texte dans le bas de page",
    TEXT_ALIGNMENT_IN_COLUMNS: "Alignement du texte dans les colonnes",
    DISPLAY_VALUE_TO_ZERO: "Afficher les valeurs à 0",
    FREEZE_FIRST_COLUMN: "Première colonne fixe",
    RESIZABLE_COLUMNS: "Colonne redimensionnable",
    ENABLE_TOOLTIP_CELL: "Activer le tooltip sur les cellules",
    CHOOSE_YOUR_COLOR_THEME: "Choisissez votre thème de couleurs",
    PALETTE1: "Palette 1",
    PALETTE2: "Palette 2",
    PALETTE3: "Palette 3",
    PALETTE4: "Palette 4",
    PALETTE5: "Palette 5",
    PALETTE6: "Palette 6",
    DECIMAL_NUMBER: "Nombre de décimales",
    THOUSAND_SEPARATOR: "Séparateur de milliers",
    DECIMAL_SEPARATOR: "Séparateur de décimal",
    DOT_OPTION: "Point",
    COMMA_OPTION: "Virgule",
    SHOW_CLOCK_HAND: "Montrer les aiguilles",
    LABELS_ROTATION_ON_X_AXE: "Rotation des labels sur l'axe X",
    COLOR_EVEN_LINE: "Couleur ligne pair",
    COLOR_ODD_LINE: "Couleur ligne impaire",
    DISPLAY_NUMBER_OF_LINE: "Afficher nombre de lignes",
    NUMBER_OF_LINE: "Nombre de lignes :",
    CUSTOM_SCALE: "Échelle personnalisée",
    AXIS_START: "Axe de début",
    AXIS_END: "Axe de fin",
    START_AXIS_TO_ZERO: "Débuter à 0",
    MIN: "Min",
    MAX: "Max",
    DELIMITED_AXIS_Y_VALUE: "Définir les limites de l'axe y",
    SET_AS_MODEL: "Définir en tant que modèle",
    HIDE_AXE_X_LABEL: "Masquer les labels de l'axe x",
    HIDE_AXE_Y_LABEL: "Masquer les labels de l'axe y",
    WIDGET_SHAPE: "Fond & Forme du widget",
    COLOR_AND_TEXT: "Couleur et texte",
    EXPORT_AND_FULLSCREEN: "Export et pleine page",
    GRID: "Grille",
    ADVANCED_STYLE: "Style Avancé",
    FEATURES: "Fonctionnalités",
    AXIS: "Axe",
    LEGEND: "Légende",
    LEGEND_LABEL_DISPLAY_TYPE: "Type d'affichage des champs de la légende",
    ENABLE_TREE_ZOOM: "Active le zoom de l'arborescence",
    ENABLE_NAVIGATION_BAR: "Activer la barre de navigation",
    MAX_LEVELS_AT_ONCE: "Nombre de niveaux à la fois",
    INITIAL_VIEW_TEXT: "Texte de la vue initiale",
    TYPE_CENTRAL_TEXT: "Type du texte central",
    CENTRAL_LABEL_STYLE: "Style du texte central",
    CENTRAL_VALUE_STYLE: "Style de la valeur centrale",
    NAME_AND_VALUE: "Nom & Valeur",
    GAUGE_ROUNDING: "Arrondi des jauges",
    TYPE_MAX_VALUE: "Type de valeur maximale",
    SUM_OF_ALL: "Somme de toutes les valeurs",
    MAX_VALUE: "Valeur maximale",
    ANGLE_PRESETS: "Angle prédéfinis",
    LINEAR_GAUGE: "Jauge linéaire",
    CIRCULAR_GAUGE_75: "Jauge circulaire 75%",
    CIRCULAR_GAUGE_100: "Jauge circulaire 100%",
    SIDE_MENU_COLOR: "Couleur du menu latéral",
    SIDE_MENU_COLOR_TEXT: "Couleur du texte du menu latéral",
    SIDE_MENU: "Menu latéral",
    APPLY_THIS_STYLE_TO_ALL_WIDGETS: "Appliquer ce style a tout les widgets",
    APPLY_STYLE_ON_WIDGET_IS_SUCCESS: "Le style a bien été appliqué à l'ensemble de vos widgets",
    //MULTITAB WIDGET
    FIRST_SELECT_A_TAB: "Sélectionner d'abord un onglet",
    TAB_NAME: "Nom de l'onglet",
    SELECT_YOUR_TAB_NAME: "Sélectionner le nom de votre onglet",
    ICON: "Icône",
    ACTIVE_TABS_EFFECT: "Effet actif des onglets",
    UNDERLINE: "Souligné",
    TABS_ALIGNMENT: "Alignement des onglets",
    CENTER: "Centre",
    ADD_A_TAB: "Ajouter un onglet",
    WIDGET: "Widget",
    TOO_MANY_FIELD_CONFIG_RESET:
      "Trop de champs sélectionnés pour ce nouveau type de widget. La configuration a été réinitialisée.",
    ICON_POSITIVE_SELECTED: "Icône positive",
    ICON_POSITIVE_STYLE: "Style de l'icône positive sélectionnée",
    ICON_NEUTRAL_SELECTED: "Icône neutre",
    ICON_NEUTRAL_STYLE: "Style de l'icône neutre sélectionnée",
    ICON_NEGATIVE_SELECTED: "Icône négative",
    ICON_NEGATIVE_STYLE: "Style de l'icône négative sélectionnée",
    VALUE_POSITIVE_STYLE: "Style de la valeur positive",
    VALUE_NEUTRAL_STYLE: "Style de la valeur neutre",
    VALUE_NEGATIVE_STYLE: "Style de la valeur négative",
    COMPARISON_STYLE: "Style du texte de comparaison",
    CUSTOM_LABEL_STYLE: "Style du texte personnalisé",
    PERCENT_OR_DELTA: "Pourcentage ou différence",
    DELTA: "Delta",
    BOLD: "Gras",
    BOLDER: "Extra Gras",
    LIGHTER: "Fin",
    NORMAL: "Normal",
    SELECT_A_RANGE: "Sélectionner une plage de valeur",
    MINIMAL_COLOR: "Couleur minimal",
    MAXIMUM_COLOR: "Couleur maximal",
    MAX_FONT_SIZE: "Taille maximale du texte",
    //CHARTS
    pieChart: "Camembert",
    semiPieChart: "Portion de camembert",
    doublePieChart: "Double Camembert",
    doubleSemiPieChart: "Double Portion de camembert",
    stackedBar: "Histogramme cumulé",
    stackedBar100: "Histogramme 100",
    horizontalBarChart: "Histogramme horizontal",
    horizontal: "Horizontal",
    vertical: "Vertical",
    lineChart: "Courbe",
    SINGLE_CURVE: "Courbe simple",
    stackedArea: "Courbe superposée",
    cumulativeLineChart: "Courbe cumulée",
    dropdownList: "Selecteur",
    LABEL_SHOW_ALL_TASKS: "Afficher les tâches terminées",
    counter: "Compteur",
    histogram: "Histogramme",
    pyramide: "Pyramide",
    table: "Tableau",
    ag_table: "Tableau",
    gaugeChart: "Jauge",
    multiGauge: "Multi Jauge",
    treeMap: "Arborescence",
    CALENDAR: "Calendrier",
    ENTER_DATE: "Saisir une date",
    RADAR_CHART: "Radar",
    CARTOGRAPHIE: "Cartographie",
    CARTE: "Carte",
    MAPPING_FILTER: "Filtre Cartographie",
    BASIC_TEXT: "Texte",
    WIDGET_REDIRECT_BUTTON_NAME: "Bouton de redirection",
    WIDGET_IMAGE_NAME: "Image",
    DOUBLE_PROGRESS_BAR: "Barre de progression",
    multiTabWidget: "Multi Tab Widget",
    googleMap: "Google map",
    rangeFilter: "Filtre Plage",
    multiGauge: "Multi Jauge",
    evolutionWidget: "Evolution",
    heatMap: "HeatMap",
    heatMapRisk: "HeatMap",
    cloudWords: "Nuage de mot",
    actualityList: "Liste d'actualités",
    HIERARCHICAL_FILTER: "Filtre hiérarchique",
    // FULLSCREEN
    EXIT_FULLSCREEN_MODE: "Quitter le mode Plein Écran",
    // CALENDAR
    FROM: "de",
    TO: "à",
    TO_V3: "en",
    TO_ADD: "À ajouter",
    ALREADY_PRESENT: "Déja presents",
    REMAININGS: "Restants",
    PLEASE_ADD_ONE_PIECE_AT_LEST: "Veuillez ajouter au moins une donnée avant de valider.",
    NUMBER_EXCEEDS_LIMIT: "Le nombre d'échantillons dépasse la limite autorisée.",
    TO_V2: "au",
    SELECTION_OF_AN_ANALYSIS_PERIOD: "Sélection d'une période d'analyse",
    SELECT_A_COMPARISON_PERIOD: "Sélectionner une période de comparaison",
    YOU_DID_NOT_SELECT_ANALYSIS_PERIOD: "Vous n'avez pas sélectionné de période d'analyse",
    // Mosaique des dashboards
    labelMosaique1: "Mes Dashboards",
    labelMosaique2: "Dashboards Partagés",
    buttonMosaique: "Nouveau Dashboard",
    SET_TO_HOME_PAGE: "Définir comme page d'accueil",
    MODIFY_THUMBNAIL: "MODIFIER LA MINIATURE",
    AUTOMATIC_SCREENSHOT: "Capture d'écran automatique",
    IMAGE: "Image",
    THUMBNAIL_TYPE: "Type de miniature",
    ADD_IMAGE: "AJOUTER UNE IMAGE",
    // Dashboard Part
    buttonDashboard1: "Editer ce Dashboard",
    buttonDashboard2: "Nouveau Dashboard",
    buttonDashboard3: "Valider les modifications",
    buttonDashboard4: "Nouveau Widget / Module",
    buttonDashboard5: "Ajouter un filtre",
    emptyWidget: "Sélectionner les données à afficher",
    labelWidgetSetting1: "Ajouter un titre",
    labelWidgetSetting2: "Période de comparaison",
    labelWidgetSetting3: "Taille du Widget",
    labelWidgetSetting4: "Fichier utilisés récemment",
    labelWidgetSetting5: "Sélectionner la donnée",
    labelWidgetSetting6: "Filtres",
    labelWidgetSetting7: "Exemple de filtre",
    labelWidgetSetting8: "Formules",
    widgetSize1: "Petite",
    widgetSize2: "Moyen",
    widgetSize3: "Grande",
    buttonWidgetSetting1: "Sélectionner le fichier",
    buttonWidgetSetting2: "Ajouter un filtre",
    buttonWidgetSetting3: "Ajouter un calcul",
    labelFormule1: "Feuilles du fichier",
    labelFormule2: "Formule",
    CONFIRM_DATA: "Valider",
    titleNewWidget: "Liste des widgets",
    MOVE_UP: "Déplacer vers le haut",
    MOVE_DOWN: "Déplacer vers le bas",
    // No Data
    OUPS_AN_ERROR_OCCURED: "Oups, une erreur est survenue",
    YOUR_APP_DOES_NOT_CONTAIN_ANY_DATA: "Votre application ne contient pas encore de données.",
    NO_PAGE_YET: "Vous n'avez pas encore publié de pages.",
    NO_SOURCE_YET: "Vous n'avez pas encore importé de source.",
    NO_SOURCE_IN_DIRECTORY: "Vous n'avez aucune source dans ce répertoire.",
    CREATE_FIRST_PAGE: "Créer ma première page",
    IMPORT_FIRST_SOURCE: "Importer une première source",
    GET_STARTED_QUESTION: "Et si vous vous lanciez ?",
    NO_DATA_REPONSE: "Aucune Réponse à ce contrôle",
    SOURCE_DELETED: "source supprimée",
    COMBINE: "Combiner",
    COMBINE_DESCRIPTION: "Utilisez des opérations pour créer de nouveaux champs de données",
    DISTINCT: "Distinguer",
    DISTINCT_DESCRIPTION: "Filtrez un champ pour en ressortir les données attendues",
    ON_WHICH_FIELD: "Sur quel champ ?",
    UNDEFINED_FIELD: "Champ introuvable",
    BY_APPLYING_WHICH_CONDITIONS: "en appliquant quelles conditions ?",
    WHAT_DO_YOU_WANT_TO_DO: "que voulez-vous faire ?",
    CHOOSE_A_DATA_TYPE_FIRST: "Choisissez un type de donnée",
    DATA_TYPE: "Type de donnée",
    FIRST_OPERATION: "première opération",
    SECOND_OPERATION: "seconde opération",
    THIRD_OPERATION: "troisième opération",
    FOURTH_OPERATION: "quatrième opération",
    FIFTH_OPERATION: "cinquième opération",
    OPERATION: "Opération",
    OPERATIONS: "Opérations",
    SEARCH_AN_OPERATION: "Rechercher une opération",
    ADD_A_CONDITION: "ajouter une condition",
    I_ADD_A_NEW_OPERATION: "J'ajoute une nouvelle opération",
    I_STOP_HERE: "Je m'arrête ici",
    BROWSE_OPERATIONS: "Parcourir les opérations",
    VALIDATE_ADDITION: "Valider l'ajout",
    ON_DATAS: "sur les données",
    FIELD_NAME: "nom du champ",
    OUTPUT_FIELD: "Champ de sortie",
    OUTPUT_VALUE: "Valeur de sortie",
    REOPEN_ANSWER: "Rouvrir la réponse",
    identity: "identité",
    mean: "moyenne",
    max: "maximum",
    min: "minimum",
    sum: "somme",
    sub: "soustraction",
    std: "ecart-type",
    prod: "multiplication",
    count: "compte",
    div: "division",
    COUNT_DISTINCT: "Compte - Distinguer",
    overallPercentage: "pourcentage par groupe",
    cumPercentage: "pourcentage par valeur",
    LIST: "Liste",
    SOURCE: "Source",
    ACTIVE: "Actif",
    THIS_FUNCTIONALITY_IS_NOT_AVAILABLE_YET: "Cette fonctionnalité n'est pas encore disponible",
    DISPLAY_LABEL: "Afficher le label",
    DISPLAY_LABEL_AND_COLOR: "Afficher le label et la couleur",
    DISPLAY_VALUE_AND_COLOR: "Afficher la valeur et la couleur",
    DISPLAY_MODE: "Mode d'affichage",
    WIDGET_FILTER_HIERARCHY_PLACEHOLDER: "Filtrer par hiérarchie",
    SELECTED: "sélectionnés",
    DISPLAY_MODE_SELECTOR: "Sélecteur (menu déroulant)",
    DISPLAY_MODE_TREE: "Arbre déplié",
    HIERARCHY_CLICK_MODE: "Clic sur une entité",
    WIDGET_DESCRIPTION: "Description (info-bulle)",
    HIERARCHY_CLICK_MODE_BRANCH: "Coche l'entité et ses enfants",
    HIERARCHY_CLICK_MODE_CYCLE: "En trois temps : entité seule, avec ses enfants, rien",
    DISPLAY_MODE_PERSONALIZATION: "Afficher configuration personnalisée",
    NO_CONFIG_YET: "Aucune configuration pour le moment",
    // Datas part
    MANAGE_SOURCES: "Gérer les sources",
    MANAGE_RELATIONS: "Gérer les relations",
    TRANSFORM_DATAS: "Transformer mes données",
    PREPARE_DATAS: "Préparer mes données",
    FORMULAS: "Formules",
    EXPLORE_DATACATALOGUE: "Explorer le datacatalogue",
    DATACATALOGUE: "Datacatalogue",
    MANAGE_YOUR_DATA_TEXT_CONTENT:
      "Gérez vos sources de données, effectuez de nouvelles connexions et enrichissez votre application.",
    TRANSFORM_TEXT_CONTENT:
      "Obtenez le meilleur de vos données en combinant vos différents champs.",
    PREPARE_TEXT_CONTENT:
      "Obtenez le meilleur de vos données en combinant ou distinguant vos différents champs",
    ANALYSE: "Analyser",
    ANALYSE_YOUR_DATA_TEXT_CONTENT:
      "Analyser vos données, détectez les anomalies et corrélations...",
    STRUCTURE: "Structurer",
    STRUCTURE_YOUR_DATA_TEXT_CONTENT:
      "Sélectionnez les champs de vos ressources pour créer vos tables de données.",
    MANAGE_TABLE: "Gérer les tables",
    VISUALIZE_TEXT_CONTENT:
      "Consultez les champs disponibles et préparez votre donnée à l'intégration dans vos pages.",
    USE_ALGORITHMS_ML_TEXT_CONTENT:
      "Faites travailler les algorithmes pour en apprendre plus sur vos données.",
    USE_RELATION_TEXT_CONTENT: "Créez des relations entre vos tables.",
    ENTER_A_NAME_FOR_YOUR_ANALYSIS: "Entrez un nom pour votre analyse",
    //SOURCES
    YOU_ASSOCIATION_MUST_BE_CONTAIN_A_TITLE: "Votre association doit contenir un titre",
    YOU_MUST_BE_SELECTIONNATE_ONE_DIFFERENT_FIELD:
      "Vous devez selectionner un champ de chaque source",
    LINK_IDENTIC_FIELD_FROM_EACH_SOURCE: "Lier les champs identiques de chaque source",
    NAME_OF_MY_ASSOCIATION: "Nom de mon association",
    SELECT_SOURCES: "Sélectionner les sources",
    COLUMN_CHOICES: "Choix des colonnes",
    ADD_COLUMN: "Ajout de colonnes",
    SOURCE_ASSOCIATION: "Associer mes sources",
    SELECT_SOURCE_TO_ASSOCIATE: "Sélectionner les sources à associer",
    MAKE_SURE_THAT_THERE_IS_AN_IDENTICAL_FIELD_IN_EACH_OF_THE_CHOSEN_SOURCES:
      "Assurez vous qu’il existe un champ identique dans chacune des sources choisies",
    YOUR_DATASOURCE_IS_CREATED_BUT_YOUR_DATA_ARE_STILL_LOADING:
      "Votre datasource est créée, le chargement de vos données est en cours. Vous serez averti lorsque vos données seront disponible.",
    DATA_FROM_THE_DATASOURCE_IS_BEING_INTEGRATED:
      "Les données de votre datasource sont en cours d'intégration",
    INTEGRATION_OF_YOUR_DATA_IS_FINISHED_YOU_CAN_NOW_ACCESS_YOUR_DATA:
      "L'intégration de vos données est terminée. Vous pouvez désormais avoir accès à votre datasource",
    seeDatacatalogue: "VOIR MON DATACATALOGUE",
    ADD_A_SOURCE: "AJOUTER UNE SOURCE",
    ADD_NEW_ROW: "AJOUTER UNE LIGNE",
    ARE_YOU_SURE_TO_DELETE_THIS_ROW: "Êtes-vous sur de vouloir supprimer cette ligne ?",
    WARNING_COLUMN_NAME_ALREADY_EXIST: "Attention ce nom de colonne existe déja",
    WARNING_COLUMN_NAME_EMPTY: "Attention le nom de colonne ne peut pas être vide",
    WARNING_MESSAGE_EMPTY: "Attention le message est vide",
    CONFIRM: "Valider",
    I_UNDERSTAND: "Je comprends",
    TYPE: "Type",
    ALL_MASCULINE: "Tous",
    ALL_FEMININE: "Toutes",
    ADD_DATA: "AJOUTER DES DONNÉES",
    ADD_NEW_COLUMN: "Ajouter une nouvelle colonne",
    NEW_COLUMN: "Nouvelle colonne",
    WHICH_COLUMN_DO_YOU_WANT_TO_DELETE: "Quelle colonne voulez-vous supprimer ?",
    COLUMN: "Colonne",
    COLUMNS: "Colonnes",
    CURRENT_COLUMNS: "Colonnes actuelles",
    DELETE_COLUMN: "Supprimer une colonne",
    DEFAULT_VALUE: "Valeur par défaut",
    TRUE: "Vrai",
    FALSE: "Faux",
    DISABLED: "Désactivé",
    ACTIVATED: "Actif",
    FIELDS: "Champs",
    LINES: "Lignes",
    UPDATED_THE: "Mis a jour le",
    UPDATED_ON: "Mis à jour le",
    searchSourceType: "Rechercher un type de source",
    UPLOAD_YOUR_FILE: "Charger votre fichier",
    FIELD_DEFINITIONS: "Définition des champs",
    WHAT_IS_THE_DELIMITER_OF_YOUR_FILE: "Quel est le délimiteur de votre fichier",
    COMMA: "Virgule",
    SEMICOLON: "Point virgule",
    OTHER_DELIMITER: "Autre délimiteur",
    NO_DATA_AVAILABLE: "Pas de données disponibles",
    NO_DATA_AVAILABLE_CHOOSE_A_FILE: "Pas de données disponibles, choisissez un fichier CSV",
    CHOOSE_A_FILE_CSV: "Téléverser le modèle complété",
    CSV_HAS_BEEN_LOADED: "Le CSV a été chargé",
    INPUT_PLACEHOLDER_NAME_SOURCE: "Saisir ici le nom à donner à cette source",
    NAME_FIELD: "NOM DU CHAMPS",
    TYPE_FIELD: "TYPE",
    ADD_YOUR_FILE: "Ajouter votre fichier",
    ADD_FILE: "Ajouter un fichier",
    REPLACE_FILE: "Remplacer le fichier",
    REPLACE_DATASOURCE: "Remplacer la datasource",
    REPLACE_SOURCE_CONTENT_OR_ADD_LINE:
      "Remplacer le contenu de votre source ou ajouter des lignes",
    ADD_LINES: "Ajouter des lignes",
    FILE_NAME: "Nom du fichier",
    SIZE: "Taille",
    DATA_UPDATE: "Mise à jour des données",
    MOVE_TO: "Déplacer vers",
    RENAME: "Renommer",
    REMOVE_FROM_FOLDER: "Retirer du dossier",

    CANT_MOVE_PAGE_ONLY_ONE_FOLDER_AVAILABLE:
      "Impossible de déplacer la page. Seulement un dossier disponible",
    BACK: "Retour",
    NB_COLUMNS: "Nombre de Colonnes",
    NB_LINES: "Nombre de Lignes",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ACTUALITY:
      "Êtes vous sûr de vouloir supprimer cette actualité ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_GOVERNANCE:
      "Êtes vous sûr de vouloir supprimer cette gouvernance ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_SOURCE:
      "Êtes vous sûr de vouloir supprimer cette source ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_RISK: "Êtes vous sûr de vouloir supprimer ce risque ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_RISK_RESIDUAL:
      "Êtes vous sûr de vouloir supprimer ce risque résiduel?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CONTROL:
      "Êtes vous sûr de vouloir supprimer ce contrôle ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CHECKPOINT:
      "Êtes vous sûr de vouloir supprimer ce point de contrôle ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEMPLATE:
      "Êtes vous sûr de vouloir supprimer ce questionnaire ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_SOURCE_IS_USED:
      "Attention les champs de cette source sont utilisés dans vos widgets, si vous supprimez cette source les widgets concernés devront être reconfigurés. Voulez vous vraiment supprimer cette source ?",
    AT_LEAST_ONE_COLUMN_HAVE_TO_BE_SELECTED: "Une colonne doit être sélectionnée à minima",
    YOU_NEED_TO_ADD_A_FILE: "Vous avez besoin d'ajouter un fichier",
    YOU_NEED_TO_ENTER_A_SOURCE_NAME: "Vous avez besoin d'entrer un nom de source",
    NEW_SOURCE_NAME: "Nouveau nom de source",
    NO_SOURCES_FOUND: "Aucune source trouvée",
    FIND_A_SOURCE: "RECHERCHER UNE SOURCE",
    WARNING_FIELDS_TYPE: "Les champs selectionnés doivent être du même type",
    WARNING_DIRECTORY_MANDATORY:
      "Attention le nom du répertoire doit contenir au minimum trois caractères pour valider la création !",
    WARNING_BEFORE_DELETE_DIRECTORY:
      "Ce répertoire contient des sources, voulez vous vraiment le supprimer ?",
    DOWNLOAD: "Télécharger",
    DOWNLOADING_FILE: "Téléchargement de",
    ERROR_DOWNLOADING_FILE: "Une erreur est survenue lors du téléchargement",
    FILE_NOT_FOUND: "Fichier non trouvé",
    REPERTORIES: "Répertoires",
    JODITEDITOR: "Editeur de texte",
    //TABLES
    TABLES: "Tables",
    TABLE: "Table",
    ADD_A_TABLE: "Ajouter une table",
    LINKED_RESSOURCES: "Ressources liées",
    REQUEST: "Requêtes",
    //RELATION
    RELATIONS: "Relations",
    MY_RELATIONS_ONE_TO_ONE: "Mes relations 1 - 1",
    MY_RELATIONS_MULTIPLE: "Mes relations multiples",
    SOURCE_NAME: "Nom de la source",
    RELATION_NAME: "Nom de la relation",
    LEFT_SOURCE: "Source gauche",
    RIGHT_SOURCE: "Source droite",
    FIELD_FROM_LEFT_SOURCE: "Champ de la source gauche",
    FIELD_FROM_RIGHT_SOURCE: "Champ de la source droite",
    NEW_RELATION: "Nouvelle relation",
    ALL_RELATIONS: "Toutes les relations",
    SORT_DIAGRAM: "Trier automatiquement le diagramme",
    //ADD_SOURCE
    SHEET_SELECTION: "Sélection de la feuille",
    SELECT_FILE_TYPE: "Sélectionner le type de fichier",
    //SOURCES
    SUCCESS_TO_CREATE_SOURCE_FOLDER: "Le dossier de source à été crée avec succès",
    SUCCESS_TO_GET_SOURCE_FOLDERS: "Les dossiers de sources ont été récupérés avec succès",
    FAIL_TO_CREATE_SOURCE_FOLDER: "Erreur lors de la création du dossier de sources",
    SUCCESS_TO_DELETE_SOURCE_FOLDER: "Le dossier de source a été supprimmé avec succès",
    //DATACATALOGUE
    ALIAS: "ALIAS",
    FIELD_TITLE: "LIBELLE CHAMP",
    FIELD_TYPE: "TYPE DE CHAMP",
    LAST_UPDATE: "DERNIERE MAJ",
    nbRowsLengthText: "résultats",
    selectRowCountText: "lignes sélectionnées",
    groupByText: "Regrouper par",
    customButtonTitle: "ajouter un champ",
    USE_THESE_FIELDS: "Utiliser ces champs",
    USE_THIS_FIELD: "Utiliser ce champ",
    BOOLEAN: "Booléen",
    INTEGER: "Nombre entier",
    NUMBER: "Nombre",
    DATE: "Date",
    IMPLEMENTATION_DATE: "Date d'implémentation",
    STRING: "Chaine de caractères",
    ARRAY: "Liste",
    ZIP_CODE_FR: " Code Postaux",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_FIELD: "Êtes vous sûr de vouloir supprimer ce champ ?",
    FIELDS_FROM_DIFFERENT_SOURCES_HAVE_BEEN_SELECTED:
      "Des champs de sources différentes ont été selectionnés",
    FIELD_NOT_FOUND: "Champ introuvable",
    NEW_FIELD_NAME: "Nouveau nom de champs",
    ALL_DATACATALOGUE: "Tout le datacatalogue",
    TABLES: "Tables",
    MAJ_DATACATALOGUE: "Mis à jour il y a",
    DAY_DATACALOGUE: "jours",
    //ANALYSIS & ML
    COLUMNS_IDENTIFY_SAMPLES: "Colonnes identifiant les échantillons",
    COLUMNS_CAN_BE_ASSOCIATED_NEW_DATA: "Colonnes pouvant être associées aux nouvelles données",
    ANALYSIS_NAME: "Nom de l'analyse",
    ANALYSIS_TYPE: "Type d'analyse",
    START_ANALYSIS: "Lancer l'analyse",
    CREATED_THE: "Créée le",
    AUTHOR: "Auteur",
    STATUS: "Statut",
    ACTIONS: "Actions",
    CREATE_AN_ANALYSIS: "Créer une analyse",
    SHOW_ANALYSE: "Montrer l'analyse",
    DELETE_ANALYSIS: "Supprimer l'analyse",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ANALYSIS:
      "Êtes vous sûr de vouloir supprimer cette analyse ?",
    TEXT_SUMMARY: "Résumé de texte",
    TOPIC_MODELING: "Modelisation de thème",
    SENTIMENT_ANALYSIS: "Analyse de sentiment",
    EMOTIONAL_LABELING: "Labelisation d'émotion",
    TEXT_SUMMARY_DESCRIPTION: "Résumé de texte description",
    TOPIC_MODELING_DESCRIPTION: "Modelisation de thème description",
    SENTIMENT_ANALYSIS_DESCRIPTION: "Analyse de sentiment description",
    EMOTIONAL_LABELING_DESCRIPTION: "Labelisation d'émotion description",
    CHANGE_ANALYSE_TYPE: "Changer le type d'analyse",
    QUICKLY_GET_A_SUMMARY_OF_YOUR_CORPUS: "Obtenez rapidement un résumé de votre corpus",
    DETERMINE_THE_MAIN_SUBJECTS_PRESENT_IN_YOUR_CORPUS:
      "Déterminez les principaux sujets présent dans votre corpus",
    PREDICT_AN_OPINION_FROM_COMMENTS: "Prévoyez une opinion à partir de commentaires",
    DETECT_THE_EMOTIONS_PRESENT_IN_YOUR_DATA: "Détectez les émotions présentes dans vos données",
    PARAMETERS: "Paramètres",
    RESULT: "Résultat",
    RESULTS: "Résultats",
    NAME: "Nom",
    DATA_FIELD_CHOICE: "Choix des champs de données",
    SUCCESS: "Succès",
    FAILURE: "Échec",
    IN_PROGRESS: "En cours",
    DONE: "Terminé",
    TODO: "A faire",
    DONE_FEMALE: "Terminée",
    ABANDONED_FEMALE: "Abandonnée",
    ANALYSIS_FAILED: "L'analyse a échoué",
    ANALYSIS_IN_PROGRESS: "Analyse en cours",
    REFRESH_PAGE_IN_SECONDS: "Rechargez la page dans quelques secondes",
    INITIAL_TEXT: "Texte initial",
    SUMMARY_FOR: "Résumé pour",
    DATA_SELECTION: "Sélection des données",
    ENTER_A_NUMBER: "Entrez un nombre",
    WORDS_NUMBER: "Nombre de mots",
    TOPICS_NUMBER: "Nombre de topics",
    ALLOWED_VALUES: "values autorisé",
    OR: "ou",
    //error form backend
    ERROR: "Erreur",
    CREATE_ACCOUNT_ERROR: "Erreur lors de la création du profil",
    DATA_COLUMNS_DONT_MATCH_THE_CURRENT_REFERENTIAL:
      "Certaines colonnes du fichier importé ne correspondent pas au référentiel",
    ACCEPT_ONLY_CSV: "Accepte uniquement les CSV",
    GET_BUSINESS_INFORMATIONS_ERROR:
      "Echec lors de la récupération des informartions de l'entreprise",
    FETCHED_USERS_ERROR: "Echec lors de la récupération des utilisateurs",
    CREATE_BUSINESS_USER_ERROR: "Echec lors de la création d'un utilisateur",
    DELETE_BUSINESS_USER_ERROR: "Echec lors de la suppression d'un utilisateur",
    UPDATE_BUSINESS_USER_ERROR: "Echec lors de l'édition d'un utilisateur",
    ERROR_GET_USER: "Impossible de récupérer l'utilisateur",
    ERROR_CANNOT_DELETE_USER: "Impossible de supprimer l'utilisateur",
    ERROR_CANNOT_UPDATE_USER: "Impossible de mettre à jour l'utilisateur",
    CREATE_BUSINESS_ROLE_ERROR: "Impossible de créer le role",
    UPDATE_BUSINESS_ROLE_ERROR: "Impossible d'éditer le role",
    CANNOT_DELETE_ROLE: "Vous ne pouvez pas supprimer ce rôle, des utilisateurs y sont liés",
    DELETE_BUSINESS_ROLE_ERROR: "Vous ne pouvez pas supprimer ce rôle",
    NO_PAGE_ID_PROVIDED: "Pas de pageId fourni",
    CANT_FIND_PAGE_THUMBNAIL: "Impossible de trouver la miniature",
    CANT_FIND_BUSINESS_LOGO: "Impossible de récupérer le logo",
    CANT_FIND_IMAGE: "Impossible de trouver l'image",
    YOUR_LOGIN_DETAILS_ARE_WRONG: "Vos identifiants sont erronés",
    YOUR_EMAIL_IS_UNKNOWN: "Votre email est inconnu",
    BAD_OLD_PASSWORD: "Ancien mot de passe incorrect",
    WIDGET_ID_TO_DELETE_IS_EMPTY: "Impossible de trouver les Id de Widget",
    FAIL_TO_GET_CSV_STREAM: "Impossible de récupérer les informations du CSV",
    FAIL_TO_GET_EXCEL_STREAM: "Impossible de récupérer les informations du EXCEL",
    FAIL_TO_ADD_CSV_FILE: "Impossible d'ajouter le fichier CSV",
    SUCCESS_DELETE_COLUMN: "Votre colonne a été supprimé avec succès",
    FAIL_TO_ADD_EXCEL_FILE: "Impossible d'ajouter le fichier EXCEL",
    TOKEN_EXPIRED: "Le Token est expiré",
    WRONG_TOKEN: "Mauvais token",
    BAD_TOKEN: "Token incorrect",
    FAIL_TO_DELETE_PAGE: "Nous avons rencontré une erreur lors da suppression de votre page",
    SUCCESS_TO_DELETE_PAGE: "Votre suppression a bien été prise en compte",
    CREATE_BUSINESS_SUCCESS: "Entreprise créée avec succes",
    CREATE_BUSINESS_ERROR: "Echec lors de la création de l'entreprise",
    FAIL_TO_ADD_DATA: "Une erreur est survenue lors de l'ajout de la donnée",
    DATA_HAS_BEEN_ADD: "La donnée a été ajoutée avec succès",
    //Back - Profil
    SUCCES_CREATE_PROFILE: "Le compte de l'utilisateur a bien été créé",
    ERROR_CREATE_PROFILE: "Nous avons rencontré une erreur lors de l'ajout de l'utilisateur",
    SUCCES_DELETE_PROFILE: "Votre suppression a bien été prise en compte",
    ERROR_DELETE_PROFILE: "Nous n'avons pas pu supprimer l'utilisateur",
    SUCCES_UPDATE_PROFILE: "Le compte de l'utilisateur a bien été modifié",
    ERROR_UPDATE_PROFILE:
      "Nous avons rencontré une erreur lors de la modification de l'utilisateur",
    SUCCESS_TO_CREATE_BUSINESS: "Votre business a été crée avec succès",
    SUCCESS_TO_GET_ALL_BUSINESS: "Tous vos business ont été récupérées avec succès",
    FAIL_TO_CREATE_BUSINESS: "La création du business a echoué",
    FAIL_TO_GET_BUSINESS: "La récupération du business a echoué",
    FAIL_TO_UPDATE_BUSINESS: "Nous n'avons pas pu modifier votre entreprise",
    SUCCESS_TO_UPDATE_BUSINESS: "Votre entreprise a bien été modifiée",
    FAIL_TO_CREATE_ROLE: "Nous avons rencontré une erreur lors de l'ajout du nouveau rôle",
    SUCCESS_TO_CREATE_ROLE: "Votre rôle a bien été ajouté",
    FAIL_TO_UPDATE_ROLE: "Nous avons rencontré une erreur lors de la modification du rôle",
    SUCCESS_TO_UPDATE_ROLE: "Le rôle a bien été modifié",
    FAIL_TO_DELETE_ROLE: "Nous n'avons pas pu supprimer le rôle",
    SUCCESS_TO_DELETE_ROLE: "Votre suppression a bien été prise en compte",
    FAIL_TO_DELETE_BUSINESS_ROLE: "Impossible de supprimer un rôle commercial",
    FAIL_TO_GET_BUSINESS_INFORMATIONS: "Impossible d'obtenir des informations sur l'entreprise",
    FAIL_TO_GET_USERS: "Impossible d'obtenir des utilisateurs",
    FAIL_TO_GET_USERS_NAMES: "Impossible d'obtenir les noms d'utilisateurs",
    FAIL_TO_GET_USER: "Impossible d'obtenir un utilisateur",
    FAIL_TO_UPDATE_USER: "Impossible de mettre à jour l'utilisateur",
    SUCCESS_TO_UPDATE_USER: "L'utilisateur a été mis a jour avec succès",
    SUCCESS_TO_GET_USERS_NAMES: "Les noms des utilisateurs ont étés récupérés avec succès",
    FAIL_TO_PATCH_A_PAGE: "Nous n'avons pas pu enregistrer vos modifications",
    SUCCESS_TO_PATCH_A_PAGE: "Vos modifications ont bien été prises en compte",
    SUCCESS_TO_UPDATE_ANOMALY: "L'anomalie a été modifiée avec succès",
    FAIL_TO_UPDATE_ANOMALY: "Erreur lors de la mise a jour de l'anomalie",
    SUCCESS_ADD_PAGE_FOLDER: "Le dossier de page a été ajouté avec succès",
    FAIL_TO_ADD_PAGE_FOLDER: "Nous avons rencontré une erreur lors de l'ajout du dossier de page",
    SUCCESS_GET_PAGE_FOLDER: "La récupération de l'utilisateur de dossier de page est un succès",
    ERROR_GET_PAGE_FOLDER: "Erreur lors de la récupération du dossier de page",
    SUCCESS_UPDATE_PAGE_FOLDER: "Le dossier de page a été mis à jour avec succès",
    FAIL_UPDATE_PAGE_FOLDER: "Erreur lors de la mise à jour du dossier de page",
    SUCCESS_DELETE_PAGE_FOLDER: "Le dossier de page a été supprimé avec succès",
    FAIL_DELETE_PAGE_FOLDER: "Erreur lors de la suppression du dossier de page",
    FAIL_TO_REQUEST_DATA: "Nous avons rencontré une erreur lors de la récupération de vos données",
    SUCCESS_TO_REQUEST_DATA: "Données récupérées avec succès",
    FAIL_TO_GET_PAGE_PERMISSION: "Échec de l'obtention de l'autorisation de la page",
    SUCCESS_TO_GET_PAGE_PERMISSION: "Permissions de page obtenues avec succès",
    FAIL_TO_GET_PAGE_PERMISSION_BY_USER:
      "Échec de l'obtention de l'autorisation d'une page par un utilisateur",
    SUCCESS_TO_GET_PAGE_PERMISSION_BY_USER:
      "Permissions de page par utilisateur obtenues avec succès",
    FAIL_TO_GET_PAGE_PERMISSION_BY_PAGE_ID:
      "Échec de l'obtention de l'autorisation d'une page par son identifiant",
    SUCCESS_TO_GET_PAGE_PERMISSION_BY_PAGE_ID:
      "Succès de l'obtention de l'autorisation d'une page par son identifiant",
    FAIL_TO_GET_A_PAGE_PERMISSION: "Échec de l'obtention d'une autorisation de page",
    SUCCESS_TO_GET_A_PAGE_PERMISSION: "Obtention réussie d'une autorisation pour une page",
    FAIL_TO_PATCH_PAGE_PERMISSION: "Échec de la mise à jour d'une page autorisée",
    SUCCESS_TO_PATCH_PAGE_PERMISSION: "Succès de la mise à jour d'une page",
    FAIL_TO_CHECK_PAGE_PERMISSION: "Échec de la vérification de l'autorisation d'une page",
    SUCCESS_TO_CHECK_PAGE_PERMISSION: "Vérification réussie de l'autorisation d'une page",
    FAIL_TO_GET_PAGES: "Échec de l'obtention des pages",
    SUCCESS_TO_GET_PAGES: "Succès de l'obtention les pages",
    SUCCESS_TO_GET_PAGES_BY_USER: "Obtention des pages par utilisateur avec succès",
    FAIL_TO_GET_PAGE_BY_PAGE_ID:
      "Nous avons rencontré une erreur lors de la récupération de la page",
    SUCCESS_TO_GET_PAGE_BY_PAGE_ID: "Page récupéré avec succès",
    SUCCESS_TO_GET_FILE_OVERVIEW: "Overview du fichier récupéré avec succès",
    FAIL_TO_GET_FILE_OVERVIEW: "Nous avons rencontré une erreur lors du chargement de votre source",
    FAIL_TO_CLEAR_FULL_PAGE: "Échec de la suppression d'une page complète",
    FAIL_TO_DELETE_PAGE_PERMISSION: "Échec de la suppression de l'autorisation de la page",
    FAIL_TO_DELETE_WIDGETS: "Échec de la suppression des widgets",
    FAIL_TO_GET_WIDGETS_BY_PAGE_ID: "Impossible d'obtenir des widgets par identifiant de page",
    SUCCESS_TO_GET_WIDGETS_BY_PAGE_ID: "Obtention des widgets selon le PageID effectué avec succès",
    FAIL_TO_CREATE_MULTIPLE_WIDGET: "Échec de la création de widgets multiples",
    SUCCESS_TO_CREATE_MULTIPLE_WIDGET: "Succès de la création de plusieurs widgets",
    SUCCESS_TO_DELETE_WIDGETS: "Vos widgets ont bien été supprimés",
    FAIL_TO_GET_A_WIDGET: "Échec de la récupération d'un widget",
    SUCCESS_TO_GET_A_WIDGET: "Succès pour obtenir un widget",
    SUCCESS_TO_DELETE_RELATION: "La relation a bien été supprimée",
    SUCCESS_TO_GET_RELATIONS: "Les relations ont bien étés récupérées",
    FAIL_TO_DELETE_RELATION: "Erreur lors de la suppression des relations",
    SUCCESS_TO_PATCH_RELATION: "Succès lors de la mise a jour d'une relation",
    FAIL_TO_PATCH_RELATION: "Erreur lors du patch des relations",
    SUCCESS_TO_POST_ANOMALY: "L'anomalie a été crée avec succès",
    SUCCESS_TO_CREATE_GROUP: "Le groupe a été crée avec succès",
    FAIL_TO_CREATE_GROUP: "Échec de la création du groupe",
    SUCCESS_TO_CREATE_TASK: "Le tâche a été crée avec succès",
    FAIL_TO_CREATE_TASK: "Échec de la création du la tâche",
    SUCCESS_TO_UPDATE_TASK: "Le tâche a bien été mis à jour",
    FAIL_TO_UPDATE_TASK: "Erreur lors de la mis à jour de la tâche",
    SUCCESS_TO_POST_INCIDENT: "L'incident a été crée avec succès",
    FAIL_TO_POST_INCIDENT: "Échec de la création du l'incident",
    SUCCESS_TO_UPDATE_INCIDENT: "L'incident a bien été mis à jour",
    FAIL_TO_UPDATE_INCIDENT: "Erreur lors de la mis à jour de l'incident",
    FAIL_TO_GET_GROUP: "Echec lors de la récupération du groupe",
    SUCCESS_TO_GET_GROUPS: "La récupération des groupes a été effectué avec succès",
    SUCCESS_TO_UPDATE_GROUP: "Le groupe a bien été mis à jour",
    SUCCESS_TO_GET_USER_GROUP: "Le groupe utilisateur à été récupéré avec succès",
    FAIL_TO_GET_USER_GROUP: "Echec lors de la récupération des groupes utilisateurs",
    FAIL_TO_UPDATE_GROUP: "Nous avons rencontré une erreur lors de la mise à jour du groupe",
    SUCCESS_TO_GET_GROUPS_BY_BUSINESS_ID:
      "La récupération des groupes par business id est un succès",
    FAIL_TO_GET_GROUPS_BY_BUSINESS_ID:
      "Nous avons rencontré une erreur lors de la récupération des groupes par le business id",
    SUCCESS_TO_ASK_FOR_ACTION_PLAN_VALIDATION:
      "Demande de validation du plan d'action a été effectué avec succès",
    FAIL_TO_ASK_FOR_ACTION_PLAN_VALIDATION:
      "Nous avons rencontré une erreur pour la demande de validation du plan d'action",
    SUCCESS_TO_VALIDATE_ACTION_PLAN: "Validation du plan d'action a été effectué avec succès",
    FAIL_TO_VALIDATE_ACTION_PLAN:
      "Nous avons rencontré une erreur pour validation du plan d'action",
    //Back - Widget
    FAIL_TO_UPDATE_WIDGET: "Nous avons rencontré une erreur lors de la mise à jour de votre widget",
    SUCCESS_TO_UPDATE_WIDGET: "Votre widget a bien été mis à jour ",
    SUCCESS_TO_DELETE_WIDGETS: "Vos widgets ont bien été supprimés",
    FAIL_TO_CREATE_DATACATALOGUE: "Échec de la création du catalogue de données",
    SUCCESS_TO_CREATE_DATACATALOGUE: "Création réussie du catalogue de données",
    FAIL_TO_GET_ALL_DATACATALOGUE_META_INFO:
      "Échec de l'obtention de toutes les méta-informations du datacatalogue",
    SUCCESS_TO_GET_ALL_DATACATALOGUE_META_INFO: "Success to get all datacatalogue meta information",
    FAIL_TO_GET_DATACATALOGUE_META_INFO: "Fail to get datacatalogue meta information",
    SUCCESS_TO_GET_DATACATALOGUE_META_INFO: "Success to get datacatalogue meta information",
    FAIL_TO_GET_DATACATALOGUE_COLUMN_FIELDS:
      "Échec de la récupération des colonnes/champs du catalogue de données",
    SUCCESS_TO_GET_DATACATALOGUE_COLUMN_FIELDS: "Success to get datacatalogue column/fields",
    FAIL_TO_PATCH_DATACATALOGUE_EMPLOYEES_RIGHTS:
      "Échec de la mise à jour des droits des employés du catalogue de données",
    SUCCESS_TO_PATCH_DATACATALOGUE_EMPLOYEES_RIGHTS:
      "Succès de la mise à jour des droits des employés du catalogue de données",
    FAIL_TO_PATCH_DATACATALOGUE_TEAMS_RIGHTS:
      "Échec de la mise à jour des droits des équipes du catalogue de données",
    SUCCESS_TO_PATCH_DATACATALOGUE_TEAMS_RIGHTS:
      "Succès de la mise à jour des droits des équipes du catalogue de données",
    SUCCESS_TO_GET_CSV_STREAM: "Succès pour obtenir les informations du fichier CSV",
    SUCCESS_TO_GET_EXCEL_STREAM: "Récupération réussie des informations du fichier Excel",
    FAIL_TO_GET_DATASOURCES: "Échec de la récupération des sources de données",
    SUCCESS_TO_GET_DATASOURCES: "Réussir à obtenir les sources de données",
    //Back - Datasource
    SUCCESS_TO_POST_NEW_RELATION: "La nouvelle relation a été créée avec succès",
    FAIL_TO_POST_NEW_RELATION: "La nouvelle relation n'as pas pu être créée",
    SUCCESS_TO_POST_DATASOURCES: "Votre fichier a bien été ajouté",
    FAIL_TO_POST_DATASOURCES: "Nous avons rencontré une erreur lors de l'ajout de votre source",
    SUCCESS_TO_DELETE_DATASOURCE: "Votre suppression a bien été prise en compte",
    FAIL_TO_DELETE_DATASOURCE: "Nous n'avons pas pu supprimer votre source",
    SUCCESS_TO_PATCH_DATASOURCE: "Votre mise à jour a bien été prise en compte",
    FAIL_TO_PATCH_DATASOURCE: "Nous n'avons pas pu mettre à jour votre source",
    FAIL_TO_ADD_FIELD_DATASOURCE:
      "Nous avons rencontré une erreur lors de l'ajout du champs dans votre source",
    SUCCESS_TO_ADD_FIELD_DATASOURCE: "Le champs a été ajouté avec succès",
    //Back - FIELDS
    SUCCESS_TO_PATCH_FIELD: "Votre champs a bien été modifié",
    FAIL_TO_PATCH_FIELD: "Nous avons rencontré une erreur lors de la modification de votre champs",
    //Back - SHARE
    SUCCESS_ADD_PAGE_PERMISSION: "Votre page a bien été partagée",
    FAIL_TO_ADD_PAGE_PERMISSION: "Nous avons rencontré une erreur lors du partage de votre page",
    //Back - PIPELINE
    SUCCESS_TO_DELETE_PIPELINE: "Votre analyse a bien été supprimée",
    FAIL_TO_DELETE_PIPELINE:
      "Nous avons rencontré une erreur lors de la suppression de votre analyse",
    FAIL_TO_CREATE_PIPELINE: "Votre analyse a été créée avec succès",
    SUCCESS_TO_CREATE_PIPELINE:
      "Nous avons rencontré une erreur lors de la création de votre analyse",
    SUCCESS_TO_UPLOAD_IMAGE: "Succès du téléchargement d'une image",
    SUCCESS_CREATE_PASSWORD: "Votre mot de passe a bien été créé",
    SUCCESS_UPDATE_PASSWORD: "Votre mot de passe a bien été modifié",
    FAIL_UPDATE_PASSWORD: "Votre mot de passe n'est pas conforme",
    SUCCESS_TO_CREATE_WIDGET: "Succès de la création du widget",
    FAIL_TO_CREATE_WIDGET: "Échec de la création du widget",
    //Back - Pages
    SUCCESS_TO_CREATE_YOUR_PAGE: "Votre page a été créée avec succès",
    SUCCESS_TO_CREATE_PIPELINE_PAGE: "Votre planner a été créée avec succès",
    DELETE_PAGE_WHILE_FAILED_TO_CREATE_PAGE_PERMISSION: "Impossible de créer une page",
    MULTIPLE_ERROR_DURING_PAGE_CREATION: "Impossible de créer une page",
    FAIL_TO_CREATE_PAGE: "Nous avons rencontré une erreur lors de la création de votre page",
    SUCCESS_TO_DUPLICATE_PAGE: "Votre page a été dupliquée avec succès",
    FAIL_TO_DUPLICATE_PAGE: "Nous avons rencontré une erreur lors de la duplication de votre page",
    //DOCUSIGN
    SUCCESS_TO_PREPARE_CONTRACT_FOR_SIGNATURE: "Votre contrat a été créé avec succès",
    //CONFIRMATION MESSAGE
    YOU_DONT_HAVE_RIGHTS_TO_ACCESS_THIS_PAGE:
      "Il semble que vous n'ayez pas les droits nécessaires pour accéder à cette page",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_PAGE: "Êtes-vous sûr de vouloir supprimer cette page ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_FOLDER: "Êtes-vous sûr de vouloir supprimer ce dossier ?",
    THIS_FUNCTIONNALITY_IS_NOT_AVAILABLE_YET: "Cette fonctionnalité n'est pas encore disponible",
    ARE_YOU_SURE_YOU_WANT_TO_DUPLICATE_WIDGET: "Êtes-vous sûr de vouloir dupliquer ce widget ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_WIDGET: "Êtes-vous sûr de vouloir supprimer ce widget ?",
    WOULD_YOU_LIKE_TO_CHANGE_PAGE_AND_LOSE_MODIFICATION:
      "Êtes-vous sûr de vouloir changer de page ? Les changements non sauvegardés seront perdus",
    IMPOSSIBLE_TO_SAVE_PAGE_WITH_EMPTY_TITLE:
      "Impossible de sauvegarder une page avec un titre vide",
    // ColorPalettes
    SUCCESS_TO_UPDATE_BUSINESS_DEFAULT_PALETTE: "Palette par défaut de l'entreprise mise à jour",
    SUCCESS_TO_CREATE_PALETTE: "Votre palette de couleur a bien été ajoutée",
    SUCCESS_TO_GET_PALETTE: "Votre palette de couleur à bien été récupérée",
    FAIL_TO_CREATE_PALETTE: "Une erreur est survenue lors de la création de la palette de couleur",
    FAIL_TO_GET_PALETTE:
      "Une erreur est survenue lors de la récupération de votre palette de couleur",
    FAIL_TO_UPDATE_BUSINESS_DEFAULT_PALETTE:
      "Une erreur est survenue lors de la mise à jour de votre palette de couleur business par défaut",
    MISSING_FIELDS_TO_CREATE_PALETTE:
      "Il manque des champs nécessaires à la création de la palette de couleur",
    SUCCESS_TO_UPDATE_PALETTE: "Votre palette de couleur a bien été mis à jour",
    FAIL_TO_UPDATE_PALETTE:
      "Une erreur est survenue lors de la modification de la palette de couleur",
    SUCCESS_TO_DELETE_PALETTE: "Votre palette de couleur a bien été supprimée",
    FAIL_TO_DELETE_PALETTE:
      "Une erreur est survenue lors de la suppression de la palette de couleur",
    SUCCESS_TO_GET_BUSINESS_PALETTE:
      "La palette de couleurs de votre entreprise a été récupérée avec succès",
    FAIL_TO_GET_BUSINESS_PALETTE:
      "Une erreur est survenue lors de la récupération des palettes de couleurs de l'entreprise",
    SUCCESS_TO_GET_PUBLIC_PALETTE: "Votre palette de couleurs publique a été récupérée avec succès",
    FAIL_TO_GET_PUBLIC_PALETTE:
      "Une erreur est survenue lors de la récupération des palettes de couleurs publiques",
    ARCHIVE: "Archiver",
    DELETE: "Supprimer",
    ACTIVE: "Activer",
    DUPLICATE: "Dupliquer",
    DUPLICATE_ANOTHER_PAGE: "Dupliquer sur une autre page",
    DUPLICATE_WIDGET_TO: "Déplacer le widget vers...",
    COPY: "Copie",
    MODYFY_THUMBNAIL: "Modifier la miniature",
    NEW_PAGE: "Nouvelle page",
    NEW_FOLDER: "Nouveau dossier",
    PAGES: "Pages",
    FOLDERS: "Dossiers",
    FOLDER: "Dossier",
    SPECIFIC_PAGES: "Pages Spécifiques",
    MOVE_PAGE_TO: "Déplacer la page vers ...",
    PAGE_LIST: "Liste des pages",
    PAGE_SCREENSHOTS_ARE_TEMPORARILY_UNAVAILABLE:
      "Les captures d'écran des pages sont temporairement indisponibles",
    CSV_NAME_ALREADY_USED: "Le nom de la source CSV existe déjà",
    EXCEL_NAME_ALREADY_USED: "Le nom de la source EXCEL existe déjà",
    NO_PAGE_OUTSIDE_FOLDERS: "Aucune page trouvée hors des dossiers",
    SUCCESS_COLOR_COPY_TO_CLIPBOARD: "La couleur a bien été copiée",
    // Page configuration
    TILTE_PAGE_CONFIGURATION: "PARAMÉTRAGE DE LA PAGE",
    LABEL_BACKGROUND_PAGE_CONFIG: "ARRIÈRE-PLAN",
    OPTION_CHOICE_BACKGROUND_PAGE_1: "Couleur unie",
    OPTION_CHOICE_BACKGROUND_PAGE_2: "Image d'arrière plan",
    OPTION_CHOICE_BACKGROUND_PAGE_3: "Identique à la page",
    LABEL_BACKGROUND_PAGE_CONFIG_COLOR: "COULEUR",
    LABEL_BACKGROUND_PAGE_CONFIG_OPACITY: "TRANSPARENCE",
    LABEL_BACKGROUND_PAGE_CONFIG_OPACITY_COLOR: "COULEUR DE FOND",
    LABEL_BACKGROUND_PAGE_CONFIG_BLUR: "FLOU",
    APPLY_TRANSPARENCY: "APPLIQUER UNE TRANSPARENCE",
    SHADOWING: "OMBRAGE",
    PAGE_STYLE: "STYLE DE LA PAGE",
    FIXED_BLOC_STYLE: "STYLE DU BLOC FIXE",
    // Page permissions
    AN_USER_HAS_AN_INVALID_PAGE_ACCESS_STATUS:
      "Un utilisateur a un statut d'accès à une page non valide",
    UNAUTHORIZED_STATUS: "Statut non autorisé",
    THERE_IS_ONLY_ONE_OWNER: "Il n'y a qu'un seul propriétaire !!",
    VIEWER: "Lecteur",
    EDITOR: "Editeur",
    OWNER: "Propriétaire",
    // **************************** Gouvernance ********************************
    // Message Request
    RESPONSE_CONTROL_EXISTING: "Une réponse a déjà été transmise pour ce contrôle",
    // Controls
    AGENCE: "Agence",
    TIMER_CONTROL: "Estimation temps d'exécution en jours-homme",
    TIMER_CONTROL_LABEL: "Estimation temps d'exécution",
    TIMER_CONTROL_VALUE: "j/h",
    OBLIGATOIRE: "Obligatoire",
    EXECUTION_TIME_CONTROL_LABEL: "Temps d'exécution",
    EXECUTION_TIME_ACTIVATION: "Activer le temps d'exécution",
    AVERAGE_NOTE: "Note moyenne",
    LEVEL: "Niveau",
    LINE_OF_DEFENSE: "Niveau",
    ACTIVITY: "Activité",
    RISK: "Risque",
    RISK_LEVEL: "Niveau de risque",
    RISKS: "Risques",
    RISKNAME: "Nom du risque",
    FREQUENCE_CONTROL: "Fréquence du contrôle",
    THEMATIC: "Thématique",
    TYPE_CONTROL: "Type",
    CHECKLIST: "FICHE DE CONTRÔLE",
    REFERENCE: "Référence",
    INCIDENT_DESCRIPTION: "Description de l'incident",
    RECOMMENDATION_DESCRIPTION: "Description",
    ACTIVITY_CONCERNED_BY_INCIDENT: "Activité concernée par l'incident",
    PROCESS: "Intitulé du contrôle",
    CONTROLLER: "Contrôleur",
    CONTROLLERS: "Contrôleurs",
    OBJECTIF_CONTROL: "Objectif du contrôle",
    OBJECTIF_MISSION: "Objectif de la mission",
    MITIGANT_TYPE: "Type de Mitigant",
    COMMENTS: "Commentaires",
    ADD_COMMENTS: "Ajouter commentaire",
    NO_COMMENTS: "Aucun commentaire",
    NO_CHANGE: "Aucun changement",
    COMMENTS_ECHANTILLON: "Description de l’échantillon",
    PERIODICITY: "Périodicité",
    SAMPLE: "Echantillonnage",
    EXHAUSTIVE: "Exhaustif",
    MODE_OPERATOIRE: "Mode Opératoire",
    AFFECTATION: "Affectation",
    CHECKPOINTS: "POINTS DE CONTRÔLE",
    DATE_FIRST_OCCURRENCE: "Date de la première occurence",
    DAILY: "Journalière",
    WEEKLY: "Hebdomadaire",
    MONTHLY: "Mensuelle",
    ANNUAL: "Annuelle",
    QUARTERLY: "Trimestrielle",
    SEMI_ANNUAL: "Semestrielle",
    ANY: "Aucune",
    RISK_PRIMARY: "Risque Primaire",
    RISK_SECONDARY: "Risque Secondaire",
    RISK_ASSIGNED: "Risque affecté",
    CRITICAL: "Critique",
    CRITICALITY: "Criticité",
    CONTROL_IDS: "Contrôles ids",
    VERYLOW: "Très faible",
    HIGH: "Fort",
    HIGH_V2: "Élevé",
    MEDIUM: "Moyen",
    HIGH_FEMALE: "Elevée",
    VERY_HIGH: "Très fort",
    VERY_HIGH_FEMALE: "Très élevée",
    MODERATE: "Modéré",
    MODERATE_FEMALE: "Modérée",
    LOW: "Faible",
    COLOR: "COULEUR",
    COLOR_LOWER_CASE: "Couleur",
    PREVIEW: "Aperçu",
    COLLABORATOR: "COLLABORATEUR",
    JOB: "POSTE",
    SELECTED_COLLABORATORS: " COLLABORATEURS SÉLECTIONNÉS",
    TO_VALIDATE: "VALIDER",
    THIS_CONTROL_IS: "Ce contrôle consiste",
    NO_REP_CONTROLE: "Vous ne pouvez pas encore répondre à ce contrôle",
    MY_SOURCES: "Mes sources",
    SORT_MY_SOURCES: "Trier mes sources",
    ALPHABETICAL_ORDER_ASC: "Ordre alphabétique croissant",
    ALPHABETICAL_ORDER_DESC: "Ordre alphabétique décroissant",
    DATE_ASC: "Date croissante",
    DATE_DESC: "Date décroissante",
    SIZE_ASC: "Taille croissante",
    SIZE_DESC: "Taille décroissante",
    NO_REP_CONTROLE: "Vous ne pouvez pas encore répondre à ce contrôle",
    filterStatus: "Statut",
    filterProcess: "Intitulé du contrôle",
    filterControls: "Contrôles",
    filterlabelRealiser: "A Réaliser",
    filterlabelNonConforme: "Non Conforme",
    filterlabelConforme: "Conforme",
    filterlabelConsultant: "En cours Consultant",
    filterlabelManager: "En cours Manager",
    filterlabelRealises: "Réalisés",
    WARNING_REQUIRED_FIELD: "Attention, tous les champs obligatoires ne sont pas répondus.",
    NAME_SECTION_CANT_BE_VOID: "Le nom de la section ne peut pas être vide.",
    SECTION_WITH_ALLREADY_EXISTING_NAME: "Une section avec ce nom existe déjà.",
    NAME_OF_NEW_SECTION: "Nom de la nouvelle section",
    ADD_SECTION: "Ajouter une section",
    NAME_OF_SECTION_IS_EDITABLE: "Le nom de la section est modifiable.",
    DUPLICATE: "Dupliquer",
    DELETE: "Supprimer",
    START: "Début",
    END: "Fin",
    ADD_RANGE: "Ajouter une plage",
    GAUGE_SCALE: "Échelle de la jauge",
    PERSONALIZED_RANGE: "Ranges personnalisés",
    CONFIGURATION_RANGES: "Configuration des ranges",
    NEW_VALUE_MAPPER: "Nouvelle correspondance",
    VALUE_MAPPER: "Correspondance",
    LABEL_VALUE_ORIGINAL: "Valeur d'origine",
    LABEL_VALUE_RENAMED: "Étiquette affichée",
    // RISK
    riskLabelAddRisk: "Ajouter un risque",
    riskLabelEditRisk: "Modifier un risque",
    riskLabelDetailRisk: "Detail du risque",
    riskLabelNameRisk: "Nom du risque",
    riskLabelActiviteRisk: "Activité",
    riskLabelDescriptionRisk: "Description",
    riskLabelRegulatoryReference: "Référence règlementaire",
    riskLabelImpact: "Impact",
    riskLabelFrequence: "Fréquence",
    riskLabelRiskBrut: "Risque Brut",
    riskLabelRiskBrutComment: "Commentaire risque brut",
    riskLabelType: "Type",
    riskLabelReferenceRisk: "Réf du risque",
    riskLabelRiskResiduel: "Risque résiduel",
    riskLabelImpactResidual: "Impact résiduel",
    riskLabelFrequenceResidual: "Fréquence résiduel",
    riskLabelResponsableRisk: "Responsable du risque",
    riskLabelRiskResidualComments: "Commentaire Risque Résiduel",
    riskLabelTypeRisk: "Type du risque",
    riskLabelLevelRisk: "Niveau du risque",
    riskLabelAffectation: "Affectation",
    // RISK RESIDUAL
    riskLabelAddRiskResidual: "Ajouter un risque résiduel",
    riskLabelEditRiskResidual: "Modifier un risque résiduel",
    riskLabelNameRiskResidual: "Nom du risque résiduel",
    riskLabelRiskResidual: "Risque résiduel",
    riskLabelRiskResidualAssocie: "Risque associé",
    riskLabelCommentRiskResidual: "Commentaire",
    // Mapping RISK
    activityLabelMapping: "Activité",
    refLabelMapping: "Référence du risque",
    riskLabelMapping: "Risque",
    impactLabelMapping: "Impact",
    frequencyLabelMapping: "Fréquence",
    riskBrutLabelMapping: "Risque Brut",
    controlLabelMapping: "Contrôles",
    mitigantLabelMapping: "Mitigants",
    riskResidualLabelMapping: "Risque Résiduel",
    commentLabelMapping: "Commentaire",
    notSpecifiedLabelMapping: "Non Renseigné",
    notControlLabelMapping: "Aucun Contrôle",
    notMitigantLabelMapping: "Aucun Mitigant",
    responsableRiskLabelMapping: "Responsable du risque",
    controlAttachedRiskLabelMapping: "Contrôles rattachés au risque",
    entitledMitigantLabelMapping: "Intitulé des mitigants",
    typeRiskLabelMapping: "Type de risque",
    ADD_DIRECTORY_FOLDER: "Ajouter un répertoire",
    CREATION_DIRECTORY_FOLDER: "Création répertoire",
    DIRECTORY_NAME: "Nom du répertoire",
    DIRECTORY_DESCRIPTION: "Description du répertoire",
    INDEX_DIRECTORY: "Répertoire",
    SHOW_DIRECTORIES_ONLY: "Afficher uniquement les répertoires",
    MESSAGE_SOURCE_USED: "Les champs de cette source sont utilisés dans vos pages.",
    MESSAGE_SOURCE_NOT_USED:
      "Les champs de cette source ne sont utilisés dans aucune de vos pages.",
    CANT_DUPLICATE_MULTITAB_WIDGET:
      "Attention, vous ne pouvez pas dupliquer ce type de widget sur une autre page",
    CANT_DUPLICATE_TEMPORARY_WIDGET:
      "Impossible de dupliquer le widget : Vous devez d'abord sauvegarder votre page",
    FAIL_TO_DUPLICATE_WIDGET_TO_ANOTHER_PAGE:
      "Impossible de dupliquer le widget sur une autre page",
    SUCCESS_TO_DUPLICATE_WIDGET_TO_ANOTHER_PAGE:
      "Duplication du widget dans une autre page réussie",
    VIEW_PLANNING: "Vue du planning",
    HIDE_PAST_CHECKS: "Masquer les contrôles passés",
    FROM_DATE: "Du",
    TO_DATE: "Au",
    SELECTED_DATES: "Dates sélectionnées",
    ADD_MAPPING: "Ajouter une cartographie",
    IMPLEMENT_REFERENCIAL: "Implémenter un référentiel",
    REFERENT_MAPPING: "Cartographie référente",
    REFERENT_RISK: "Risque référent",
    REFERENT_PERSON: "Personne référente",
    AFFECTED_PERSON: "Personne assignée",
    MAPPING: "Cartographie",
    ANSWERS: "Réponses",
    CREATE_A_ACTIVITY: "CRÉER UNE ACTIVITÉ",
    CREATE_A_RISK: "CRÉER UN RISQUE",
    CREATE_A_CONTROL: "CRÉER UN CONTRÔLE",
    CREATE_A_RESIDUAL_RISK: "CRÉER UN RISQUE RÉSIDUEL",
    TABLE_LABEL_CONTROLS: "# CONTRÔLES",
    TABLE_LABEL_MITIGANTS: "# MITIGANTS",
    RISK_CONTROL_SYSTEM: "Dispositif de maîtrise des risques",
    FIGER_LA_CARTOGRAPHIE: "Figer la cartographie",
    RETOUR_HISTORIQUE_CARTOGRAPHIE: "Retour à l'historique",
    TITLE_OF_MITIGANTS: "Intitulé des mitigant",
    RISK_RELATED_CONTROLS: "Contrôles rattachés au risque",
    RETAIL: "Détail",
    RELATED_FILES: "Fichiers associés",
    ACTIVITY_REFERENCE: "Référence de l'activité",
    ACTIVITY_NAME: "Nom de l'activité",
    MAPPING_RISK_SINGULAR: "Cartographie du risque",
    AUCUN_RESULTAT: "Aucun résultat n'a été trouvé",
    A_CETTE_DATE: "à cette date",
    ASSIGN_TO_ACTIVITY: "Affecter à une activité",
    ASSIGN_TO_SUB_ACTIVITY: "Affecter à une sous activité",
    SUB_ACTIVITY: "Sous activité",
    CONTROL_TITLE: "Intitulé du contrôle",
    ADD_A_CONTROL: "Ajouter un contrôle",
    PUBLISH: "Publier",
    DRAFT: "Brouillon",
    CONTROL: "Contrôle",
    CONTROLS: "Contrôles",
    MITIGANT: "Mitigant",
    SAMPLE_SINGULAR: "Echantillon",
    SAMPLES: "Echantillons",
    NO_SAMPLES_AVAILABLE: "Aucun échantillon actuellement",
    NO_SAMPLES_AVAILABLE_YET: "Aucun échantillon n'est encore disponible",
    SELECT: "Sélectionner",
    SHOW_SOURCES_USED_ONLY: "Afficher uniquement les sources utilisées",
    DATE_EFFECT_CONTROL: "Date d'effet du contrôle",
    DATE_DEADLINE_CONTROL: "Date d'échéance de la réalisation du contrôle",
    DATE_INVALID_EFFECT_DEADLINE:
      "Attention la date d'effet ne peut pas être supérieure à la date d'échéance du contrôle !",
    FIRST_DAY_WORKING: "1er jour ouvré",
    FIVE_DAY_WORKING: "5ème jour ouvré",
    TEN_DAY_WORKING: "10ème jour ouvré",
    FIFTEEN_DAY_WORKING: "15ème jour ouvré",
    TWENTY_DAY_WORKING: "20ème jour ouvré",
    HORS_THEMATIC: "Hors thématique",
    LABEL_IN_ENGLISH: "Label en anglais",
    LABEL_IN_FRENCH: "Label en français",
    // ****************** Document Management ******************
    ACTUALITY_TAB: "Actualités / veille réglementaire",
    GOVERNANCE_TAB: "Gouvernance",
    DOCUMENT_TAB: "Documents sollicités",
    HISTORY_TAB: "Historique",
    CREATED_DATE: "Créé le",
    UPDATE_DATE: "Mise à jour le",
    VISIBILY_ONLINE: "Visible en ligne",
    BUSINESS_UNIT: "Business Unit",
    SECTOR_ACTIVITY: "Secteur d'activité",
    ADD_ACTUALITY: "Ajouter une actu",
    CONCERNED_CLIENT: "Client concerné",
    CONCERNED_CONSULTANT: "Consultant concerné",
    ADD_YEAR: "Ajouter une année",
    ARCHIVED: "Archivé le",
    TO_ARCHIVE: " Archiver",
    FILTER_BY: "Filtrer par",
    DOCUMENTS: "Documents",
    DOCUMENT: "Document",
    CONCERNED_CONTROLE: "Contrôle concerné",
    CONTROLEUR: "Contrôleur",
    DATES: "Dates",
    UPDATE_DATE_BY: "Mise à jour par",
    NAME_DOCUMENT: "Nom du document",
    TITLE_DOCUMENT: "Titre du document",
    CONTROL_TABLE: "Tableau des contrôles",
    GOVERNANCE_TEXT1:
      "Gouvernance mission d'externalisation du contrôle interne permanent et périodique",
    GOVERNANCE_TEXT2: "Comité de conformité et de contrôle interne",
    GOVERNANCE_TEXT3: "Organisation des missions de contrôle interne permanent",
    NO_REQUESTED_DOCUMENT: "Il n'y a aucun document sollicité",
    WAITING: "En attente",
    ADDED: "Ajouté",
    REJECTED: "Rejeté",
    A_REJECTED: "A rejeté",
    REJECTED_FEMININ: "Rejetée",
    VALIDATION_IN_PROGRESS: "En cours de validation",
    REJECT: "Rejeter",
    VALIDATED: "Validé",
    THIS_COLUMNS_WILL_BE_IGNORED: "cette colonne sera ignorée",
    true: "Oui",
    false: "Non",
    RESULTAT_CONFORMITE: "Résultat conformité",
    // ****************** Incident Management ******************
    INCIDENT_MANAGEMENT: "Gestion des incidents",
    CORRECTIVE_ACTIONS_MANAGEMENT: "Gestion des actions correctives",
    VIEW_ALL_INCIDENTS: "Visualiser tous les incidents",
    ACCESS_INCIDENT: "Accéder aux incidents",
    CREATE_INCIDENT: "Créer un incident",
    EDIT_INCIDENT: "Modifier un incident",
    EDIT_REFERENCE_INCIDENT: "Editer la référence d'un incident",
    DELETE_INCIDENT: "Supprimer un Incident",
    VALIDATE_INCIDENT: "Valider un Incident",
    INCIDENT_VALIDATION: "Validation d'Incidents",
    ACTION_PLAN_VALIDATION: "Validation du plan d'action",
    ACTION_PLAN_VALIDATE: "Valider le plan d'action",
    ACTION_PLAN_REJECT: "Rejeter le plan d'action",
    ACTION_PLAN_CONFIRM: "Soumettre le plan d'action",
    ACTION_PLAN_ACCESS: "Accès aux plans d'actions",
    VISION_TASKS: "Vision par tâche",
    TASK_VISION: "Vision par tâche",
    VALIDATION: "Validation",
    IMPORTED_RESPONSES_WILL_BE: "Les réponses importées seront enregistrées comme",
    CONSULTANTS: "Consultants",
    CREATE_CONTROLS_PLAN: "CRÉER UN PLAN DE CONTRÔLE",
    LINK_CONTROLS: "Associer des contrôles",
    LINK_RISQUES: "Associer des risques",
    LINK_ACTIVITY: "Associer des activités",
    CONTEXT: "Contexte",
    CONSTAT: "Constat",
    TOPICS: "THÉMATIQUES",
    TOPIC: "Thématique",
    LEVELS: "NIVEAUX",
    CUSTOMERS: "CLIENTS",
    THEME: "Thème",
    STANDARD: "Standard",
    BLANC: "Blanc",
    VERT: "Vert",
    GREY: "Gris",
    RETRO: "Retro",
    AUBERGINE: "Aubergine",
    BLACK: "Noir",
    NIGHT: "Nuit",
    CUSTOMER: "Client",
    CUSTOMER_LOGO: "Logo du client",
    CONTROL_PLAN_PARAMETERS: "Paramétrage du plan de contrôle",
    AUDIT_PLAN_PARAMETERS: "Paramétrage du plan d'audit",
    CREATE_CONTROL: "CRÉER UN CONTRÔLE",
    NUMBER_CONTROL_POINTS: "Nombre de points de contrôles",
    NUMBER_AFFECTATION_CONSULTANT: "Nombre d'affectation consultants",
    MY_CONTROLS_LIST: "Ma liste de contrôles",
    ASSIGN: "Assigner",
    CONSULTANT: "Consultant",
    AFFECTATION_STATUS: "Statut d'affectation",
    SETTINGS: "Réglages",
    SETTING: "Paramètrage",
    REQUESTED_DOCUMENTS: "Documentations sollicitées",
    REQUESTED_DOCUMENTS_CLIENT: "Documentations sollicitées Client",
    REQUESTED_DOCUMENTS_CONSULTANT: "Documentations sollicitées Consultant",
    CONFIRM_DELETE_PLAN_CONTROL:
      "Êtes-vous certain de vouloir supprimer définitivement ce plan de contrôle ainsi que tous les contrôles associés ?",
    CONFIRM_ARCHIVE_PLAN_CONTROL:
      "Êtes-vous certain de vouloir archiver ce plan de contrôle ainsi que tous les contrôles associés ?",
    CONFIRM_ARCHIVE_MODEL_PLAN_CONTROL:
      "Attention ce plan de contrôle est un modèle, voulez vous vraiment l'archiver ainsi que tous les contrôles associés ?",
    CONFIRM_DELETE_MODEL_PLAN_CONTROL:
      "Attention ce plan de contrôle est un modèle, voulez vous vraiment le supprimer définitivement ainsi que tous les contrôles associés ?",
    CONFIRM_DUPLICATE_PLAN_CONTROL: "Voulez-vous vraiment dupliquer ce plan de contrôle ?",
    CONFIRM_DUPLICATE_MODEL_PLAN_CONTROL:
      "Voulez-vous vraiment dupliquer ce modèle de plan de contrôle ?",
    CONFIRM_DELETE_CONTROL: "Êtes-vous certain de vouloir supprimer définitivement ce contrôle ?",
    CONFIRM_ARCHIVE_CONTROL: "Êtes-vous certain de vouloir archiver ce contrôle ?",
    CONTROLLED_PERIOD: "Période contrôlée",
    DATE_OF_COMPLETION: "Période de réalisation",
    EVOLUTION: "Évolution",
    DATE_OF_COMPLETION_CONTROL: "Date de réalisation du contrôle",
    CONTROLLER_TRIGRAM: "Trigramme contrôleur",
    REVIEWER_TRIGRAM: "Trigramme réviseur",
    CONTROL_DESCRIPTION: "Description du contrôle",
    RISK_DESCRIPTION: "Description du risque",
    TOOLS_DOCUMENTS_USED: "Outils et documents utilisés",
    SEE_DOCUMENTS_REQUESTED: "Cf.Documents sollicités ou liste des documents obtenus",
    RISK_APPROACH: "Approche par les risques",
    REGULATORY_REFERENCE: "Référence réglementaire",
    CONTROL_PROTOCOL: "Protocole du contrôle",
    CONTROL_ATTACHED_DOCUMENTS: "Documents joints au contrôle",
    ACTUALITY_ATTACHED_DOCUMENTS: "Documents joints à l'actualité",
    TASK_ATTACHED_DOCUMENTS: "Documents joints à la tâche",
    INSERT_FILE: "Insérer un fichier",
    CREATE_CONTROL_POINT: "Créer un point de contrôle",
    CHECKPOINT: "Point de contrôle",
    REFERENCE_CHECKPOINT: "Référence",
    NAME_CHECKPOINT: "Intitulé du point de contrôle",
    CONTROL_SUMMARY_SHEET: "Fiche synthèse du contrôle",
    SYNTHESIS: "Synthèse",
    SUMMARY_OF_CONTROL: "Synthèse du contrôle",
    SUMMARY_CONTROL_AND_RECOMMENDATIONS: "Synthèse du contrôle et recommandations",
    TABLE_OF_RECOMMENDATIONS: "Tableau des recommandations",
    TABLE_OF_PREVIOUS_RECOMMENDATIONS: "Tableau des précédentes recommandations",
    CONTACTS: "Contacts",
    DEPARTMENTS_CONCERNED: "Départements concernés",
    CONFIRM_DELETE_CONTROL: "Voulez-vous vraiment supprimer ce contrôle ?",
    CONFIRM_DUPLICATE_CONTROL: "Voulez-vous vraiment duppliquer ce contrôle ?",
    RATING: "Notation",
    COMPLIANCE_DEGREES: "Degré de conformité",
    CONTROL_PLANS: "Plans de contrôle",
    CONTROL_NEED_AFFECTATION_AND_CONTROL_POINT:
      "Attention pour publier un contrôle au moins un point de contrôle et une affectation doivent être définies.",
    SOME_FIELDS_MANDATORY_ARE_EMPTY: "Attention certains champs requis sont vides.",
    CONFIRM_DUPLICATE_CONTROL: "Voulez-vous vraiment dupliquer ce contrôle ?",
    ALERT_PARAMETERS_UNVALID: "Attention certains paramètres requis sont vide.",
    ALERT_CHECKPOINT_UNDEFINED: "Au moins un point de contrôle doit être créé.",
    ALERT_AFFECTATION_UNDEFINED: "Au moins une affectation doit être attribuée.",
    ALERT_RESULTAT_UNDEFINED: "Attention le RÉSULTAT est obligatoire dans vos points de contrôles.",
    DELETE_ACTIVITY: "Supprimer Activité",
    CONFIRM_DELETE_ACTIVITY: "Voulez vous vraiment supprimer cette activité ?",
    MY_CONTROL_PLANS: "Mes plans de contrôle",
    DOWNLOAD_ATTACHMENTS: "Télécharger les pièces jointes",
    ATTACHMENTS: "Pièces jointes",
    MANDATORY_ATTACHMENTS: "Pièces jointes obligatoires",
    UPDATED_FINEGAN_EXPERTISES: "Mise à jour FINEGAN EXPERTISES",
    VALIDATION_FINEGAN_EXPERTISES: "Validation FINEGAN EXPERTISES",
    TOOLS_AND_DOCUMENTS: "Outils et documents",
    DOCUMENT_TAB_PLURAL: "Documents sollicités",
    ADD_THE: "Ajouté le ",
    REGULATORY_REFERENCE_PLURAL: "Références réglementaires",
    PENDING: "En attente",
    UNAFFECTED: "Non affecté",
    AFFECTED: "Affecté",
    WAITING_FOR_DOCUMENTS: "En attente de documents",
    AWAITING_VALIDATION_MANAGER: "En attente de validation manager",
    AWAITING_VALIDATION_CUSTOMER: "En attente de validation client",
    RESPONSABLE: "Responsable",
    DATE_CIBLE: "Date cible de mise en oeuvre",
    CONTROL_REPORT_OF: "Rapport de contrôle du",
    DATA_PREVIEW: "Prévisualisation des données",
    // ****************** ACTION PLAN ******************
    REFERENCE_TAB_AP: "Référence",
    ANOMALIE_TAB_AP: "Anomalie",
    LIBELLE_TAB_AP: "Libellés",
    TASKS_TAB_AP: "Tâches",
    CREATOR_TAB_AP: "Créateur",
    PERIOD_TAB_AP: "Période",
    STATUS_TAB_AP: "Statut",
    CONTROL_TAB_AP: "Contrôles",
    DESCRIPTION_TAB_AP: "Description",
    CONFORMITE_TAB_AP: "Conformité",
    DATE_TAB_AP: "Date",
    HISTORY_TAB_AP: "Historique",
    ANO_TAB_AP: "Anomalies",
    HISTORY_LABEL_AP: "Historique du contrôle",
    // ****************** RECOMMANDATIONS ******************
    PARTIELLEMENT_CONFORME_AVEC_FAIBLE_IMPACT: "PARTIELLEMENT CONFORME AVEC FAIBLE IMPACT",
    PARTIELLEMENT_CONFORME_AVEC_FORT_IMPACT: "PARTIELLEMENT CONFORME AVEC FORT IMPACT",
    FICHE_SUIVI_DES_RECOMMANDATIONS: "FICHE SUIVI DES RECOMMANDATIONS",
    STATUT_DES_RECOMMANDATIONS: "STATUT DES RECOMMANDATIONS",
    DATE_CLOTURE_RECOMMANDATION_2: "DE LA RECOMMANDATION",
    NOMBRE_DE_RECOMMANDATION: "NOMBRE DE RECOMMANDATION",
    DATE_CLOTURE_RECOMMANDATION_1: "DATE DE CLOTURE",
    EN_ATTENTE_DE_VALIDATION_2: "DE VALIDATION",
    AJOUT_COMMENTAIRE: "AJOUT D'UN COMMENTAIRE",
    POINTS_DE_CONTROLE: "POINTS DE CONTRÔLE",
    EN_ATTENTE_DE_VALIDATION_1: "EN ATTENTE",
    RECOMMANDATION: "Recommandation",
    REFERENCE_RECO: "RÉFÉRENCE",
    DATE_ECHEANCE: "D'ÉCHÉANCE",
    COMMENTAIRE: "COMMENTAIRE",
    ABANDONED: "ABANDONNÉE",
    CONFORMITE: "CONFORMITÉ",
    DATE_SUIVI_2: "DE SUIVI",
    EN_COURS: "EN COURS",
    CONTROLE: "CONTRÔLE",
    CONFORME: "CONFORME",
    DATE_SUIVI_1: "DATE",
    PRIORITE: "PRIORITÉ",
    PERIODE: "PÉRIODE",
    NIVEAU: "NIVEAU",
    STATUT: "STATUT",
    CLOSE: "CLOSE",
    ENTER_TEXT: "Entrez du text...",
    ASSOCIATED_ACTIVITY: "Activité associée",
    ASSOCIATED_RISK: "Risque associé",
    ASSOCIATED_RISKS: "Risques associés",
    DATE_OF_CONTROL: "Dates du contrôle",
    TYPE_OF_CONTROL: "Type de contrôle",
    OCCURENCE: "Occurence",
    EDIT_OCCURRENCE: "Modifier l'occurrence",
    ARCHIVE_OCCURRENCE: "Archiver l'occurrence",
    OVERVIEW_OF_CONTROL: "Vue globale du contrôle",
    CONTROL_PARAMETERS: "Paramètres du contrôle",
    CONFIRMATION_DELETE_MAPPING_RISKS: "Voulez vous vraiment supprimer cette cartographie ?",
    ASSOCIATED_MAPPING_RISKS: "Cartographie associée",
    COMPLIANCE: "Conformité",
    USE_WORKING_DAYS: "Utiliser les jours ouvrés",
    SORT_BY_NAME: "Trier par nom",
    DAILY: "Quotidienne",
    NO_DOCUMENT: "Aucun document",
    LIST_CHANGED_CONTROLS: "Liste des contrôles modifiés",
    VALIDATION_OF_CONTROLS: "Validation des contrôles",
    ENTITLED: "Intitulé",
    REGULATORY_REFERENCE_DOCUMENTS: "Documents référence règlementaire",
    COMMIT_CHANGES: "Valider les modifications",
    SUCCESS_TO_DELETE_FILE: "Le document a bien été supprimé",
    SUCCESS_TO_UPLOAD_FILE: "Le document a bien été ajouté",
    SUCCESS_TO_UPDATE_CONTROL_PLAN: "Le plan de contrôle a été modifié avec succès",
    WARNING_RISK_EMPTY: "Attention le risque ne peut pas être vide.",
    GLOBAL_VISUALIZATION: "Visualisation globale",
    NOT_STARTED: "A réaliser",
    CONFORM: "Conforme",
    NOT_CONFORM: "Non conforme",
    ENDED: "Terminé",
    LOW_CONFORM: "Partiellement conforme avec un faible impact",
    STRONG_CONFORM: "Partiellement conforme avec un fort impact",
    OPERATIONAL: "Opérationnel",
    LEGAL: "Juridique",
    FRAUD: "Fraude",
    OPERATIONAL_CONFORMITE: "Opérationnel/Conformité",
    IT: "IT",
    FINANCIAL: "Financier",
    SECURITY: "Sécurité",
    LITIGE_COMMERCIAUX: "Litiges commerciaux",
    RISQUE_CREDIT: "Risque de crédit",
    LITIGE_AUTORITES: "Litige avec les autorités",
    ERREURS_EVALUATION_RISQUE: "Erreurs dans l'évaluation des risques",
    ERREUR_EXECUTION: "Erreur d'exécution",
    FRAUDE_ET_AUTRES: "Fraude et autres activités criminelles",
    DEFAILLANCE_SYSTEME: "Défaillance des systèmes d'information",
    RISQUE_LIQUIDITE: "Risque de liquidité",
    PERTE_RESSOURCES_EXPLOITATION: "Perte de ressources d'exploitation",
    CONFIRM_ADD_THESE_DOCUMENTS: "Confirmer l'ajout de ces documents",
    ASSOCIATED_CONTROL: "Contrôle associé",
    ASSOCIATED_CONTROLS: "Contrôles associés",
    ADDED_FILENAME: "Nom du fichier ajouté",
    ADDED_DATE: "Date d'ajout",
    FORM_IS_EMPTY: "Le formulaire est vide",
    NO_DOCUMENTS_TO_DISPLAY: "Aucun documents à afficher",
    VALIDATION_SPACE: "Espace de validation",
    VALIDATION_OF_REQUESTED_DOCUMENTS: "Validation des documents sollicités",
    CONFIRMATION_REJECT_DOCUMENT: "Voulez vous vraiment rejeter ce document ?",
    CONFIRMATION_VALIDATE_DOCUMENT: "Voulez vous vraiment valider ce document ?",
    NAME_OF_ADDED_FILE: "Nom du fichier ajouté",
    NAME_OF_REQUESTED_DOCUMENT: "Nom du document sollicité",
    MODIFIED_THE: "Modifié le...",
    DOCUMENTS_TO_VALIDATE: "Documents à valider",
    REVIEWS: "Avis",
    EDIT_RECOMMENDATION: "Modifier la recommandation",
    PRIORITY: "Priorité",
    MANAGER: "Responsable",
    MANAGER_V2: "Manager",
    DUE_DATE: "Date d'échéance",
    FOLLOW_UP_DATE: "Date de suivi",
    RECOMMENDATIONS: "Recommandations",
    RECOMMENDATION: "Recommandation",
    MY_RECOMMENDATIONS: "Mes recommandations",
    ERROR_FOLLOW_UP_DATE:
      "Attention la date d'ouverture ne peut pas être inférieure à la date actuelle.",
    ERROR_DUE_DATE:
      "Attention la date d'échéance ne peut pas être inférieure à la date d'ouverture.",
    ERROR_RECOMMENDATION_IS_EMPTY:
      "Vous devez remplir tous les champs avant de valider cette recommendation.",
    ERROR_OPINION_IS_EMPTY: "Attention le commentaire doit contenir au moins 5 caractères !",
    SUCCESS_TO_UPDATE_RECOMMENDATION: "La recommandation a bien été mise à jour.",
    SUCCESS_TO_CREATE_RECOMMENDATION: "La recommandation a bien été créé.",
    WARNING_TO_DELETE_MAPPING_RISK:
      "Une activité, un risque ou un contrôle est lié à la cartographie, celle-ci ne peut donc pas être supprimée",
    VALIDATE_WITHOUT_MODIFICATIONS: "Valider sans modifications",
    VALIDATE_WITH_MODIFICATIONS: "Valider avec les modifications",
    SEE_CHANGES: "Voir les modifications",
    FAIL_CONSULTANT_UPDATE_CONTROL: "Erreur lors de la mise à jour du contrôle",
    CONTROLS_IN_WAITING: "Contrôles en attente",
    CONTROL_STATUS: "Statut du contrôle",
    NOT_AFFECTED: "Non affecté",
    AFFECTED_TO_CONSULTANT: "Affecté au consultant",
    WAITING_FOR_CONTROL_MODIFICATIONS_VALIDATION: "En attente de validation des modifications",
    WAITING_FOR_CLIENTS_DOCUMENTS: "En attente de documents clients",
    WAITING_FOR_DOCUMENTS_VALIDATION: "En attente de validation des documents",
    READY_TO_BE_ANSWERED: "Prêt à répondre",
    FINISHED: "Terminé",
    SUCCESS_CONSULTANT_UPDATE_CONTROL: "Le statut du contrôle a bien été mis à jour",
    ACTIVITIES_AND_RISKS: "Activités et risques",
    VIEW_CHANGES: "Voir les modifications",
    PENDING_CONTROL_CHANGES: "Modifications du contrôle en attente",
    VALIDATE_CONTROL: "Voulez vous vraiment valider de contrôle ?",
    DO_YOU_START_CONTROL: "Voulez-vous lancer ce contrôle ?",
    START_CONTROL: "Lancer le contrôle",
    CONFIRM_CONTROL_WITHOUT_CHANGES:
      "Voulez vous vraiment confirmer ce contrôle sans modifications ?",
    CONFIRM_CONTROL_REQUEST_CHANGES:
      "Voulez vous vraiment demander ces modifications pour ce contrôle ?",
    REJECT_CONTROL_REQUEST_CHANGES_V1: "Rejeter et renvoyer au consultant.",
    REJECT_CONTROL_REQUEST_CHANGES_V2: "Rejeter et publier le contrôle.",
    SUCCESS_TO_REJECT_MODIFICATION: "Le contrôle a bien été rejeté",
    MODIFICATIONS: "Modifications",
    FAIL_TO_UPDATE_CONTROL: "La mise à jour du contrôle a échouée",
    SUCCESS_TO_PATCH_CONTROL: "La mise à jour du contrôle a bien été effectuée",
    RECOMMENDATION_OPENING_DATE: "Date d'ouverture de la recommandation",
    NUMBER_OF_RECOMMENDATIONS: "Nombre de recommandations",
    PERMANENT: "Permanent",
    PERIODIC: "Périodique",
    SECTORS: "Secteurs d'activités",
    WEEK_SHORT: "SEM",
    SUCCESS_TO_ADD_RISK: "Nouveau risque ajouté avec succès",
    SUCCESS_TO_DELETE_RISK: "Risque supprimé avec succès",
    SUCCESS_TO_ADD_RISK_RESIDUAL: "Nouveau risque résiduel ajouté avec succès",
    SUCCESS_TO_UPDATE_RISK_RESIDUAL: "Le risque résiduel a été modifié avec succès",
    SUCCESS_TO_DELETE_RISK_RESIDUAL: "Le risque résiduel a été supprimé avec succès",
    SUCCESS_TO_ARCHIVE_RISK_RESIDUAL: "Le risque résiduel a été supprimé avec succès",
    SELECT_A_DATE: "Sélectionner une date",
    SEND_A_MESSAGE: "Envoyer un message",
    THREAD: "Fil de discussion",
    TASKS_VALIDATION: "Validation des tâches",
    FORM: "Formulaire",
    FILES: "Fichiers",
    FILE_INSERT: "Insertion de fichier",
    CONCERNED_DEPARTMENTS: "Département(s) concerné(s)",
    MY_DOCUMENT: "Mon document",
    DOCUMENTS_ASSOCIATED_WITH_CHECKPOINTS: "Documents associés aux points de contrôle",
    DRAG_YOUR_FILE: "Dépose ton fichier",
    OR_CLICK_HERE: "ou clique ici",
    ADMINISTRATION_AND_MANAGEMENT_OF_THE_COMPANY:
      "Administration et pilotage de la société de gestion",
    CUSTOMER_RELATIONSHIPS: "Relations clients",
    FUNDS_MANAGEMENT_AND_OPERATIONS: "Gestion des fonds et opérations",
    COMPLIANCE_ETHICS_RISKS_AND_CYBERSECURITY: "Conformité, déontologie, risques et cybersécurité",
    CONTROL_ALREADY_ANSWERED: "Le contrôle a déja été complété",
    CONTROL_ISNT_READY_ANSWERED: "Le contrôle n'est pas encore prêt à être répondu",
    CONTROL_WRONG_RIGHTS: "Vous n'avez pas les droits pour répondre au contrôle.",
    EFFACER: "Effacer",
    ERROR_MESSAGE_CREATE_FIRST_CLIENT:
      "Vous devez d'abord créer votre client avant de lui ajouter un logo",
    THERE_ARE_NO_FILES_TO_ADD: "Il n'y a aucun fichiers à ajouter.",
    ERROR_USER_TYPE_POST_DOCS_ASSOCIATE_RESPONSE:
      "Votre type d'utilisateur ne permet pas l'ajout de ce type de documents.",
    ERROR_CONTROL_RESPONSE_POST_DOCS_ASSOCIATE_RESPONSE:
      "Le contrôle doit d'abord avoir reçu une réponse avant de pouvoir ajouter ce type de documents.",
    ERROR_CONTROL_RESPONSE_POST_DOCS_ASSOCIATE_RESPONSE_V2:
      "Vous devez avoir sauvegardé ou envoyé une réponse avant d'ajouter ces documents.",
    CONTROL_WAITING_VALID_MANAGER: "Le contrôle est en attente de validation Manager.",
    CONTROL_WAITING_VALID_CLIENT: "Le contrôle est en attente de validation Client.",
    CONTROL_IS_OVER: "Le contrôle est terminé.",
    ERROR_CONTROL_CANT_VALIDATE: "Erreur, le contrôle n'a pas pu être validé",
    ERROR_CONTROL_CANT_REJECT: "Erreur, le contrôle n'a pas pu être rejeté",
    START_CONTROLLED_PERIOD: "Début de la période contrôlée",
    END_CONTROLLED_PERIOD: "Fin de la période contrôlée",
    SUCCESS_TO_DELETE_GROUP: "Le client a bien été supprimé",
    SUCCESS_TO_DELETE_ENTITY: "L'entité a bien été supprimée",
    SUCCESS_TO_ARCHIVE_ENTITY: "L'entité a bien été archivée",
    SUCCESS_TO_UNARCHIVE_ENTITY: "L'entité a bien été désarchivée",
    SUCCESS_TO_DELETE_ENTITIES: "Les entités ont bien été supprimées",
    SUCCESS_TO_ARCHIVE_ENTITIES: "Les entités ont bien été archivées",
    SUCCESS_TO_UNARCHIVE_ENTITIES: "Les entités ont bien été désarchivées",
    WARNING_CANT_DELETE_GROUP_CLIENT:
      "Veuillez enlever tous les utilisateurs rattachés avant de supprimer ce groupe client.",
    ADDED_A_MESSAGE_TO_THE_CONTROL: "a ajouté un message au contrôle",
    ADD_DOCUMENTS_TO_RECOMMENDATION: "a ajouté des documents à la recommandation",
    BELONGING_TO_THE_CONTROL: "appartenant au contrôle",
    MESSAGE_CONTENT: "Contenu du message",
    LIST_CONTROL_RESPONSES: "Réponses au contrôle",
    CONTROL_RESPONSE: "Réponse au contrôle",
    CREATOR_NAME: "Nom du créateur",
    CONTROL_TYPE: "Type de contrôle",
    START_DATE: "Date de début",
    NEXT_FOLLOWUP_DATE: "Date de prochain suivi",
    END_DATE: "Date de fin",
    PLACEHOLDER_SAMPLING:
      "Description de l'échantillonnage retenu : Typologie / Nombre / Taille / Année(s) sous revue / Autres",
    CONTROL_PROGRESS: "Progression du contrôle",
    ON_DATE: "Le",
    CONTROL_OPENED_BY: "Contrôle ouvert par",
    AUDIT_TRAIL: "Piste d'audit",
    AUDIT_TRAILS: "Pistes d'audit",
    SUCCESS_TO_ADD_OPINION_TO_RECOMMENDATION: "Votre commentaire à bien été ajouté",
    ASSIGNED_TO: "Affecté à",
    VALIDATION_MANAGER_ON: "Validé par le Manager le",
    VALIDATION_CLIENT_ON: "Validé par le Client le",
    SUCCESS_TO_ADD_RESPONSE: "Sauvegarde de votre réponse avec succès",
    SUCCESS_TO_PATCH_RESPONSE: "Sauvegarde de votre réponse avec succès",
    FAIL_TO_DELETE_FILE: "La suppression du fichier a échouée",
    NO_CONTROLS_SELECTED: "Aucun contrôles selectionnés",
    CONTROLS_SELECTED: "Contrôles sélectionnés",
    EXPORT_CONTROLS: "Exporter les contrôles",
    EXPORT_DATA: "Exporter les données",
    EXPORT_AFFECTED_CONTROLS: "Exporter les contrôles affectés",
    EXPORT_CUSTOM_SHEET_DEFAULT: "Feuille personnalisée",
    EXPORT_TABLE_HEADERS_UNDEFINED: "Erreur : en-têtes de tableau non définis.",
    EXPORT_TABLE_NO_DATA: "Aucune donnée disponible pour ce tableau.",
    EXPORT_TABLE_GENERATION_ERROR: "Erreur lors de la génération du tableau : %error%",
    EXPORT_PDF_TABLE_UNSUPPORTED: "Rendu PDF non pris en charge pour ce tableau.",
    JSONFORMS_EMPTY_NO_DATA_TITLE: "Aucune donnée disponible",
    JSONFORMS_EMPTY_FILTERED_TITLE: "Aucun résultat avec ces filtres",
    JSONFORMS_EMPTY_SEARCH_TITLE: "Aucun résultat pour cette recherche",
    JSONFORMS_EMPTY_NO_ACCESS_TITLE: "Accès restreint",
    JSONFORMS_EMPTY_SUB_CREATE_ONLY: "Créez un nouvel élément.",
    JSONFORMS_EMPTY_SUB_LINK_ONLY: "Liez un élément (%s) existant.",
    JSONFORMS_EMPTY_SUB_LINK_OR_CREATE: "Liez un élément (%s) existant ou créez-en un nouveau.",
    JSONFORMS_EMPTY_SUB_NO_ACTION: "Aucune donnée disponible.",
    JSONFORMS_EMPTY_SUB_FILTER: "Ajustez ou réinitialisez vos filtres.",
    JSONFORMS_EMPTY_SUB_SEARCH: "Modifiez ou effacez la recherche.",
    JSONFORMS_EMPTY_SUB_NO_ACCESS: "Vous n'avez pas les droits pour voir ce contenu.",
    JSONFORMS_EMPTY_BTN_EDIT_FILTERS: "Modifier les filtres",
    JSONFORMS_EMPTY_BTN_RESET_FILTERS: "Réinitialiser",
    JSONFORMS_EMPTY_BTN_CLEAR_SEARCH: "Effacer la recherche",
    JSONFORMS_EMPTY_BTN_ADD: "Ajouter",
    JSONFORMS_EMPTY_BTN_CREATE: "Créer",
    JSONFORMS_EMPTY_BTN_CREATE_MODAL: "Créer dans la modale",
    JSONFORMS_EMPTY_BTN_CREATE_REDIRECT: "Créer par redirection",
    JSONFORMS_EMPTY_BTN_MORE_OPTIONS: "Plus d’options",
    JSONFORMS_FIELD_REQUIRED: "Champ obligatoire",
    JSONFORMS_FIELD_LOCKED_BY_RULE: "Champ verrouillé par une règle de la fiche",
    JSONFORMS_SECTION_HIGHLIGHTED: "Section concernée par l'étape en cours",
    JSONFORMS_SECTION_FOLD_EXPAND: "Déplier la section",
    JSONFORMS_SECTION_FOLD_COLLAPSE: "Replier la section",
    JSONFORMS_SECTION_FOLDED_HINT: "Replié : non signalé pour cette fiche. Dépliez pour vérifier.",
    RELATION_VIEW_CREATE: "Créer",
    RELATION_VIEW_CREATE_CONSTRAINED: "La création est contrainte sur ce bloc",
    RELATION_VIEW_PICK_PARENT: "Choisir l'élément de rattachement",
    RELATION_VIEW_PICK_PARENT_EMPTY: "Cette fiche n'a encore aucun élément lié — créez-en un d'abord.",
    JSONFORMS_LINK_UNLINK: "Dissocier",
    JSONFORMS_LINK_CREATE: "Créer",
    JSONFORMS_LINK_ACTIONS: "Actions",
    JSONFORMS_LINK_ADD: "Lier un(e) %s existant(e)",
    JSONFORMS_LINK_ADD_TAB: "Lier",
    JSONFORMS_LINK_CREATE_ITEM: "Créer un(e) nouveau(elle) %s",
    JSONFORMS_LINK_VIEW_TABLE: "Vue tableau",
    JSONFORMS_LINK_VIEW_GANTT: "Vue Gantt",
    JSONFORMS_LINK_COLLAPSE: "Replier le tableau",
    JSONFORMS_LINK_EXPAND: "Déployer le tableau",
    JSONFORMS_LINK_COMPLETE: "Activer l'édition locale",
    JSONFORMS_LINK_IMPORT_TAB: "Importer",
    JSONFORMS_LINK_SELECTED_COUNT: "{count} sélectionné(s)",
    JSONFORMS_LINK_SELECTION_CAP_EXCEEDED: "Trop d'éléments sélectionnés ({count}), affinez la sélection (maximum {max})",
    JSONFORMS_IMPORT_BACK: "Retour",
    JSONFORMS_IMPORT_TEMPLATE_ERROR: "Le modèle n'a pu être récupéré, veuillez réessayer d'ici quelques instants",
    JSONFORMS_GOOGLE_SHOW_TEXT: "Afficher en texte",
    JSONFORMS_GOOGLE_SHOW_MAP: "Afficher sur la carte",
    JSONFORMS_GOOGLE_TOGGLE_LABEL: "Basculer l'affichage",
    JSONFORMS_GOOGLE_OPEN_MAP: "Ouvrir dans OpenStreetMap",
    JSONFORMS_JODIT_PLACEHOLDER: "Écrivez ici…",
    JSONFORMS_ERROR_REQUIRED: "Ce champ est obligatoire.",
    JSONFORMS_ERROR_MIN_CHAR: "Ce champ doit contenir au moins un caractère.",
    JSONFORMS_ERROR_MIN_ITEMS: "Ce champ doit contenir au moins une valeur.",
    JSONFORMS_ERROR_NUMBER: "Caractères autorisés (0,...,9,.,-,,)",
    JSONFORMS_ERROR_STRING: "Ce champ doit être un texte.",
    JSONFORMS_ERROR_DEFAULT: "Valeur invalide.",
    JSONFORMS_ERROR_MIN_LENGTH: "Ce champ doit contenir au moins {limit} caractères.",
    JSONFORMS_ERROR_MAX_LENGTH: "Ce champ ne doit pas dépasser {limit} caractères.",
    JSONFORMS_ERROR_MIN_ITEMS_COUNT: "Ce champ doit contenir au moins {limit} valeurs.",
    JSONFORMS_ERROR_MAX_ITEMS: "Ce champ ne doit pas contenir plus de {limit} valeurs.",
    JSONFORMS_ERROR_UNIQUE_ITEMS: "Les valeurs doivent être uniques.",
    JSONFORMS_ERROR_MINIMUM: "Cette valeur doit être supérieure ou égale à {limit}.",
    JSONFORMS_ERROR_EXCLUSIVE_MINIMUM: "Cette valeur doit être strictement supérieure à {limit}.",
    JSONFORMS_ERROR_MAXIMUM: "Cette valeur doit être inférieure ou égale à {limit}.",
    JSONFORMS_ERROR_EXCLUSIVE_MAXIMUM: "Cette valeur doit être strictement inférieure à {limit}.",
    JSONFORMS_ERROR_MULTIPLE_OF: "Cette valeur doit être un multiple de {limit}.",
    JSONFORMS_ERROR_FORMAT: "Le format de cette valeur est invalide.",
    JSONFORMS_ERROR_ENUM: "Cette valeur ne fait pas partie des valeurs autorisées.",
    JSONFORMS_ERROR_CONST: "Cette valeur n'est pas celle attendue.",
    JSONFORMS_ERROR_NOT: "Cette valeur n'est pas autorisée.",
    JSONFORMS_ERROR_IF: "Ce champ ne respecte pas la règle conditionnelle applicable.",
    JSONFORMS_ERROR_DATE_AFTER: "{end} doit être postérieure à {start}.",
    CHOOSING_OBJECTS_SEPARATOR: "Choix du séparateur pour les objets multiples",
    ANSWER_OF: "Réponse du",
    SURVEY: "Questionnaire",
    SURVEY_CONFIGURATION: "Paramètrage questionnaire",
    ADD_SURVEY: "Ajouter un questionnaire",
    ENABLE_COLUMNS_TOTAL: "Activer le total des colonnes",
    ORGANIZE_YOUR_TASKS: "Organiser vos tâches",
    ASSOCIATE_TASKS: "Tâches associées",
    HAS_BEEN_COMPLETED_AND_READY_VALIDATION: "a été complété et est prêt à être validé.",
    PRESENTATION_OF_CONTROL: "Présentation du contrôle",
    FAIL_TO_DELETE_ACTIVITY: "Echec de la suppression de l'activité",
    RECOMMENDATIONS_PRIORITY: "Priorité des recommandations",
    CONTROL_PLAN_LEVEL: "Niveau du plan de contrôle",
    IN_DEVELOPMENT_PROGRESS: "En cours de développement",
    CONTROL_LOCKED_DEADLINE_PAST:
      "Le contrôle est verouillé car la date limite de réponse est depassée.",
    CREATE_AUDIT_PLAN: "Créer un plan d'audit",
    CREATE_AUDIT_MISSION: "Créer une mission d'audit",
    CREATE_AUDIT_POINT: "Créer un point d'audit",
    SUBMIT: "Soumettre",
    SUBMITTED: "A soumis",
    SUBMIT_AUDIT_PLAN: " Soumettre le plan d'audit",
    REVIEW: "Revue",
    SUMMARY_SHEET_AUDIT_PLAN: "Fiche synthèse du plan d'audit",
    MY_AUDIT_PLANS: "Mes plans d'audits",
    AUDIT_REPORT: "Rapport d'audit",
    MY_CURRENT_AUDIT_REPORT: "Mon rapport d'audit actuel",
    ADD_A_RECOMMENDATION: "Ajouter une recommandation",
    NAME_AUDIT_PLAN: "Nom du plan d'audit",
    CONFIRM_DELETE_AUDIT_PLAN: "Voulez vous vraiment supprimer ce plan d'audit ?",
    CONFIRM_DELETE_AUDIT_RECOMMENDATION: "Voulez vous vraiment supprimer cette recommandation ?",
    AUDIT_RECOMMENDATION: "Recommandation d'audit",
    AUDIT_RECOMMENDATIONS: "Recommandations d'audit",
    AUDIT_PLAN: "Plan d'audit",
    AUDIT_MISSION: "Mission d'audit",
    CANT_DELETE_AUDIT_PLAN_IT_CONTAINS_RECOS:
      "Vous ne pouvez pas supprimer ce plan d'audit car il contient encore des recommandations.",
    FAIL_TO_DELETE_AUDIT_PLAN: "Erreur lors de la suppression du plan d'audit",
    WAITING_AUDIT_PLAN_VALIDATION: "En attente de soumission du plan d'audit",
    SUCCESS_TO_MODIFY_AUDIT_PLAN: "Le plan d'audit a été modifié avec succès",
    AUDIT_PLANS: "Plans d'audits",
    ACCESS_AUDIT_PLANS: "Accès aux plans d'audits",
    VIEW_AUDITS_PLANS: "Visualiser les plans d'audits",
    EDIT_AUDIT_PLAN: "Editer un plan d'audit",
    DELETE_AUDIT_PLAN: "Supprimer un plan d'audit",
    DUPLICATE_AUDIT_PLAN: "Dupliquer un plan d'audit",
    USE_AUDIT_PLANS_SCOPE: "Utiliser le périmètre des plans  d'audit",
    ACTIVATE_THEMATIC_CONTROLS: "Activer la thématique des contrôles",
    CREATE_NEW_THEMATIC: "Créer une nouvelle thématique",
    RECOMMENDATION_STATUS: "Statut de la recommandation",
    ENABLE_REDIRECT_ANOMALY_CONTROL_NOT_COMPLIANT:
      "Être rediriger vers la création d'anomalie en cas de non-conformité du contrôle",
    ERROR_MESSAGE_DELETE_ACTIVITY_SUB_ACTIVITIES:
      "Cette activité ne peut pas être supprimée car des activités secondaires y sont toujours liés, veuillez d'abord supprimer les activités secondaires.",
    ENABLE_PARENT_CONTROL: "Activer les contrôles parents",
    ENABLE_RECO_CONTROL: "Activer les recommandations dans les contrôles",
    NEW_PLANNER: "Nouveau planner",
    BETA_VERSION: "version beta",
    PERIMETER: "Périmètre",
    CONCERNED_TEAMS: "Équipes concernées",
    ADD_AUDIT_TRAIL: "Ajouter cette piste d'audit",
    MY_AUDIT_TRAIL: "Ma piste d'audit",
    MODEL_NAME: "Nom du modèle",
    FREE_TEXT: "Texte libre",
    TEXT_AREA: "Zone de texte",
    SELECTOR: "Sélecteur simple",
    SELECTOR_MULTIPLES: "Sélecteur multiples",
    CHECKBOX: "Checkbox",
    SUCCESS_TO_CREATE_CUSTOM_SKELETON: "Le nouveau modèle a été créé avec succès",
    SUCCESS_TO_DELETE_CUSTOM_SKELETON: "Le modèle a été supprimé avec succès",
    USE_CUSTOM_SKELETONS_ANOMALIES: "Utiliser les modèles personnalisés d'anomalies",
    USE_CUSTOM_SKELETONS_INCIDENTS: "Utiliser les modèles personnalisés d'incidents",
    USE_CUSTOM_SKELETONS_RECOMMENDATIONS: "Utiliser les modèles personnalisés de recommandations",
    USE_CUSTOM_SKELETONS_ACTIVITIES: "Utiliser les modèles personnalisés d'activités",
    USE_NEW_RIKS_CREATION_PAGE: "Utiliser la nouvelle page de création de risques",
    USE_CUSTOM_SKELETONS_RISKS: "Utiliser les modèles personnalisés de risques",
    CONFIRMATION_DELETE_MODEL: "Voulez vous vraiment supprimer ce modèle ?",
    ERROR_SKELETON_NEED_NAME_AND_FIELD:
      "Attention le modèle a besoin d'un nom et d'au moins un champ qui ne soit pas un champ par défaut !",
    DECLARANT_NAME: "Nom du déclarant",
    CONTROLEUR_NAME: "Responsable Suivi Recommandation",
    OPTIONS_LIST: "Liste d'options",
    OPTIONS: "Options",
    CURRENT_OPTIONS: "Options actuelles",
    LIST_INVALID_LIST_NAME: "Veuillez entrer un nom de liste.",
    LIST_INVALID_LIST_OPTIONS: "Veuillez saisir au moins une option",
    LIST_LIST_NAME: "Nom de la liste",
    LIST_LIST_OPTIONS: "Options",
    LIST_NEW_LIST: "Ajouter une liste de Choix",
    LIST_TITLE_LIST_SETTINGS: "Paramétrage de la liste",
    LIST_CONFIRM_DELETE_LIST: "Êtes vous sur de vouloir supprimer cette liste ?",
    LIST_DELETE_LIST: "Supprimer",
    LIST_CANCEL_LIST: "Annuler",
    LIST_VALIDATE_LIST: "Valider",
    ADD_OPTION: "Ajouter une option",
    CREATE_A_NEW_LIST: "Créer une nouvelle liste",
    STRING_LIST: "Liste de chaîne de caractères",
    CONTACT_RCCI: "Contact - Identité du RCCI / RCSI",
    ADD_NEW_VALUE: "Ajouter une nouvelle valeur",
    SAVE_LIST: "Sauvegarder la liste",
    EDIT_LIST: "Modifier la liste",
    SUCCESS_TO_CREATE_CUSTOM_LIST: "La liste a été créée avec succès",
    SUCCESS_TO_PATCH_CUSTOM_LIST: "La liste a été modifiée avec succès",
    RESPONSIBLES: "Responsables",
    THREAD_IS_OPEN_TO_ALL_USERS:
      "Le fil de discussion est actuellement ouvert à tous les utilisateurs.",
    WARNING_MESSAGE_EDIT_MODEL_CONTROL_PLAN:
      "Attention vous allez modifier un modèle de plan de contrôle, voulez vous continuer ?",
    TABLE_VIEW: "Vue en tableau",
    CARDS_VIEW: "Vue en cartes",
    ONE_RECO_IS_LATE: "Au moins une recommandation est en retard",
    RECO_ARE_STILL_TO_BE_COMPLETED: "Des recommandations sont encore à compléter",
    NEW_RECO_READY_TO_BE_COMPLETED: "Une nouvelle recommandation est prête a être complétée",
    NEW_MESSAGES: "Nouveaux messages !",
    NO_CLIENT_ASSIGNED_TO_CONTROL_PLAN: "Aucun client n'est affecté à ce plan de contrôle",
    ACCESS_MESSAGES: "Accéder aux messages",
    GLOBAL_COMPLIANCE: "Conformité globale",
    MY_LIST_OF_MISSIONS: "Ma liste de missions",
    MISSION: "Mission",
    MISSIONS: "Missions",
    MY_MISSIONS: "Mes missions",
    CREATE_A_MISSION: "Créer une mission",
    PENDING_MISSIONS: "Missions en attente",
    AUDIT_POINT: "Point d'audit",
    MISSION_STATUS: "Statut de la mission",
    CREATE_AN_AUDIT_POINT: "Créer un point d'audit",
    AUDIT_PLAN_LEVEL: "Niveau du plan d'audit",
    AUDIT_POINT_TITLE: "Intitulé du point d'audit",
    TITLE_OF_THE_MISSION: "Intitulé de la mission",

    WITH_HISTORY: "Avec historique",
    WITHOUT_HISTORY: "Sans historique",

    // ****************** ACTIVITIES 99 ADVISORY******************
    CROWFUNDING_SERVICE_PROVIDER: "Prestataire de services de financement participatif",
    FINANCIAL_INVESTMENT_ADVISOR: "Conseiller en investissements financiers",
    DIGITAL_ASSET_SERVICE_PROVIDERS: "Prestataires de services sur actifs numériques",
    MUTUAL_SECURITIZATION_FUND: "Fonds commun de titrisation",
    INVESTMENT_FIRM: "Entreprise d'investissement",
    BANKING_ESTABLISHMENT: "Établissement bancaire",
    FOREST_MANAGEMENT: "Gestion forestière",
    PRIVATE_EQUITIY: "Capital investissement",
    INFRASTRUCTURE: "Infrastructure",
    PRIVATE_DEBT: "Dette privée",
    PROPERTY_MANAGEMENT: "Gestion immobilière",
    SOPHISTICATED_MANAGEMENT: "Gestion sophistiqué",
    TRADITIONAL_MANAGEMENT: "Gestion traditionnelle",
    ACTION_PLAN_RELATED_ANOMALY: "Le plan d'action lié à l'anomalie",
    ACTION_PLAN_RELATED_INCIDENT: "Le plan d'action lié à l'incident",
    AUDIT_TRAIL_NAME: "Nom de la piste d'audit",
    NEW_FIELD: "Nouveau champ",
    DOCUMENTS_RECOMMENDATIONS: "Documents recommandations",
    RISK_PERIMETER: "Périmètre du risque",
    RISK_VALUATION: "Évaluation du risque",
    // ****************** BUSINESS INFORMATIONS CLIENTS ******************
    BI_CLIENTS: "Clients",
    BI_TELECHARGER: "Télécharger",
    BI_AJOUT_CLIENT: "Ajouter un client",
    BI_EDIT_CLIENT: "Modifier le client",
    // ****************** BUSINESS INFORMATIONS GROUPS ******************
    TAB_GROUPS: "Groupes",
    GROUP_NAME: "Nom du groupe",
    ADD_GROUP: "Ajouter un groupe",
    EDIT_GROUP: "Editer un groupe",
    MANAGER_GROUP: "Manager du groupe",
    CONNECTES_USERS: "Utilisateurs rattaches",
    // ****************** NOTIFICATIONS ****************
    SUBSCRIBE: "S'abonner",
    NOTIFICATIONS: "Notifications",
    NOUVELLES_NOTIFICATIONS: "Nouvelles notifications",
    AUCUNE_NOUVELLE_NOTIFICATION: "Aucune nouvelle notification",
    HISTORIQUE_NOTIFICATIONS: "Historique des notifications",
    AUCUN_HISTORIQUE: "Aucun historique disponible",
    NO_NOTIFICATION_AVAILABLE: "Vous n'avez reçu aucune notification pour le moment",
    NOTIFICATION_SUBSCRIPTION_INFO_1:
      "Vous pouvez vous abonner à des notifications en cliquant sur le bouton ",
    NOTIFICATION_SUBSCRIPTION_INFO_2: " sur la page d'un référentiel.",
    A_REPONDU_AU_CONTROLE: "a répondu au contrôle",
    LE_CONTROLE_EST: "Le contrôle est",
    A_CREER_ANOMALIE: "a créé l'anomalie",
    UPDATED_STATUS_NON_CONFORMITY_TO: "a mis à jour le statut de la non-conformité",
    A_CREER_CONTROL: "a créé le contrôle",
    A_CREER_INCIDENT: "a créé l'incident",
    A_CREER_AUDIT_RECO: "a créé la recommandation d'audit",
    A_SUPPRIME_LA_PAGE: "a supprimé la page",
    A_MODIFIE_LA_PAGE: "a modifié la page",
    ASSIGNATION_PLAN_CONTROLE: "vous a assigné au plan de contrôle",
    ASSIGNATION_CONTROLE: "vous a assigné au contrôle",
    REJECTED_CONTROL: "a rejeté le contrôle",
    VALIDATED_CONTROL: "a validé le contrôle",
    VALIDATED_ACTION_PLAN: "a validé le plan d'action",
    ACTIVATE_EMAIL_NOTIFICATIONS: "Activer les notifications email",
    REGROUP_NOTIFICATIONS_SUMMARY: "Regrouper vos notifications en une synthèse",
    MAIL_SYNTHESIS_FREQUENCY: "Fréquence",
    CATEGORIE_CONTROLE_1: "Affectation à un contrôle",
    CATEGORIE_CONTROLE_2: "Traitement du contrôle par l’opérationnel",
    CATEGORIE_CONTROLE_3: "Degrés de conformité du contrôle si contrôle non conforme",
    CATEGORIE_CONTROLE_4: "Degrés de conformité si contrôle conforme",
    CATEGORIE_CONTROLE_5: "Relance à J-2 deadline du contrôle",
    CATEGORIE_CONTROLE_6: "Relance à J deadline du contrôle",
    CATEGORIE_CONTROLE_7: "Relance J+2 du contrôle",
    CATEGORIE_CONTROLE_8: "Validation / Rejet du contrôle",
    CATEGORIE_ANOMALIE_1: "Création d’une anomalie / Incident",
    CATEGORIE_ANOMALIE_2: "Création d’un plan d’action lié à une anomalie",
    CATEGORIE_ANOMALIE_3: "Affectation d’un plan d’action",
    CATEGORIE_ANOMALIE_4: "Relance à J-2 deadline du plan d’action",
    CATEGORIE_ANOMALIE_5: "Relance à J deadline du plan d’action",
    CATEGORIE_ANOMALIE_6: "Relance J+2 du plan d’action",
    CATEGORIE_ANOMALIE_7: "Traitement du plan d’action par l’opérationnel",
    CATEGORIE_ANOMALIE_8: "Validation ou rejet d'un plan d'action complété",
    CATEGORIE_RECOMMENDATION_1: "Création d’une recommandation",
    CATEGORIE_RECOMMENDATION_2: "Clôture de la recommandation",
    CATEGORIE_RECOMMENDATION_3: "Création du plan d'action de la recommandation",
    CATEGORIE_RECOMMENDATION_4: "Affectation du plan d’action de la recommandation",
    CATEGORIE_RECOMMENDATION_5: "Traitement du plan d’action par l’opérationnel",
    CATEGORIE_RECOMMENDATION_6: "Commentaires des fiches de contrôle",
    CATEGORIE_RECOMMENDATION_7: "Commentaires recommandation",
    CATEGORIE_DASHBOARD_1: "Partage d’un dashboard",
    CATEGORIE_DASHBOARD_2: "Modification d’un dashboard",
    CATEGORIE_DASHBOARD_3: "Suppression d’un dashboard",
    MSF_CONTRAT_ETUDE_SIGNATAIRE: "vous a assigné comme signataire au contrat étude",
    MSF_CONTRAT_ETUDE_VALIDATION: "a validé le contrat étude",
    MSF_CONTRAT_TRAVAUX_SIGNATAIRE: "vous a assigné comme signataire au contrat travaux",
    MSF_CONTRAT_TRAVAUX_VALIDATION: "a validé le contrat travaux",
    MSF_DOES_NOT: "n'as pas",
    MSF_BESOIN_MSF_COMPLET: "besoin d'un DCS complet",
    MSF_OUVERTURE_PL: "PL demandé le",
    MSF_FACTURATION: "CE transmis à la facturation le",
    MSF_PPI_COPIE_INFRAPOLE: "PL et demande astre transmis au PPI le",
    // ****************** ANOMALIES ****************
    ANOMALIE_REFERENCE: "Référence",
    ANOMALIE_CONTROLE: "Contrôles",
    ANOMALIE_PLAN_ACTION: "Plans d'action",
    ANOMALIE_STATUS: "Statut",
    INCIDENT_NOM: "Nom",
    INCIDENT_PROPRIETAIRE: "ID propriétaire",
    INCIDENT_CRITICITE: "Criticité",
    INCIDENTS: "Incidents",
    CREATOR: "Créateur",
    WAITING_FOR_ADMIN_VALIDATION: "En attente de validation par l'administrateur",
    AWAITING_ADMIN_TASKS_VALIDATION: "En attente de validation des tâches par l'administrateur",
    AWAITING_AUDITOR_TASKS_VALIDATION: "En attente de validation des tâches par l'auditeur",
    WAITING_VALIDATION: "En attente de validation",
    WAITING_FINAL_VALIDATION: "En attente de validation définitive",
    VALIDATE_BY_ADMIN: "Validé par l'administrateur",
    TASKS_TO_BE_CARRIED: "Tâches à réaliser",
    CLOSED: "Cloturée",
    SUCCESS_TO_DELETE_ANOMALY: "L'anomalie a été supprimé avec succès",
    CONFIRMATION_DELETE_ANOMALIE: "Voulez-vous vraiment supprimer cette anomalie ?",
    CONFIRMATION_DELETE_INCIDENT: "Voulez-vous vraiment supprimer cet incident ?",
    CONFIRMATION_DELETE_AUDIT_RECO: "Voulez-vous vraiment supprimer cette recommandation d'audit ?",
    CONFIRMATION_DELETE_RECO: "Voulez-vous vraiment supprimer cette recommandation ?",
    IL_A_REFERENCE: "il a comme référence",
    ELLE_A_REFERENCE: "elle a comme référence",
    PERFORMERS_ANO: "Performers",
    TASK_LIST: "Listes des tâches",
    NO_NEED_TASK: "La criticité ne nécessite pas d'établir de tâches",
    SUCESS_TO_CREATE_NON_CONFORMITY: "La non-conformité a été créée avec succès.",
    SUCCESS_TO_UPDATE_NON_CONFORMITY: "La non-conformité a été modifiée avec succès.",
    SUCCESS_TO_UPDATE_STATUT_NON_CONFORMITY:
      "Le statut de la non-conformité a été modifié avec succès.",
    SUCCESS_TO_DELETE_NON_CONFORMITY: "La non-conformité a été supprimée avec succès.",
    SUCCESS_TO_DELETE_INCIDENT: "L'incident a été supprimé avec succès.",
    SUCCESS_TO_DELETE_ANOMALY: "L'anomalie a été supprimée avec succès.",
    FAIL_TO_DELETE_INCIDENT: "La suppression de l'incident a échoué.",
    FAIL_TO_DELETE_ANOMALY: "La suppression de l'anomalie a échouée.",
    FAIL_TO_CREATE_NON_CONFORMITY:
      "Nous avons rencontré une erreur lors de la création de votre non-conformité.",
    FAIL_TO_UPDATE_NON_CONFORMITY:
      "Nous avons rencontré une erreur lors de la modification de votre non-conformité.",
    FAIL_TO_DELETE_NON_CONFORMITY:
      "Nous avons rencontré une erreur lors de la suppression de votre non-conformité.",
    APPEARS_IN_VISUALIZATION_BOARD: "Apparait dans le tableau de visualisation",
    WARNING_TO_EXIST_REF_NON_CONFORMITY: "La référence renseigné est déjà utilisé.",
    // ****************** CONFIG PARTAGE SOURCE ****************
    SHARE_MY_SOURCE: "Partager ma source",
    ADD_NEW_RIGHT: "Ajouter nouveau droit",
    CONFIG_SOURCE_RIGHT: "Configuration des droits sur la source",
    CONFIG_LINE_SOURCE_RIGHT: "Configuration des droits sur les lignes de la source",
    MY_CURRENT_SOURCE_RIGHT: "Mes droits actuel sur la source",
    RIGHT_AFFECTED: "Droits affectés",
    GROUPS_CONCERNED: "Groupes concernés",
    OPERATOR: "Opérateur",
    VALUE_FIELD: "Valeur du champ",
    READ_LABEL: "Lecture",
    EDIT_LABEL: "Edition",
    SHARE_LABEL: "Partager",
    DELETE_LABEL: "Suppression",
    ADD_FIELD_LABEL: "Ajouter un champ",
    MESSAGE_ALERT_PERMISSION:
      "Le groupe ne possède pas les droits sur la source suffisant pour configurer des droits sur les lignes",
    // ****************** CENTRE NOTIFICATION ****************
    QUAND_ET_COMMENT: "Choisissez quand et comment recevoir des notifications",
    SELECT_NOTIFICATION:
      "Sélectionnez les notifications Push et les notifications par e-mail que vous souhaitez recevoir",
    // ****************** Traduction Orange ****************
    PROCESSUS: "Processus",
    SUB_PROCESSUS: "Sous processus",
    CREATE_A_PROCESSUS: "CRÉER UN PROCESSUS",
    ADD_PROCESSUS: "Créer Processus",
    EDIT_PROCESSUS: "Editer Processus",
    newProcessus: "nouveau processus",
    addProcessus: "ajouter un processus",
    editProcessus: "éditer un processus",
    labelProcessus1: "Nom du processus",
    labelProcessus2: "Référence du processus",
    ASSIGN_TO_PROCESSUS: "Affecter à un processus",
    ASSIGN_TO_SUB_PROCESSUS: "Affecter à un sous processus",
    DELETE_PROCESSUS: "Supprimer Processus",
    CONFIRM_DELETE_PROCESSUS: "Voulez vous vraiment supprimer ce processus ?",
    // ****************** Traduction SNCF MSF ****************
    NAME: "Nom",
    EMAIL: "Email",
    PHONE: "Téléphone",
    BUSINESS: "Entreprise",
    DESCRIPTIF: "Descriptif",
    STUDY_CONTRACT: "Contrat étude",
    WORKS_CONTRACT: "Contrat travaux",
    MSF_MANAGER: "Responsable",
    MSF_AFFAIRE_CONCERNED: "Affaire concernée",
    MSF_MODEL: "Modèle",
    MSF_NAME_CONTRAT: "Nom du contrat",
    MSF_ADD_ATTACHMENT: "Ajouter une pièce jointe",
    WORK_PLANNING: "PLANNING DES TRAVAUX",
    CAPABILITIES: "CAPACITÉS",
    STEP_TRACKING: "SUIVIS DES ÉTAPES",
    SEND_PLANNING: "ENVOYER LE PLANNING",
    VALIDATE_PLANNING: "VALIDER LE PLANNING",
    UNVALIDATE_PLANNING: "INVALIDER LE PLANNING",
    ACCOMPANIMENTS: "Accompagnements",
    CATENARY_BREAKS: "Coupures caténaires",
    ITC: "ITC",
    ADVERTISERS: "Annonceurs",
    LTV: "LTV",
    IC_VISIT: "Visite IC",
    SETTING_TARGET: "Pose de cibles",
    FOLLOWED_BY_DRILLING: "Accompagnement suivi de forage",
    TARGET_DROP: "Dépose de cibles",
    MSF_LINES: "Lignes",
    MSF_WAY: "Voies",
    MSF_WORKING_RANGE_AVAILABLE: "Plage de travaux disponible",
    MSF_WORKING_RANGE_TIME: "Horaires plage de travaux disponible",
    MSF_AVAILABLE_DATE: "Date disponible",
    MSF_REMARKS: "Remarques",
    MSF_ADD_LINES: "AJOUTER UNE LIGNE",
    MSF_ADD_LINES_TRAVAUX: "AJOUTER UNE LIGNE TRAVAUX",
    MSF_NATURE_OPERATION: "Nature de l'opération",
    MSF_SIGNATORY_STUDY: "Signataire du contrat étude",
    MSF_SIGNATORY_WORKS: "Signataire du contrat travaux",
    MSF_ADD_A_DATE: "AJOUTER UNE DATE",
    MSF_NIGHT_OF: "Nuit du",
    MSF_RELANCE_SIGNATORY: "RELANCER LA SIGNATURE",
    MSF_RELANCE_SIGNATORY_SUCCESS: "La relance a été effectuée",
    MSF_MAIL_SENT: "Mail envoyé",
    MSF_TIME_RANGE: "Amplitude horaire",
    MSF_DAY_TO_DAY: "Jour à jour (ex: LuMa)",
    DESTINATAIRE: "Destinataire",
    INTERLOCUTEUR: "Interlocuteur",
    MAIL_SUBJECT: "Objet du mail",
    EMAIL_SENT: "Mail envoyé",
    SUCCESS_TO_PATCH_DATA_AFFAIRE: "Les données de l'affaire ont été modifiées avec succès",
    SUCCESS_TO_GET_DOCUSIGN_ACCESS_TOKEN: "Connexion à DocuSign réussie",
    // **************** Structuring Source *************************
    CREATED_TABLE: "Création nouvelle table",
    ADD_TABLE: "Ajouter une table",
    IMPORT_TABLE: "Importer une table",
    LOAD_TABLE: "Charger une table",
    JOINTURE: "Jointure",
    ADD_COLONNE: "Ajouter une colonne",
    NOM_COLONNE: "Nom de la colonne",
    DELETE_COLONNE: "Supprimer une colonne",
    GROUPER_PAR: "Grouper par",
    FORMULE: "Formule",
    FILTRE: "Filtre",
    CLEAR_FILTER: "Supprimer le filtre",
    NOM_CHAMP: "Nom du champ",
    CONDITION: "Condition",
    DISPO_TABLE: "Tables disponibles",
    MANIPULE_TABLE: "Table manipulée",
    EXPORT: "Exporter",
    LOAD: "Charger",
    // **************** Administration *************************
    INFORMATIONS: "Informations",
    CREATED: "Créé",
    PROFILE: "Profil",
    CREATE_NEW_PROFILE: "Créer un nouveau profil",
    NEW_PROFILE: "Nouveau profil",
    PROFILE_NAME: "Nom du profil",
    PROFILE_NAME_IS_EMPTY: "Le nom du profil n'est pas valide",
    NO_MODULE_SELECTED: "Pas de module sélectionné",
    PROFILES: "Profils",
    ORGANIGRAMME: "Organigramme",
    SA: "SA",
    CREATE_NEW_ENTITY: "Créer une nouvelle entité",
    ADD_OR_DELETE_USER_FROM_ENTITY: "Ajouter / Supprimer un utilisateur de l’entité",
    REMOVE_ALL_MEMBERS_OF_ENTITY: "Retirer tous les membres de l'entité",
    WOULD_YOU_LIKE_TO_DELETE_THIS_ENTITY: "Voulez-vous supprimer cette entité ?",
    SUB_ENTITIES_WILL_ALSO_BE_DELETED: "Les sous-entités seront également supprimées",
    WOULD_YOU_LIKE_TO_ARCHIVE_THIS_ENTITY: "Voulez-vous archiver cette entité ?",
    SUB_ENTITIES_WILL_ALSO_BE_ARCHIVED: "Les sous-entités seront également archivées",
    WOULD_YOU_LIKE_TO_UNARCHIVE_THIS_ENTITY: "Voulez-vous désarchiver cette entité ?",
    SUB_ENTITIES_WILL_ALSO_BE_UNARCHIVED: "Les sous-entités seront également désarchivées",
    WOULD_YOU_LIKE_TO_REMOVE_ALL_MEMBERS_OF_THIS_ENTITY:
      "Voulez-vous retirer tous les membres de cette entité ?",
    NEW_ENTITY: "Nouvelle entité",
    ATTACHED_TO_SUPERIOR_ENTITY: "Attachée à une entité supérieure",
    CONCERNED_MODULE: "Module concerné",
    CLEARANCE_LEVEL: "Niveau d'habilitation",
    INSTITUTIONAL_RELATION: "Relation institutionnelle",
    MAIL_MANAGEMENT: "Gestion du courrier",
    PLATEFORM: "Plateforme",
    CAN_ACCESS_MAIL_MANAGEMENT: "Accès à la gestion du courrier",
    CAN_ACCESS_INSTITUTIONAL_RELATION: "Accès aux relations institutionnelles",
    // ****************** Objectif Perigourdine *********************
    GESTION_OBJECTIFS: "Gestion des objectifs",
    OBJECTIF: "Objectif",
    PAR_GROUPE: "Par groupes",
    PAR_POLE_COMMERCIAL: "Par pole commercial",
    OBJECTIF_CA: "Objectif CA",
    OBJECTIF_MARGE: "Objectif marge",
    CHIFFRE_AFFAIRE_N1: "Chiffre d'affaire N-1",
    CA_N1: "CA N-1",
    CA: "CA",
    CA_CALCULE: "Chiffre d'affaire calculé",
    TAUX_CROISSANCE_ATTENDU: "Taux de croissance attendu",
    MARGE_N1: "Marge N-1",
    MARGE_CALCULEE: "Marge calculée",
    MARGE: "Marge",
    SOUS_FAMILLE: "Sous Famille",
    FAMILLE: "Famille",
    COMMERCIAL: "Commercial",
    VARIATION_N1: "Variation N-1",
    REALISE: "Réalisé",
    DASHBOARD_VISUALISATION: "Visualisation Dashboard",
    EDIT_OBJECTIFS: "Editer les Objectifs",
    // *********** Chats ******************
    CHAT_ACCESS_TO_CHAT:
      "Vous pourrez accéder au chat une fois que vous aurez créé la fiche chrono.",
    CHAT_ERROR_LOAD_DATA: "Un problème est survenu lors de la récupération de vos messages.",
    CHAT_REQUIRE_CONTENT: "Le message ne peut pas être vide.",
    CHAT_RETRY: "Réessayer",
    CHAT_MENTION_PLACEHOLDER: "Écrire un message, @ pour mentionner quelqu'un",
    CHAT_MENTION_NO_RESULT: "Aucun utilisateur ayant accès à cette fiche",
    CHAT_MENTION_LOADING: "Recherche…",
    CHAT_MENTION_UNKNOWN_USER: "Utilisateur inconnu",
    CHAT_MENTION_LIMIT_REACHED: "Vous pouvez mentionner jusqu'à 20 personnes par message",
    // *************** GRC REFERENTIALS *************
    WAITING_SAVE: "Sauvegarde en cours",
    LABEL_RIGHT: "Droit",
    LABEL_ADD: "Ajouter",
    LABEL_DOWNLOAD_EXEMPLE: "Télécharger le modèle",
    LABEL_DOWNLOAD_NOT_IMPORTED_DATA: "Télécharger les données non intégrées",
    LABEL_IMPORT: "Importer",
    LABEL_CREATE: "Créer",
    REFERENTIAL: "Référentiel",
    REFERENTIALS: "Référentiels",
    REFERENTIALS_SELECT_REFERENTIAL: "Veuillez sélectionner un référentiel.",
    REFERENTIALS_SHOW_WORKFLOW: "Voir les workflows",
    REFERENTIALS_ACTION_ADD: "Ajouter",
    REFERENTIALS_NOT_FOUND: "Erreur: Référentiel introuvable.",
    REFERENTIALS_OPEN_MODAL: "Voir dans la modale",
    REFERENTIALS_LOAD_MORE: "Charger plus",
    REFERENTIALS_LOADING_MORE: "Chargement...",
    REFERENTIALS_NO_DATASOURCE: "Aucune source de données",
    REFERENTIALS_EMPTY_STATE: "Aucun élément",
    REFERENTIALS_OPEN_SAMPLE: "Ouvrir la fiche",
    REFERENTIALS_SAMPLE_DETAILS: "Détail de l'élément",
    REFERENTIALS_MENU_SECTION_ACTIONS: "Actions",
    REFERENTIALS_MENU_SECTION_ADMIN: "Admin",
    REFERENTIALS_MENU_SECTION_WORKFLOW: "Workflow",
    REFERENTIALS_MENU_SECTION_CAMPAIGNS: "Campagnes",
    REFERENTIALS_MENU_IMPORT: "Importer",
    REFERENTIALS_MENU_DUPLICATE: "Dupliquer",
    REFERENTIALS_MENU_REPAIR_RIGHTS: "Réparer les échantillons",
    REFERENTIALS_REPAIR_SUCCESS: "Réparation terminée.",
    REFERENTIALS_REPAIR_STREAM_ERROR: "Erreur du flux de réparation : %error%",
    REFERENTIALS_KPI_UPDATE_SUCCESS: "Succès lors de la mise à jour des KPIs.",
    REFERENTIALS_KPI_UPDATE_ERROR: "Une erreur est survenue lors de la modification des KPIs.",
    REFERENTIALS_UNIQUE_INFO_PREFIX: "Information déjà existante:",
    UPDATE_AVAILABLE: "Des mises à jour sont disponibles",
    HISTORY_REDIRECTION_TITLE: "Afficher la version correspondant à cette mise à jour",
    HISTORY_TITLE: "Dernières modifications",
    HISTORY_TEXT: "a modifié",
    FORM_SUCCESS_MESSAGE: "Mise à jour réussie.",
    FORM_NO_CHANGES_MESSAGE: "Aucune modification à enregistrer",
    FORM_ERROR_MESSAGE: "Erreur lors de la mise à jour.",
    FORM_NEW_VERSION_RECEIVED: "Nouvelle version reçue.",
    ARIA_LABEL_ADD_SAMPLE: "Ajouter un échantillon",
    ARIA_LABEL_CREATE_SAMPLE: "Créer un échantillon",
    ARIA_LABEL_CLOSE_MODAL: "Fermer la modal",
    ARIA_LABEL_CLOSE: "Fermer",
    ALERT_REDIRECT_CREATE_SAMPLE:
      "Veuillez sauvegarder l'édition en cours avant de pouvoir créer un nouvel enregistrement. Bouton Actions > Sauvegarder.",
    BOOLEAN_INPUT_FALSE: "Non",
    BOOLEAN_INPUT_TRUE: "Oui",
    INPUT_UPLOAD_FILE_COUNT_ONE: "{count} fichier ajouté",
    INPUT_UPLOAD_FILE_COUNT_OTHER: "{count} fichiers ajoutés",
    INPUT_UPLOAD_FILE_LABEL_ONE: "Fichier ajouté",
    INPUT_UPLOAD_FILE_LABEL_OTHER: "Fichiers ajoutés",
    INPUT_UPLOAD_FILE_TEXT_1: "fichier",
    INPUT_UPLOAD_FILE_TEXT_2: "ajouté",
    FORM_BLOCKER_UNSAVED_QUIT_TITLE: "Modifications non sauvegardées.",
    FORM_BLOCKER_UNSAVED_QUIT_CONTENT: "Voulez-vous sauvegarder avant de quitter ?",
    FROM_BLOCKER_SAVE_QUIT: "Non, Sauvegarder et quitter",
    FROM_BLOCKER_NOSAVE_QUIT: "Oui, Quitter sans sauvegarder",
    FILE_TRANSFER_IN_PROGRESS: "Transfert du fichier en cours",
    EXPORT_IN_PROGRESS: "Exportation en cours",
    REQUIRED_FIELDS_ARE_EMPTY:
      "Assurez-vous de corriger tous les champs en rouge et de suivre les consignes indiquées en rouge",
    EXPORT_TYPE: "Type d'export",
    AG_GRID_MENU_1: "Ouvrir dans un nouvel onglet",
    DOWNLOAD_DOCUMENT_1: "Récupération de la donnée",
    DOWNLOAD_DOCUMENT_2: "Préparation de la donnée",
    DOWNLOAD_DOCUMENT_3: "Téléchargement de la donnée",
    DOWNLOAD_DOCUMENT_MENU_1: "Exporter cette page en CSV",
    DOWNLOAD_DOCUMENT_MENU_2: "Exporter en CSV",
    DOWNLOAD_DOCUMENT_MENU_3: "Exporter cette page en XLSX",
    DOWNLOAD_DOCUMENT_MENU_4: "Exporter en XLSX",
    TOOLTIP_LOCK_JSON_FORMS: "Champ automatique",
    TOOLTIP_LOCK_SELECT_ROLE_DOC: "Veuillez créer votre fiche pour accéder à cette fonctionnalité",
    TOOLTIP_REQUIRED_FIELD: "Champ obligatoire",
    NO_FILE: "Aucun fichier",
    ALERT_DELETE_REFERENTIAL_SUB_CONTENT: "Cet élément est lié à d'autres éléments.",
    ALERT_REQUIRED_FIELDS: "Le/Les champs suivants doivent être correctement renseignés :",
    CHOOSE_A_STEP: "Choisi une étape",
    ROLES_SPEC_DOC: "Rôles spécifique au document",
    CONFIG_ROLES_SPEC_DOC: "Configuration des rôles par référentiel",
    // *************** GRC Evaluation *************
    INSTANTIATION: "Instanciation",
    ASSIGNED: "Assignés",
    INSERT: "Insérer",
    ADD_FOLDER: "Ajout Dossier",
    OCCURENCES: "Occurrences",
    A_QUESTION: "Une question",
    A_TEXT: "Un texte",
    ADD_A_QUESTION: "Ajouter une question",
    EDIT_A_QUESTION: "Modifier la question",
    QUESTION: "Question",
    SCOPE_OF_QUESTION: "Portée de la question",
    RESPONSE_TYPE: "Type de réponse",
    MANDATORY_RESPONSE: "Réponse obligatoire",
    CONDITIONAL_QUESTION: "Question conditionnelle",
    CONDITIONAL_QUESTION_REFERENCE: "Choisir la question de référence",
    CONDITIONAL_QUESTION_VALUE: "Valeur conditionnelle",
    CONDITIONAL_QUESTION_OPERATOR: "Opérateur",
    ADD_TEXT: "Ajouter un texte",
    EDIT_TEXT: "Modifier le texte",
    WORDING: "Libéllé",
    EDITER: "Editer",
    PARAMETER: "Paramètre",
    FOLLOW_UPS: "Suivis",
    RESULTAT: "Résultat",
    ADDED_SAMPLE: "Nouveau lien",
    REMOVED_SAMPLE: "Lien supprimé",
    SAVE_AND_ACTIVE: "Sauvegarder et active",
    SAVE_AND_RUN: "Sauvegarder et lancer run",
    SEND_FOR_REVIEW: "Envoyer pour revue",
    EXTRACT: "Extraire",
    VARIABLE: "Variable",
    KPIS: "KPIS",
    CALCULATE_KPI: "Calculer un KPI",
    EDIT_KPI: "Modifier le KPI",
    NO_OCCURENCE_ACTIVE: "Aucune occurence active",
    NO_ACTIVE_WORFLOW: "Aucun workflow actif",
    START_RUN: "Valider",
    FROM_TITLE_START_RUN: "Lancer l'évaluation",
    FROM_CONTENT_START_RUN:
      "Une fois l'évaluation lancée, vous ne pourrez plus modifier le contenu du questionnaire. Êtes vous sur de vouloir continuer ?",
    FROM_CONTENT_START_RUN_2:
      "Vous vous apprêtez à lancer l'évaluation. Êtes-vous sûr de vouloir continuer ?",
    QUESTIONNAIRE_NOT_CREATED_INFO:
      "Vous n'avez pas encore créé de questionnaire pour ce contrôle.",
    LIST_OF_FOLDERS: "Liste des dossiers",
    PREVIOUS: "Précédent",
    NEXT: "Suivant",
    ACCES_REFERENTIAL: "Accéder au référentiel",
    IMPORT_EXCEL: "Importer excel",
    DELETE_SAMPLES: "Êtes-vous sûr de vouloir supprimer les données sélectionnées ?",
    ADD_SAMPLES: "Ajouter des échantillons",
    ADD_SAMPLE: "Ajouter un échantillon",
    NUMBER_OF_SAMPLES_TO_ADD: "Nombre d'échantillons à ajouter",
    ADD_SAMPLES_MANUALLY: "Intégrer manuellement",
    ADD_SAMPLES_CSV: "Intégrer via un fichier CSV",
    ADD_VARIABLE: "Ajouter une variable",
    OCCURRENCE_NOTES_ADD_BTN: "Ajouter",
    OCCURRENCE_NOTES_ADD_BTN_TITLE: "Ajouter une pièce jointe",
    OCCURRENCE_NOTES_ATTACHMENTS_LABEL: "Pièces justificatives",
    OCCURRENCE_NOTES_BTN_LABEL: "Justificatifs",
    OCCURRENCE_NOTES_CANCEL: "Annuler",
    OCCURRENCE_NOTES_CLOSE: "Fermer",
    OCCURRENCE_NOTES_DELETE_TITLE: "Supprimer",
    OCCURRENCE_NOTES_ERR_DELETE: "Erreur lors de la suppression de la pièce justificative",
    OCCURRENCE_NOTES_ERR_MAX_FILES: "Nombre maximum de pièces jointes atteint (5)",
    OCCURRENCE_NOTES_ERR_MIME: "Type de fichier non autorisé",
    OCCURRENCE_NOTES_ERR_OPEN: "Impossible d'ouvrir le fichier",
    OCCURRENCE_NOTES_ERR_SAVE: "Erreur lors de la sauvegarde de l'observation",
    OCCURRENCE_NOTES_ERR_SIZE: "Fichier trop volumineux (max 10 Mo)",
    OCCURRENCE_NOTES_ERR_UPLOAD: "Erreur lors de l'upload",
    OCCURRENCE_NOTES_NO_ATTACHMENTS: "Aucune pièce jointe",
    OCCURRENCE_NOTES_OBSERVATION_LABEL: "Observation",
    OCCURRENCE_NOTES_OBSERVATION_PLACEHOLDER: "Ajouter une observation…",
    OCCURRENCE_NOTES_SUCCESS_ADD: "Pièce justificative ajoutée",
    OCCURRENCE_NOTES_SUCCESS_DELETE: "Pièce justificative supprimée",
    OCCURRENCE_NOTES_TITLE: "Justificatifs",
    OCCURRENCE_NOTES_VALIDATE: "Valider",
    MESSAGE_INFOS_SAMPLE: "L'ajout a été ignoré car ce référentiel est déjà en cours d'utilisation",
    MESSAGE_INFOS_EXISTING_LINK: "Lien déjà existant",
    ONE_ITEM_ONLY: "Unique",
    RESPONSE_RATE: "Taux de réponse",
    RESPONSE_EXIT_ALERT_CONTENT: "Cette réponse contient des modifications non enregistrées. Que voulez-vous en faire ?",
    RESPONSE_EXIT_ALERT_LEAVE: "Quitter sans enregistrer",
    RESPONSE_EXIT_ALERT_REQUIRED_MISSING: "Des champs obligatoires sont vides : complétez-les pour pouvoir valider.",
    RESPONSE_EXIT_ALERT_TITLE: "Modifications non enregistrées",
    ANSWERED: "Répondu",
    BY: "par",
    NOT_ANSWERED: "Non répondu",
    WEIGHT: "Poids",
    PERSONALIZED_FORMULA: "Formule personnalisé",
    PTS_CONTROL_TABLE_COL_1: "Date début",
    PTS_CONTROL_TABLE_COL_2: "Date fin",
    PTS_CONTROL_TABLE_COL_3: "Responsable",
    PTS_CONTROL_TABLE_COL_4: "Assignés",
    PTS_CONTROL_TABLE_COL_5: "Date début de réalisation",
    PTS_CONTROL_TABLE_COL_6: "Date fin de réalisation",
    CLOSED_F: "Fermée",
    TO_ANSWER: "À répondre",
    ANSWERED_F: "Répondue",
    NOT_READY_F: "Pas prête",
    MODAL_AFFECT_OCCURRENCE_1: "Période de réponse",
    MODAL_AFFECT_OCCURRENCE_2: "Date de début",
    MODAL_AFFECT_OCCURRENCE_3: "Date de fin",
    LOADER_GRC: "Chargement...",
    EXECUTION: "Exécution",
    EXECUTION_DU_CONTROLE: "Exécution du contrôle",
    EXECUTE_CONTROL: "Exécuter le contrôle",
    EDIT_KPIS: "Modifier les KPIS",
    SAVE_ANSWER: "Enregistrer et valider",
    SAVE_DRAFT_V2: "Enregistrer en brouillon",
    SYNCING_AFTER_SAVE: "Enregistrement confirmé — synchronisation serveur…",
    NEW_DATA_AVAILABLE_RELOAD: "Nouvelles données disponibles — veuillez recharger avant d'enregistrer.",
    DRAFT_CONFLICTS_TITLE: "Conflits détectés",
    DRAFT_IN_CREATION: "Création en cours : modifications non sauvegardées.",
    CREATION_READY: "Création en cours : vous pouvez commencer à saisir.",
    DRAFT_UNSAVED_TITLE: "Vous avez des modifications non sauvegardées.",
    DRAFT_EXISTS_READONLY: "Modifications (lecture) non sauvegardées. Vous pouvez les enregistrer.",
    WRITE_DRAFT_EXISTS: "Un brouillon d’édition existe (non appliqué dans ce mode).",
    SYNCING: "Synchronisation…",
    RELOAD: "Recharger",
    RESOLVE_CONFLICTS: "Résoudre",
    RELOAD_BEFORE_SAVE: "Recharger avant d'enregistrer",
    VIEW_CHANGES_TITLE: "Aperçu de vos modifications",
    DELTA_OLD_VALUE: "Ancienne valeur",
    DELTA_NEW_VALUE: "Nouvelle valeur",
    HISTORY_VERSION_OF: "Version du {date}",
    CELL_LIST_MORE_ARIA: "{count} de plus, voir tout",
    CELL_LIST_LINKS_COUNT_ONE: "1 lien",
    CELL_LIST_LINKS_COUNT_OTHER: "{count} liens",
    CELL_LIST_UNTITLED: "{count} sans titre",
    RESOLVE_CONFLICTS_TITLE: "Résolution de conflits",
    RESOLVE_AND_CONTINUE: "Résoudre et continuer",
    DISCARD_DRAFT: "Annuler",
    DISCARD_DRAFT_CONFIRM: "Annuler le brouillon ?",
    DRAFT_DISCARDED: "Brouillon annulé.",
    NO_CHANGES_TO_SAVE: "Aucune modification à sauvegarder",
    SAMPLE_UPDATED_SUCCESSFULLY: "Enregistré.",
    HEADER_SWITCH_CLASSIC: "Revenir au classique",
    HEADER_SWITCH_MODERN: "Essayer le style moderne",
    AUTH_GUARD_MODAL_H2: "Votre session va bientôt expirer",
    AUTH_GUARD_MODAL_CONTENT:
      "Pour votre sécurité, votre session expirera dans 5 minutes. Assurez-vous de sauvegarder votre travail en cours ou renouveler votre session pour rester connecté.",
    AUTH_GUARD_MODAL_BUTTON: "Renouveler la session",
    GRACE_PERIOD: "Délai de grace",
    REALISATION_DURATION: "Durée de la réalisation",
    // *************** GRC Tasks *************
    TASK: "Tâche",
    MY_TASKS: "Mes tâches",
    GROUP_TASKS: "Groupe de tâches",
    NATURE: "Nature",
    COMPLETION: "Complétion",
    LATE: "Retard",
    IS_LATE: "En retard",
    DAYS_LATE: "Journées de retard",
    LATE_STATUS: "Statut du retard",
    ASSIGNOR: "Assignateur",
    ASSIGNED: "Assigné",
    TASKS_STATUS: "Statut des tâches",
    TASKS_NATURE: "Nature des tâches",
    OBJECT_TYPE: "Type d'objet",
    OBJECT_NAME: "Nom de l'objet",
    GROUP_LEVEL: "Groupe niveau",
    LABEL_YEAR: "Année",
    LABEL_MONTH: "Mois",
    LABEL_WEEK: "Semaine",
    SHOW_LIST: "Montrer la liste",
    LABEL_TABLE: "Tableau",
    LABEL_GANTT: "Gantt",
    LABEL_SHOW_LEGEND: "Montrer légende",
    LABEL_LIBELLE: "Libellé",
    LABEL_START_DATE: "Date de début",
    LABEL_END_DATE: "Date de fin",
    LABEL_PROGRESS: "Progression",
    LABEL_DURATION: "Durée",
    LABEL_DAY: "jour",
    UNIT: "Unité",
    DOWNLOAD_QUESTIONNAIRE: "Télécharger le questionnaire",
    DOWNLOAD_QUESTIONNAIRE_UNIQ_SHEET:
      "Télécharger le questionnaire (réponse dans un onglet unique)",
    DOWNLOAD_QUESTIONNAIRE_MULTIPLES_SHEETS: "Télécharger le questionnaire (réponses par élément)",
    RETURN_QUESTIONNAIRE: "Renvoyer le questionnaire",
    SEND_ANSWERS: "Envoyer les réponses",
    EXPORT_RESPONSES: "Exporter les réponses",
    ENLARGE: "Agrandir",
    REDUCE: "Réduire",
    // *************** Communications Page ***************
    CONVERSATIONS: "Conversations",
    NAVIGATION_ERROR_1: "Une erreur est survenue lors de la récupération des conversations.",
    MODAL_SETTING_CONVERSATION_1: "Paramètres de la conversation",
    MODAL_SETTING_CONVERSATION_SELECT_1: "Participants",
    MODAL_SETTING_CONVERSATION_INPUT_1: "Nom de la conversation",
    MODAL_SETTING_CONVERSATION_INPUT_2: "Epingler la conversation",
    MODAL_SETTING_CONVERSATION_BUTTON_1: "Supprimer",
    MODAL_SETTING_CONVERSATION_DELETE_1: "Êtes vous-sûr de vouloir supprimer cette conversation ?",
    ICON_CONVERSATION_TEXT_1:
      "Commencez une nouvelle discussion pour voir apparaître vos conversations ici.",
    ICON_CONVERSATION_TEXT_2: "Créer une conversation",
    ICON_CONVERSATION_TEXT_3: "Vous n'avez pas encore de conversation n'a été trouvé.",
    ICON_CONVERSATION_TEXT_4: "Vous n'avez pas encore de conversation associée à :",
    // *************** Modal Configuration Duplication ***************
    MODAL_DUPLICATION_CONFIGURATION_MAIN_TITLE: "Paramètres de duplication",
    MODAL_DUPLICATION_CONFIGURATION_FIELD_1: "Tout sélectionner",
    MODAL_DUPLICATION_CONFIGURATION_LABEL_1: "Dupliquer en conservant les liens :",
    // *************** Export Modal ***************
    MODAL_EXPORT_CONFIGURATION_LABEL_1: "Exporter en conservant les données :",
    MODAL_EXPORT_CONFIGURATION_LABEL_2: "Éléments liés :",
    // *************** Import Data Modal ***************
    MODAL_IMPORT_DATA_LABEL_1: "Téléchargez le modèle pour saisir vos données",
    MODAL_IMPORT_DATA_ERROR_LABEL_1:
      "Erreur lors de l'import - Certaines données n'ont pas pu être intégrées",
    MODAL_IMPORT_DATA_ERROR_SUB_LABEL_1: "Cliquer ici pour voir le détail des erreurs",
    MODAL_IMPORT_DATA_ERROR_MODAL_HEADER: "Détail des erreurs",
    MODAL_IMPORT_DATA_LABEL_2: "Téléversez ici le fichier une fois complété",
    MODAL_IMPORT_DATA_ERROR_LABEL_2: "Téléversez ici le fichier une fois modifié",
    MODAL_IMPORT_DATA_LABEL_3: "Cliquez sur Ajouter pour importer vos données dans l'application",
    MODAL_IMPORT_DATA_ERROR_LABEL_3:
      "Cliquez sur Ajouter pour importer vos données dans l'application",
    MODAL_IMPORT_DATA_LABEL_4: "Données en cours d'intégration...",
    MODAL_IMPORT_DATA_ERROR_LABEL_4: "Données en cours d'intégration...",
    INPUT_FILES_DND_LABEL_1: "Glisser / déposer votre fichier",
    INPUT_FILES_DND_LABEL_2:
      "Téléchargement en cours, cette opération peut prendre quelques instants...",
    NUMBER_OF_DAYS: "Nombre de jours",
    CUSTOMIZE_REALIZATION_PERIOD: "Personnaliser la période de réalisation",
    RESTRICTION_REALIZATION_PERIOD: "Restriction de la période de réalisation",
    NO_CONTROL_IS_LINKED_YET: "Aucun contrôle n'est encore lié",
    CONTROLS_WILL_BE_CARRIED_OUF_FROM: "Les contrôles seront exécutés du",
    CHOOSE_FREQUENCY_EACH_CONTROL:
      "Veuillez choisir une fréquence d'occurrence pour chaque contrôle",
    EXECUTION_OF_CONTROLS: "Exécution des contrôles",
    FOR_THIS_CHECK_CHOOSE_DOMAIN:
      "Pour un contrôle de ce type, choisissez un domaine d'échantillons",
    FOR_THIS_CHECK_CHOOSE_COUNT_ECHANTILLONS:
      "Pour un contrôle de ce type, choisissez une taille d'échantillon",
    RAPPORTER: "Rapporteur",
    TASK_LABEL: "Libellé de la tâche",
    CURRENT_TASKS: "Tâches en cours",
    NEW_DOCUMENTS: "Nouveaux documents",
    SELECT_FIELDS: "Sélectionner des champs",
    SELECT_FIELDS_DESCRIPTION:
      "Sélectionnez les champs que vous souhaitez ajouter à votre questionnaire.",
    CONDITIONAL: "Conditionnel",
    NO_FIELDS_AVAILABLE: "Aucun champ disponible",
    REQUIRED: "Obligatoire",
    CONTROL_INSTANCE: "Instance du contrôle",
    DATES_OF_OCCURENCE: "Dates occurence",
    RESULT_OF_CONTROL: "Résultats du contrôle",
    NONE_KPIS_CONFIGURED: "Aucun indicateur de suivi configuré",
    MAIN_KPI: "KPI principal",
    NO_RESULT_YET: "Aucun résultat pour le moment.",
    MAIN_KPI_NOT_COMPUTED: "KPI principal non calculé pour cette campagne.",
    CURRENT_PERIOD: "actuelle",
    PERIODS_LABEL: "période(s)",
    CAMPAIGN_MISSING_NAME: "Nom de la campagne manquant",
    CAMPAIGN_MISSING_START_DATE: "Date de début manquante",
    CAMPAIGN_MISSING_END_DATE: "Date de fin manquante",
    CAMPAIGN_MISSING_CONTROLS: "Aucun contrôle à lancer",
    MISSING_INFORMATIONS: "Informations manquantes",
    COMPLETED: "Terminé",
    CANCELLED_FEMALE: "Annulée",
    SUCCESS_OCCURENCE_UPDATE: "Occurence mise à jour avec succès",
    ERROR_OCCURENCE_UPDATE: "Erreur lors de la mise à jour de l'occurence",
    SUCCESS_SAMPLES_ADDED: "Échantillons ajoutés avec succès",
    ERROR_SAMPLES_ADDED: "Erreur lors de l'ajout des échantillons",
    EXECUTE_CONTROLS: "Exécuter les contrôles",
    CAMPAIGN_ALREADY_EXISTS:
      " Une campagne étant déjà en cours, vous pouvez modifier la date de début d'exécution des contrôles.",
    OCCURENCE_CLOSED_PAST:
      "Impossible de répondre à cette occurence car la date de réalisation est dépassée.",
    OCCURENCE_CLOSED_FUTURE:
      "Impossible de répondre à cette occurence car la date de réalisation n'est pas encore atteinte.",
    OCCURENCE_LOCKED: "L'occurrence est verrouillée car une réponse a déjà été enregistrée",
    RELOAD: "Recharger",
    NEXT_STEP: "Étape suivante",
    PREVIOUS_STEP: "Étape précédente",
    CONFIGURATION: "Configuration",
    CAMPAIGNS_RESULTS: "Résultats des campagnes",
    CAMPAIGNS_NAME: "Nom de la campagne",
    CAMPAIGN_SUPERVISORS: "Superviseurs de la campagne",
    CAMPAIGNS_SELECT_FOR_ALL: "Sélectionner pour tous :",
    CAMPAIGNS: "Campagnes",
    ARCHIVE_OCCURRENCE: "Archiver l'occurrence",
    ARCHIVE_DOSSIER_SAMPLE: "Archiver l'échantillon",
    CAMPAIGN_CREATE: "Créer une campagne",
    CARD_NO_DESCRIPTION: "Aucune description",
    NO_CAMPAIGN_CREATED: "Aucune campagne n'a encore été créée.",
    NO_RESULT_CAMPAIGN: "Aucune réponse n’est disponible pour le moment.",
    FROM_TITLE_CLOSING_CAMPAIGN: "Clôturer la campagne",
    FROM_CONTENT_CLOSING_CAMPAIGN: "Vous vous apprêtez à clôturer la campagne",
    FROM_SUB_CONTENT_CLOSING_CAMPAIGN: "Êtes-vous sûr de vouloir continuer ?",
    FROM_TITLE_ARCHIVING_CAMPAIGN: "Archiver la campagne",
    FROM_CONTENT_ARCHIVING_CAMPAIGN: "Vous vous apprêtez à archiver la campagne",
    FROM_CONTENT_ARCHIVING_OCCURRENCE: "Vous vous apprêtez à archiver cette occurence.",
    FROM_SUB_CONTENT_ARCHIVING_OCCURRENCE: "Êtes-vous sûr de vouloir continuer ?",
    FROM_CONTENT_ARCHIVING_DOSSIER: "Vous vous apprêtez à archiver l'échantillon",
    FROM_SUB_CONTENT_ARCHIVING_DOSSIER: "Êtes-vous sûr de vouloir continuer ?",
    FROM_SUB_CONTENT_ARCHIVING_CAMPAIGN: "Êtes-vous sûr de vouloir continuer ?",
    ERROR_DATE_CAMPAIGN: "La date de fin ne peut pas être antérieure à la date de début.",
    LABEL_RESPONSE: "Réponse",
    LABEL_RESPONSES: "Réponses",
    NO_CAMPAIGN: "Pas de campagne",
    CLOSING_CAMPAIGN: "Clôturée",
    VIEW_CAMPAIGN: "Visualiser",
    ENCLOSE_CAMPAIGN: "Clôturer",
    NONE_CAMPAIGN: "Aucune campagne trouvée avec votre recherche.",
    ERROR_LOAD: "Erreur de chargement",
    AFFECTED_ORGA: "Affectation des entités",
    TAB_OVERVIEW: "Vue d'ensemble",
    TAB_TABLE_LIST: "Liste",
    TAB_TABLE_ARBRE: "Arborescence",
    SAVING_THE_CONFIGURATION: "Sauvegarde de la configuration",
    REFRESH_DATA: "Actualiser les données",
    DATA_UP_TO_DATE: "Données à jour",
    DATA_STALE: "Données périmées",
    DATA_LAST_MODIFIED: "Dernière modif. des données",
    REFERENTIAL_LAST_UPDATED: "Dernière modif. config. référentiels",
    DASHBOARD_LAST_REFRESHED: "Dernier recalcul du dashboard",
    DATA_STALE_HINT: "Des données ont changé depuis le dernier calcul — pensez à actualiser.",
    NEVER: "jamais",
    ERROR_RETRY: "Une erreur inattendue est survenue. Veuillez réessayer.",
    ADD_CUSTOM_FIELD: "Ajouter un champ personnalisé",
    // JsonForms GedLink
    GED_LINK_VIEW_DOCUMENT: "Visualiser le document",
    GED_LINK_EDIT_DOCUMENT: "Editer le document",
    GED_LINK_DELETE_DOCUMENT: "Supprimer le document",
    GED_LINK_LOADING: "Chargement des documents...",
    GED_LINK_OPEN_DOCUMENT: "Parcourir les documents",
    GED_SEE_MORE: "Voir plus",
    websocketLost: {
      title: "Connexion au serveur perdue",
      reconnecting: "Nous tentons de rétablir la connexion automatiquement…",
      disconnected: "Connexion perdue. Tentative de reconnexion en cours…",
      disconnectedNetwork:
        "Connexion perdue. Veuillez vérifier votre réseau ou contacter votre service IT.",
      disconnectedServer:
        "Connexion perdue. Le serveur semble indisponible : vérifiez le statut ou contactez le support.",
      attempts: "Nombre de tentatives",
      reloadWarning: "Ne rechargez pas la page pour éviter toute perte de données.",
      checkServers: "Avant toute action, vérifiez l'état des serveurs :",
      viewStatus: "Voir le statut en temps réel",
      reloadButton: "Recharger la page (en dernier recours)",
      reloadConfirmTitle: "Attention",
      reloadConfirmMessage:
        "Recharger la page entraînera la perte de vos données non sauvegardées. Confirmer ?",
    },
    FERMER: "Fermer",
    TAPEZ_POUR_RECHERCHER: "Tapez pour rechercher…",
    CREE_PAR: "Créé par",
    MODIFIE_PAR: "Modifié par",
    LE: "le",
    TAPEZ_AU_MOINS_3_CARACTERES: "Tapez au moins 3 caractères…",
    CHARGEMENT_DU_REFERENTIEL: "Chargement du référentiel...",
    FIRSTNAME: "Nom",
    LASTNAME: "Prénom",
    UNSAVED_CHANGES_TITLE: "Modifications non enregistrées",
    UNSAVED_CHANGES_MESSAGE_WRITE:
      "Vous avez des modifications non enregistrées. Voulez-vous les enregistrer avant d'ouvrir le workflow ?",
    UNSAVED_CHANGES_MESSAGE_READ:
      "Vous avez des modifications locales non enregistrées. Voulez-vous les enregistrer avant d'ouvrir le workflow ?",
    SAVE_AND_CONTINUE: "Enregistrer et continuer",
    CONTINUE_WITHOUT_SAVE: "Continuer sans enregistrer",
    SAVING: "Enregistrement...",
    EMAIL_RESET_PASSWORD_BY_ADMIN_SUCCESS: "L'email a été délivré avec succès",
    EMAIL_RESET_PASSWORD_BY_ADMIN_ERROR: "Une erreur est survenue lors de l'envoi de l'email",
    // ***************************************** Modal Profil V2
    EN_COURS_DE_SAUVEGARDE: "En cours de sauvegarde...",
    AVATAR_CHANGER: "CHANGER",
    AVATAR_SUPPRIMER: "SUPPRIMER",
    AVATAR_RULES: "La taille maximale du fichier autorisée est de 400Ko",
    AVATAR_ERROR: "Le fichier est trop volumineux",
    MODIFIER_MON_MOT_DE_PASSE: "Modifier mon mot de passe",
    PALCEHOLDER_INPUT_NOM: "Nom",
    PALCEHOLDER_INPUT_PRENOM: "Prénom",
    PALCEHOLDER_INPUT_EMAIL: "Email",
    PALCEHOLDER_INPUT_LANGUE: "Langue",
    PALCEHOLDER_INPUT_PAGE_D_ACCUEIL: "Page d'accueil",
    ANCIEN_MOT_DE_PASSE: "Ancien mot de passe",
    NOUVEAU_MOT_DE_PASSE: "Nouveau mot de passe",
    CONFIRMER_LE_NOUVEAU_MOT_DE_PASSE: "Confirmer le nouveau mot de passe",
    VALIDER_MON_MOT_DE_PASSE: "VALIDER MON MOT DE PASSE",
    VALIDATION_EN_COURS: "VALIDATION EN COURS...",
    MOT_DE_PASSE_MODIFIE: "Mot de passe modifié avec succès",
    MOT_DE_PASSE_MODIFIE_ERROR: "Une erreur est survenue lors de la modification du mot de passe",
    UTILISATEUR_MODIFIE: "Utilisateur modifié avec succès",
    UTILISATEUR_MODIFIE_ERROR: "Une erreur est survenue lors de la modification de l'utilisateur",
    // ***************************************** Administration V2
    AMDMINISTRATION_TITLE: "Administration",
    LOGO_CHANGER: "CHANGER",
    LOGO_SUPPRIMER: "SUPPRIMER",
    LOGO_RULES: "La taille maximale du fichier autorisée est de 500Ko",
    LOGO_ERROR: "Le fichier est trop volumineux",
    SAUVEGARDE_EN_COURS: "Sauvegarde en cours...",
    UPDATE_BUSINESS_SUCCESS: "Les informations de votre entreprise ont été mises à jour",
    UPDATE_BUSINESS_ERROR: "Une erreur est survenue lors de la modification de l'entreprise",
    PALETTE_DE_COULEURS: "Palettes de couleurs",
    TOOLTIP_ANNULER_SUPPRESSION: "Restaurer les palettes supprimés",
    SUPPRIMER_TOUTES_PALETES: "Supprimer toutes les palettes",
    AJOUTER_PALETTE: "Ajouter une palette",
    AUCUNE_PALETTE: "Aucune palette de couleurs disponible",
    COPIE_COULEUR: "Couleur copiée:",
    COPIE_COULEUR_WARNING: "Erreur lors de la copie",
    MODIFIER_LA_PALETTE: "Modifier la palette",
    AJOUTER_UNE_PALETTE: "Ajouter une palette",
    ENREGISTRER_LA_PALETTE: "Enregistrer la palette",
    SUPPRIMER_LA_PALETTE: "Supprimer la palette",
    NOM_DE_LA_PALETTE: "Nom de la palette",
    PALETTE_PAR_DEFAUT: "Palette par défaut",
    PALETTE_DE_COULEURS: "Palette de couleurs",
    AJOUTER_UNE_COULEUR: "Ajouter une couleur",
    PROFIL_UPDATE_SUCESS: "Votre profil a été modifié avec succès",
    PROFIL_UPDATE_ERROR: "Une erreur est survenue lors de la modification de votre profil",
    // ***************************************** Duplication Modal page référentiel
    DUPLICATION_EN_COURS: "Duplication en cours...",
    DUPLICATION_DES: "Duplication des",
    ECHANTILLONS_EN_COURS: "échantillons en cours...",
    ESTIMATION: "estimation",
    DUPLIQUER: "Dupliquer",
    TOOLTIP_PROPS_CHECKBOX_DUPLICATION:
      "Cet élément ne peut pas être dupliqué, car il dépend d’un lien unique",
    AUCUN_CHAMP_DISPONIBLE: "Aucun champ disponible",
    DUPLICATION_SUCCESS_MESSAGE: "Duplication terminé avec succès",
    DUPLICATION_ERROR_MESSAGE: "Une erreur est survenue lors de la duplication",
    APPLIQUER_A_TOUT: "Appliquer à tous les éléments dupliqués",
    // ***************************************** Code erreurs V2
    FILE_EXTENSION_NOT_ACCEPTED: "Extension du fichier non acceptée",
    FILE_SIZE_TOO_LARGE: "Taille du fichier trop grande",
    WIDGET_DATA_NETWORK_ERROR: "Certaines données du tableau de bord n'ont pas pu être chargées. Réessayez ou actualisez la page.",
    UPLOAD_FAILED: "Une erreur s'est produite lors du téléchargement",
    UNKNOWN_ERROR: "Une erreur inattendue est survenue",
    UNIQUE_CONSTRAINT_VIOLATION_PART_1: "La valeur",
    UNIQUE_CONSTRAINT_VIOLATION_PART_2: "existe déjà. Veuillez en saisir une autre.",
    REFERENTIAL_LOCK_BANNER_TITLE: "Cet enregistrement est verrouillé",
    REFERENTIAL_LOCK_BANNER_DESCRIPTION: "Le champ « {field} » vaut « {value} ». Tous les champs sont en lecture seule. Utilisez une transition de workflow pour déverrouiller cet enregistrement.",
    REFERENTIAL_LOCK_RULES_TITLE: "Règles de verrouillage",
    REFERENTIAL_LOCK_RULES_SAVED: "Règles de verrouillage enregistrées.",
    REFERENTIAL_LOCK_RULES_ERROR: "Échec de l'enregistrement des règles de verrouillage.",
    REFERENTIAL_LOCK_ADD_RULE: "Ajouter une règle",
    REFERENTIAL_LOCK_WATCH_FIELD: "Champ surveillé",
    REFERENTIAL_LOCK_TRIGGER_VALUES: "Valeurs déclenchantes",
    REFERENTIAL_LOCK_EXCEPT_FIELDS: "Champs exclus",
    "ERROR.SAMPLE_LOCKED": "Cet enregistrement est verrouillé : le champ « {field} » vaut « {value} ». Utilisez une transition de workflow pour le déverrouiller.",
    "ERROR.SAMPLES_DUPLICATION_SCOPE_INVALID": "Choisissez les fiches à dupliquer : sélectionnez des lignes ou appliquez un filtre (l'un ou l'autre).",
    "ERROR.SAMPLES_DUPLICATION_FORBIDDEN": "Vous n'avez pas le droit de créer des fiches dans ce référentiel.",
    "ERROR.SAMPLES_DUPLICATION_IN_PROGRESS": "Une duplication est déjà en cours sur ce référentiel. Attendez sa fin avant d'en lancer une autre.",
    "ERROR.SAMPLES_DUPLICATION_EMPTY": "Rien à dupliquer : aucune fiche ne correspond à la sélection.",
    "ERROR.SAMPLES_DUPLICATION_TOO_MANY": "Trop de fiches à dupliquer en une fois : restreignez la sélection ou le filtre.",
    "SAMPLES_DUPLICATION_DOCK_TITLE": "Duplication : {{referential}}",
    "SAMPLES_DUPLICATION_ALREADY_RUNNING": "Une duplication est déjà en cours sur ce référentiel — suivez-la dans la barre de progression. Vous pourrez en lancer une autre à sa fin.",
    "SAMPLES_DUPLICATION_SKIPPED": "{{count}} fiche(s) sélectionnée(s) n'ont pas pu être lues ou n'existent plus : elles n'ont pas été dupliquées.",
    "DUPLICATE_CONFIRM_ALL": "{{count}} fiches vont être dupliquées. Continuer ?",
    "SAMPLES_DUPLICATION_SELECT_ALL_UNAVAILABLE": "La sélection de toutes les lignes n'est pas disponible ici — cochez les lignes à dupliquer.",
    "SAMPLES_DUPLICATION_SUMMARY_ALL": "{{done}} fiche(s) dupliquée(s)",
    "SAMPLES_DUPLICATION_SUMMARY_PARTIAL": "{{done}} fiche(s) dupliquée(s), {{failed}} en échec",
    "SAMPLES_DUPLICATION_SUMMARY_NONE": "Aucune fiche n'a pu être dupliquée",
    "ERROR.TRANSLATE_ALL_IN_PROGRESS": "Une traduction de tous les libellés est déjà en cours. Suivez-la dans la barre de progression ; vous pourrez en lancer une autre à sa fin.",
    "ERROR.TRANSLATE_ALL_LOCALES_INVALID": "Aucune langue cible reconnue : cochez au moins une langue.",
    "ERROR.LABEL_I18N_GLOSSARY_TERM_INVALID": "Le terme du glossaire est invalide : vérifiez sa longueur et les langues utilisées.",
    "ERROR.LABEL_I18N_GLOSSARY_TERM_DUPLICATE": "Ce terme existe déjà dans le glossaire.",
    "ERROR.LABEL_I18N_GLOSSARY_CONFLICT": "Ce terme a été modifié par quelqu'un d'autre. Rechargez le glossaire et réessayez.",
    "ERROR.LABEL_I18N_GLOSSARY_FULL": "Le glossaire est plein : supprimez un terme avant d'en ajouter un autre.",
    "ERROR.LABEL_I18N_SUGGEST_UNAVAILABLE": "Le service de suggestion de traduction est indisponible. Les libellés restent saisissables à la main.",
    "ERROR.LABEL_I18N_SUGGEST_SOURCE_INVALID": "Rien à traduire : le libellé est vide ou dépasse 2 000 caractères.",
    "ERROR.LABEL_I18N_SUGGEST_SOURCE_LOCALE_INVALID": "Langue source inconnue : utilisez l'une des six langues de l'outil.",
    "TRANSLATE_ALL_DOCK_TITLE": "Traduction de tous les libellés",
    "TRANSLATE_ALL_RUNNING": "Traduction en cours…",
    "TRANSLATE_ALL_ELEMENT": "{{translated}} traduit(s), {{failed}} échec(s)",
    "TRANSLATE_ALL_REMAINING": "{{remaining}} libellé(s) non traité(s) (durée maximale atteinte, service de traduction indisponible, ou libellé modifié pendant la traduction) — relancez pour compléter",
    "TRANSLATE_ALL_FAILED": "Erreur technique — l'équipe technique a été notifiée",
    "TRANSLATE_ALL_INTERRUPTED": "Traduction interrompue — les catégories de libellés déjà traduites sont enregistrées ; relancez pour compléter",
    "TRANSLATE_ALL_NOTHING": "Rien à traduire : tous les libellés ont déjà leurs traductions",
    "TRANSLATE_ALL_SUMMARY_ALL": "{{done}} catégorie(s) de libellés traduite(s)",
    "TRANSLATE_ALL_SUMMARY_PARTIAL": "{{done}} catégorie(s) de libellés entièrement traduite(s), {{failed}} incomplète(s) — relancez pour compléter",
    "TRANSLATE_ALL_SUMMARY_NONE": "Aucun libellé n'a pu être traduit — réessayez plus tard",
    "OPERATION_TYPE_TRANSLATE_ALL": "Traduction de tous les libellés",
    "OPERATION_TYPE_SERIES_SYNC": "Synchronisation de série",
    "OPERATION_TYPE_SAMPLES_DUPLICATION": "Duplication de fiches",
    "OPERATION_RUN_PENDING": "En file d'attente — en attente d'un créneau libre",
    "OPERATION_TYPE_CAMPAIGN_LAUNCH": "Lancement de campagne",
    "OPERATION_TYPE_SERIES_GENERATION": "Génération de série",
    "ADMIN_TRANSLATIONS_SAVE_SKIPPED": "{{count}} ligne(s) non enregistrée(s) : le libellé a changé ou n'existe plus sur le serveur. Votre saisie est conservée — rechargez la grille et refaites-la.",
    "ADMIN_TRANSLATIONS_SAVED_REFRESH_FAILED": "Enregistré — l'actualisation a échoué, rechargez la grille.",
    "ADMIN_TRANSLATIONS_GLOSSARY_TAB": "Glossaire",
    "ADMIN_TRANSLATIONS_GLOSSARY_TITLE": "Glossaire du client",
    "ADMIN_TRANSLATIONS_GLOSSARY_HELP": "Les termes listés ici sont appliqués par les suggestions de l'IA et par « Tout traduire ». Les traductions déjà saisies ne changent jamais.",
    "ADMIN_TRANSLATIONS_GLOSSARY_TERM": "Terme",
    "ADMIN_TRANSLATIONS_GLOSSARY_MEANING": "Sens (aide l'IA pour les sigles)",
    "ADMIN_TRANSLATIONS_GLOSSARY_FORBIDDEN": "Traductions interdites",
    "ADMIN_TRANSLATIONS_GLOSSARY_ADD": "Ajouter un terme",
    "ADMIN_TRANSLATIONS_GLOSSARY_EDIT": "Modifier",
    "ADMIN_TRANSLATIONS_GLOSSARY_DELETE": "Supprimer",
    "ADMIN_TRANSLATIONS_GLOSSARY_CONFIRM_DELETE": "Supprimer le terme « {{term}} » ? Les traductions existantes ne sont pas modifiées.",
    "ADMIN_TRANSLATIONS_GLOSSARY_EMPTY": "Aucun terme pour l'instant. Ajoutez le vocabulaire que l'IA doit respecter.",
    "ADMIN_TRANSLATIONS_GLOSSARY_SAVED": "Terme enregistré.",
    "ADMIN_TRANSLATIONS_GLOSSARY_CONFLICT_RELOADED": "Ce terme a été modifié par quelqu'un d'autre. La dernière version a été rechargée ; refaites votre modification.",
    "ADMIN_TRANSLATIONS_GLOSSARY_FORBIDDEN_LIMIT": "Au plus {{max}} traductions interdites par langue, {{length}} caractères chacune.",
    "ERROR.WORKFLOW_WARNING_NOT_ACKNOWLEDGED": "Cette étape présente un avertissement. Confirmez pour soumettre malgré tout.",
    REFERENTIAL_LOCK_MESSAGE: "Message personnalisé",
    REFERENTIAL_LOCK_MESSAGE_PLACEHOLDER: "Message affiché à l'utilisateur (facultatif)...",
    REFERENTIAL_LOCK_NO_RULES: "Aucune règle de verrouillage configurée.",
    SELECT_FIELD: "Sélectionner un champ...",
    SELECT_VALUES: "Sélectionner des valeurs...",
    TYPE_VALUE_ENTER: "Saisissez une valeur puis Entrée...",
    SELECT_EXCLUDED_FIELDS: "Champs exclus (facultatif)...",
    REFERENTIAL_NOT_FOUND: "Le référentiel est introuvable.",
    REFERENTIAL_NO_TEMPLATE: "Ce référentiel n'a pas de template de synthèse.",
    TEMPLATE_SYNTHESIS_NOT_FOUND: "Le template de synthèse est introuvable.",
    USER_NOT_FOUND: "L'utilisateur est introuvable.",
    EMAIL_NOT_ENABLED:
      "Veuillez activer l'option d'envoi de courriel dans les réglages de notification.",
    ALREADY_SENT: "La synthèse a déjà été envoyée ce mois-ci.",
    ERROR_SUMMARY_SYNTHESIS: "Erreur lors de l'envoi de la synthèse.",
    // Historique d'audit des uploads (AdminConsole > Supervision > Historique des uploads)
    ADMIN_PAGE_UPLOAD_HISTORY: "Historique des uploads",
    UPLOAD_HISTORY_TITLE: "Piste d'audit des uploads",
    UPLOAD_HISTORY_DESC:
      "Journal de chaque tentative d'upload : accepté, accepté sans analyse antivirus, ou refusé.",
    UPLOAD_HISTORY_EMPTY: "Aucun upload enregistré.",
    UPLOAD_HISTORY_SHOWING: "Affichage de",
    UPLOAD_HISTORY_COL_DATE: "Date",
    UPLOAD_HISTORY_COL_USER: "Utilisateur",
    UPLOAD_HISTORY_COL_FILE: "Fichier",
    UPLOAD_HISTORY_COL_SIZE: "Taille",
    UPLOAD_HISTORY_COL_REPOSITORY: "Dépôt",
    UPLOAD_HISTORY_COL_PATH: "Chemin d'upload",
    UPLOAD_HISTORY_COL_STATUS: "Statut",
    UPLOAD_HISTORY_COL_REASON: "Motif de refus",
    UPLOAD_HISTORY_FILTER_USER: "Filtrer par email…",
    UPLOAD_HISTORY_FILTER_REPOSITORY: "Filtrer par dépôt…",
    UPLOAD_HISTORY_FILTER_FROM: "Du",
    UPLOAD_HISTORY_FILTER_TO: "Au",
    UPLOAD_HISTORY_FILTER_ALL_STATUSES: "Tous les statuts",
    UPLOAD_HISTORY_FILTER_ALL_REASONS: "Tous les motifs",
    UPLOAD_HISTORY_FILTER_ALL_PATHS: "Tous les chemins",
    UPLOAD_HISTORY_FILTER_APPLY: "Filtrer",
    UPLOAD_STATUS_ACCEPTED: "Accepté",
    UPLOAD_STATUS_ACCEPTED_UNSCANNED: "Accepté (non scanné)",
    UPLOAD_STATUS_ACCEPTED_UNSCANNED_TOOLTIP:
      "Accepté sans analyse antivirus : l'antivirus était désactivé ou injoignable. La plateforme ne bloque pas les uploads quand son scanner est en panne.",
    UPLOAD_STATUS_REJECTED: "Refusé",
    UPLOAD_PATH_SINGLE: "Simple",
    UPLOAD_PATH_MULTIPART: "Multipart",
    UPLOAD_REJECTION_INVALID_FILENAME: "Nom de fichier invalide",
    UPLOAD_REJECTION_DOUBLE_EXTENSION: "Double extension dangereuse",
    UPLOAD_REJECTION_BLOCKED_EXTENSION: "Extension de fichier bloquée",
    UPLOAD_REJECTION_SVG_BLOCKED: "Fichier SVG non autorisé",
    UPLOAD_REJECTION_INVALID_MSG_STRUCTURE: "Structure de message Outlook invalide",
    UPLOAD_REJECTION_CFB_NOT_ALLOWED: "Conteneur de fichier composé non pris en charge",
    UPLOAD_REJECTION_MIME_NOT_ALLOWED: "Type de fichier non autorisé",
    UPLOAD_REJECTION_UNDETECTABLE_TYPE: "Type de fichier indétectable",
    UPLOAD_REJECTION_MALWARE: "Logiciel malveillant détecté",
  },
]

export function getTraductionVariableByCode(languageId, code) {
  return traduction?.[languageId]?.[code] || "Traduction du code erreur introuvable"
}
